/**
 * © 2025 Grupo Salamander SAPI de CV
 * Author: Pablo Adoue Peralta
 *
 * English (Mexico) locale translations. Auto-generated by build-locale script
 *
 * */

const enmx = {
  "address/components/additional-info": "Additional information",
  "address/components/admin-area-1": "State / province",
  "address/components/admin-area-1/department": "Department",
  "address/components/admin-area-1/parish": "Parish",
  "address/components/admin-area-1/province": "Province",
  "address/components/admin-area-1/region": "Region",
  "address/components/admin-area-1/state": "State",
  "address/components/admin-area-2": "Municipality / county",
  "address/components/admin-area-2/municipality": "Municipality",
  "address/components/locality": "City",
  "address/components/postal-code": "Postal code",
  "address/components/street-name": "Street",
  "address/components/street-number": "Street number",
  "address/components/sub-locality": "Neighborhood",
  "address/components/sub-locality/neighborhood-mx": "Neighborhood",
  "address/components/unit-number": "Unit number",
  "address/editor/country": "Country",
  "address/editor/country-not-enabled":
    "That address is in a country that is not available.",
  "address/editor/label": "Name (optional)",
  "address/editor/locate": "Find on map",
  "address/editor/locate-none": "No location was found for this address.",
  "address/editor/lookup-failed": "Could not look up the postal code.",
  "address/editor/map": "Address map",
  "address/editor/map-placeholder": "The map is not available.",
  "address/editor/pick-settlement":
    "Pick the neighborhood from the list for this postal code.",
  "address/editor/pin-confirm": "Confirm location",
  "address/editor/pin-confirmed": "Location confirmed.",
  "address/editor/pin-drag-hint": "Drag the pin to the exact location.",
  "address/editor/pin-remove": "Remove location",
  "address/editor/pin-suggested":
    "Suggested location. Confirm it or move the pin.",
  "address/editor/place-failed": "Could not read the selected address.",
  "address/editor/postal-example": "Example: {{example}}",
  "address/editor/postal-not-found":
    "This postal code is not in the catalogue. Enter the neighborhood by hand.",
  "address/editor/primary": "Primary address for this purpose",
  "address/editor/profiles-error": "Could not load the address settings.",
  "address/editor/purpose": "Purpose",
  "address/editor/save-error": "Could not save the address.",
  "address/editor/search": "Search address",
  "address/editor/search-no-options": "No matching addresses",
  "address/editor/search-placeholder": "Start typing an address",
  "address/panel/action-error": "Could not complete the action.",
  "address/panel/add": "Add address",
  "address/panel/delete": "Delete address",
  "address/panel/delete-confirm":
    "This address will be removed from the record.",
  "address/panel/edit": "Edit address",
  "address/panel/empty": "No addresses yet.",
  "address/panel/load-error": "Could not load the addresses.",
  "address/panel/primary": "Primary",
  "address/panel/set-primary": "Set as primary",
  "address/panel/title": "Addresses",
  "address/purposes/billing": "Billing",
  "address/purposes/correspondence": "Correspondence",
  "address/purposes/fiscal": "Tax address",
  "address/purposes/other": "Other",
  "address/purposes/residence": "Residence",
  "address/purposes/risk-location": "Insured location",
  "api/auth/login-revoked": "Access revoked",
  "api/auth/login-revoked-description":
    "This account no longer has access to the platform.",
  "api/catalogue-reference-invalid": "Invalid catalogue reference",
  "api/catalogue-reference-invalid-description":
    "Select an enabled entry from the configured catalogue for this company.",
  "api/catalogue-update/already-running":
    "A catalogue update is already running",
  "api/catalogue-update/already-running-description":
    "Wait for the current update to finish, then request another.",
  "api/configuration/ambiguous-inheritance":
    "This configuration inherits different values from equally close parent agencies.",
  "api/configuration/ambiguous-inheritance-description":
    "Set an explicit value on this agency before saving.",
  "api/configuration/cedent-availability-reserved":
    "Your role cannot change this cedent availability.",
  "api/configuration/cedent-availability-reserved-description":
    "Only administrators of the program can switch cedents on or off.",
  "api/configuration/cedent-line-removal-reserved":
    "Only program-wide administrators can remove a line of business.",
  "api/configuration/cedent-line-removal-reserved-description":
    "Your role can disable the line instead of removing it.",
  "api/configuration/cedent-outside-company":
    "The cedent is not an insurer of this company.",
  "api/configuration/cedent-outside-company-description":
    "Availability can only be set for a registered insurer legal entity of the program company.",
  "api/configuration/commission-default-missing":
    "No default commission is configured for this line of business.",
  "api/configuration/commission-default-missing-description":
    "Ask a platform administrator to configure the default commissions.",
  "api/configuration/currency-outside-boundary":
    "The currency is not allowed for this line of business or program.",
  "api/configuration/currency-outside-boundary-description":
    "Choose only currencies enabled for the line of business in this program.",
  "api/configuration/currency-selection-reserved":
    "Only platform administrators can change currency selections.",
  "api/configuration/currency-selection-reserved-description":
    "Your role can enable lines of business but not change currencies.",
  "api/configuration/invalid-policy-types":
    "The allowed policy types are invalid.",
  "api/configuration/invalid-policy-types-description":
    "Choose at least one policy type from the allowed set.",
  "api/configuration/invalid-term-rule": "The term rule is inconsistent.",
  "api/configuration/invalid-term-rule-description":
    "A fixed term needs an amount, a unit and a locked expiration; a bounded term needs a valid range.",
  "api/configuration/lob-not-available-in-program":
    "This line of business is not available in the program.",
  "api/configuration/lob-not-available-in-program-description":
    "Enable it for the program first.",
  "api/configuration/participation-outside-program":
    "The agency does not belong to this program.",
  "api/configuration/participation-outside-program-description":
    "Configuration can only reference agencies of the current program.",
  "api/configuration/program-mode-required":
    "This configuration is only available for program-based companies.",
  "api/configuration/program-mode-required-description":
    "The company is not configured for program isolation.",
  "api/could-not-get-signed-link": "Could not get signed link",
  "api/could-not-get-signed-link-description": "Could not get signed link",
  "api/database/cross-instance-access": "Cross-instance database access",
  "api/database/cross-instance-access-detail":
    "Cannot access {{requestedInstance}} while database work for {{activeInstance}} is active.",
  "api/documents/asset-in-use": "The asset is in use",
  "api/documents/asset-in-use-description":
    "A published document or letterhead uses this file. Publish a version without it first.",
  "api/documents/asset-type-refused": "Asset type refused",
  "api/documents/asset-type-refused-description":
    "The file is not an accepted image or font, or its licence forbids embedding.",
  "api/documents/asset-unavailable": "Asset unavailable",
  "api/documents/asset-unavailable-description":
    "An image or font the document uses could not be loaded. Try again or replace the asset.",
  "api/documents/binding-unknown": "Unknown field",
  "api/documents/binding-unknown-description":
    "The document refers to a field that none of its data providers supplies.",
  "api/documents/block-id-duplicate": "Duplicate block id",
  "api/documents/block-id-duplicate-description":
    "Two blocks of the document share the same id.",
  "api/documents/body-too-complex":
    "Document content too large or too deeply nested",
  "api/documents/body-too-complex-description":
    "The document has too many elements, is nested too deeply or carries too many rows. Split it or remove content.",
  "api/documents/body-too-deep": "The document is nested too deeply",
  "api/documents/body-too-deep-description":
    "Simplify the structure so it has at most 32 nested levels.",
  "api/documents/body-too-large": "The document is too large",
  "api/documents/body-too-large-description":
    "The document content may not exceed 1 MiB.",
  "api/documents/body-too-many-nodes": "The document has too many blocks",
  "api/documents/body-too-many-nodes-description":
    "Blocks and table cells together may not exceed 5,000.",
  "api/documents/bundle-invalid": "Invalid export file",
  "api/documents/bundle-invalid-description":
    "The file is damaged, was edited, or comes from an incompatible version.",
  "api/documents/caller-missing": "Document service called without a caller",
  "api/documents/caller-missing-description":
    "The document service was called without the request company or principal. This is an internal error; contact support.",
  "api/documents/condition-error": "Invalid document condition",
  "api/documents/condition-error-description":
    "A visibility condition in the document could not be evaluated.",
  "api/documents/content-document-missing":
    "Document is missing its content document",
  "api/documents/content-document-missing-description":
    "The document declares the content provider but its definition names no content document. Set the content document on the definition and try again.",
  "api/documents/context-invalid": "Invalid request context",
  "api/documents/context-invalid-description":
    "The company or instance of the request could not be resolved.",
  "api/documents/default-super-admin-only":
    "Only a super admin can change instance defaults",
  "api/documents/default-super-admin-only-description":
    "The instance default letterhead can be written only by a super admin.",
  "api/documents/format-unavailable": "Format not enabled",
  "api/documents/format-unavailable-description":
    "This document is not available in the requested format.",
  "api/documents/format-unsupported": "Document format not supported",
  "api/documents/format-unsupported-description":
    "The requested document format is not available.",
  "api/documents/helper-unknown": "Unknown helper",
  "api/documents/helper-unknown-description":
    "A template calls a helper function that does not exist.",
  "api/documents/letterhead-in-use": "The letterhead is in use",
  "api/documents/letterhead-in-use-description":
    "A document fixes this letterhead. Change that document first.",
  "api/documents/letterhead-owner-taken":
    "Letterhead already exists for this owner",
  "api/documents/letterhead-owner-taken-description":
    "Edit the existing letterhead instead of creating another one.",
  "api/documents/letterhead-unavailable": "Letterhead unavailable",
  "api/documents/letterhead-unavailable-description":
    "The letterhead this document requires is missing, disabled or not published.",
  "api/documents/no-draft": "There is no draft to publish",
  "api/documents/no-draft-description": "Save a draft before publishing.",
  "api/documents/no-published-version": "No published version",
  "api/documents/no-published-version-description":
    "Publish a version before exporting, or choose a version.",
  "api/documents/not-applicable": "Document not available here",
  "api/documents/not-applicable-description":
    "This document is not offered for this record, stage or user.",
  "api/documents/not-authorized": "Not authorized",
  "api/documents/not-authorized-description":
    "Your role cannot perform this action on documents.",
  "api/documents/not-found": "Document not found",
  "api/documents/not-found-description":
    "The document or version does not exist.",
  "api/documents/precondition-unknown": "Document requirement not recognised",
  "api/documents/precondition-unknown-description":
    "The document has a requirement this system cannot check, so it cannot be generated.",
  "api/documents/provider-deprecated": "Deprecated data provider",
  "api/documents/provider-deprecated-description":
    "The data provider is kept only for shipped system documents and cannot be used in documents you write.",
  "api/documents/provider-requires": "Data provider dependency missing",
  "api/documents/provider-requires-description":
    "The data provider needs another provider that the document does not declare.",
  "api/documents/provider-subject-unsupported":
    "Data provider not supported for this subject",
  "api/documents/provider-subject-unsupported-description":
    "The data provider cannot load data for the kind of record this document is about.",
  "api/documents/render-busy": "Document service is busy",
  "api/documents/render-busy-description":
    "Too many documents are being generated right now. Try again in a few seconds.",
  "api/documents/render-failed": "Document could not be generated",
  "api/documents/render-failed-description":
    "The document file could not be rendered. Check the fonts, images and page settings of the document and try again.",
  "api/documents/render-required": "Document must be generated again",
  "api/documents/render-required-description":
    "The stored file is no longer available. Try generating the document again.",
  "api/documents/render-timeout": "Document took too long to generate",
  "api/documents/render-timeout-description":
    "The document could not be generated in time. Try again or simplify the document.",
  "api/documents/repeat-invalid": "Invalid document repeater",
  "api/documents/repeat-invalid-description":
    "A repeater in the document points to something that is not a list, or uses an invalid alias.",
  "api/documents/request-invalid": "Invalid document request",
  "api/documents/request-invalid-description":
    "The request is missing a field or one of its values is not valid.",
  "api/documents/revision-conflict": "The document was changed by someone else",
  "api/documents/revision-conflict-description": "Reload it and try again.",
  "api/documents/schema-invalid": "Invalid document body",
  "api/documents/schema-invalid-description":
    "The document or letterhead body does not match its schema.",
  "api/documents/slug-invalid": "The document key is not valid",
  "api/documents/slug-invalid-description":
    "Use lowercase letters and digits separated by single hyphens, up to 64 characters.",
  "api/documents/slug-taken": "Document identifier already in use",
  "api/documents/slug-taken-description":
    "Another document of this company already uses that identifier.",
  "api/documents/system-asset-super-admin-only": "System assets are read-only",
  "api/documents/system-asset-super-admin-only-description":
    "Only a super admin can change a system asset.",
  "api/documents/template-error": "Document template error",
  "api/documents/template-error-description":
    "The document template could not be rendered. Fix the reported block and try again.",
  "api/documents/unauthenticated": "Sign in required",
  "api/documents/unauthenticated-description": "Sign in to use documents.",
  "api/documents/unknown-provider": "Unknown data provider",
  "api/documents/unknown-provider-description":
    "The document declares a data provider that does not exist.",
  "api/documents/value-missing": "Value not available",
  "api/documents/value-missing-description":
    "A value the document refers to is not present in its data; it is left blank.",
  "api/documents/version-not-published": "The version is not published",
  "api/documents/version-not-published-description":
    "Only a published version can be made current.",
  "api/errors/company-access-denied": "Company access denied",
  "api/errors/company-access-denied-description":
    "You do not have access to this company",
  "api/errors/company-header-missing": "Company header missing",
  "api/errors/company-header-missing-description":
    "The X-Company-Id header is required",
  "api/invalid-in-force-date": "Invalid In Force Date",
  "api/laipo/token-principal-not-allowed":
    "API tokens cannot use the assistant.",
  "api/marketing/activation-failed": "Marketing could not be activated",
  "api/marketing/activation-failed-description":
    "Check the provider, policy and sender configuration and try again.",
  "api/marketing/activation-forbidden": "Activation is not permitted",
  "api/marketing/activation-forbidden-description":
    "Both Marketing configuration and company settings permissions are required.",
  "api/marketing/artifact/checksum-mismatch":
    "The stored artifact failed verification",
  "api/marketing/artifact/checksum-mismatch-description":
    "The stored content does not match its recorded checksum.",
  "api/marketing/artifact/company-mismatch":
    "This artifact does not belong to your company",
  "api/marketing/artifact/company-mismatch-description":
    "The requested storage key does not belong to the expected company.",
  "api/marketing/artifact/storage-unavailable":
    "Artifact storage is unavailable",
  "api/marketing/artifact/storage-unavailable-description":
    "Try again later, or contact support if this continues.",
  "api/marketing/asset-category/invalid-label":
    "Enter a label in both languages",
  "api/marketing/asset-category/invalid-label-description":
    "A resource category needs an English and a Spanish label.",
  "api/marketing/asset-category/invalid-slug": "Enter a category identifier",
  "api/marketing/asset-category/invalid-slug-description":
    "The category identifier cannot be blank.",
  "api/marketing/asset-category/not-found": "Category not found",
  "api/marketing/asset-category/not-found-description":
    "This resource category does not exist for your company.",
  "api/marketing/asset-version/immutable-field": "This field cannot be changed",
  "api/marketing/asset-version/immutable-field-description":
    "A resource version is immutable once created; upload a new version instead.",
  "api/marketing/asset-version/invalid-scan-state": "Choose clean or blocked",
  "api/marketing/asset-version/invalid-scan-state-description":
    "A manual scan attestation must record clean or blocked.",
  "api/marketing/asset/asset-version-required": "Choose a resource version",
  "api/marketing/asset/asset-version-required-description":
    "A resource version is required to continue.",
  "api/marketing/asset/bootstrap-company-not-found": "Company not found",
  "api/marketing/asset/bootstrap-company-not-found-description":
    "This company could not be found while registering the logo.",
  "api/marketing/asset/bootstrap-fetch-failed":
    "Could not fetch the hosted logo",
  "api/marketing/asset/bootstrap-fetch-failed-description":
    "Confirm the URL is publicly reachable and try again.",
  "api/marketing/asset/bootstrap-fields-required":
    "Enter a name, category and hosted URL",
  "api/marketing/asset/bootstrap-fields-required-description":
    "All three fields are required to register an existing logo.",
  "api/marketing/asset/derivative-too-large":
    "This image could not be resized for email",
  "api/marketing/asset/derivative-too-large-description":
    "Choose a smaller or simpler image and try again.",
  "api/marketing/asset/document-not-publishable":
    "Documents cannot be published as inline images",
  "api/marketing/asset/document-not-publishable-description":
    "Only images can be published for use in email content.",
  "api/marketing/asset/file-too-large": "This file is too large",
  "api/marketing/asset/file-too-large-description":
    "Choose a smaller file and try again.",
  "api/marketing/asset/invalid-document": "This file is not a valid document",
  "api/marketing/asset/invalid-document-description":
    "Only PDF documents are supported.",
  "api/marketing/asset/invalid-hosted-url": "Enter a valid HTTPS URL",
  "api/marketing/asset/invalid-hosted-url-description":
    "The hosted logo must be served over HTTPS from an existing URL.",
  "api/marketing/asset/invalid-image": "This file is not a valid image",
  "api/marketing/asset/invalid-image-description":
    "Only PNG, JPEG and WebP images are supported.",
  "api/marketing/asset/invalid-kind": "Choose image or document",
  "api/marketing/asset/invalid-kind-description":
    "The resource kind must be image or document.",
  "api/marketing/asset/invalid-publication-purpose":
    "Invalid publication purpose",
  "api/marketing/asset/invalid-publication-purpose-description":
    "Choose a supported publication purpose.",
  "api/marketing/asset/kind-mismatch":
    "This file does not match the resource type",
  "api/marketing/asset/kind-mismatch-description":
    "An image cannot be uploaded as a new version of a document, or vice versa.",
  "api/marketing/asset/name-and-category-required":
    "Enter a name and choose a category",
  "api/marketing/asset/name-and-category-required-description":
    "A new resource needs a name and a category.",
  "api/marketing/asset/not-found": "Resource not found",
  "api/marketing/asset/not-found-description":
    "This resource does not exist for your company.",
  "api/marketing/asset/not-publish-ready":
    "This resource is not ready to publish",
  "api/marketing/asset/not-publish-ready-description":
    "A resource must be verified and scanned clean before it can be published.",
  "api/marketing/asset/publication-not-found": "Publication not found",
  "api/marketing/asset/publication-not-found-description":
    "This publication does not exist for your company.",
  "api/marketing/asset/publication-required": "Choose a publication",
  "api/marketing/asset/publication-required-description":
    "A publication is required to continue.",
  "api/marketing/asset/upload-id-required": "The upload could not be found",
  "api/marketing/asset/upload-id-required-description":
    "Start a new upload and try again.",
  "api/marketing/asset/upload-not-found":
    "The uploaded file could not be found",
  "api/marketing/asset/upload-not-found-description":
    "The upload may have expired. Start a new upload and try again.",
  "api/marketing/asset/version-not-found": "Resource version not found",
  "api/marketing/asset/version-not-found-description":
    "This resource version does not exist for your company.",
  "api/marketing/audience/audience-not-ready":
    "This category cannot be sent yet: its operational eligibility is not available.",
  "api/marketing/audience/audience-not-ready-description":
    "This category cannot be sent yet: its operational eligibility is not available.",
  "api/marketing/audience/candidate-limit-exceeded":
    "The audience exceeds the supported limit. Narrow its selection.",
  "api/marketing/audience/candidate-limit-exceeded-description":
    "The audience exceeds the supported limit. Narrow its selection.",
  "api/marketing/audience/invalid-definition":
    "Review the audience fields, operators and values.",
  "api/marketing/audience/invalid-definition-description":
    "Review the audience fields, operators and values.",
  "api/marketing/audience/not-found":
    "The audience was not found in this company.",
  "api/marketing/audience/not-found-description":
    "The audience was not found in this company.",
  "api/marketing/audience/source-access-denied":
    "You do not have permission to use one or more source fields in this audience.",
  "api/marketing/audience/source-access-denied-description":
    "You do not have permission to use one or more source fields in this audience.",
  "api/marketing/audience/source-unavailable":
    "The audience source is unavailable or has changed. Review its configuration.",
  "api/marketing/audience/source-unavailable-description":
    "The audience source is unavailable or has changed. Review its configuration.",
  "api/marketing/audit-event-immutable": "Audit events cannot be changed",
  "api/marketing/audit-event-immutable-description":
    "Audit history is permanent.",
  "api/marketing/brand-profile/invalid-name": "Enter a brand profile name",
  "api/marketing/brand-profile/invalid-name-description":
    "The brand profile name cannot be blank.",
  "api/marketing/bulk-update-not-allowed": "Bulk changes are not supported",
  "api/marketing/bulk-update-not-allowed-description":
    "Update each record with its current revision.",
  "api/marketing/campaign-approval-immutable":
    "An approval decision cannot be changed",
  "api/marketing/campaign-approval-immutable-description":
    "Approval decisions are permanent records.",
  "api/marketing/campaign-approval/invalid-decision":
    "The approval decision is not valid",
  "api/marketing/campaign-approval/invalid-decision-description":
    "The decision must be approved or rejected.",
  "api/marketing/campaign-approval/invalid-revision-hash":
    "The approved revision hash is not valid",
  "api/marketing/campaign-approval/invalid-revision-hash-description":
    "The hash must be a 64-character lowercase hexadecimal digest.",
  "api/marketing/campaign-revision-immutable":
    "A prepared revision cannot be changed",
  "api/marketing/campaign-revision-immutable-description":
    "Prepare a new revision instead of editing a past one.",
  "api/marketing/campaign-revision/invalid-audience-selection":
    "The audience selection is not valid",
  "api/marketing/campaign-revision/invalid-audience-selection-description":
    "The audience selection must be an object of list, group and audience ids.",
  "api/marketing/campaign-revision/invalid-excluded-contacts":
    "The excluded contacts are not valid",
  "api/marketing/campaign-revision/invalid-excluded-contacts-description":
    "The excluded contacts must be a list of contact ids.",
  "api/marketing/campaign-revision/invalid-readiness-state":
    "The revision readiness state is not valid",
  "api/marketing/campaign-revision/invalid-readiness-state-description":
    "Use pending, ready or invalid.",
  "api/marketing/campaign-revision/invalid-revision-hash":
    "The revision hash is not valid",
  "api/marketing/campaign-revision/invalid-revision-hash-description":
    "The hash must be a 64-character lowercase hexadecimal digest.",
  "api/marketing/campaign-revision/invalid-revision-number":
    "The revision number is not valid",
  "api/marketing/campaign-revision/invalid-revision-number-description":
    "Revision numbers start at 1.",
  "api/marketing/campaign-write-forbidden":
    "Campaign records are changed only by campaign commands",
  "api/marketing/campaign-write-forbidden-description":
    "Use the campaign actions instead of editing records directly.",
  "api/marketing/campaign/campaign-locked":
    "This campaign can no longer be edited",
  "api/marketing/campaign/campaign-locked-description":
    "A send has been scheduled. Duplicate the campaign to change its content.",
  "api/marketing/campaign/conflict":
    "Another change to this campaign was saved first",
  "api/marketing/campaign/conflict-description":
    "Reload the campaign and try again.",
  "api/marketing/campaign/decision-conflict":
    "A different decision was already recorded",
  "api/marketing/campaign/decision-conflict-description":
    "Prepare a new revision to change the outcome.",
  "api/marketing/campaign/invalid-input": "The campaign request is not valid",
  "api/marketing/campaign/invalid-input-description":
    "Check the fields and try again.",
  "api/marketing/campaign/invalid-name": "The campaign needs a name",
  "api/marketing/campaign/invalid-name-description":
    "Enter a name for the campaign.",
  "api/marketing/campaign/invalid-state": "The campaign state is not valid",
  "api/marketing/campaign/invalid-state-description":
    "Use one of the supported campaign states.",
  "api/marketing/campaign/not-found": "The campaign was not found",
  "api/marketing/campaign/not-found-description":
    "It may have been removed or belongs to another company.",
  "api/marketing/campaign/reference-denied": "You cannot use a selected item",
  "api/marketing/campaign/reference-denied-description":
    "Your role does not allow reading one of the selected items.",
  "api/marketing/campaign/reference-not-found": "A selected item was not found",
  "api/marketing/campaign/reference-not-found-description":
    "The template version, category, sender, list, group, audience or contact does not exist in this company.",
  "api/marketing/campaign/revision-not-current":
    "This is not the current revision",
  "api/marketing/campaign/revision-not-current-description":
    "Only the latest prepared revision can be approved or rejected.",
  "api/marketing/campaign/revision-not-found":
    "The campaign revision was not found",
  "api/marketing/campaign/revision-not-found-description":
    "It may belong to another campaign or company.",
  "api/marketing/campaign/revision-not-ready": "The revision is not ready",
  "api/marketing/campaign/revision-not-ready-description":
    "Fix the blocking issues and prepare a new revision before approving.",
  "api/marketing/campaign/stale-revision":
    "The campaign changed since you opened it",
  "api/marketing/campaign/stale-revision-description":
    "Reload the campaign and apply your changes again.",
  "api/marketing/campaign/state-conflict":
    "The campaign is not in a state that allows this action",
  "api/marketing/campaign/state-conflict-description":
    "Reload the campaign to see its current state.",
  "api/marketing/capability-denied":
    "You do not have permission to perform this action.",
  "api/marketing/capability-denied-description":
    "Marketing must be enabled and your current role must allow this action.",
  "api/marketing/category/invalid-description": "The description is invalid",
  "api/marketing/category/invalid-description-description":
    "Provide an English and Spanish description, or leave it empty.",
  "api/marketing/category/invalid-label":
    "A label is required in both languages",
  "api/marketing/category/invalid-label-description":
    "Enter nonempty English and Spanish labels.",
  "api/marketing/category/not-found": "Category not found",
  "api/marketing/category/not-found-description":
    "The requested category does not exist for this company.",
  "api/marketing/company-id-immutable": "The company cannot be changed",
  "api/marketing/company-id-immutable-description":
    "Create a separate record for the other company.",
  "api/marketing/contact/delete-not-allowed": "Contacts must be archived",
  "api/marketing/contact/delete-not-allowed-description":
    "Archive this contact to preserve address and preference history.",
  "api/marketing/contact/invalid-email": "Invalid email address",
  "api/marketing/contact/invalid-email-description":
    "Enter a valid email address without a display name.",
  "api/marketing/contact/invalid-input":
    "Check the contact email, name and language.",
  "api/marketing/contact/invalid-input-description":
    "Check the contact email, name and language.",
  "api/marketing/contact/not-found": "Contact not found",
  "api/marketing/contact/not-found-description":
    "This contact is not available in the selected company.",
  "api/marketing/contacts/candidate-limit-exceeded":
    "Contact query limit reached",
  "api/marketing/contacts/candidate-limit-exceeded-description":
    "This directory exceeds the supported scan limit.",
  "api/marketing/contacts/display-name-entity-owned":
    "Name is managed by the linked record",
  "api/marketing/contacts/display-name-entity-owned-description":
    "This contact is linked to a directory record; its display name cannot be edited here.",
  "api/marketing/contacts/forbidden": "Contact access denied",
  "api/marketing/contacts/forbidden-description":
    "You do not have access to this contact operation or its required fields.",
  "api/marketing/contacts/invalid-filter": "Invalid contact filter",
  "api/marketing/contacts/invalid-filter-description":
    "Use one of: all, entity-linked, mailing-only, unsubscribed, suppressed.",
  "api/marketing/contacts/invalid-input": "Invalid contacts request",
  "api/marketing/contacts/invalid-input-description":
    "Use a nonnegative offset, a page size between 1 and 100, and only the supported query parameters.",
  "api/marketing/contacts/invalid-page": "Invalid page",
  "api/marketing/contacts/invalid-page-description":
    "Use a nonnegative offset and a page size between 1 and 100.",
  "api/marketing/contacts/not-found": "Contact not found",
  "api/marketing/contacts/not-found-description":
    "The requested contact is unavailable in this company.",
  "api/marketing/context-invalid": "Invalid Marketing context",
  "api/marketing/context-invalid-description":
    "Your session must belong to the selected company.",
  "api/marketing/cross-company-target": "Company mismatch",
  "api/marketing/cross-company-target-description":
    "Select records that belong to the same company.",
  "api/marketing/delivery-attempt-invalid-transition":
    "The delivery attempt cannot move to that state",
  "api/marketing/delivery-attempt-invalid-transition-description":
    "Only the documented delivery transitions are allowed.",
  "api/marketing/delivery-attempt/invalid-field":
    "A delivery attempt value is not valid",
  "api/marketing/delivery-attempt/invalid-field-description":
    "Check the delivery attempt values and try again.",
  "api/marketing/derived-membership-service-only": "Membership is synchronized",
  "api/marketing/derived-membership-service-only-description":
    "Edit the source relationship to change derived membership.",
  "api/marketing/dispatch-command/already-scheduled":
    "This campaign already has a send scheduled",
  "api/marketing/dispatch-command/already-scheduled-description":
    "A campaign can only be sent once.",
  "api/marketing/dispatch-command/ambiguous-local-time":
    "That local time happens twice in the chosen time zone",
  "api/marketing/dispatch-command/ambiguous-local-time-description":
    "Send the UTC offset that you mean.",
  "api/marketing/dispatch-command/dispatch-held": "The send is on hold",
  "api/marketing/dispatch-command/dispatch-held-description":
    "Resolve the hold before resuming.",
  "api/marketing/dispatch-command/dispatch-not-found": "The send was not found",
  "api/marketing/dispatch-command/dispatch-not-found-description":
    "It may belong to another company or no longer exist.",
  "api/marketing/dispatch-command/dispatch-state-conflict":
    "The send is not in a state that allows this action",
  "api/marketing/dispatch-command/dispatch-state-conflict-description":
    "Reload the send to see its current state.",
  "api/marketing/dispatch-command/idempotency-conflict":
    "That idempotency key was already used for a different request",
  "api/marketing/dispatch-command/idempotency-conflict-description":
    "Use a new key for a different request.",
  "api/marketing/dispatch-command/idempotency-key-required":
    "The Idempotency-Key header is required",
  "api/marketing/dispatch-command/idempotency-key-required-description":
    "Send a unique key (letters, digits and . _ ~ : -) with this request.",
  "api/marketing/dispatch-command/invalid-dispatch-ids":
    "The list of dispatches is not valid",
  "api/marketing/dispatch-command/invalid-dispatch-ids-description":
    "Send between 1 and 100 dispatch ids.",
  "api/marketing/dispatch-command/invalid-offset":
    "The UTC offset does not match the chosen time",
  "api/marketing/dispatch-command/invalid-offset-description":
    "Use an offset such as -06:00 that applies at that time.",
  "api/marketing/dispatch-command/invalid-scheduled-at":
    "The send time is not valid",
  "api/marketing/dispatch-command/invalid-scheduled-at-description":
    "Use a local date and time such as 2026-11-03T09:30.",
  "api/marketing/dispatch-command/invalid-time-zone":
    "The time zone is not valid",
  "api/marketing/dispatch-command/invalid-time-zone-description":
    "Use an IANA zone such as America/Mexico_City.",
  "api/marketing/dispatch-command/nonexistent-local-time":
    "That local time does not exist in the chosen time zone",
  "api/marketing/dispatch-command/nonexistent-local-time-description":
    "The clocks skip this time. Choose a different time.",
  "api/marketing/dispatch-command/not-ready":
    "This campaign cannot be sent yet",
  "api/marketing/dispatch-command/not-ready-description":
    "Resolve the readiness problems and try again.",
  "api/marketing/dispatch-command/schedule-in-past":
    "The send time must be in the future",
  "api/marketing/dispatch-command/schedule-in-past-description":
    "Choose a later time.",
  "api/marketing/dispatch-command/schedule-too-far":
    "The send time is too far ahead",
  "api/marketing/dispatch-command/schedule-too-far-description":
    "Choose a time within the next 90 days.",
  "api/marketing/dispatch-command/still-draining": "The send is still stopping",
  "api/marketing/dispatch-command/still-draining-description":
    "Wait until it is paused, then resume it.",
  "api/marketing/dispatch-command/test-recipient-not-allowed":
    "A test recipient is not on the allowed list",
  "api/marketing/dispatch-command/test-recipient-not-allowed-description":
    "Add the address to the test recipients in the marketing policy.",
  "api/marketing/dispatch-command/test-recipient-suppressed":
    "A test recipient is suppressed",
  "api/marketing/dispatch-command/test-recipient-suppressed-description":
    "Choose a different address.",
  "api/marketing/dispatch-command/test-recipients-invalid":
    "The test recipients are not valid",
  "api/marketing/dispatch-command/test-recipients-invalid-description":
    "Provide between 1 and 5 valid email addresses.",
  "api/marketing/dispatch-command/version-conflict":
    "The send changed before this action was applied",
  "api/marketing/dispatch-command/version-conflict-description":
    "Reload the send and try again.",
  "api/marketing/dispatch-field-immutable":
    "This dispatch value cannot be changed",
  "api/marketing/dispatch-field-immutable-description":
    "Schedule a new dispatch instead of editing a frozen value.",
  "api/marketing/dispatch-run/invalid-field":
    "A dispatch run value is not valid",
  "api/marketing/dispatch-run/invalid-field-description":
    "Check the run values and try again.",
  "api/marketing/dispatch-state-write-forbidden":
    "The dispatch state cannot be written directly",
  "api/marketing/dispatch-state-write-forbidden-description":
    "Use a dispatch command to change its state.",
  "api/marketing/dispatch/illegal-transition":
    "The dispatch cannot move to that state",
  "api/marketing/dispatch/illegal-transition-description":
    "Reload the dispatch and use an action available in its current state.",
  "api/marketing/dispatch/invalid-field": "A dispatch value is not valid",
  "api/marketing/dispatch/invalid-field-description":
    "Check the dispatch values and try again.",
  "api/marketing/dispatch/invalid-input": "The dispatch change is invalid",
  "api/marketing/dispatch/invalid-input-description":
    "Check the values sent and try again.",
  "api/marketing/dispatch/invalid-set": "That dispatch field cannot be changed",
  "api/marketing/dispatch/invalid-set-description":
    "Only the fields of the dispatch workflow can be updated.",
  "api/marketing/dispatch/run-dispatch-not-found": "The dispatch was not found",
  "api/marketing/dispatch/run-dispatch-not-found-description":
    "Check that the dispatch belongs to this company.",
  "api/marketing/exclusion-actor-forbidden": "Invalid exclusion actor",
  "api/marketing/exclusion-actor-forbidden-description":
    "The exclusion must identify the authenticated operator.",
  "api/marketing/exclusion-already-lifted":
    "This exclusion has already been removed. Refresh the membership list.",
  "api/marketing/exclusion-already-lifted-description":
    "This exclusion has already been removed. Refresh the membership list.",
  "api/marketing/exclusion-delete-not-allowed":
    "Exclusion history cannot be deleted",
  "api/marketing/exclusion-delete-not-allowed-description":
    "Lift the exclusion to allow membership again while preserving its history.",
  "api/marketing/exclusion-immutable": "Exclusion evidence cannot be changed",
  "api/marketing/exclusion-immutable-description":
    "Create or lift an exclusion using the authorized actions.",
  "api/marketing/exclusion-removal-forbidden": "Exclusion cannot be lifted",
  "api/marketing/exclusion-removal-forbidden-description":
    "An authenticated operator must explicitly lift an active exclusion.",
  "api/marketing/group-not-found": "The group was not found in this company.",
  "api/marketing/group-not-found-description":
    "The group was not found in this company.",
  "api/marketing/import/cell-too-large": "A CSV cell exceeds the allowed size.",
  "api/marketing/import/cell-too-large-description":
    "A CSV cell exceeds the allowed size.",
  "api/marketing/import/commit-key-conflict":
    "This import key is already in use. Open the existing import or start a new one.",
  "api/marketing/import/commit-key-conflict-description":
    "This import key is already in use. Open the existing import or start a new one.",
  "api/marketing/import/company-scope":
    "The import and its rows must belong to the selected company.",
  "api/marketing/import/company-scope-description":
    "The import and its rows must belong to the selected company.",
  "api/marketing/import/file-too-large":
    "The CSV exceeds the allowed file size.",
  "api/marketing/import/file-too-large-description":
    "The CSV exceeds the allowed file size.",
  "api/marketing/import/forbidden":
    "You do not have permission to import contacts.",
  "api/marketing/import/forbidden-description":
    "You do not have permission to import contacts.",
  "api/marketing/import/import-in-progress":
    "This import is still being processed.",
  "api/marketing/import/import-in-progress-description":
    "Wait a moment and try again. The import continues where it stopped.",
  "api/marketing/import/invalid-headers":
    "The CSV must have valid, unique column headers.",
  "api/marketing/import/invalid-headers-description":
    "The CSV must have valid, unique column headers.",
  "api/marketing/import/invalid-input":
    "Check the import request and try again.",
  "api/marketing/import/invalid-input-description":
    "Check the import request and try again.",
  "api/marketing/import/invalid-limits":
    "The import limits must be within the supported range.",
  "api/marketing/import/invalid-limits-description":
    "The import limits must be within the supported range.",
  "api/marketing/import/invalid-mapping":
    "Map one column to email and use each destination field only once.",
  "api/marketing/import/invalid-mapping-description":
    "Map one column to email and use each destination field only once.",
  "api/marketing/import/invalid-pagination":
    "The requested import page is invalid.",
  "api/marketing/import/invalid-pagination-description":
    "The requested import page is invalid.",
  "api/marketing/import/malformed-csv":
    "The CSV contains invalid quoting or row separators.",
  "api/marketing/import/malformed-csv-description":
    "The CSV contains invalid quoting or row separators.",
  "api/marketing/import/not-found": "The import was not found in this company.",
  "api/marketing/import/not-found-description":
    "The import was not found in this company.",
  "api/marketing/import/not-validated":
    "Resolve all validation errors before committing the import.",
  "api/marketing/import/not-validated-description":
    "Resolve all validation errors before committing the import.",
  "api/marketing/import/service-only":
    "Use the import workflow to change this record.",
  "api/marketing/import/service-only-description":
    "Use the import workflow to change this record.",
  "api/marketing/import/storage-unavailable":
    "Private import storage is unavailable. Try again later or contact an administrator.",
  "api/marketing/import/storage-unavailable-description":
    "Private import storage is unavailable. Try again later or contact an administrator.",
  "api/marketing/import/too-many-columns":
    "The CSV contains more columns than allowed.",
  "api/marketing/import/too-many-columns-description":
    "The CSV contains more columns than allowed.",
  "api/marketing/import/too-many-rows":
    "The CSV exceeds the allowed number of rows. Split it into smaller imports.",
  "api/marketing/import/too-many-rows-description":
    "The CSV exceeds the allowed number of rows. Split it into smaller imports.",
  "api/marketing/import/unsupported-encoding":
    "Save the CSV with UTF-8 encoding and try again.",
  "api/marketing/import/unsupported-encoding-description":
    "Save the CSV with UTF-8 encoding and try again.",
  "api/marketing/import/wrong-column-count":
    "A CSV row has a different number of columns than its header.",
  "api/marketing/import/wrong-column-count-description":
    "A CSV row has a different number of columns than its header.",
  "api/marketing/invalid-membership-selection":
    "Select valid lists and groups from the current company.",
  "api/marketing/invalid-membership-selection-description":
    "Select valid lists and groups from the current company.",
  "api/marketing/lists/candidate-limit-exceeded": "List query limit reached",
  "api/marketing/lists/candidate-limit-exceeded-description":
    "This directory exceeds the supported scan limit.",
  "api/marketing/lists/consistent-snapshot-required":
    "Consistent read required",
  "api/marketing/lists/consistent-snapshot-required-description":
    "Retry this operation with a fresh consistent snapshot.",
  "api/marketing/lists/contact-not-found": "Contact not found",
  "api/marketing/lists/contact-not-found-description":
    "A selected contact is unavailable in this company.",
  "api/marketing/lists/forbidden": "List access denied",
  "api/marketing/lists/forbidden-description":
    "You do not have access to this list operation or its required fields.",
  "api/marketing/lists/invalid-input": "Invalid list input",
  "api/marketing/lists/invalid-input-description":
    "Provide a list name and an optional text description without additional fields.",
  "api/marketing/lists/invalid-members": "Invalid members",
  "api/marketing/lists/invalid-members-description":
    "Select between 1 and 100 contacts.",
  "api/marketing/lists/invalid-page": "Invalid page",
  "api/marketing/lists/invalid-page-description":
    "Use a nonnegative offset and a page size between 1 and 100.",
  "api/marketing/lists/invalid-search": "Search term required",
  "api/marketing/lists/invalid-search-description":
    "Enter a contact name or email address to search.",
  "api/marketing/lists/not-found": "List not found",
  "api/marketing/lists/not-found-description":
    "The requested list is unavailable in this company.",
  "api/marketing/lists/read-committed-required":
    "Write transaction unavailable",
  "api/marketing/lists/read-committed-required-description":
    "Retry this change in a new read-committed transaction.",
  "api/marketing/membership-immutable": "Membership identity cannot be changed",
  "api/marketing/membership-immutable-description":
    "Remove the membership and create the intended one.",
  "api/marketing/membership-limit-exceeded":
    "The selection exceeds the recipient limit. Reduce the selection.",
  "api/marketing/membership-limit-exceeded-description":
    "The selection exceeds the recipient limit. Reduce the selection.",
  "api/marketing/module-disabled":
    "This module is not enabled for your company.",
  "api/marketing/outbox-invalid-transition":
    "The outbox entry cannot move to that state",
  "api/marketing/outbox-invalid-transition-description":
    "Only the documented outbox transitions are allowed.",
  "api/marketing/outbox-not-found": "The dispatch has no outbox entry",
  "api/marketing/outbox-not-found-description":
    "Schedule the dispatch before resuming it.",
  "api/marketing/outbox/invalid-field": "An outbox value is not valid",
  "api/marketing/outbox/invalid-field-description":
    "Check the outbox values and try again.",
  "api/marketing/policy/invalid-first-batch-size":
    "The first batch size is invalid",
  "api/marketing/policy/invalid-first-batch-size-description":
    "Enter a positive whole number within the campaign recipient limit.",
  "api/marketing/policy/invalid-limit": "The configured limit is invalid",
  "api/marketing/policy/invalid-limit-description":
    "Use a positive whole number within the supported limit.",
  "api/marketing/policy/invalid-observation-hold":
    "The observation hold is invalid",
  "api/marketing/policy/invalid-observation-hold-description":
    "Enter zero or a positive whole number of minutes.",
  "api/marketing/policy/invalid-test-recipients":
    "The test recipient list is invalid",
  "api/marketing/policy/invalid-test-recipients-description":
    "Enter valid email addresses for approved test recipients.",
  "api/marketing/policy/test-recipient-limit-exceeded":
    "Too many test recipients",
  "api/marketing/policy/test-recipient-limit-exceeded-description":
    "Reduce the list to the configured test recipient limit.",
  "api/marketing/preference-token/category-not-optional":
    "This category cannot be unsubscribed from",
  "api/marketing/preference-token/category-not-optional-description":
    "A one-click token can only be issued for a category that allows unsubscribing.",
  "api/marketing/preference-token/immutable-field":
    "This token cannot be modified",
  "api/marketing/preference-token/immutable-field-description":
    "Revoke and reissue the token instead of changing an existing row.",
  "api/marketing/preference-token/missing-category":
    "A category is required for this token",
  "api/marketing/preference-token/missing-category-description":
    "A one-click token must be scoped to exactly one category.",
  "api/marketing/preference-token/missing-requested-changes":
    "No requested changes were provided",
  "api/marketing/preference-token/missing-requested-changes-description":
    "An opt-in confirmation token needs at least one requested category.",
  "api/marketing/preference-token/no-company-url":
    "This company has no branding host configured",
  "api/marketing/preference-token/no-company-url-description":
    "A company-level URL record is required before a preference link can be issued.",
  "api/marketing/preference-token/no-instance":
    "The instance for this link could not be determined",
  "api/marketing/preference-token/no-instance-description":
    "Issue the token inside an instance-bound context.",
  "api/marketing/preferences/category-not-optional":
    "Category preference cannot be changed",
  "api/marketing/preferences/category-not-optional-description":
    "Choose an active optional category and submit each category once.",
  "api/marketing/preferences/invalid-input": "Invalid preference changes",
  "api/marketing/preferences/invalid-input-description":
    "Provide valid preference changes and the current revision.",
  "api/marketing/preferences/invalid-token": "This link is no longer valid",
  "api/marketing/preferences/invalid-token-description":
    "The link may have expired or already been used. Request a new one from a recent email.",
  "api/marketing/preferences/unavailable":
    "Preferences are temporarily unavailable",
  "api/marketing/preferences/unavailable-description":
    "Please try again later.",
  "api/marketing/provider-binding/adapter-key-required":
    "A provider adapter is required",
  "api/marketing/provider-binding/adapter-key-required-description":
    "Select the configured provider adapter.",
  "api/marketing/provider-binding/invalid-rate-ceiling":
    "The provider rate limit is invalid",
  "api/marketing/provider-binding/invalid-rate-ceiling-description":
    "Enter a positive rate or leave the override empty.",
  "api/marketing/readiness/audience-empty":
    "The campaign has no audience selected.",
  "api/marketing/readiness/authority-revoked":
    "The person who scheduled this send no longer has permission to send campaigns.",
  "api/marketing/readiness/binding-not-ready":
    "The sender connection is not ready to send.",
  "api/marketing/readiness/category-disabled":
    "The campaign category is disabled or no longer exists.",
  "api/marketing/readiness/dispatch-not-found":
    "The send was not found in this company.",
  "api/marketing/readiness/hold-active":
    "An active hold is blocking this send.",
  "api/marketing/readiness/launch-readiness-failed":
    "A sending readiness check is failing. Review the deliverability settings.",
  "api/marketing/readiness/missed-window":
    "The scheduled time passed more than 30 minutes ago, so the send was not started.",
  "api/marketing/readiness/module-disabled":
    "Marketing is not enabled for this company.",
  "api/marketing/readiness/operational-eligibility-missing":
    "This operational category has no eligibility source configured, so it cannot be sent.",
  "api/marketing/readiness/prefetched-input-missing":
    "A required status check could not be completed. Try again shortly.",
  "api/marketing/readiness/provider-sending-paused":
    "The email provider account is not allowed to send right now.",
  "api/marketing/readiness/revision-drifted":
    "Something this revision was approved with has changed (category, audience definition, sender, brand profile or template). Prepare a new revision and approve it again.",
  "api/marketing/readiness/revision-not-approved":
    "The campaign revision is not approved. Approve this exact revision before sending.",
  "api/marketing/readiness/revision-not-current":
    "This is not the current revision of the campaign.",
  "api/marketing/readiness/revision-not-found":
    "The campaign revision was not found in this company.",
  "api/marketing/readiness/revision-not-ready":
    "The campaign revision is not ready to send. Fix its validation errors first.",
  "api/marketing/readiness/sender-not-ready":
    "The sender or its provider connection is not ready to send.",
  "api/marketing/readiness/subject-not-static":
    "The subject cannot contain personalization placeholders.",
  "api/marketing/readiness/template-version-missing":
    "The template version used by this campaign is no longer available.",
  "api/marketing/recipient-invalid-transition":
    "The recipient cannot move to that state",
  "api/marketing/recipient-invalid-transition-description":
    "Only the documented delivery transitions are allowed.",
  "api/marketing/recipient/invalid-field": "A recipient value is not valid",
  "api/marketing/recipient/invalid-field-description":
    "Check the recipient values and try again.",
  "api/marketing/resources/bootstrap-version-not-downloadable":
    "This resource cannot be downloaded or republished",
  "api/marketing/resources/bootstrap-version-not-downloadable-description":
    "This version references an already-hosted image and has no private original to download or republish.",
  "api/marketing/resources/bootstrap-version-not-publishable":
    "This resource cannot be published again",
  "api/marketing/resources/bootstrap-version-not-publishable-description":
    "This version references an already-hosted image and has no private original to publish. It already has its own publication from the bootstrap step.",
  "api/marketing/revision-conflict": "This record has changed",
  "api/marketing/revision-conflict-description":
    "Reload the latest version before saving your changes.",
  "api/marketing/sender/binding-required": "Select a provider binding",
  "api/marketing/sender/binding-required-description":
    "An institutional sender must be linked to a provider binding.",
  "api/marketing/sender/invalid-display-name": "Enter a display name",
  "api/marketing/sender/invalid-display-name-description":
    "The institutional name shown to recipients cannot be blank.",
  "api/marketing/sender/invalid-from-email": "Enter a valid from address",
  "api/marketing/sender/invalid-from-email-description":
    "The from address must be a valid institutional email.",
  "api/marketing/sender/invalid-reply-to": "Enter a valid reply-to address",
  "api/marketing/sender/invalid-reply-to-description":
    "The reply-to address must be a valid institutional email.",
  "api/marketing/sender/invalid-verification-state":
    "Invalid verification outcome",
  "api/marketing/sender/invalid-verification-state-description":
    "The verification outcome must be a recognized readiness state.",
  "api/marketing/sender/not-send-ready": "This sender is not ready to send",
  "api/marketing/sender/not-send-ready-description":
    "Only a verified and enabled sender can become the company default.",
  "api/marketing/service-write-required": "Use the available action",
  "api/marketing/service-write-required-description":
    "This record can only be changed through its dedicated action.",
  "api/marketing/source-binding/invalid-allowed-fields":
    "The source field configuration is invalid.",
  "api/marketing/source-binding/invalid-allowed-fields-description":
    "The source field configuration is invalid.",
  "api/marketing/template-version-immutable":
    "A saved version cannot be changed",
  "api/marketing/template-version-immutable-description":
    "Save a new version instead of editing a past one.",
  "api/marketing/template/category-missing":
    "This template has no communication category",
  "api/marketing/template/category-missing-description":
    "Assign a communication category before previewing or sending this template.",
  "api/marketing/template/fallback-references-variable":
    "A fallback cannot reference another variable",
  "api/marketing/template/fallback-references-variable-description":
    "Use a plain fallback value instead of a personalization token.",
  "api/marketing/template/header-injection":
    "Subject and preheader cannot contain line breaks",
  "api/marketing/template/header-injection-description":
    "Remove any line breaks from the subject or preheader.",
  "api/marketing/template/invalid-category": "Invalid communication category",
  "api/marketing/template/invalid-category-description":
    "Choose a communication category that belongs to your company.",
  "api/marketing/template/invalid-current-version": "Invalid current version",
  "api/marketing/template/invalid-current-version-description":
    "The selected version must belong to this same template.",
  "api/marketing/template/invalid-input": "Some fields are missing or invalid",
  "api/marketing/template/invalid-input-description":
    "Check the subject, HTML source and personalization variables.",
  "api/marketing/template/invalid-name": "A template name is required",
  "api/marketing/template/invalid-name-description":
    "Enter a name to identify this template.",
  "api/marketing/template/invalid-subject": "A subject line is required",
  "api/marketing/template/invalid-subject-description":
    "Enter the subject recipients will see.",
  "api/marketing/template/invalid-version-number": "Invalid version number",
  "api/marketing/template/invalid-version-number-description":
    "Version numbers are assigned automatically; do not set one manually.",
  "api/marketing/template/missing-contact":
    "A recipient is required for a production render",
  "api/marketing/template/missing-contact-description":
    "Preview or test-send modes do not require a real recipient.",
  "api/marketing/template/not-found": "Template not found",
  "api/marketing/template/not-found-description":
    "This template does not exist or you do not have access to it.",
  "api/marketing/template/oversized-source":
    "This content is too large or too deeply nested",
  "api/marketing/template/oversized-source-description":
    "Reduce the HTML size or simplify its nesting before saving this version.",
  "api/marketing/template/placeholder-not-allowed-here":
    "This variable cannot be used here",
  "api/marketing/template/placeholder-not-allowed-here-description":
    "Variables are only allowed inside plain text content or as the entire value of a link (href) attribute.",
  "api/marketing/template/preference-token-pending-integration":
    "Sending is not available yet",
  "api/marketing/template/preference-token-pending-integration-description":
    "Preference-token issuance is not deployed on this environment yet.",
  "api/marketing/template/reserved-variable-name":
    "This variable name is reserved",
  "api/marketing/template/reserved-variable-name-description":
    'Names starting with "system." are reserved for the platform footer and identity block.',
  "api/marketing/template/version-not-found": "Template version not found",
  "api/marketing/template/version-not-found-description":
    "This version does not exist or you do not have access to it.",
  "api/marketing/unauthenticated": "Sign in required",
  "api/marketing/unauthenticated-description":
    "Marketing is not available to unauthenticated requests.",
  "api/models/Address/company-not-found": "Company not found",
  "api/models/Address/company-not-found-description": "Company not found",
  "api/models/Address/coordinates-invalid": "Invalid coordinates",
  "api/models/Address/coordinates-invalid-description":
    "The latitude and longitude are not valid.",
  "api/models/Address/country-not-enabled": "Country not enabled",
  "api/models/Address/country-not-enabled-description":
    "Addresses are not enabled for country {{country}}.",
  "api/models/Address/country-profile-missing": "Country profile missing",
  "api/models/Address/country-profile-missing-description":
    "There is no address profile for country {{country}}.",
  "api/models/Address/country-required": "Country required",
  "api/models/Address/country-required-description":
    "The address needs a country.",
  "api/models/Address/entity-id-is-required": "Entity Id is required",
  "api/models/Address/entity-id-is-required-description":
    "Entity Id is required",
  "api/models/Address/entity-not-found": "Entity not found",
  "api/models/Address/entity-not-found-description": "Entity not found",
  "api/models/Address/geo-attempt-server-only":
    "Geocoding schedule is managed by the server",
  "api/models/Address/geo-attempt-server-only-description":
    "The geocoding attempt time cannot be set by a request.",
  "api/models/Address/geo-entry-not-found": "Place not found",
  "api/models/Address/geo-entry-not-found-description":
    "The selected place is not in the geographic catalogue.",
  "api/models/Address/geo-source-invalid": "Invalid geographic source",
  "api/models/Address/geo-source-invalid-description":
    "The geographic source {{source}} is not valid.",
  "api/models/Address/geo-source-server-only":
    "Geographic source managed by the server",
  "api/models/Address/geo-source-server-only-description":
    "Only the geocoding service can mark an address as geocoded.",
  "api/models/Address/geocode-query-invalid": "Search text invalid",
  "api/models/Address/geocode-query-invalid-description":
    "Enter between 1 and 200 characters to search for an address.",
  "api/models/Address/geocode-unavailable": "Address search unavailable",
  "api/models/Address/geocode-unavailable-description":
    "The address search could not be completed. Try again later.",
  "api/models/Address/geocoding-disabled": "Address search unavailable",
  "api/models/Address/geocoding-disabled-description":
    "Address search is not enabled on this platform.",
  "api/models/Address/not-configured": "Addresses not configured",
  "api/models/Address/not-configured-description":
    "Address settings have not been configured for this company.",
  "api/models/Address/owner-company-unresolved": "Company not resolved",
  "api/models/Address/owner-company-unresolved-description":
    "The company of the owner record could not be determined.",
  "api/models/Address/owner-id-required": "Owner required",
  "api/models/Address/owner-id-required-description":
    "An address must belong to a record.",
  "api/models/Address/owner-immutable": "Owner cannot change",
  "api/models/Address/owner-immutable-description":
    "The owner of an address cannot be changed.",
  "api/models/Address/owner-model-not-allowed": "Owner not allowed",
  "api/models/Address/owner-model-not-allowed-description":
    "This kind of record cannot own addresses.",
  "api/models/Address/owner-not-found": "Owner not found",
  "api/models/Address/owner-not-found-description":
    "The record that owns this address was not found.",
  "api/models/Address/postal-code-invalid": "Invalid postal code",
  "api/models/Address/postal-code-invalid-description":
    "The value of {{component}} is not a valid postal code.",
  "api/models/Address/purpose-unknown": "Unknown purpose",
  "api/models/Address/purpose-unknown-description":
    "The address purpose {{purpose}} is not recognized.",
  "api/models/Address/required-missing": "Address incomplete",
  "api/models/Address/required-missing-description":
    "Missing required address fields: {{components}}.",
  "api/models/Address/settings-invalid": "Address settings invalid",
  "api/models/Address/settings-invalid-description":
    "The address settings are malformed.",
  "api/models/Address/value-too-long": "Value too long",
  "api/models/Address/value-too-long-description":
    "The value of {{component}} is too long.",
  "api/models/AddressCountryProfile/invalid-shape": "Invalid country profile",
  "api/models/AddressCountryProfile/invalid-shape-description":
    "The field {{field}} of the address country profile is invalid: {{problem}}.",
  "api/models/AddressCountryProfile/write-forbidden":
    "Address country profiles are changed only by migration",
  "api/models/AddressCountryProfile/write-forbidden-description":
    "These rows cannot be created, edited or deleted through the API.",
  "api/models/AgentKey/assignments-outside-validity":
    "The key has assignments outside the new validity",
  "api/models/AgentKey/assignments-outside-validity-description":
    "Close or shorten the {{count}} assignment(s) of this key before narrowing its validity",
  "api/models/AgentKey/code-already-exists": "The key already exists",
  "api/models/AgentKey/code-already-exists-description":
    "The insurer already has the key {{code}}",
  "api/models/AgentKey/code-is-required": "Agent key code is required",
  "api/models/AgentKey/code-is-required-description":
    "Capture the key exactly as the insurer issued it",
  "api/models/AgentKey/company-is-required": "Company is required",
  "api/models/AgentKey/company-is-required-description":
    "An agent key needs the company it belongs to",
  "api/models/AgentKey/company-mismatch": "Company not allowed",
  "api/models/AgentKey/company-mismatch-description":
    "An agent key belongs to the company you are working in",
  "api/models/AgentKey/delete-not-allowed": "Agent keys are not deleted",
  "api/models/AgentKey/delete-not-allowed-description":
    "Retire the key instead: it stays in the history",
  "api/models/AgentKey/holder-not-canonical-agency": "Invalid key holder",
  "api/models/AgentKey/holder-not-canonical-agency-description":
    "The holder must be the agency legal entity of this company, not one of its positions",
  "api/models/AgentKey/immutable-field": "Field cannot be changed",
  "api/models/AgentKey/immutable-field-description":
    "The insurer and the holder of a key cannot change; end the key and record a new one",
  "api/models/AgentKey/insurer-not-appointed": "Insurer is not designated",
  "api/models/AgentKey/insurer-not-appointed-description":
    "Agent keys can only be recorded for designated insurers",
  "api/models/AgentKey/key-has-assignments": "The key has assignments",
  "api/models/AgentKey/key-has-assignments-description":
    "End the key instead of deleting it, so its history is kept",
  "api/models/AgentKey/mutation-not-allowed": "Operation not allowed",
  "api/models/AgentKey/mutation-not-allowed-description":
    "Agent keys are changed one at a time",
  "api/models/AgentKey/retire-forbidden": "You cannot retire this key",
  "api/models/AgentKey/retire-forbidden-description":
    "Only a company administrator can retire an agent key",
  "api/models/AgentKey/validity-invalid": "Invalid validity",
  "api/models/AgentKey/validity-invalid-description":
    "The start date is required and the end date cannot be before it",
  "api/models/AgentKeyAssignment/conflict":
    "The position already has a key in force",
  "api/models/AgentKeyAssignment/conflict-description":
    "{{node}} already uses the key {{code}} at this insurer in that period",
  "api/models/AgentKeyAssignment/immutable-field": "Field cannot be changed",
  "api/models/AgentKeyAssignment/immutable-field-description":
    "Only the validity of an assignment can change",
  "api/models/AgentKeyAssignment/key-not-found": "Agent key not found",
  "api/models/AgentKeyAssignment/key-not-found-description":
    "The key does not exist in this company",
  "api/models/AgentKeyAssignment/mutation-not-allowed": "Operation not allowed",
  "api/models/AgentKeyAssignment/mutation-not-allowed-description":
    "Assignments are changed one at a time",
  "api/models/AgentKeyAssignment/node-not-holder-position": "Invalid position",
  "api/models/AgentKeyAssignment/node-not-holder-position-description":
    "A key can only be assigned to its holder or to one of its positions",
  "api/models/AgentKeyAssignment/outside-key-validity":
    "Outside the key validity",
  "api/models/AgentKeyAssignment/outside-key-validity-description":
    "An assignment must fall within the validity of its key",
  "api/models/AgentKeyAssignment/validity-invalid": "Invalid validity",
  "api/models/AgentKeyAssignment/validity-invalid-description":
    "The start date is required and the end date cannot be before it",
  "api/models/ApiToken/entity-not-found": "Entity Not Found",
  "api/models/ApiToken/entity-not-found-description":
    "The specified entity does not exist.",
  "api/models/ApiToken/entity-required": "Entity Required",
  "api/models/ApiToken/entity-required-description":
    "An API token must be associated with an entity.",
  "api/models/ApiToken/token-fields-restricted":
    "Token fields can only change through token actions.",
  "api/models/ApiToken/token-fields-restricted-description":
    "TokenVersion and EntityId can only change through generate-token or regenerate-token.",
  "api/models/ApiToken/token-secret-not-configured":
    "Token Configuration Error",
  "api/models/ApiToken/token-secret-not-configured-description":
    "The JWT token signing secret is not configured. Contact your administrator.",
  "api/models/ApiTokenRole/account-not-found": "Account Not Found",
  "api/models/ApiTokenRole/account-not-found-description":
    "The specified account does not exist.",
  "api/models/ApiTokenRole/agency-not-found": "Agency Not Found",
  "api/models/ApiTokenRole/agency-not-found-description":
    "The specified agency does not exist.",
  "api/models/ApiTokenRole/already-assigned": "Role Already Assigned",
  "api/models/ApiTokenRole/already-assigned-description":
    "This role is already assigned to the API token.",
  "api/models/ApiTokenRole/company-not-found": "Company Not Found",
  "api/models/ApiTokenRole/company-not-found-description":
    "The specified company does not exist.",
  "api/models/ApiTokenRole/exceeds-parent-permissions":
    "Exceeds Parent Permissions",
  "api/models/ApiTokenRole/exceeds-parent-permissions-description":
    "The token role exceeds the parent entity permissions. A token cannot have higher access than its owner.",
  "api/models/ApiTokenRole/multiple-scope-fks": "Invalid Scope",
  "api/models/ApiTokenRole/multiple-scope-fks-description":
    "Only one of CompanyId, AccountId, or AgencyId may be specified.",
  "api/models/ApiTokenRole/not-an-agency": "Not an Agency",
  "api/models/ApiTokenRole/not-an-agency-description":
    "The specified entity is not an agency.",
  "api/models/ApiTokenRole/role-not-active": "Role Not Active",
  "api/models/ApiTokenRole/role-not-active-description":
    "The specified role is not active.",
  "api/models/ApiTokenRole/role-not-found": "Role Not Found",
  "api/models/ApiTokenRole/role-not-found-description":
    "The specified role does not exist.",
  "api/models/ApiTokenRole/scope-mismatch": "Scope Mismatch",
  "api/models/ApiTokenRole/scope-mismatch-description":
    "The scope foreign key does not match the role scope type.",
  "api/models/ApiTokenRole/token-not-found": "API Token Not Found",
  "api/models/ApiTokenRole/token-not-found-description":
    "The specified API token does not exist.",
  "api/models/AuditEvent/append-only": "Audit events cannot be changed",
  "api/models/AuditEvent/append-only-description":
    "Audit records are append-only.",
  "api/models/AuditEvent/trail-forbidden": "Not Allowed to Read This History",
  "api/models/AuditEvent/trail-forbidden-description":
    "Only an administrator of the company who may read the record can read its history.",
  "api/models/AuditEvent/trail-invalid": "Invalid Audit Trail Request",
  "api/models/AuditEvent/trail-invalid-description":
    "Name the model and the id of the record whose history you want to read.",
  "api/models/AuditEvent/trail-target-not-allowed":
    "History Not Available for This Model",
  "api/models/AuditEvent/trail-target-not-allowed-description":
    "The history of this kind of record cannot be read.",
  "api/models/AuditEvent/trail-target-not-found": "Record Not Found",
  "api/models/AuditEvent/trail-target-not-found-description":
    "The record does not exist in the company.",
  "api/models/CatalogueDefinition/invalid-management":
    "Invalid Management Declaration",
  "api/models/CatalogueDefinition/invalid-management-description":
    'Management must be null or { owner: "ingest", availability: boolean }.',
  "api/models/CatalogueDefinition/managed-structure-forbidden":
    "Managed Catalogue Change Forbidden",
  "api/models/CatalogueDefinition/managed-structure-forbidden-description":
    "A managed catalogue and its attributes are maintained by the automatic update and cannot be changed or deleted here.",
  "api/models/CatalogueDefinition/management-forbidden":
    "Management Change Forbidden",
  "api/models/CatalogueDefinition/management-forbidden-description":
    "Only a super administrator may change a catalogue Management declaration.",
  "api/models/CatalogueEntry/attribute-not-writable": "Attribute not editable",
  "api/models/CatalogueEntry/attribute-not-writable-description":
    "Your role cannot change this attribute",
  "api/models/CatalogueEntry/availability-not-managed":
    "This Catalogue Has No Availability Control",
  "api/models/CatalogueEntry/availability-not-managed-description":
    "Only the versions of a catalogue that declares availability can be switched on or off.",
  "api/models/CatalogueEntry/constraint-violation":
    "Catalogue entry constraint violation",
  "api/models/CatalogueEntry/constraint-violation-description":
    "This entry does not meet a required condition of its catalogue.",
  "api/models/CatalogueEntry/definition-not-found": "Catalogue Not Found",
  "api/models/CatalogueEntry/definition-not-found-description":
    "The catalogue does not exist in the company.",
  "api/models/CatalogueEntry/definition-not-program-manageable":
    "Program administrators cannot manage this catalogue",
  "api/models/CatalogueEntry/definition-not-program-manageable-description":
    "Only platform administrators can create, edit or delete entries in this catalogue.",
  "api/models/CatalogueEntry/entry-not-found": "Catalogue Entry Not Found",
  "api/models/CatalogueEntry/entry-not-found-description":
    "This entry no longer exists in the company.",
  "api/models/CatalogueEntry/invalid-constraint-descriptor":
    "Invalid catalogue constraint descriptor",
  "api/models/CatalogueEntry/invalid-constraint-descriptor-description":
    "A constraint declared on this catalogue is missing its type.",
  "api/models/CatalogueEntry/managed-write-forbidden":
    "The entries of a managed catalogue are changed only by the ingestion engine",
  "api/models/CatalogueEntry/managed-write-forbidden-description":
    "Entries of a catalogue kept up to date from an external source cannot be created, changed, enabled, disabled or deleted through the generic data API.",
  "api/models/CatalogueEntry/not-owned":
    "This catalogue entry cannot be changed from this program",
  "api/models/CatalogueEntry/not-owned-description":
    "The entry belongs to the whole company or to another program. Ask a platform administrator to change it.",
  "api/models/CatalogueEntry/options-invalid": "Invalid Catalogue Query",
  "api/models/CatalogueEntry/options-invalid-description":
    "Check the catalogue, the filters and the page of the request.",
  "api/models/CatalogueEntry/resolve-references-invalid-model":
    "Unsupported model for catalogue reference resolution",
  "api/models/CatalogueEntry/resolve-references-invalid-model-description":
    "Catalogue references can only be resolved for a Policy or a SubjectMatterInstance.",
  "api/models/CatalogueEntry/resolve-references-not-found": "Record not found",
  "api/models/CatalogueEntry/resolve-references-not-found-description":
    "The record does not exist or is not visible to you.",
  "api/models/CatalogueEntry/set-availability-forbidden":
    "Not Allowed to Change Availability",
  "api/models/CatalogueEntry/set-availability-forbidden-description":
    "Only an administrator of the company may switch a version of its catalogue on or off.",
  "api/models/CatalogueEntry/set-availability-invalid":
    "Invalid Availability Change",
  "api/models/CatalogueEntry/set-availability-invalid-description":
    "State only whether the version is enabled, as true or false.",
  "api/models/CatalogueEntry/unknown-constraint-type":
    "Unknown catalogue constraint type",
  "api/models/CatalogueEntry/unknown-constraint-type-description":
    "A constraint declared on this catalogue has an unrecognized type.",
  "api/models/CatalogueEntryExternalRef/catalogue-entry-id-is-required":
    "Catalogue entry is required",
  "api/models/CatalogueEntryExternalRef/catalogue-entry-id-is-required-description":
    "An external reference must point to a catalogue entry",
  "api/models/CatalogueEntryExternalRef/catalogue-entry-not-found":
    "Catalogue entry not found",
  "api/models/CatalogueEntryExternalRef/catalogue-entry-not-found-description":
    "The referenced catalogue entry does not exist",
  "api/models/CatalogueEntryExternalRef/duplicate-identity":
    "Duplicate source identity",
  "api/models/CatalogueEntryExternalRef/duplicate-identity-description":
    "A live reference already exists for that system, code and qualifier",
  "api/models/CatalogueEntryExternalRef/duplicate-system-key":
    "Duplicate external reference",
  "api/models/CatalogueEntryExternalRef/duplicate-system-key-description":
    "This catalogue entry already has a reference for that system",
  "api/models/CatalogueEntryExternalRef/external-id-is-required":
    "External identifier is required",
  "api/models/CatalogueEntryExternalRef/external-id-is-required-description":
    "An external reference must carry the external system identifier",
  "api/models/CatalogueEntryExternalRef/managed-write-forbidden":
    "Catalogue source references are changed only by the ingestion engine",
  "api/models/CatalogueEntryExternalRef/managed-write-forbidden-description":
    "These records cannot be created, edited or deleted through the generic data API.",
  "api/models/CatalogueEntryExternalRef/system-key-is-required":
    "System key is required",
  "api/models/CatalogueEntryExternalRef/system-key-is-required-description":
    "An external reference must declare its source system key",
  "api/models/CatalogueIngestMapping/managed-write-forbidden":
    "The catalogue name dictionary is changed only by the ingestion engine",
  "api/models/CatalogueIngestMapping/managed-write-forbidden-description":
    "These records cannot be created, edited or deleted through the generic data API.",
  "api/models/CatalogueIngestMapping/normalize-forbidden":
    "Not Allowed to Change the Dictionary",
  "api/models/CatalogueIngestMapping/normalize-forbidden-description":
    "Only an administrator of the company may set the brand and model names of its catalogue dictionary.",
  "api/models/CatalogueIngestMapping/normalize-invalid":
    "Invalid Dictionary Entry",
  "api/models/CatalogueIngestMapping/normalize-invalid-description":
    "The brand and the model need a name of 1 to 120 characters, and the request must state whether the model name is included and the revision that was edited.",
  "api/models/CatalogueIngestMapping/revision-conflict":
    "Dictionary Entry Changed",
  "api/models/CatalogueIngestMapping/revision-conflict-description":
    "Someone else changed this dictionary entry. Reload it and apply your change again.",
  "api/models/CatalogueIngestRecord/managed-write-forbidden":
    "Catalogue source records are changed only by the ingestion engine",
  "api/models/CatalogueIngestRecord/managed-write-forbidden-description":
    "These records cannot be created, edited or deleted through the generic data API.",
  "api/models/CatalogueUpdateRun/admin-forbidden":
    "Not Allowed to Update the Catalogue",
  "api/models/CatalogueUpdateRun/admin-forbidden-description":
    "Only an administrator of the company may start or preview a catalogue update.",
  "api/models/CatalogueUpdateRun/company-required": "A company is required",
  "api/models/CatalogueUpdateRun/company-required-description":
    "Choose the company whose catalogue is updated.",
  "api/models/CatalogueUpdateRun/invalid-field": "Invalid update run field",
  "api/models/CatalogueUpdateRun/invalid-field-description":
    "A field has a missing or malformed value (Counts and Errors have a fixed shape).",
  "api/models/CatalogueUpdateRun/not-configured":
    "Catalogue update is not configured",
  "api/models/CatalogueUpdateRun/not-configured-description":
    "This company has no valid catalogue source configuration.",
  "api/models/CatalogueUpdateRun/run-closed": "Update run is closed",
  "api/models/CatalogueUpdateRun/run-closed-description":
    "Status, Counts and Errors no longer change once it has finished.",
  "api/models/CatalogueUpdateRun/super-admin-forbidden":
    "Not Allowed to Load the Reference Data",
  "api/models/CatalogueUpdateRun/super-admin-forbidden-description":
    "Only a super administrator may start the load of the shared reference data of this instance.",
  "api/models/CatalogueUpdateRun/write-forbidden":
    "Catalogue update runs are changed only by the ingestion engine",
  "api/models/CatalogueUpdateRun/write-forbidden-description":
    "These records cannot be created, edited or deleted through the generic data API.",
  "api/models/CatalogueUpdateRun/year-range-invalid": "Invalid year range",
  "api/models/CatalogueUpdateRun/year-range-invalid-description":
    "Give both years as whole numbers, the first not after the second, from the earliest year the sources can supply to next year.",
  "api/models/CatalogueUpdateRunPortion/invalid-field":
    "Invalid update run portion field",
  "api/models/CatalogueUpdateRunPortion/invalid-field-description":
    "A field has a missing or malformed value (Counts and Errors have a fixed shape).",
  "api/models/CatalogueUpdateRunPortion/portion-closed":
    "Update run portion is closed",
  "api/models/CatalogueUpdateRunPortion/portion-closed-description":
    "Status, Counts and Errors no longer change once it has finished.",
  "api/models/CatalogueUpdateRunPortion/write-forbidden":
    "Catalogue update run portions are changed only by the ingestion engine",
  "api/models/CatalogueUpdateRunPortion/write-forbidden-description":
    "These records cannot be created, edited or deleted through the generic data API.",
  "api/models/ComissionTable/entity-id-is-required": "Entity Id is required",
  "api/models/ComissionTable/entity-not-found": "Entity not found",
  "api/models/ComissionTable/invalid-component":
    "The commission table component is invalid.",
  "api/models/ComissionTable/invalid-component-description":
    "Agency tables need an agency; cedent tables need a program, a cedent and a rate.",
  "api/models/CommunicationContact/entity-owned-field-read-only":
    "This field comes from the Entity directory",
  "api/models/CommunicationContact/entity-owned-field-read-only-description":
    "Edit the source Entity to change its name or address.",
  "api/models/Company/country-is-required": "Country is required",
  "api/models/Company/country-is-required-description":
    "A company must have a country",
  "api/models/Company/country-not-found": "Country not found",
  "api/models/Company/country-not-found-description":
    "The specified country does not exist",
  "api/models/Company/id-already-exists": "Id already exists",
  "api/models/Company/id-already-exists-description":
    "A company with the provided Id already exists.",
  "api/models/Company/id-required": "Id is required",
  "api/models/Company/id-required-description":
    "An Id is required when creating a new Company",
  "api/models/Company/id-update-not-allowed": "Id update not allowed",
  "api/models/Company/id-update-not-allowed-description":
    "Once the Id for a company is set, it cannot be changed.",
  "api/models/Company/maximum-parent-companies-reached":
    "Maximum parent companies reached",
  "api/models/Company/maximum-parent-companies-reached-description":
    "Maximum parent companies reached",
  "api/models/Company/parent-company-not-found": "Parent company not found",
  "api/models/Company/parent-company-not-found-description":
    "The parent company was not found",
  "api/models/Company/parents-cant-be-directly-modyfied":
    "Can't be directly modified",
  "api/models/Company/parents-cant-be-directly-modyfied-description":
    "Parent fields can't be directly modified. You must only modify the ParentId field and the other fields will be automatically updated.",
  "api/models/Company/tax-id-already-exists": "Tax Id already exists",
  "api/models/Company/tax-id-already-exists-description":
    "There is already a company registred with the provided Tax Id",
  "api/models/CoverageDefinition/definition-id-is-required":
    "Subject matter definition is required",
  "api/models/CoverageDefinition/definition-id-is-required-description":
    "Provide the SubjectMatterDefinitionId this coverage belongs to.",
  "api/models/CoverageDefinition/definition-not-found":
    "Subject matter definition not found",
  "api/models/CoverageDefinition/definition-not-found-description":
    "The referenced SubjectMatterDefinition does not exist.",
  "api/models/CoverageDefinition/duplicate-slug": "Duplicate coverage slug",
  "api/models/CoverageDefinition/duplicate-slug-description":
    "A coverage with this slug already exists for this subject matter definition and line of business.",
  "api/models/CoverageDefinition/line-of-business-below-proposal-start":
    "Line of business is below a proposal-start line of business",
  "api/models/CoverageDefinition/line-of-business-below-proposal-start-description":
    "This coverage is declared at a line of business strictly below one that already anchors an active QuoteBridge. Declare it at that line of business or higher.",
  "api/models/CoverageDefinition/line-of-business-id-is-required":
    "Line of business is required",
  "api/models/CoverageDefinition/line-of-business-id-is-required-description":
    "Provide the LineOfBusinessId this coverage is declared at.",
  "api/models/CoverageDefinition/line-of-business-not-found":
    "Line of business not found",
  "api/models/CoverageDefinition/line-of-business-not-found-description":
    "The referenced LineOfBusiness does not exist.",
  "api/models/CoverageDefinition/resolve-inheritance-invalid-body":
    "Subject matter definition is required",
  "api/models/CoverageDefinition/resolve-inheritance-invalid-body-description":
    "Provide the SubjectMatterDefinitionId to resolve coverages for.",
  "api/models/CoverageDefinition/resolve-inheritance-not-found":
    "Subject matter definition not found",
  "api/models/CoverageDefinition/resolve-inheritance-not-found-description":
    "No SubjectMatterDefinition exists with this id.",
  "api/models/Currency/id-is-required": "Id is required",
  "api/models/Currency/id-is-required-description": "Id is required",
  "api/models/DocumentAsset/asset-immutable": "An asset file cannot be changed",
  "api/models/DocumentAsset/asset-immutable-description":
    "Only the name can change; upload a new asset instead.",
  "api/models/DocumentAsset/bulk-write-refused": "Bulk changes are not allowed",
  "api/models/DocumentAsset/bulk-write-refused-description":
    "Change document assets one at a time.",
  "api/models/DocumentAsset/invalid-content-type":
    "This file type is not allowed for the asset kind",
  "api/models/DocumentAsset/invalid-content-type-description":
    "Images take PNG, JPEG, GIF or WebP; backgrounds PNG, JPEG or WebP; fonts TTF or OTF.",
  "api/models/DocumentAsset/invalid-key":
    "The asset file does not belong to this company",
  "api/models/DocumentAsset/invalid-key-description":
    "The storage key is not under the company prefix.",
  "api/models/DocumentAsset/invalid-kind": "Invalid asset kind",
  "api/models/DocumentAsset/invalid-kind-description":
    "Choose image, background or font.",
  "api/models/DocumentAsset/invalid-size": "The file size is not allowed",
  "api/models/DocumentAsset/invalid-size-description":
    "Images and backgrounds up to 10 MiB, fonts up to 5 MiB.",
  "api/models/DocumentAsset/key-required": "The uploaded file is required",
  "api/models/DocumentAsset/key-required-description":
    "Upload the file before registering the asset.",
  "api/models/DocumentAsset/system-super-admin-only":
    "Only a super admin can change a system asset",
  "api/models/DocumentAsset/system-super-admin-only-description":
    "System assets are shared by every company.",
  "api/models/DocumentAvailability/invalid-audience": "Invalid audience",
  "api/models/DocumentAvailability/invalid-audience-description":
    "Audience must be a list of known viewer roles.",
  "api/models/DocumentAvailability/invalid-definition":
    "Invalid document definition",
  "api/models/DocumentAvailability/invalid-definition-description":
    "The availability must belong to an existing document definition.",
  "api/models/DocumentAvailability/invalid-line-of-business":
    "Invalid line of business",
  "api/models/DocumentAvailability/invalid-line-of-business-description":
    "The line of business must belong to the same company as the definition.",
  "api/models/DocumentAvailability/invalid-precondition":
    "Invalid precondition",
  "api/models/DocumentAvailability/invalid-precondition-description":
    "Each precondition must be an object with a known kind.",
  "api/models/DocumentAvailability/too-many-rows": "Too many availability rows",
  "api/models/DocumentAvailability/too-many-rows-description":
    "A document may have at most 200 availability rows.",
  "api/models/DocumentDefinition/bulk-write-refused":
    "Bulk changes are not allowed",
  "api/models/DocumentDefinition/bulk-write-refused-description":
    "Change document definitions one at a time.",
  "api/models/DocumentDefinition/company-id-immutable":
    "A document definition cannot change company",
  "api/models/DocumentDefinition/company-id-immutable-description":
    "The company of a definition is fixed when it is created.",
  "api/models/DocumentDefinition/invalid-current-version":
    "Invalid current version",
  "api/models/DocumentDefinition/invalid-current-version-description":
    "The current version must be a published version of this definition.",
  "api/models/DocumentDefinition/invalid-letterhead":
    "Invalid fixed letterhead",
  "api/models/DocumentDefinition/invalid-letterhead-description":
    "A fixed letterhead must be the instance default or belong to the same company.",
  "api/models/DocumentDefinition/invalid-slug":
    "The document definition needs a slug",
  "api/models/DocumentDefinition/invalid-slug-description":
    "Provide a non-empty slug.",
  "api/models/DocumentDefinition/revision-conflict":
    "The document definition was changed by someone else",
  "api/models/DocumentDefinition/revision-conflict-description":
    "Reload the definition and try again.",
  "api/models/DocumentDefinitionVersion/invalid-definition":
    "The document definition does not exist",
  "api/models/DocumentDefinitionVersion/invalid-definition-description":
    "The version must belong to an existing definition.",
  "api/models/DocumentDefinitionVersion/version-immutable":
    "A published version cannot be changed",
  "api/models/DocumentDefinitionVersion/version-immutable-description":
    "Save a new draft instead of editing a published or retired version.",
  "api/models/DocumentEngine/write-forbidden":
    "Document engine records are changed only by the engine",
  "api/models/DocumentEngine/write-forbidden-description":
    "These records cannot be created, edited or deleted through the generic data API.",
  "api/models/DocumentTemplate/scope-change-not-allowed":
    "This record cannot be moved to another company.",
  "api/models/ERAircraft/age-rate-not-found": "Age rate not found",
  "api/models/ERAircraft/age-rate-not-found-description": "Age rate not found",
  "api/models/ERAircraft/base-rate-not-found": "Base rate not found",
  "api/models/ERAircraft/base-rate-not-found-description":
    "Base rate not found",
  "api/models/ERAircraft/could-not-get-year": "Could not get year",
  "api/models/ERAircraft/could-not-get-year-description": "Could not get year",
  "api/models/ERAircraft/create-response-invalid": "Aircraft creation failed",
  "api/models/ERAircraft/create-response-invalid-description":
    "The server returned an incomplete response — please try again",
  "api/models/ERAircraft/endorsement-fetch-failed":
    "Failed to load aircraft endorsement",
  "api/models/ERAircraft/endorsement-fetch-failed-description":
    "Could not retrieve the aircraft endorsement record — please try again",
  "api/models/ERAircraft/entity-id-is-required": "Entity Id is required",
  "api/models/ERAircraft/entity-id-is-required-description":
    "Entity Id is required",
  "api/models/ERAircraft/entity-not-found": "Entity not found",
  "api/models/ERAircraft/entity-not-found-description": "Entity not found",
  "api/models/ERAircraft/no-agency-hierarchy":
    "Cannot create aircraft without agency information",
  "api/models/ERAircraft/no-agency-hierarchy-description":
    "Neither the policy nor the entity has agency hierarchy data — contact support",
  "api/models/ERAircraft/policy-not-found": "Policy not found",
  "api/models/ERAircraft/policy-not-found-description": "Policy not found",
  "api/models/ERAircraft/usage-not-found": "Usage not found",
  "api/models/ERAircraft/usage-not-found-description": "Usage not found",
  "api/models/ERAircraft/voluntary-settlements-rate-not-found":
    "Voluntary Settlements Rate not found",
  "api/models/ERAircraft/voluntary-settlements-rate-not-found-description":
    "Voluntary Settlements Rate not found",
  "api/models/ERAircraftProposal/age-rate-not-found": "Age rate not found",
  "api/models/ERAircraftProposal/age-rate-not-found-description":
    "No age rate matches the aircraft age and policy dates",
  "api/models/ERAircraftProposal/aircraft-id-missing":
    "Aircraft is required to create a proposal",
  "api/models/ERAircraftProposal/aircraft-id-missing-description":
    "The aircraft must be created before the proposal — please go back and try again",
  "api/models/ERAircraftProposal/aircraft-not-found": "Aircraft not found",
  "api/models/ERAircraftProposal/aircraft-not-found-description":
    "The aircraft referenced by the proposal was not found",
  "api/models/ERAircraftProposal/base-rate-not-found": "Base rate not found",
  "api/models/ERAircraftProposal/base-rate-not-found-description":
    "No base rate matches the hull value and policy dates",
  "api/models/ERAircraftProposal/cargo-rate-not-found":
    "Cargo liability rate not found",
  "api/models/ERAircraftProposal/cargo-rate-not-found-description":
    "No cargo liability rate matches the selected limit",
  "api/models/ERAircraftProposal/cmp-rate-not-found":
    "Crew medical payments rate not found",
  "api/models/ERAircraftProposal/cmp-rate-not-found-description":
    "No crew medical payments rate matches the selected limit",
  "api/models/ERAircraftProposal/create-response-invalid":
    "Aircraft proposal creation failed",
  "api/models/ERAircraftProposal/create-response-invalid-description":
    "The server returned an incomplete response — please try again",
  "api/models/ERAircraftProposal/cvs-rate-not-found":
    "Crew voluntary settlements rate not found",
  "api/models/ERAircraftProposal/cvs-rate-not-found-description":
    "No crew voluntary settlements rate matches the selected limit",
  "api/models/ERAircraftProposal/geographic-limit-not-defined":
    "Geographic limit not defined",
  "api/models/ERAircraftProposal/geographic-limit-not-defined-description":
    "A geographic limit is required to quote hull coverage",
  "api/models/ERAircraftProposal/hangar-rate-not-found":
    "Hangar liability rate not found",
  "api/models/ERAircraftProposal/hangar-rate-not-found-description":
    "No hangar liability rate matches the selected limit",
  "api/models/ERAircraftProposal/invalid-in-force-date":
    "Invalid In Force Date",
  "api/models/ERAircraftProposal/invalid-in-force-date-description":
    "The policy In Force Date is missing or invalid",
  "api/models/ERAircraftProposal/liability-rate-not-found":
    "Liability rate not found",
  "api/models/ERAircraftProposal/liability-rate-not-found-description":
    "No liability rate matches the selected limit and policy dates",
  "api/models/ERAircraftProposal/limit-rate-not-found":
    "Geographic limit rate not found",
  "api/models/ERAircraftProposal/limit-rate-not-found-description":
    "No rate matches the selected geographic limit",
  "api/models/ERAircraftProposal/luggage-rate-not-found":
    "Luggage liability rate not found",
  "api/models/ERAircraftProposal/luggage-rate-not-found-description":
    "No luggage liability rate matches the selected limit",
  "api/models/ERAircraftProposal/missing-scope": "Proposal scope error",
  "api/models/ERAircraftProposal/missing-scope-description":
    "The policy is missing company information — contact support",
  "api/models/ERAircraftProposal/pmp-rate-not-found":
    "Passenger medical payments rate not found",
  "api/models/ERAircraftProposal/pmp-rate-not-found-description":
    "No passenger medical payments rate matches the selected limit",
  "api/models/ERAircraftProposal/policy-not-found": "Policy not found",
  "api/models/ERAircraftProposal/policy-not-found-description":
    "The policy referenced by the proposal was not found",
  "api/models/ERAircraftProposal/pvs-rate-not-found":
    "Passenger voluntary settlements rate not found",
  "api/models/ERAircraftProposal/pvs-rate-not-found-description":
    "No passenger voluntary settlements rate matches the selected limit",
  "api/models/ERAircraftProposal/spare-parts-limit-exceeded":
    "Spare parts limit exceeded",
  "api/models/ERAircraftProposal/spare-parts-limit-exceeded-description":
    "The spare parts limit exceeds the maximum allowed",
  "api/models/ERAircraftProposal/spare-parts-ratio-exceeded":
    "Spare parts ratio exceeded",
  "api/models/ERAircraftProposal/spare-parts-ratio-exceeded-description":
    "The spare parts limit to hull value ratio exceeds the maximum allowed",
  "api/models/ERAircraftProposal/usage-rates-not-found":
    "Usage rates not found",
  "api/models/ERAircraftProposal/usage-rates-not-found-description":
    "No usage rates match the selected usages and policy dates",
  "api/models/ERAircraftProposal/war-risk-rate-not-found":
    "War risk rate not found",
  "api/models/ERAircraftProposal/war-risk-rate-not-found-description":
    "No war risk rate matches the hull value and policy dates",
  "api/models/Entity/access-flags-restricted":
    "Only platform administrators can change account access flags.",
  "api/models/Entity/access-flags-restricted-description":
    "Changing the login, test-account or revocation flags requires a company administrator for this account, or a platform administrator.",
  "api/models/Entity/account-admin-read-only": "Account Admin is read-only",
  "api/models/Entity/account-admin-read-only-description":
    "The Account Admin field is computed and cannot be updated directly",
  "api/models/Entity/account-employee-read-only":
    "Account Employee is read-only",
  "api/models/Entity/account-employee-read-only-description":
    "The Account Employee field is computed and cannot be updated directly",
  "api/models/Entity/account-manager-read-only": "Account Manager is read-only",
  "api/models/Entity/account-manager-read-only-description":
    "The Account Manager field is computed and cannot be updated directly",
  "api/models/Entity/account-user-read-only": "Account User is read-only",
  "api/models/Entity/account-user-read-only-description":
    "The Account User field is computed and cannot be updated directly",
  "api/models/Entity/agency-admin-read-only": "Agency Admin is read-only",
  "api/models/Entity/agency-admin-read-only-description":
    "The Agency Admin field is computed and cannot be updated directly",
  "api/models/Entity/agency-employee-read-only": "Agency Employee is read-only",
  "api/models/Entity/agency-employee-read-only-description":
    "The Agency Employee field is computed and cannot be updated directly",
  "api/models/Entity/agency-has-hierarchy-children":
    "This agency has agencies under it",
  "api/models/Entity/agency-has-hierarchy-children-description":
    "Move the agencies under this agency to another parent agency before deleting it.",
  "api/models/Entity/agency-manager-read-only": "Agency Manager is read-only",
  "api/models/Entity/agency-manager-read-only-description":
    "The Agency Manager field is computed and cannot be updated directly",
  "api/models/Entity/agency-user-read-only": "Agency User is read-only",
  "api/models/Entity/agency-user-read-only-description":
    "The Agency User field is computed and cannot be updated directly",
  "api/models/Entity/anagram-read-only": "Anagram is read-only",
  "api/models/Entity/anagram-read-only-description":
    "The Anagram field is computed and cannot be updated directly",
  "api/models/Entity/appearance-invalid": "Choose Light, Dark or Auto.",
  "api/models/Entity/appearance-invalid-description":
    "The appearance preference must be light, dark, auto or empty.",
  "api/models/Entity/appearance-self-only":
    "You can only change your own appearance preference.",
  "api/models/Entity/appearance-self-only-description":
    "This action sets the calling user’s own Light/Dark/Auto preference and cannot target another account.",
  "api/models/Entity/appearance-write-restricted":
    "The appearance preference can only be changed by its owner.",
  "api/models/Entity/appearance-write-restricted-description":
    "Appearance is a personal Light/Dark/Auto preference and can only be changed through the dedicated self-service action, never a generic entity update.",
  "api/models/Entity/cedent-admin-read-only": "Cedent Admin is read-only",
  "api/models/Entity/cedent-admin-read-only-description":
    "The Cedent Admin field is computed and cannot be updated directly",
  "api/models/Entity/cedent-employee-read-only": "Cedent Employee is read-only",
  "api/models/Entity/cedent-employee-read-only-description":
    "The Cedent Employee field is computed and cannot be updated directly",
  "api/models/Entity/cedent-in-use":
    "This cedent is in use and cannot be deleted",
  "api/models/Entity/cedent-in-use-description":
    "This cedent has policies, business, roles or memberships and cannot be deleted.",
  "api/models/Entity/cedent-manager-read-only": "Cedent Manager is read-only",
  "api/models/Entity/cedent-manager-read-only-description":
    "The Cedent Manager field is computed and cannot be updated directly",
  "api/models/Entity/cedent-user-read-only": "Cedent User is read-only",
  "api/models/Entity/cedent-user-read-only-description":
    "The Cedent User field is computed and cannot be updated directly",
  "api/models/Entity/child-entity-readonly": "Child entity is read-only",
  "api/models/Entity/child-entity-readonly-description":
    "Child agency attributes are inherited from the parent. Only the Alias can be modified directly.",
  "api/models/Entity/child-hierarchy-invalid": "Invalid hierarchy level",
  "api/models/Entity/child-hierarchy-invalid-description":
    "Child agency must be at a hierarchy level below its parent agency.",
  "api/models/Entity/cognito-config-not-available":
    "Login email changes require Cognito configuration.",
  "api/models/Entity/company-admin-read-only": "Company Admin is read-only",
  "api/models/Entity/company-admin-read-only-description":
    "The Company Admin field is computed and cannot be updated directly",
  "api/models/Entity/company-employee-read-only":
    "Company Employee is read-only",
  "api/models/Entity/company-employee-read-only-description":
    "The Company Employee field is computed and cannot be updated directly",
  "api/models/Entity/company-id-is-required": "Company Id is required",
  "api/models/Entity/company-id-is-required-description":
    "Company Id is required when creating a new Entity.",
  "api/models/Entity/company-manager-read-only": "Company Manager is read-only",
  "api/models/Entity/company-manager-read-only-description":
    "The Company Manager field is computed and cannot be updated directly",
  "api/models/Entity/company-not-found": "Company not found",
  "api/models/Entity/company-not-found-description":
    "The provided company was not found when trying to create a new Entity.",
  "api/models/Entity/company-user-read-only": "Company User is read-only",
  "api/models/Entity/company-user-read-only-description":
    "The Company User field is computed and cannot be updated directly",
  "api/models/Entity/country-is-required": "Country is required",
  "api/models/Entity/country-is-required-description":
    "Natural and legal entities must have a country",
  "api/models/Entity/country-not-found": "Country not found",
  "api/models/Entity/country-not-found-description":
    "The specified country does not exist",
  "api/models/Entity/duplicate-entity": "Duplicate entity",
  "api/models/Entity/duplicate-entity-description":
    "An entity with the same information already exists",
  "api/models/Entity/email-already-exists": "Email already registered",
  "api/models/Entity/email-already-exists-description":
    "Another person or company is already registered with this email.",
  "api/models/Entity/email-is-not-valid": "Email is not valid",
  "api/models/Entity/email-is-not-valid-description": "Email is not valid",
  "api/models/Entity/external-id-already-exists":
    "Another insurer already has this external ID.",
  "api/models/Entity/external-id-already-exists-description":
    "The external ID must be unique among insurers. Check the value or use the existing record.",
  "api/models/Entity/external-id-is-required": "The external ID is required.",
  "api/models/Entity/external-id-is-required-description":
    "Enter the external ID for this insurer to continue.",
  "api/models/Entity/external-id-not-allowed":
    "The external ID cannot be set or changed.",
  "api/models/Entity/external-id-not-allowed-description":
    "Only a company administrator for this account, or a platform administrator, can set or change the external ID.",
  "api/models/Entity/hidden-read-only": "Hidden is read-only",
  "api/models/Entity/hidden-read-only-description":
    "The Hidden field is computed and cannot be updated directly",
  "api/models/Entity/hierarchy-parent-invalid": "Invalid parent agency",
  "api/models/Entity/hierarchy-parent-invalid-description":
    "The parent agency must be an agency of the same company, with a hierarchy level above this one, and must not be this agency or one of the agencies under it.",
  "api/models/Entity/id-can-not-be-modified": "Id can not be modified",
  "api/models/Entity/id-can-not-be-modified-description":
    "Id can not be modified",
  "api/models/Entity/identity-parent-invalid": "Invalid legal entity",
  "api/models/Entity/identity-parent-invalid-description":
    "An alias must belong to a main agency legal entity of the same company, not to another alias.",
  "api/models/Entity/immutable-field": "Field cannot be changed",
  "api/models/Entity/login-email-change-disabled-in-environment":
    "Login email changes are not available in this environment.",
  "api/models/Entity/login-email-change-disabled-in-environment-description":
    "The Cognito user pools are shared across environments; this action only mutates them in production.",
  "api/models/Entity/login-email-change-forbidden":
    "You cannot change this user's login email.",
  "api/models/Entity/login-email-change-forbidden-description":
    "Changing another user’s login email requires holding every company of the target, and an admin target requires superAdmin.",
  "api/models/Entity/login-email-change-restricted":
    "The login email can only be changed with the dedicated action.",
  "api/models/Entity/login-email-change-restricted-description":
    "A generic update cannot change the login email of a user with an existing sign-in identity.",
  "api/models/Entity/login-email-in-use":
    "That email is already used by another login.",
  "api/models/Entity/login-email-in-use-description":
    "Choose a different email address.",
  "api/models/Entity/login-email-invalid": "Enter a valid, different email.",
  "api/models/Entity/login-email-invalid-description":
    "The new login email must be a valid address, different from the current one.",
  "api/models/Entity/national-id-already-exists": "National Id already exists",
  "api/models/Entity/national-id-already-exists-description":
    "There is already an entity registred with the provided National Id",
  "api/models/Entity/not-a-token-entity": "Invalid Entity Type",
  "api/models/Entity/not-a-token-entity-description":
    "Token regeneration is only available for token-type entities.",
  "api/models/Entity/out-of-scope": "This record is outside your access scope.",
  "api/models/Entity/out-of-scope-description":
    "This account or role assignment is outside the companies, agencies or cedents you have access to.",
  "api/models/Entity/participation-canonical-not-eligible":
    "The selected organization is not available for this participation",
  "api/models/Entity/participation-canonical-not-eligible-description":
    "The selected organization is not one of the canonical agencies available to you for this creation.",
  "api/models/Entity/participation-columns-read-only":
    "The platform manages participation level, program and program root",
  "api/models/Entity/participation-columns-read-only-description":
    "Participation level, program and program-root are set by the platform and cannot be written directly.",
  "api/models/Entity/participation-defaults-missing":
    "The program configuration required to create this agency is incomplete",
  "api/models/Entity/participation-defaults-missing-description":
    "The program is missing the configuration this new participation needs (lines of business, currencies or commission terms).",
  "api/models/Entity/participation-identity-required":
    "Look up the identifier, select an existing organization or create a new one",
  "api/models/Entity/participation-identity-required-description":
    "Resolve the legal identity of a new participation by identifier lookup, an existing organization or a new record.",
  "api/models/Entity/participation-in-use":
    "This participation is in use and cannot be deleted",
  "api/models/Entity/participation-in-use-description":
    "This participation has hierarchy links, business, roles or memberships and cannot be deleted.",
  "api/models/Entity/participation-level-immutable":
    "The hierarchy level of a participation cannot be changed",
  "api/models/Entity/participation-level-immutable-description":
    "A participation’s hierarchy level cannot be changed once set.",
  "api/models/Entity/participation-level-not-creatable":
    "Participations can only be created at agency levels 3, 2 and 1",
  "api/models/Entity/participation-level-not-creatable-description":
    "Program roots and regional containers are created only by platform migrations.",
  "api/models/Entity/participation-not-found":
    "The participation was not found in this program",
  "api/models/Entity/participation-not-found-description":
    "No active participation with this id exists in the current program.",
  "api/models/Entity/participation-parent-not-eligible":
    "The selected parent is not eligible in this program",
  "api/models/Entity/participation-parent-not-eligible-description":
    "The selected parent is not an active participation one level above, in this program.",
  "api/models/Entity/participation-parents-required":
    "Select at least one parent",
  "api/models/Entity/participation-parents-required-description":
    "A participation must have at least one active parent.",
  "api/models/Entity/participation-program-immutable":
    "A participation cannot move to another program",
  "api/models/Entity/participation-program-immutable-description":
    "A participation’s program cannot be changed once set.",
  "api/models/Entity/participation-requires-agency":
    "A participation level requires an agency",
  "api/models/Entity/participation-requires-agency-description":
    "Only agency Entities can carry a participation level.",
  "api/models/Entity/participation-requires-alias":
    "Operational participations must reference their legal entity",
  "api/models/Entity/participation-requires-alias-description":
    "An operational participation (agency 3, 2 or 1) must be an alias of a canonical legal entity.",
  "api/models/Entity/participation-requires-method":
    "Agencies in a program are created through participation creation",
  "api/models/Entity/participation-requires-method-description":
    "In program mode, agency and alias Entities must be created through the create-participation method.",
  "api/models/Entity/program-mode-required":
    "This operation is only available inside a program",
  "api/models/Entity/program-mode-required-description":
    "Hierarchy links can only be managed for a company that operates in program mode.",
  "api/models/Entity/program-root-immutable":
    "The program root flag cannot be changed",
  "api/models/Entity/program-root-immutable-description":
    "Whether a participation is a program root cannot be changed after creation.",
  "api/models/Entity/program-root-invalid":
    "The program reference is not valid",
  "api/models/Entity/program-root-invalid-description":
    "The participation program, level and program-root flag must be consistent with each other.",
  "api/models/Entity/registration/access-denied": "Not authorized",
  "api/models/Entity/registration/access-denied-description":
    "You are not authorized to register entities in this context.",
  "api/models/Entity/registration/already-associated-with-agency":
    "Already registered with this agency",
  "api/models/Entity/registration/already-associated-with-agency-description":
    "This cedent is already registered with this agency.",
  "api/models/Entity/registration/appointed-carrier-not-registrable":
    "Cannot set appointed carrier here",
  "api/models/Entity/registration/appointed-carrier-not-registrable-description":
    "AppointedCarrier cannot be changed through registration.",
  "api/models/Entity/registration/auth-required": "Authentication required",
  "api/models/Entity/registration/auth-required-description":
    "Sign in to use registration.",
  "api/models/Entity/registration/country-not-enabled": "Country not available",
  "api/models/Entity/registration/country-not-enabled-description":
    "Registration is not available yet for this country.",
  "api/models/Entity/registration/duplicate": "Already registered",
  "api/models/Entity/registration/duplicate-description":
    "An insurer with this identifier already exists.",
  "api/models/Entity/registration/identifier-required":
    "Official identifier required",
  "api/models/Entity/registration/identifier-required-description":
    "Cedents and insurers require their official identifier.",
  "api/models/Entity/registration/identity-fields-server-derived":
    "Identity fields are calculated by the platform",
  "api/models/Entity/registration/identity-fields-server-derived-description":
    "Remove normalized identity fields from the request.",
  "api/models/Entity/registration/identity-lookup-token-invalid":
    "Lookup expired",
  "api/models/Entity/registration/identity-lookup-token-invalid-description":
    "Look up the identifier again before continuing.",
  "api/models/Entity/registration/identity-target-invalid":
    "Invalid identity target",
  "api/models/Entity/registration/identity-target-invalid-description":
    "A verified identity can only be applied to an active canonical legal entity.",
  "api/models/Entity/registration/insurer-facet-requires-registration":
    "Use the registration flow",
  "api/models/Entity/registration/insurer-facet-requires-registration-description":
    "Cedents and insurers can only be activated through country-first registration.",
  "api/models/Entity/registration/invalid-context":
    "Registration context required",
  "api/models/Entity/registration/invalid-context-ambiguous-agency":
    "Contact your administrator",
  "api/models/Entity/registration/invalid-context-ambiguous-agency-description":
    "You belong to more than one agency; ask your administrator to register this cedent for the right agency.",
  "api/models/Entity/registration/invalid-context-description":
    "We could not determine where to register this entity.",
  "api/models/Entity/registration/invalid-format": "Invalid identifier",
  "api/models/Entity/registration/invalid-format-description":
    "The identifier does not match the official format or check digit for this country.",
  "api/models/Entity/registration/legal-name-required": "Legal name required",
  "api/models/Entity/registration/legal-name-required-description":
    "Enter the legal name to continue.",
  "api/models/Entity/registration/lookup-failed": "Lookup failed",
  "api/models/Entity/registration/lookup-failed-description":
    "We could not verify the identifier. Try again.",
  "api/models/Entity/registration/member-flow-required": "Program member",
  "api/models/Entity/registration/member-flow-required-description":
    "This insurer is an original member of the program and operates through the member flow.",
  "api/models/Entity/registration/namespace-conflict":
    "Identifier already registered under another jurisdiction",
  "api/models/Entity/registration/namespace-conflict-description":
    "The same official identifier exists under a different country. An authorized correction is required.",
  "api/models/Entity/registration/prohibited-identifier":
    "Generic identifier not allowed",
  "api/models/Entity/registration/prohibited-identifier-description":
    "Generic or shared identifiers cannot be registered; use the entity's own identifier.",
  "api/models/Entity/registration/soft-deleted": "Restoration required",
  "api/models/Entity/registration/soft-deleted-description":
    "This entity was deleted; a user with permission must restore it.",
  "api/models/Entity/registration/stale-save":
    "This identifier was just registered by someone else",
  "api/models/Entity/registration/stale-save-description":
    "A concurrent registration claimed this identifier first. Reload and try again.",
  "api/models/Entity/registration/unavailable": "Registration unavailable",
  "api/models/Entity/registration/unavailable-description":
    "Registration is currently disabled.",
  "api/models/Entity/registration/unexpected-attributes": "Invalid request",
  "api/models/Entity/registration/unexpected-attributes-description":
    "Only legal name, commercial name and incorporation date can be sent.",
  "api/models/Entity/reparent-reserved":
    "Only platform administration can change parents",
  "api/models/Entity/reparent-reserved-description":
    "Changing a participation’s parents is reserved to company-level platform administration.",
  "api/models/Entity/save-policy-party/auth-required":
    "Authentication required",
  "api/models/Entity/save-policy-party/auth-required-description":
    "Sign in to save a party of a policy.",
  "api/models/Entity/save-policy-party/existing-party-out-of-reach":
    "This party already exists",
  "api/models/Entity/save-policy-party/existing-party-out-of-reach-description":
    "A person or company with these details already exists and is outside your access, so it cannot be linked from here. An administrator can link it to the policy.",
  "api/models/Entity/save-policy-party/forbidden": "Party cannot be saved",
  "api/models/Entity/save-policy-party/forbidden-description":
    "You are not allowed to change the parties of this policy.",
  "api/models/Entity/save-policy-party/identity-fields-admin-only":
    "Only an administrator can change this",
  "api/models/Entity/save-policy-party/identity-fields-admin-only-description":
    "The legal name and the incorporation date of an existing company can only be changed by an administrator. The rest of the data can still be saved.",
  "api/models/Entity/save-policy-party/invalid-request":
    "Invalid party request",
  "api/models/Entity/save-policy-party/invalid-request-description":
    "The request names a field this action does not accept.",
  "api/models/Entity/save-policy-party/protected-entity":
    "This record cannot be edited here",
  "api/models/Entity/save-policy-party/protected-entity-description":
    "This person or company is also a user, an agency, a cedent or another kind of record, so its data cannot be changed from a policy.",
  "api/models/Entity/save-policy-party/stale": "The policy changed",
  "api/models/Entity/save-policy-party/stale-description":
    "The policy was changed by someone else while you were saving. Reload it and try again.",
  "api/models/Entity/shared-identity-read-only":
    "Shared legal identity fields cannot be edited.",
  "api/models/Entity/shared-identity-read-only-description":
    "Only a company administrator for this account, or a platform administrator, can change these fields.",
  "api/models/Entity/tax-id-already-exists": "Tax Id already exists",
  "api/models/Entity/tax-id-already-exists-description":
    "An entity with the provided Tax Id already exists.",
  "api/models/Entity/token-secret-not-configured": "Token Configuration Error",
  "api/models/Entity/token-secret-not-configured-description":
    "The JWT token signing secret is not configured. Contact your administrator.",
  "api/models/Entity/type-can-not-be-modified": "Type can not be modified",
  "api/models/Entity/type-can-not-be-modified-description":
    "Type can not be modified.",
  "api/models/Entity/type-is-not-valid": "Entyty type is not valid",
  "api/models/Entity/type-is-not-valid-description":
    'The entity type must be either "natural" or "legal", the provided value is not valid.',
  "api/models/EntityAgencyRegistration/immutable":
    "Registration cannot be changed",
  "api/models/EntityAgencyRegistration/immutable-description":
    "A cedent registration cannot be changed once it is created.",
  "api/models/EntityAgencyRegistration/not-deletable":
    "Registration cannot be deleted",
  "api/models/EntityAgencyRegistration/not-deletable-description":
    "Cedent registrations cannot be deleted.",
  "api/models/EntityAgencyRegistration/registration-service-only":
    "Registration cannot be created here",
  "api/models/EntityAgencyRegistration/registration-service-only-description":
    "Cedent registrations are created only through the registration flow.",
  "api/models/EntityContact/contact-already-linked": "Contact Already Linked",
  "api/models/EntityContact/contact-already-linked-description":
    "This contact is already linked to the entity.",
  "api/models/EntityContact/contact-entity-not-found": "Contact Not Found",
  "api/models/EntityContact/contact-entity-not-found-description":
    "The specified contact entity does not exist.",
  "api/models/EntityContact/contact-must-be-natural":
    "Contact Must Be a Natural Person",
  "api/models/EntityContact/contact-must-be-natural-description":
    "Only natural-type entities can be added as contacts.",
  "api/models/EntityContact/entity-id-required": "Entity ID Required",
  "api/models/EntityContact/entity-id-required-description":
    "EntityId is required to create a contact relationship.",
  "api/models/EntityContact/missing-required-fields": "Missing Required Fields",
  "api/models/EntityContact/missing-required-fields-description":
    "EntityId and ContactId are required to create a contact relationship.",
  "api/models/EntityContact/reports-to-different-entity":
    "Manager Belongs to Different Entity",
  "api/models/EntityContact/reports-to-different-entity-description":
    "The ReportsTo contact must belong to the same entity.",
  "api/models/EntityContact/reports-to-not-found": "Manager Not Found",
  "api/models/EntityContact/reports-to-not-found-description":
    "The specified ReportsTo contact record does not exist or has been removed.",
  "api/models/EntityContact/self-contact-not-allowed":
    "Self-Contact Not Allowed",
  "api/models/EntityContact/self-contact-not-allowed-description":
    "An entity cannot be linked to itself as a contact.",
  "api/models/EntityEmail/email-already-exists": "Email already exists",
  "api/models/EntityEmail/email-already-exists-description":
    "Email already exists",
  "api/models/EntityEmail/entity-email-is-invalid": "Email is not valid",
  "api/models/EntityEmail/entity-email-is-invalid-description":
    "The provided email is not valid.",
  "api/models/EntityEmail/entity-email-is-required": "Entity Email is required",
  "api/models/EntityEmail/entity-email-is-required-description":
    "Entity Email is required when creating a new Entity Email",
  "api/models/EntityEmail/entity-id-is-required": "Entity Id is required",
  "api/models/EntityEmail/entity-id-is-required-description":
    "Entity Id is required when creating a new Entity Email",
  "api/models/EntityEmail/entity-not-found": "Entity not found",
  "api/models/EntityEmail/entity-not-found-description":
    "The provided entity was not found",
  "api/models/EntityFile/entity-id-is-required": "Entity Id is required",
  "api/models/EntityFile/entity-id-is-required-description":
    "Entity Id is required",
  "api/models/EntityFile/entity-not-found": "Entity not found",
  "api/models/EntityFile/entity-not-found-description": "Entity not found",
  "api/models/EntityIdentifierAlias/identity-service-only":
    "Identifier alias cannot be created here",
  "api/models/EntityIdentifierAlias/identity-service-only-description":
    "Identifier aliases are created only by the platform's identity service.",
  "api/models/EntityIdentifierAlias/immutable":
    "Identifier alias cannot be changed",
  "api/models/EntityIdentifierAlias/immutable-description":
    "An identifier alias cannot be changed once it is created.",
  "api/models/EntityIdentifierAlias/not-deletable":
    "Identifier alias cannot be deleted",
  "api/models/EntityIdentifierAlias/not-deletable-description":
    "Identifier aliases cannot be deleted.",
  "api/models/EntityIdentifierDefinition/incomplete-definition":
    "Identifier definition is incomplete",
  "api/models/EntityIdentifierDefinition/incomplete-definition-description":
    "A definition can only be enabled with verified format, checksum policy, fixtures and evidence.",
  "api/models/EntityIdentifierDefinition/migration-only":
    "Identifier definitions are read-only",
  "api/models/EntityIdentifierDefinition/migration-only-description":
    "Identifier definitions are created and changed only by database migrations.",
  "api/models/EntityIdentifierDefinition/unknown-checksum-algorithm":
    "Unknown check-digit algorithm",
  "api/models/EntityIdentifierDefinition/unknown-checksum-algorithm-description":
    "The definition references an algorithm that is not registered.",
  "api/models/EntityPhone/Phone-already-exists": "Phone already exists",
  "api/models/EntityPhone/Phone-already-exists-description":
    "The phone number is already registered. Please use a different one.",
  "api/models/EntityPhone/entity-Phone-is-invalid": "Phone is not valid",
  "api/models/EntityPhone/entity-Phone-is-invalid-description":
    "The provided phone number is not valid",
  "api/models/EntityPhone/entity-Phone-is-required": "Phone is required",
  "api/models/EntityPhone/entity-Phone-is-required-description":
    "Phone is required",
  "api/models/EntityPhone/entity-id-is-required": "Entity Id is required",
  "api/models/EntityPhone/entity-id-is-required-description":
    "Entity Id is required",
  "api/models/EntityPhone/entity-not-found": "Entity not found",
  "api/models/EntityPhone/entity-not-found-description":
    "Could not find the entity with the provided Id",
  "api/models/EntityRegistrationLookup/registration-service-only":
    "Lookup cannot be written here",
  "api/models/EntityRegistrationLookup/registration-service-only-description":
    "Registration lookups are written only by the registration service.",
  "api/models/EntityRegulatoryException/company-id-is-required":
    "A company is required",
  "api/models/EntityRegulatoryException/company-id-is-required-description":
    "The exception must belong to a company.",
  "api/models/EntityRegulatoryException/company-mismatch":
    "The company does not match the request",
  "api/models/EntityRegulatoryException/company-mismatch-description":
    "An exception can only be created for the company of the session.",
  "api/models/EntityRegulatoryException/created-by-is-server-derived":
    "The author of an exception cannot be set",
  "api/models/EntityRegulatoryException/created-by-is-server-derived-description":
    "The author is always the user who creates the exception.",
  "api/models/EntityRegulatoryException/entity-id-is-required":
    "An insurer is required",
  "api/models/EntityRegulatoryException/entity-id-is-required-description":
    "Choose the insurer the exception applies to.",
  "api/models/EntityRegulatoryException/entity-not-found": "Insurer not found",
  "api/models/EntityRegulatoryException/entity-not-found-description":
    "The insurer does not exist or is not an insurer of this company.",
  "api/models/EntityRegulatoryException/ids-are-immutable":
    "The insurer and company cannot be changed",
  "api/models/EntityRegulatoryException/ids-are-immutable-description":
    "Remove the exception and create a new one instead.",
  "api/models/EntityRegulatoryException/note-is-required": "A note is required",
  "api/models/EntityRegulatoryException/note-is-required-description":
    "Explain why this insurer is active although the regulator does not list it.",
  "api/models/EntityRegulatoryException/update-not-allowed":
    "An exception cannot be edited",
  "api/models/EntityRegulatoryException/update-not-allowed-description":
    "Remove the exception and create a new one instead.",
  "api/models/EntityRole/account-not-found": "Account not found",
  "api/models/EntityRole/account-not-found-description":
    "The specified account entity was not found",
  "api/models/EntityRole/agency-assignment-requires-participation":
    "This agency does not belong to a program yet.",
  "api/models/EntityRole/agency-assignment-requires-participation-description":
    "Agency-scope role assignments require the agency to be part of a participation program.",
  "api/models/EntityRole/agency-not-found": "Agency not found",
  "api/models/EntityRole/agency-not-found-description":
    "The specified agency entity was not found",
  "api/models/EntityRole/agency-not-in-company":
    "Agency does not belong to this company",
  "api/models/EntityRole/agency-not-in-company-description":
    "The specified agency is not linked to the current company. Only agencies within your company can be assigned roles.",
  "api/models/EntityRole/assignment-limit-reached":
    "This person already has the maximum number of roles",
  "api/models/EntityRole/assignment-limit-reached-description":
    "This person already holds as many role assignments as this company allows. To change their role, delete the current assignment and then add the new one.",
  "api/models/EntityRole/assignment-mixed-scope-types":
    "Agency and cedent roles cannot be combined",
  "api/models/EntityRole/assignment-mixed-scope-types-description":
    "This person holds a role of the other kind (agency or cedent), and this company does not allow both on the same person. Delete the current role first.",
  "api/models/EntityRole/assignment-options-invalid-body":
    "The person to assign a role to is not valid",
  "api/models/EntityRole/assignment-options-invalid-body-description":
    "Send no body, or an object whose EntityId is the id of the person (text).",
  "api/models/EntityRole/assignment-out-of-scope":
    "This assignment is outside your program authority.",
  "api/models/EntityRole/assignment-out-of-scope-description":
    "A program administrator may only assign or remove agency and cedent roles (below admin) inside their own program.",
  "api/models/EntityRole/cedent-not-found": "Cedent not found",
  "api/models/EntityRole/cedent-not-found-description":
    "The specified cedent entity was not found",
  "api/models/EntityRole/cedent-not-in-program":
    "This cedent does not belong to that program.",
  "api/models/EntityRole/cedent-not-in-program-description":
    "The cedent must be an active member of the program, or registered as an agency in it.",
  "api/models/EntityRole/cedent-not-insurer": "Entity is not an insurer",
  "api/models/EntityRole/cedent-not-insurer-description":
    "The specified entity does not have IsInsurer set to true",
  "api/models/EntityRole/company-account-agency-exclusive":
    "Company, Account, and Agency are mutually exclusive",
  "api/models/EntityRole/company-account-agency-exclusive-description":
    "Only one of CompanyId, AccountId, or AgencyId can be provided",
  "api/models/EntityRole/company-account-or-agency-required":
    "Company, Account, or Agency required",
  "api/models/EntityRole/company-account-or-agency-required-description":
    "Exactly one of CompanyId, AccountId, or AgencyId must be provided",
  "api/models/EntityRole/company-not-found": "Company not found",
  "api/models/EntityRole/company-not-found-description": "Company not found",
  "api/models/EntityRole/company-role-requires-no-program":
    "A company-scope assignment cannot name a program.",
  "api/models/EntityRole/entity-not-agency": "Entity is not an agency",
  "api/models/EntityRole/entity-not-agency-description":
    "The specified entity does not have IsAgency set to true",
  "api/models/EntityRole/entity-not-found": "Entity not found",
  "api/models/EntityRole/entity-not-found-description":
    "The specified entity was not found",
  "api/models/EntityRole/global-role-super-admin-only":
    "Only a super administrator can manage global roles.",
  "api/models/EntityRole/global-role-super-admin-only-description":
    "A role without a company, account, agency or cedent scope can only be assigned or removed by a super administrator.",
  "api/models/EntityRole/program-context-mismatch":
    "The supplied program does not match the request context.",
  "api/models/EntityRole/program-context-mismatch-description":
    "A cedent-scope assignment inside a program request must name that same program.",
  "api/models/EntityRole/program-required":
    "A program is required for this assignment.",
  "api/models/EntityRole/program-required-description":
    "Cedent-scope assignments made outside a request context must name a program explicitly.",
  "api/models/EntityRole/replace-assignment-invalid-body":
    "A removal id and a complete replacement assignment are required.",
  "api/models/EntityRole/replace-assignment-invalid-body-description":
    "The body must carry removeAssignmentId plus create.EntityId and create.RoleId.",
  "api/models/EntityRole/replace-assignment-reserved":
    "This assignment requires company administrator authority.",
  "api/models/EntityRole/replace-assignment-reserved-description":
    "Replacing an assignment requires a company-scope companyAdmin group for the company owning both the removed and the created assignment (or superAdmin).",
  "api/models/EntityRole/reserved-assignment":
    "This assignment requires company administrator authority.",
  "api/models/EntityRole/reserved-assignment-description":
    "Creating or removing a companyAdmin, or an agencyAdmin at a program root, requires a company-scope companyAdmin group for the target company.",
  "api/models/EntityRole/role-already-assigned": "Role already assigned",
  "api/models/EntityRole/role-already-assigned-description":
    "This user already has this role assigned",
  "api/models/EntityRole/role-cant-be-updated": "Role can't be updated",
  "api/models/EntityRole/role-cant-be-updated-description":
    "Roles can't be updated, only added or removed",
  "api/models/EntityRole/role-not-found":
    "The assignment to replace was not found.",
  "api/models/EntityRole/role-not-found-description":
    "The assignment named by removeAssignmentId does not exist or was already removed.",
  "api/models/EntityRole/target-entity-not-found": "Target entity not found",
  "api/models/EntityRole/target-entity-not-found-description":
    "Target entity not found",
  "api/models/ExternalCatalogue/company-id-is-required":
    "The catalogue needs a company",
  "api/models/ExternalCatalogue/company-id-is-required-description":
    "Choose the company that owns the catalogue",
  "api/models/ExternalCatalogue/company-not-allowed": "Company not allowed",
  "api/models/ExternalCatalogue/company-not-allowed-description":
    "You cannot manage catalogues for that company",
  "api/models/ExternalCatalogue/company-not-found": "Company not found",
  "api/models/ExternalCatalogue/company-not-found-description":
    "The company of the catalogue does not exist",
  "api/models/ExternalCatalogue/has-enabled-codes":
    "The catalogue still has enabled codes",
  "api/models/ExternalCatalogue/has-enabled-codes-description":
    "Disable every code before deleting the catalogue",
  "api/models/ExternalCatalogue/immutable-field": "Field cannot be changed",
  "api/models/ExternalCatalogue/immutable-field-description":
    "The key and the company of a catalogue cannot be changed after it is created",
  "api/models/ExternalCatalogue/key-already-exists":
    "Catalogue key already in use",
  "api/models/ExternalCatalogue/key-already-exists-description":
    "This company already has an active catalogue with that key",
  "api/models/ExternalCatalogue/key-invalid": "Invalid catalogue key",
  "api/models/ExternalCatalogue/key-invalid-description":
    "The key may only contain lowercase letters, digits and hyphens",
  "api/models/ExternalCatalogue/key-is-required": "The catalogue needs a key",
  "api/models/ExternalCatalogue/key-is-required-description":
    "Enter a key for the external catalogue",
  "api/models/ExternalCatalogue/name-is-required": "The catalogue needs a name",
  "api/models/ExternalCatalogue/name-is-required-description":
    "Enter a name for the external catalogue",
  "api/models/ExternalCatalogueCode/catalogue-disabled":
    "The catalogue is disabled",
  "api/models/ExternalCatalogueCode/catalogue-disabled-description":
    "Enable the catalogue before adding codes to it",
  "api/models/ExternalCatalogueCode/catalogue-not-found": "Catalogue not found",
  "api/models/ExternalCatalogueCode/catalogue-not-found-description":
    "The external catalogue does not exist or is not available to you",
  "api/models/ExternalCatalogueCode/code-already-assigned":
    "The code is already assigned",
  "api/models/ExternalCatalogueCode/code-already-assigned-description":
    "Another cedent holds that code in this catalogue",
  "api/models/ExternalCatalogueCode/code-is-required": "The code is required",
  "api/models/ExternalCatalogueCode/code-is-required-description":
    "Enter the code assigned to the cedent",
  "api/models/ExternalCatalogueCode/entity-already-has-code":
    "The cedent already has a code",
  "api/models/ExternalCatalogueCode/entity-already-has-code-description":
    "Disable its current code in this catalogue before assigning another",
  "api/models/ExternalCatalogueCode/entity-not-insurer":
    "The cedent is not valid for this catalogue",
  "api/models/ExternalCatalogueCode/entity-not-insurer-description":
    "Choose an active cedent of the same company",
  "api/models/ExternalCatalogueCode/immutable-field": "Field cannot be changed",
  "api/models/ExternalCatalogueCode/immutable-field-description":
    "To correct a code, disable it and assign a new one",
  "api/models/ExternalCatalogueCode/mutation-not-allowed":
    "Operation not allowed",
  "api/models/ExternalCatalogueCode/mutation-not-allowed-description":
    "Codes are disabled, never deleted or changed in bulk",
  "api/models/FileUploadTicket/content-type-not-allowed":
    "This file type is not allowed.",
  "api/models/FileUploadTicket/file-too-large":
    "The file exceeds the maximum size.",
  "api/models/FileUploadTicket/key-not-issued":
    "The uploaded file could not be verified. Upload it again.",
  "api/models/FileUploadTicket/service-only":
    "Upload tickets cannot be changed",
  "api/models/FileUploadTicket/service-only-description":
    "Upload tickets are issued and consumed only by the file service.",
  "api/models/FileUploadTicket/upload-not-authorized":
    "You are not allowed to upload files to this record.",
  "api/models/FormDefinition/invalid-collection-config":
    "Invalid collection configuration",
  "api/models/FormDefinition/invalid-config": "Invalid form configuration",
  "api/models/FormDefinition/reserved-submit-platform-managed":
    "This form action cannot be set",
  "api/models/FormDefinition/reserved-submit-platform-managed-description":
    "Forms that submit a reserved-authority action are set by the platform, not through the API",
  "api/models/FormField/invalid-config": "Invalid form field configuration",
  "api/models/FormRule/invalid-rule": "Invalid form rule",
  "api/models/GeneratedDocument/invalid-definition-version":
    "Invalid definition version",
  "api/models/GeneratedDocument/invalid-definition-version-description":
    "The version must belong to a document definition of the policy company.",
  "api/models/GeneratedDocument/invalid-format": "Invalid document format",
  "api/models/GeneratedDocument/invalid-format-description":
    "Choose PDF or Word.",
  "api/models/GeneratedDocument/invalid-letterhead-version":
    "Invalid letterhead version",
  "api/models/GeneratedDocument/invalid-letterhead-version-description":
    "The letterhead must belong to the policy company or be the instance default.",
  "api/models/GeneratedDocument/invalid-storage-key":
    "The generated file does not belong to this company",
  "api/models/GeneratedDocument/invalid-storage-key-description":
    "The storage key was not issued for this company and subject.",
  "api/models/GeneratedDocument/invalid-subject": "Invalid document subject",
  "api/models/GeneratedDocument/invalid-subject-description":
    "A policy document must refer to its own policy.",
  "api/models/GeneratedDocument/policy-id-required": "A policy is required",
  "api/models/GeneratedDocument/policy-id-required-description":
    "A generated document belongs to one policy.",
  "api/models/GeneratedDocument/policy-not-found": "Policy not found",
  "api/models/GeneratedDocument/policy-not-found-description":
    "The generated document must belong to an existing policy.",
  "api/models/GeneratedDocument/record-immutable":
    "A generated document cannot be changed",
  "api/models/GeneratedDocument/record-immutable-description":
    "Generated documents are append-only; only expiry clears the stored file.",
  "api/models/GeneratedDocument/scope-field-immutable":
    "A scope field cannot be changed",
  "api/models/GeneratedDocument/storage-key-required":
    "The generated file is required",
  "api/models/GeneratedDocument/storage-key-required-description":
    "Store the file before recording the document.",
  "api/models/IndividualVehicleCommissionTable/entity-id-is-required":
    "Entity Id is required",
  "api/models/IndividualVehicleCommissionTable/entity-id-is-required-description":
    "Entity Id is required",
  "api/models/IndividualVehicleCommissionTable/entity-not-found":
    "Entity not found",
  "api/models/IndividualVehicleCommissionTable/entity-not-found-description":
    "Entity not found",
  "api/models/InstanceSetting/bulk-write-forbidden": "Bulk write forbidden",
  "api/models/InstanceSetting/bulk-write-forbidden-description":
    "Instance settings can only be written one row at a time, so each value can be validated.",
  "api/models/InstanceSetting/company-and-key-required":
    "Company and key required",
  "api/models/InstanceSetting/company-and-key-required-description":
    "Instance settings require both a company and a key.",
  "api/models/InstanceSetting/protected-key-forbidden": "Protected Setting",
  "api/models/InstanceSetting/protected-key-forbidden-description":
    "Only a super administrator may change this setting.",
  "api/models/InstanceSetting/sender-forbidden": "Sender change forbidden",
  "api/models/InstanceSetting/sender-forbidden-description":
    "Only a super administrator may set, change or remove the notification sender of a company.",
  "api/models/InstanceSetting/value-invalid": "Invalid setting value",
  "api/models/InstanceSetting/value-invalid-description":
    "The value does not match the shape this setting key requires.",
  "api/models/Letterhead/bulk-write-refused": "Bulk changes are not allowed",
  "api/models/Letterhead/bulk-write-refused-description":
    "Change letterheads one at a time.",
  "api/models/Letterhead/company-required": "A company is required",
  "api/models/Letterhead/company-required-description":
    "Only the default letterhead has no company.",
  "api/models/Letterhead/default-super-admin-only":
    "Only a super admin can change the default letterhead",
  "api/models/Letterhead/default-super-admin-only-description":
    "The instance default letterhead is shared by every company.",
  "api/models/Letterhead/invalid-current-version": "Invalid current version",
  "api/models/Letterhead/invalid-current-version-description":
    "The current version must be a published version of this letterhead.",
  "api/models/Letterhead/invalid-owner": "Invalid letterhead owner",
  "api/models/Letterhead/invalid-owner-description":
    "An agency or cedent letterhead needs an agency or insurer entity of the company; other letterheads take no owner.",
  "api/models/Letterhead/invalid-owner-type": "Invalid letterhead owner type",
  "api/models/Letterhead/invalid-owner-type-description":
    "Choose default, company, agency or cedent.",
  "api/models/Letterhead/owner-immutable": "A letterhead cannot change owner",
  "api/models/Letterhead/owner-immutable-description":
    "The company, owner type and owner are fixed when the letterhead is created.",
  "api/models/Letterhead/revision-conflict":
    "The letterhead was changed by someone else",
  "api/models/Letterhead/revision-conflict-description":
    "Reload the letterhead and try again.",
  "api/models/LetterheadVersion/invalid-letterhead":
    "The letterhead does not exist",
  "api/models/LetterheadVersion/invalid-letterhead-description":
    "The version must belong to an existing letterhead.",
  "api/models/LetterheadVersion/version-immutable":
    "A published letterhead version cannot be changed",
  "api/models/LetterheadVersion/version-immutable-description":
    "Save a new draft instead.",
  "api/models/LineOfBusinessCommissionDefault/invalid-component-rates":
    "Default commission rates do not match the component.",
  "api/models/LineOfBusinessCommissionDefault/invalid-component-rates-description":
    "Agency defaults use level rates; cedent defaults use a single rate.",
  "api/models/LineOfBusinessContentDefinition/identity-fields-are-required":
    "Document, namespace and key are required",
  "api/models/LineOfBusinessContentDefinition/identity-fields-are-required-description":
    "A content definition is identified by its document, namespace and key",
  "api/models/LineOfBusinessContentDefinition/invalid-definition":
    "Invalid content definition",
  "api/models/LineOfBusinessContentDefinition/invalid-definition-description":
    "The content definition is not valid for its document",
  "api/models/LineOfBusinessContentDefinition/line-of-business-id-is-required":
    "Line of business is required",
  "api/models/LineOfBusinessContentDefinition/line-of-business-id-is-required-description":
    "A content definition must belong to a line of business",
  "api/models/LineOfBusinessContentDefinition/line-of-business-not-found":
    "Line of business not found",
  "api/models/LineOfBusinessContentDefinition/line-of-business-not-found-description":
    "The line of business of the content definition does not exist",
  "api/models/LineOfBusinessContentDefinition/unresolvable-definition":
    "Content definition cannot be resolved",
  "api/models/LineOfBusinessContentDefinition/unresolvable-definition-description":
    "A stored content row of this document is misconfigured, so the document cannot be produced. The error data names the row.",
  "api/models/LineOfBusinessContentDefinition/write-forbidden":
    "Content definitions are changed only by migration",
  "api/models/LineOfBusinessContentDefinition/write-forbidden-description":
    "These rows cannot be created, edited or deleted through the API.",
  "api/models/LineOfBusinessReport/scope-change-not-allowed":
    "This record cannot be moved to another company.",
  "api/models/MotorQuote/missing-scope": "Quote scope missing",
  "api/models/MotorQuote/missing-scope-description":
    "The parent proposal carries no company scope.",
  "api/models/MotorQuote/policy-id-is-required": "Policy required",
  "api/models/MotorQuote/policy-id-is-required-description":
    "A Motor quote must belong to a proposal.",
  "api/models/MotorQuote/policy-not-found": "Proposal not found",
  "api/models/MotorQuote/policy-not-found-description":
    "The proposal this quote belongs to does not exist.",
  "api/models/MotorQuoteCoverage/coverage-definition-mismatch":
    "Coverage definition does not match",
  "api/models/MotorQuoteCoverage/coverage-definition-mismatch-description":
    "The given CoverageDefinitionId must match the resolved SubjectMatterCoverage's own CoverageDefinitionId.",
  "api/models/MotorQuoteCoverage/coverage-definition-not-found":
    "Coverage definition not found",
  "api/models/MotorQuoteCoverage/coverage-definition-not-found-description":
    "The referenced CoverageDefinition does not exist.",
  "api/models/MotorQuoteCoverage/duplicate-coverage":
    "Duplicate coverage rating result",
  "api/models/MotorQuoteCoverage/duplicate-coverage-description":
    "A rating result has already been created for this motor quote and subject matter coverage.",
  "api/models/MotorQuoteCoverage/motor-quote-id-is-required":
    "Motor quote is required",
  "api/models/MotorQuoteCoverage/motor-quote-id-is-required-description":
    "Provide the MotorQuoteId this rating result belongs to.",
  "api/models/MotorQuoteCoverage/motor-quote-not-found":
    "Motor quote not found",
  "api/models/MotorQuoteCoverage/motor-quote-not-found-description":
    "The referenced MotorQuote does not exist.",
  "api/models/MotorQuoteCoverage/subject-matter-coverage-id-is-required":
    "Subject matter coverage is required",
  "api/models/MotorQuoteCoverage/subject-matter-coverage-id-is-required-description":
    "Provide the SubjectMatterCoverageId this rating result was computed for.",
  "api/models/MotorQuoteCoverage/subject-matter-coverage-not-found":
    "Subject matter coverage not found",
  "api/models/MotorQuoteCoverage/subject-matter-coverage-not-found-description":
    "The referenced SubjectMatterCoverage does not exist.",
  "api/models/NavigationShortcut/invalid": "Invalid shortcut",
  "api/models/NavigationShortcut/invalid-access-role-ids":
    "The roles must be a non-empty list of role identifiers or empty.",
  "api/models/NavigationShortcut/invalid-target":
    "The target must be an enabled catalogue or subject-matter definition, or the catalogue source setting, belonging to this company.",
  "api/models/NavigationShortcut/label-required":
    "Provide exactly one label or translation key.",
  "api/models/NavigationShortcut/parent-company-mismatch":
    "The parent shortcut belongs to another company.",
  "api/models/NavigationShortcut/parent-cycle":
    "A shortcut cannot be nested inside itself.",
  "api/models/NavigationShortcut/parent-not-found":
    "The parent shortcut does not exist.",
  "api/models/NavigationShortcut/target-required":
    "This kind of shortcut needs a target. Only a group has none.",
  "api/models/Notification/not-recipient":
    "This notification belongs to another user",
  "api/models/Notification/not-recipient-description":
    "You can only read and mark your own notifications.",
  "api/models/Notification/write-forbidden":
    "Notifications are written only by the notification center",
  "api/models/Notification/write-forbidden-description":
    "Notifications cannot be created, edited or deleted through the generic data API.",
  "api/models/ParticipationCedent/engine-managed":
    "Availability rows are managed by the system",
  "api/models/ParticipationCedent/engine-managed-description":
    "Switch the cedent on or off; rows cannot be created or deleted by hand.",
  "api/models/ParticipationCedent/immutable-field": "Field cannot be changed",
  "api/models/ParticipationCedent/immutable-field-description":
    "Only the availability switches can be changed.",
  "api/models/ParticipationCedent/invalid-arguments":
    "The list request is not valid",
  "api/models/ParticipationCedent/invalid-arguments-description":
    "Check the identifier, search text, filter, page and page size sent.",
  "api/models/ParticipationCedent/not-accessible":
    "You cannot see these cedents",
  "api/models/ParticipationCedent/not-accessible-description":
    "The program or agency is outside your access.",
  "api/models/ParticipationCedent/program-disabled":
    "The cedent is disabled in the program",
  "api/models/ParticipationCedent/program-disabled-description":
    "Enable the cedent in the program before enabling it for an agency.",
  "api/models/ParticipationClosure/engine-managed":
    "The hierarchy closure is managed by the platform",
  "api/models/ParticipationClosure/engine-managed-description":
    "Hierarchy closure rows are recalculated automatically when hierarchy links change and cannot be edited directly.",
  "api/models/ParticipationEdge/company-mismatch":
    "Both participations must belong to the same company",
  "api/models/ParticipationEdge/company-mismatch-description":
    "A hierarchy link cannot connect participations of different companies.",
  "api/models/ParticipationEdge/cross-program-edge":
    "Hierarchy links cannot cross program boundaries",
  "api/models/ParticipationEdge/cross-program-edge-description":
    "Both ends of an operational hierarchy link must belong to the same program.",
  "api/models/ParticipationEdge/cycle-detected":
    "This link would create a cycle in the hierarchy",
  "api/models/ParticipationEdge/cycle-detected-description":
    "This hierarchy link would make a participation its own ancestor.",
  "api/models/ParticipationEdge/duplicate-edge":
    "This hierarchy link already exists",
  "api/models/ParticipationEdge/duplicate-edge-description":
    "An active hierarchy link between these participations already exists.",
  "api/models/ParticipationEdge/engine-managed":
    "Hierarchy links are managed by the platform",
  "api/models/ParticipationEdge/engine-managed-description":
    "Hierarchy links are created and removed through the participation methods; bulk changes and restores of links are not allowed.",
  "api/models/ParticipationEdge/immutable":
    "Hierarchy links cannot be modified; remove and create them instead",
  "api/models/ParticipationEdge/immutable-description":
    "A hierarchy link cannot be changed once created; soft-delete it and create a new one instead.",
  "api/models/ParticipationEdge/level-not-adjacent":
    "The parent must be exactly one hierarchy level above the child",
  "api/models/ParticipationEdge/level-not-adjacent-description":
    "Hierarchy links can only connect a participation to the level directly above it.",
  "api/models/ParticipationEdge/not-a-participation":
    "Both ends of a hierarchy link must be agency participations",
  "api/models/ParticipationEdge/not-a-participation-description":
    "A hierarchy link can only connect two active agency participations.",
  "api/models/ParticipationEdge/self-link":
    "A participation cannot be its own parent",
  "api/models/ParticipationEdge/self-link-description":
    "A hierarchy link cannot connect a participation to itself.",
  "api/models/Pipeline/invalid-validity-config":
    "The pipeline validity configuration is invalid",
  "api/models/Pipeline/invalid-validity-config-description":
    "The pipeline validity configuration is invalid: {{problem}}.",
  "api/models/PipelineAction/invalid-prominence":
    "The action prominence is invalid",
  "api/models/PipelineAction/invalid-prominence-description":
    "An action prominence can only be primary or left empty.",
  "api/models/PipelineAction/invalid-transition":
    "The action transition is invalid",
  "api/models/PipelineAction/invalid-transition-description":
    "The transition of the action is invalid: {{problem}}.",
  "api/models/PipelineStage/all-steps-hidden":
    "A FormLayout needs at least one non-hidden step",
  "api/models/PipelineStage/box-invalid-config":
    "A box DetailLayout field.config must be an object",
  "api/models/PipelineStage/box-invalid-span":
    "A box config.span must be 'half' or 'full'",
  "api/models/PipelineStage/box-invalid-title-key":
    "A box DetailLayout field.config.titleKey must be a non-empty string",
  "api/models/PipelineStage/entity-row-invalid-config":
    "An entity row config (policy-holder, primary-insured, agency, cedent, requester) must be an object with an optional boolean hideWhenEmpty",
  "api/models/PipelineStage/eyebrow-key-must-be-string":
    "The eyebrowKey of a form layout must be a non-empty string",
  "api/models/PipelineStage/field-grid-invalid-label":
    "A field-grid DetailLayout field needs a non-empty config.label",
  "api/models/PipelineStage/field-grid-invalid-source":
    "A field-grid DetailLayout field needs a valid config.source",
  "api/models/PipelineStage/field-grid-missing-config":
    "A field-grid DetailLayout field needs a config object",
  "api/models/PipelineStage/field-grid-missing-definition-id":
    "A subject-matter field-grid field needs config.definitionId",
  "api/models/PipelineStage/field-grid-missing-rows":
    "A field-grid DetailLayout field needs a non-empty config.rows",
  "api/models/PipelineStage/field-grid-row-invalid-emphasis":
    "A field-grid row emphasis must be a boolean",
  "api/models/PipelineStage/field-grid-row-invalid-format":
    "A field-grid row names an unknown format",
  "api/models/PipelineStage/field-grid-row-invalid-hide-when-empty":
    "A field-grid row.hideWhenEmpty must be a boolean",
  "api/models/PipelineStage/field-grid-row-invalid-value-template":
    "A field-grid row valueTemplate must be a non-empty string",
  "api/models/PipelineStage/field-grid-row-missing-label":
    "Each field-grid row needs a label",
  "api/models/PipelineStage/field-grid-row-missing-path":
    "Each field-grid row needs a path",
  "api/models/PipelineStage/field-grid-row-missing-path-end":
    "A date-range field-grid row needs pathEnd",
  "api/models/PipelineStage/field-grid-row-must-be-object":
    "Each field-grid row must be an object",
  "api/models/PipelineStage/field-invalid-avatar-path":
    "A field DetailLayout field.avatarPath must be a non-empty string",
  "api/models/PipelineStage/field-invalid-display":
    "A field DetailLayout field.config.display must be 'labelled'",
  "api/models/PipelineStage/field-invalid-emphasis":
    "A field DetailLayout field.config.emphasis must be a boolean",
  "api/models/PipelineStage/field-invalid-hide-label":
    "A field DetailLayout field.config.hideLabel must be a boolean",
  "api/models/PipelineStage/field-invalid-path-end":
    "A field DetailLayout field.config.pathEnd must be a non-empty string",
  "api/models/PipelineStage/field-invalid-subtitle-format":
    "subtitleFormat must be a valid field format",
  "api/models/PipelineStage/field-invalid-subtitle-path":
    "A field DetailLayout field.subtitlePath must be a non-empty string",
  "api/models/PipelineStage/field-invalid-subtitle-template":
    "A field DetailLayout field.config.subtitleTemplate must be a non-empty string",
  "api/models/PipelineStage/field-invalid-suffix":
    "A field DetailLayout field.suffix must be a non-empty string",
  "api/models/PipelineStage/field-invalid-term-time":
    "A period time must be a 24-hour HH:mm string",
  "api/models/PipelineStage/field-invalid-use-policy-icon":
    "A field DetailLayout field.usePolicyIcon must be a boolean",
  "api/models/PipelineStage/field-invalid-value-template":
    "A field DetailLayout field.config.valueTemplate must be a non-empty string",
  "api/models/PipelineStage/field-list-invalid-avatar-from":
    "A field-list config.avatarFrom must be a non-empty string",
  "api/models/PipelineStage/field-list-invalid-avatar-path":
    "A field-list config.avatarPath must be a non-empty string",
  "api/models/PipelineStage/field-list-invalid-format":
    "A field-list DetailLayout field names an unknown format",
  "api/models/PipelineStage/field-list-invalid-hide-when-empty":
    "A field-list DetailLayout field.hideWhenEmpty must be a boolean",
  "api/models/PipelineStage/field-list-invalid-label-key":
    "A field-list config.labelKey must be a non-empty string",
  "api/models/PipelineStage/field-list-invalid-source":
    "A field-list DetailLayout field needs a valid config.source",
  "api/models/PipelineStage/field-list-invalid-subtitle-template":
    "A field-list config.subtitleTemplate must be a non-empty string",
  "api/models/PipelineStage/field-list-invalid-warning-path":
    "A field-list needs warningWhenPath and warningTextPath together, each a non-empty string",
  "api/models/PipelineStage/field-list-missing-config":
    "A field-list DetailLayout field needs a config object",
  "api/models/PipelineStage/field-list-missing-definition-id":
    "A subject-matter field-list field needs config.definitionId",
  "api/models/PipelineStage/field-list-missing-label-path":
    "A field-list DetailLayout field needs config.labelPath",
  "api/models/PipelineStage/field-list-missing-rows-path":
    "A field-list DetailLayout field needs config.rowsPath",
  "api/models/PipelineStage/field-list-missing-title-path":
    "A field-list DetailLayout field needs config.titlePath",
  "api/models/PipelineStage/field-missing-coverage-slug":
    "A subject-matter-coverage field needs config.coverageSlug",
  "api/models/PipelineStage/field-missing-path-end":
    "A date-range DetailLayout field needs config.pathEnd",
  "api/models/PipelineStage/field-table-column-invalid-cell":
    "A field-table column's cell must be 'tag'",
  "api/models/PipelineStage/field-table-column-invalid-format":
    "A field-table column names an unknown format",
  "api/models/PipelineStage/field-table-column-invalid-label-path":
    "A field-table column labelPath must be a non-empty string",
  "api/models/PipelineStage/field-table-column-missing-label":
    "Each field-table column needs a label",
  "api/models/PipelineStage/field-table-column-missing-path":
    "Each field-table column needs a path",
  "api/models/PipelineStage/field-table-column-must-be-object":
    "Each field-table column must be an object",
  "api/models/PipelineStage/field-table-invalid-caption-path":
    "A field-table captionPath must be a non-empty string",
  "api/models/PipelineStage/field-table-invalid-display":
    "A field-table DetailLayout field.config.display must be 'table', 'compact' or 'list'",
  "api/models/PipelineStage/field-table-invalid-source":
    "A field-table DetailLayout field needs a valid config.source",
  "api/models/PipelineStage/field-table-invalid-tag-key":
    "A field-table DetailLayout field.config.tagKey must be a non-empty string",
  "api/models/PipelineStage/field-table-missing-columns":
    "A field-table DetailLayout field needs a non-empty config.columns",
  "api/models/PipelineStage/field-table-missing-config":
    "A field-table DetailLayout field needs a config object",
  "api/models/PipelineStage/field-table-missing-definition-id":
    "A subject-matter field-table field needs config.definitionId",
  "api/models/PipelineStage/field-table-missing-label":
    "A field-table DetailLayout field needs config.label",
  "api/models/PipelineStage/field-table-missing-rows-path":
    "A field-table DetailLayout field needs config.rowsPath",
  "api/models/PipelineStage/field-unknown-component":
    "A DetailLayout field names a component the slip has no renderer for",
  "api/models/PipelineStage/figure-invalid-background":
    "A figure config.background must be a #rrggbb colour",
  "api/models/PipelineStage/figure-invalid-caption":
    "A figure config.caption must be a non-empty string",
  "api/models/PipelineStage/figure-invalid-caption-format":
    "A figure config.captionFormat names an unknown format",
  "api/models/PipelineStage/figure-invalid-caption-path":
    "A figure config.captionPath must be a non-empty string",
  "api/models/PipelineStage/figure-invalid-foreground":
    "A figure config.foreground must be a #rrggbb colour",
  "api/models/PipelineStage/figure-invalid-format":
    "A figure DetailLayout field names an unknown format",
  "api/models/PipelineStage/figure-invalid-hide-when-empty":
    "A figure config.hideWhenEmpty must be a boolean",
  "api/models/PipelineStage/figure-invalid-source":
    "A figure DetailLayout field needs a valid config.source",
  "api/models/PipelineStage/figure-invalid-tone":
    "A figure config.tone must be black, grey, accent or white",
  "api/models/PipelineStage/figure-missing-config":
    "A figure DetailLayout field needs a config object",
  "api/models/PipelineStage/figure-missing-coverage-slug":
    "A subject-matter-coverage figure field needs config.coverageSlug",
  "api/models/PipelineStage/figure-missing-definition-id":
    "A subject-matter figure field needs config.definitionId",
  "api/models/PipelineStage/figure-missing-label":
    "A figure DetailLayout field needs a non-empty config.label",
  "api/models/PipelineStage/figure-missing-path":
    "A figure DetailLayout field needs a non-empty config.path",
  "api/models/PipelineStage/invalid-attribute-requirements":
    "The stage field settings are invalid",
  "api/models/PipelineStage/invalid-attribute-requirements-description":
    "The stage field settings are invalid: {{problem}}.",
  "api/models/PipelineStage/invalid-court": "The stage court is invalid",
  "api/models/PipelineStage/invalid-court-description":
    "The stage court is invalid: {{problem}}.",
  "api/models/PipelineStage/invalid-drop-empty-template-segments":
    "dropEmptyTemplateSegments must be a boolean",
  "api/models/PipelineStage/invalid-form-layout":
    "The stage form layout is invalid",
  "api/models/PipelineStage/invalid-layout": "The stage layout is invalid",
  "api/models/PipelineStage/invalid-list-config":
    "The stage list configuration is invalid",
  "api/models/PipelineStage/invalid-list-config-description":
    "The stage list configuration is invalid: {{problem}}.",
  "api/models/PipelineStage/invalid-validity-clock":
    "The stage validity clock is invalid",
  "api/models/PipelineStage/invalid-validity-clock-description":
    "The stage validity clock is invalid: {{problem}}.",
  "api/models/PipelineStage/policy-information-invalid-config":
    "A policy-information field config must be an object with an optional boolean placeholderWhenEmpty",
  "api/models/PipelineStage/policy-term-config-must-be-object":
    "The config of a policy-term node must be an object",
  "api/models/PipelineStage/quote-view-missing-config":
    "A quote DetailLayout field needs a config object",
  "api/models/PipelineStage/quote-view-missing-record-model":
    "A quote DetailLayout field needs config.recordModel",
  "api/models/PipelineStage/quote-view-missing-sections":
    "A quote DetailLayout field needs config.layout.sections",
  "api/models/PipelineStage/rate-table-invalid-label":
    "A rate-table config.label must be a non-empty string",
  "api/models/PipelineStage/rate-table-invalid-source":
    "A rate-table DetailLayout field.config.source is not a valid source",
  "api/models/PipelineStage/rate-table-missing-config":
    "A rate-table DetailLayout field needs a config object",
  "api/models/PipelineStage/rate-table-missing-definition-id":
    "A subject-matter rate-table DetailLayout field needs config.definitionId",
  "api/models/PipelineStage/rate-table-missing-rows":
    "A rate-table DetailLayout field needs a non-empty config.rows",
  "api/models/PipelineStage/rate-table-row-invalid-flag":
    "A rate-table DetailLayout row emphasis, total, hideWhenEmpty and hideWhenZero must be booleans",
  "api/models/PipelineStage/rate-table-row-invalid-string":
    "A rate-table DetailLayout row basePath, ratePath, note and notePath must be non-empty strings",
  "api/models/PipelineStage/rate-table-row-missing-amount-path":
    "Every rate-table DetailLayout row needs an amountPath",
  "api/models/PipelineStage/rate-table-row-missing-label":
    "Every rate-table DetailLayout row needs a label",
  "api/models/PipelineStage/rate-table-row-must-be-object":
    "Every rate-table DetailLayout row must be an object",
  "api/models/PipelineStage/step-duplicate-slug":
    "Two steps in this FormLayout share the same slug",
  "api/models/PipelineStage/step-invalid-collection-config":
    "A subject-matter-collection step config needs a writeback with an attribute and a flag of empty or nonEmpty",
  "api/models/PipelineStage/step-invalid-coverage-of":
    "A step's coverageOf needs hostDefinitionSlug and coverageSlug as non-empty strings, and stateField (when present) as a non-empty string",
  "api/models/PipelineStage/step-invalid-hidden":
    'A step\'s "hidden" flag must be a boolean',
  "api/models/PipelineStage/step-invalid-onsubmit":
    "A step's config.onSubmit must be an object",
  "api/models/PipelineStage/step-invalid-party-sections":
    "A party-sections step needs a non-empty list of sections with unique keys, a title key, a valid kind and its matching scope or party definition",
  "api/models/PipelineStage/step-invalid-party-sections-description":
    "A party-sections step needs a non-empty list of sections with unique keys, a title key, a valid kind and its matching scope or party definition",
  "api/models/PipelineStage/step-invalid-redirect-tab":
    "A step's config.redirectTab must be a non-empty string",
  "api/models/PipelineStage/step-invalid-related-party-of":
    "A step's relatedPartyOf needs hostDefinitionSlug and relatedPartySlug as non-empty strings",
  "api/models/PipelineStage/step-onsubmit-missing-failure-step":
    "config.onSubmit.onFailureStep must be a non-empty step slug",
  "api/models/PipelineStage/step-onsubmit-unknown-calculation":
    "config.onSubmit.calculate must name a known calculation action",
  "api/models/PipelineStage/step-onsubmit-unknown-failure-step":
    "config.onSubmit.onFailureStep must name another step in the same FormLayout",
  "api/models/PipelineStage/tab-activity-config-must-be-object":
    "An activity tab config must be an object",
  "api/models/PipelineStage/tab-activity-invalid-sources":
    "Activity tab sources must be a non-empty list of distinct known sources",
  "api/models/PipelineStage/tab-activity-unknown-key":
    "An activity tab takes only slug, label, type and config (no fields or badge)",
  "api/models/PipelineStage/tab-activity-unknown-param":
    "An activity tab config takes only sources",
  "api/models/PipelineStage/tab-badge-invalid-count-of":
    "A DetailLayout tab badge countOf names an unsupported model",
  "api/models/PipelineStage/tab-badge-must-be-object":
    "A DetailLayout tab badge must be an object",
  "api/models/PipelineStage/tab-invalid-type":
    "A DetailLayout tab type must be fields or activity",
  "api/models/PipelineStage/term-time-not-allowed":
    "termStartTime and termEndTime are only allowed on a date-range field or the policy-term node",
  "api/models/PipelineStage/validity-config-must-be-object":
    "A validity node config must be an object with expiredKey (and optionally runningKey)",
  "api/models/PipelineStage/validity-dates-config-must-be-object":
    "A validity-dates node config must be an object with titleKey, issuedLabelKey, validUntilLabelKey, remainingKey and expiredKey",
  "api/models/PipelineStage/validity-dates-invalid-key":
    "The titleKey, issuedLabelKey, validUntilLabelKey, remainingKey and expiredKey of a validity-dates node must be non-empty strings",
  "api/models/PipelineStage/validity-dates-unknown-config-key":
    "A validity-dates node config accepts only titleKey, issuedLabelKey, validUntilLabelKey, remainingKey and expiredKey",
  "api/models/PipelineStage/validity-invalid-key":
    "The expiredKey of a validity node (and its runningKey, when given) must be a non-empty string",
  "api/models/PipelineStage/validity-unknown-config-key":
    "A validity node config accepts only runningKey and expiredKey",
  "api/models/PipelineTransition/duplicate-reactivate":
    "The stage already has a reactivate transition",
  "api/models/PipelineTransition/duplicate-reactivate-description":
    "A stage can declare only one enabled reactivate action transition; the stage {{sourceStageId}} already has one.",
  "api/models/PipelineTransition/invalid-config":
    "The transition configuration is invalid",
  "api/models/PipelineTransition/invalid-config-description":
    "The configuration of the {{type}} transition is invalid: {{problem}}.",
  "api/models/Policy/agency-id-is-required": "Agency Id is required",
  "api/models/Policy/agency-not-eligible": "Agency not available",
  "api/models/Policy/agency-not-eligible-description":
    "You cannot create business for the selected agency in this program.",
  "api/models/Policy/agency-not-found": "Agency not found",
  "api/models/Policy/agent-key-required": "An agent key in force is required",
  "api/models/Policy/agent-key-required-description":
    "There is no agent key in force at {{insurer}} for this agency or for the house. Record a key in force before issuing.",
  "api/models/Policy/already-cancelled": "Policy is already cancelled",
  "api/models/Policy/already-issued": "Policy already issued",
  "api/models/Policy/already-moved": "This case was already moved",
  "api/models/Policy/already-moved-automatic-description":
    "This case was moved to another stage automatically. Reload it to see where it stands now.",
  "api/models/Policy/already-moved-description":
    "{{actor}} already moved this case to another stage. Reload it to see where it stands now.",
  "api/models/Policy/already-moved-unknown-description":
    "Someone already moved this case to another stage. Reload it to see where it stands now.",
  "api/models/Policy/assignee-write-forbidden":
    "Assignee cannot be written directly",
  "api/models/Policy/assignee-write-forbidden-description":
    "Use claim or reassign on the task to change the assignee.",
  "api/models/Policy/authority-correct-field-not-allowed":
    "This field cannot be corrected",
  "api/models/Policy/authority-correct-field-not-allowed-description":
    "The field {{field}} cannot be changed by a correction.",
  "api/models/Policy/authority-correct-not-allowed":
    "The correction cannot be made",
  "api/models/Policy/authority-correct-not-allowed-description":
    "Only a signed-in user with correction authority may correct a case.",
  "api/models/Policy/authority-correct-not-configured":
    "Authority corrections are not configured",
  "api/models/Policy/authority-correct-not-configured-description":
    "This company has not configured the reasons for correcting a case.",
  "api/models/Policy/authority-correct-nothing-to-change":
    "The correction changes nothing",
  "api/models/Policy/authority-correct-nothing-to-change-description":
    "Give at least one field with a new value.",
  "api/models/Policy/authority-correct-reason-invalid":
    "The reason for the correction is not valid",
  "api/models/Policy/authority-correct-reason-invalid-description":
    "Choose a reason from the list of correction reasons. The explanation may have up to 2000 characters.",
  "api/models/Policy/authority-correct-reason-required":
    "A reason for the correction is required",
  "api/models/Policy/authority-correct-reason-required-description":
    "Explain why the case is corrected.",
  "api/models/Policy/av-crop-duster-hull-deductible-not-found":
    "Crop-duster hull deductible not found",
  "api/models/Policy/av-crop-duster-hull-deductible-not-found-description":
    "No crop-duster hull deductible is configured for the insured hull value. Contact support.",
  "api/models/Policy/av-fumigation-liability-cap-exceeded":
    "Liability limit above the fumigation tariff maximum",
  "api/models/Policy/av-fumigation-liability-cap-exceeded-description":
    "The liability limit {{limit}} exceeds the maximum of the fumigation tariff: {{maxLimit}}.",
  "api/models/Policy/av-fumigation-occupant-limit-exceeded":
    "Occupant limit above the fumigation tariff maximum",
  "api/models/Policy/av-fumigation-occupant-limit-exceeded-description":
    "The limit per occupant cannot exceed USD {{maxLimit}} under the fumigation tariff. Declared limits: passenger voluntary payments {{pvs}}, crew voluntary payments {{cvs}}, passenger medical expenses {{pmp}}, crew medical expenses {{cmp}}.",
  "api/models/Policy/av-hangar-liability-deductible-not-found":
    "Hangar liability deductible not found",
  "api/models/Policy/av-hangar-liability-deductible-not-found-description":
    "No hangar liability deductible is configured for the enabled coverage and liability limit. Contact support.",
  "api/models/Policy/av-hull-deductible-not-found": "Hull deductible not found",
  "api/models/Policy/av-hull-deductible-not-found-description":
    "No hull deductible is configured for the selected use(s) and insured hull value. Contact support.",
  "api/models/Policy/av-hull-type-cap-exceeded":
    "Hull value above the aircraft-type maximum",
  "api/models/Policy/av-hull-type-cap-exceeded-description":
    "The hull value exceeds the maximum allowed for the aircraft type: 5,000,000 for airplanes and 2,500,000 for helicopters.",
  "api/models/Policy/av-liability-type-cap-exceeded":
    "Liability limit above the aircraft-type maximum",
  "api/models/Policy/av-liability-type-cap-exceeded-description":
    "The liability limit (LUC) exceeds the maximum allowed for the aircraft type: 5,000,000 for airplanes and helicopters.",
  "api/models/Policy/av-parts-spares-deductible-not-found":
    "Parts and spares deductible not found",
  "api/models/Policy/av-parts-spares-deductible-not-found-description":
    "No parts and spares deductible is configured for the enabled coverage and insured sum. Contact support.",
  "api/models/Policy/av-quote-aircraft-incomplete":
    "Aircraft information incomplete",
  "api/models/Policy/av-quote-aircraft-incomplete-description":
    "The aircraft type and class are required to quote this proposal.",
  "api/models/Policy/av-quote-geographic-limit-unavailable":
    "Geographic limit unavailable",
  "api/models/Policy/av-quote-geographic-limit-unavailable-description":
    "The selected geographic limit is not available for this aircraft category.",
  "api/models/Policy/av-quote-lob-not-found": "Line of business not found",
  "api/models/Policy/av-quote-lob-not-found-description":
    "No line of business was found for this aircraft category.",
  "api/models/Policy/av-quote-missing-subject-matter": "Quote unavailable",
  "api/models/Policy/av-quote-missing-subject-matter-description":
    "The proposal is missing its aircraft or coverages information.",
  "api/models/Policy/av-quote-no-duster-jet":
    "Jets cannot be quoted for fumigation",
  "api/models/Policy/av-quote-no-duster-jet-description":
    "Jet aircraft cannot be quoted as fumigation aircraft.",
  "api/models/Policy/av-quote-usage-unavailable": "Usage unavailable",
  "api/models/Policy/av-quote-usage-unavailable-description":
    "A selected usage has no rate available for this aircraft category.",
  "api/models/Policy/av-usage-age-cap-exceeded":
    "Aircraft age above the maximum for the selected use",
  "api/models/Policy/av-usage-age-cap-exceeded-description":
    'The aircraft age ({{age}} years) exceeds the maximum of {{maxAge}} years for use "{{restrictingUse}}".',
  "api/models/Policy/av-usage-age-cap-not-found": "Usage age limit not found",
  "api/models/Policy/av-usage-age-cap-not-found-description":
    "No per-use aircraft age limit is configured for the selected use(s). Contact support.",
  "api/models/Policy/av-usage-hull-value-cap-exceeded":
    "Hull value above the maximum for the selected use",
  "api/models/Policy/av-usage-hull-value-cap-exceeded-description":
    'The hull value for use "{{restrictingUse}}" cannot exceed USD {{maxHullValue}}.',
  "api/models/Policy/av-usage-hull-value-cap-not-found":
    "Usage hull-value cap not found",
  "api/models/Policy/av-usage-hull-value-cap-not-found-description":
    "No per-use hull-value cap is configured for the selected use(s). Contact support.",
  "api/models/Policy/av-usage-not-yet-quotable": "Use not yet quotable",
  "api/models/Policy/av-usage-not-yet-quotable-description":
    'The use "{{use}}" cannot be quoted in the system yet. Contact underwriting.',
  "api/models/Policy/back-transition-blocked": "Requote to save the changes",
  "api/models/Policy/back-transition-blocked-description":
    "The proposal changed since the last quote, so it cannot go back. Requote to save the changes.",
  "api/models/Policy/cannot-duplicate-parent": "Cannot duplicate",
  "api/models/Policy/cannot-duplicate-policy": "Cannot duplicate",
  "api/models/Policy/cannot-endorse-parent":
    "Cannot endorse a parent policy directly",
  "api/models/Policy/cannot-endorse-proposal": "Cannot endorse a proposal",
  "api/models/Policy/cedent-not-available": "Cedent not available",
  "api/models/Policy/cedent-not-available-description":
    "The selected cedent is not enabled for this program and agency (or for business without an agency).",
  "api/models/Policy/cedent-not-eligible": "Cedent not available",
  "api/models/Policy/cedent-not-eligible-description":
    "The selected cedent is not available for this context.",
  "api/models/Policy/cedent-scope-violation": "Cedent outside your scope",
  "api/models/Policy/cedent-scope-violation-description":
    "You can only create policies for the cedents you belong to. Please select one of your own cedents and try again.",
  "api/models/Policy/close-ambiguous":
    "This case has more than one way to be closed",
  "api/models/Policy/close-ambiguous-description":
    "The pipeline of this case declares more than one close transition from its current stage. Ask an administrator to keep only one.",
  "api/models/Policy/close-not-available": "This case cannot be closed as lost",
  "api/models/Policy/close-not-available-description":
    "The pipeline of this case does not offer closing it as lost from its current stage.",
  "api/models/Policy/close-not-configured":
    "Closing reasons are not configured",
  "api/models/Policy/close-not-configured-description":
    "Your company has no catalogue of closing reasons. Ask an administrator to configure it.",
  "api/models/Policy/close-reason-invalid": "The closing reason is not valid",
  "api/models/Policy/close-reason-invalid-description":
    "Choose a reason from the list of closing reasons. The note may have up to 2000 characters.",
  "api/models/Policy/close-reason-required": "A closing reason is required",
  "api/models/Policy/close-reason-required-description":
    "Choose why the case is closed before closing it.",
  "api/models/Policy/comission-table-not-assigned":
    "Comission table not assigned",
  "api/models/Policy/comission-table-not-assigned-description":
    "This agency does not have a commission table configured for the selected line of business. Please configure it before creating a proposal.",
  "api/models/Policy/continuation-source-mismatch": "Invalid copy",
  "api/models/Policy/continuation-source-mismatch-description":
    "The copied record does not belong to the same business.",
  "api/models/Policy/continuation-source-not-found": "Source record not found",
  "api/models/Policy/continuation-source-not-found-description":
    "The record being copied no longer exists.",
  "api/models/Policy/coverage-label-crop-duster-hull": "Hull (Crop-Dusting)",
  "api/models/Policy/coverage-label-hangar-liability": "Hangar Liability",
  "api/models/Policy/coverage-label-hull": "Hull",
  "api/models/Policy/coverage-label-liability": "Liability",
  "api/models/Policy/coverage-label-parts-and-spares": "Parts and Spares",
  "api/models/Policy/creation-change-needs-registration":
    "The cedent is not registered with this agency",
  "api/models/Policy/creation-change-needs-registration-description":
    "This change needs a new registration of the cedent with the agency, which cannot be created while editing a proposal. Register it first or choose another cedent.",
  "api/models/Policy/creation-data-invalid": "Invalid general information",
  "api/models/Policy/creation-data-invalid-description":
    "One of the values sent is not valid. Dates use the YYYY-MM-DD format.",
  "api/models/Policy/creation-edit-not-proposal":
    "Only a proposal can be edited here",
  "api/models/Policy/creation-edit-not-proposal-description":
    "The creation data can only be edited while the record is still a proposal.",
  "api/models/Policy/creation-edit-row-not-updatable":
    "You cannot edit every record of this case",
  "api/models/Policy/creation-edit-row-not-updatable-description":
    "Changing the creation data rewrites every endorsement of the case, and you do not have permission to update one of them.",
  "api/models/Policy/creation-edit-stage-not-editable":
    "The proposal cannot be edited at this stage",
  "api/models/Policy/creation-edit-stage-not-editable-description":
    "The creation data can only be edited at a stage that declares it editable.",
  "api/models/Policy/creation-field-not-editable":
    "This field cannot be changed",
  "api/models/Policy/creation-field-not-editable-description":
    "Only the agency, cedent, underwriter, dates and currency of a proposal can be changed here.",
  "api/models/Policy/creation-field-shared-description":
    "A record of this proposal is also used by another case, so this field can no longer be changed here.",
  "api/models/Policy/creation-step-inputs-missing":
    "Missing earlier selections",
  "api/models/Policy/creation-step-inputs-missing-description":
    "This step needs the cedent and the line of business chosen in the earlier steps. Go back and complete them.",
  "api/models/Policy/creation-step-not-editable": "This step cannot be edited",
  "api/models/Policy/creation-step-not-editable-description":
    "The policy type is chosen when the proposal is created and cannot be changed afterwards.",
  "api/models/Policy/creation-step-unknown": "Unknown creation step",
  "api/models/Policy/creation-step-unknown-description":
    "The new-business form requested an unknown step. Reload the form and start again.",
  "api/models/Policy/currency-not-eligible": "Currency not available",
  "api/models/Policy/currency-not-eligible-description":
    "The selected currency is not enabled for this context.",
  "api/models/Policy/declared-transition-required":
    "This action runs only from its step in the process",
  "api/models/Policy/declared-transition-required-description":
    "The process of this line runs this action from one of its steps. Continue from the proposal instead.",
  "api/models/Policy/delete-disabled": "Proposals cannot be deleted",
  "api/models/Policy/delete-disabled-description":
    "Your company does not allow deleting proposals. Close the case with a reason instead.",
  "api/models/Policy/deleted-not-writable":
    "A case cannot be deleted by editing it",
  "api/models/Policy/deleted-not-writable-description":
    "The deletion mark is managed by the server. Delete the case with the delete action instead.",
  "api/models/Policy/expiration-date-inconsistent-with-term":
    "Invalid expiration date",
  "api/models/Policy/expiration-date-inconsistent-with-term-description":
    "The expiration date does not match the configured term.",
  "api/models/Policy/field-locked": "This field is locked in the current stage",
  "api/models/Policy/field-locked-description":
    "The current stage of this case does not allow changing: {{fields}}.",
  "api/models/Policy/helicopter-class-multi-turbine":
    "multi-engine turbine helicopters",
  "api/models/Policy/helicopter-class-single-piston":
    "single-engine piston helicopters",
  "api/models/Policy/helicopter-class-single-turbine":
    "single-engine turbine helicopters",
  "api/models/Policy/immutable-field": "Field cannot be changed",
  "api/models/Policy/inception-date-before-today": "Invalid inception date",
  "api/models/Policy/inception-date-before-today-description":
    "The inception date cannot be earlier than today.",
  "api/models/Policy/invalid-new-business-payload": "Invalid proposal data",
  "api/models/Policy/invalid-new-business-payload-description":
    "Some required proposal fields are missing or invalid.",
  "api/models/Policy/line-of-business-not-editable":
    "The line of business cannot be changed",
  "api/models/Policy/line-of-business-not-editable-description":
    "The line of business is chosen when the proposal is created and cannot be changed afterwards.",
  "api/models/Policy/line-of-business-not-eligible":
    "Line of business not available",
  "api/models/Policy/line-of-business-not-eligible-description":
    "The selected line of business is not enabled for this program, agency and cedent.",
  "api/models/Policy/motor-block-not-available": "Block not available",
  "api/models/Policy/motor-block-not-available-description":
    "The selected deductible block does not exist for the declared vehicle type (motorcycles offer Block 1 only).",
  "api/models/Policy/motor-gm-limit-out-of-range":
    "Medical expenses limit out of range",
  "api/models/Policy/motor-gm-limit-out-of-range-description":
    "The elected medical expenses limit must be between 1 and the table limit for the vehicle type.",
  "api/models/Policy/motor-gm-not-available":
    "Medical expenses cover not available",
  "api/models/Policy/motor-gm-not-available-description":
    "Medical expenses are not offered for the declared vehicle type.",
  "api/models/Policy/motor-quote-missing-subject-matter": "Quote unavailable",
  "api/models/Policy/motor-quote-missing-subject-matter-description":
    "The proposal is missing its vehicle or coverages information.",
  "api/models/Policy/motor-rc-limit-out-of-range":
    "Liability limit out of range",
  "api/models/Policy/motor-rc-limit-out-of-range-description":
    "The elected liability limit must be between 1 and the table limit for the vehicle type.",
  "api/models/Policy/motor-rc-not-available": "Liability cover not available",
  "api/models/Policy/motor-rc-not-available-description":
    "Third-party liability is not offered for the declared vehicle type.",
  "api/models/Policy/motor-retention-at-ceiling":
    "Retention must be below 100%",
  "api/models/Policy/motor-retention-at-ceiling-description":
    "A 100% retention cedes no risk to the XS layer, so there is nothing to quote.",
  "api/models/Policy/motor-retention-too-low":
    "Retention below the band minimum",
  "api/models/Policy/motor-retention-too-low-description":
    "The requested retention cannot be lower than the band minimum for the declared vehicle type.",
  "api/models/Policy/motor-value-out-of-range":
    "Sum insured outside the rate matrix",
  "api/models/Policy/motor-value-out-of-range-description":
    "The sum insured falls outside every band defined for the declared vehicle type. This risk cannot be quoted.",
  "api/models/Policy/motor-vin-duplicate": "VIN already covered",
  "api/models/Policy/motor-vin-duplicate-description":
    "This VIN already appears on an active quote or bound policy in this instance.",
  "api/models/Policy/motor-vin-duplicate-own": "You already quoted this VIN",
  "api/models/Policy/motor-vin-duplicate-own-description":
    "You already have an active quote for this VIN — open it instead of creating a new one.",
  "api/models/Policy/motor-vin-invalid": "Invalid VIN",
  "api/models/Policy/motor-vin-invalid-description":
    "The VIN failed validation (17 characters, no I/O/Q, valid WMI and ISO 3779 check digit).",
  "api/models/Policy/motor-year-out-of-range": "Vehicle year out of range",
  "api/models/Policy/motor-year-out-of-range-description":
    "The vehicle year must be between 1900 and next year.",
  "api/models/Policy/no-valid-transition": "No valid transition",
  "api/models/Policy/no-valid-transition-description":
    "There is no next step available from the current stage. This is the last configured step of the workflow.",
  "api/models/Policy/not-found": "Case not found",
  "api/models/Policy/not-found-description":
    "The case no longer exists or was deleted while you worked on it.",
  "api/models/Policy/not-implemented": "Not available yet",
  "api/models/Policy/not-implemented-description":
    "This operation is not implemented yet.",
  "api/models/Policy/only-endorsements-can-be-duplicated":
    "Open a specific proposal to duplicate it.",
  "api/models/Policy/only-endorsements-can-be-endorsed":
    "Only endorsements can be endorsed",
  "api/models/Policy/only-issued-policies-can-be-endorsed":
    "Only issued policies can be endorsed",
  "api/models/Policy/only-proposals-can-be-duplicated":
    "Only proposals can be duplicated.",
  "api/models/Policy/only-proposals-can-be-issued":
    "Only proposals can be issued",
  "api/models/Policy/parent-id-not-found": "Parent Id not found",
  "api/models/Policy/parent-id-not-found-description": "Parent Id not found",
  "api/models/Policy/parent-not-found": "Parent not found",
  "api/models/Policy/parent-not-found-description": "Parent not found",
  "api/models/Policy/parent-policy-not-found": "Parent policy not found",
  "api/models/Policy/pipeline-has-no-entry-step": "Pipeline has no entry step",
  "api/models/Policy/pipeline-has-no-entry-step-description":
    "This line of business is pipeline-driven but its pipeline has no usable entry stage or first step. A proposal cannot be started until the pipeline is configured with an initial stage and at least one form step.",
  "api/models/Policy/placement-requires-proposal":
    "Only a proposal can complete its placement",
  "api/models/Policy/placement-requires-proposal-description":
    "This record is already an issued policy, so its placement cannot be completed again.",
  "api/models/Policy/policy-already-cancelled":
    "This policy has already been cancelled",
  "api/models/Policy/policy-id-is-required": "Policy Id is required",
  "api/models/Policy/policy-id-is-required-description":
    "Policy Id is required",
  "api/models/Policy/policy-id-not-found": "Policy not found",
  "api/models/Policy/policy-id-not-found-description":
    "The provided policy was not found",
  "api/models/Policy/policy-must-be-inforce-to-endorse":
    "Policy must be in force to create an endorsement",
  "api/models/Policy/policy-not-inforce": "Policy is not in force",
  "api/models/Policy/policy-type-not-allowed": "Policy type not allowed",
  "api/models/Policy/policy-type-not-allowed-description":
    "The selected policy type is not enabled for this program and line of business.",
  "api/models/Policy/premium-family-hangar-liability":
    "Net Hangar Liability Premium",
  "api/models/Policy/premium-family-hull": "Net Hull Premium",
  "api/models/Policy/premium-family-liability": "Net Liability Premium",
  "api/models/Policy/premium-line-hull": "Hull Premium",
  "api/models/Policy/premium-line-liability-combined":
    "Liability Combined Single Limit",
  "api/models/Policy/presentation-read-only": "Presentation is read-only",
  "api/models/Policy/presentation-read-only-description":
    "The Presentation field is computed and cannot be updated directly",
  "api/models/Policy/program-mode-required": "Not available for this portal",
  "api/models/Policy/program-mode-required-description":
    "This operation is only available in program portals.",
  "api/models/Policy/proposal-validity-expired": "This quote has expired",
  "api/models/Policy/proposal-validity-expired-description":
    "The quote validity ended, so it can no longer move forward. Reactivate it once it shows as expired.",
  "api/models/Policy/quote-bridge-not-found": "Quoting not configured",
  "api/models/Policy/quote-bridge-not-found-description":
    "No active quote bridge is configured for this line of business.",
  "api/models/Policy/quote-catalogue-unavailable": "Selection unavailable",
  "api/models/Policy/quote-catalogue-unavailable-description":
    "A selected catalogue option is no longer available.",
  "api/models/Policy/quote-leaf-lob-not-found": "Line of business not found",
  "api/models/Policy/quote-leaf-lob-not-found-description":
    "The resolved line of business does not exist in this instance.",
  "api/models/Policy/quote-leaf-lob-unresolved": "Risk information incomplete",
  "api/models/Policy/quote-leaf-lob-unresolved-description":
    "The captured risk information does not resolve to a rateable line of business.",
  "api/models/Policy/quote-missing-subject-matter": "Quote unavailable",
  "api/models/Policy/quote-missing-subject-matter-description":
    "The proposal is missing required risk information.",
  "api/models/Policy/quote-slip-hull-war-extortion-kidnap-text":
    "90% of 10% of the aircraft's agreed value; 10% borne by the insured",
  "api/models/Policy/quote-slip-missing-required":
    "Required information not available.",
  "api/models/Policy/quote-slip-spare-parts-cap-qualification-text":
    "Up to 10% of the hull value",
  "api/models/Policy/ramo-summary": "Aviation Insurance — {{coverages}}",
  "api/models/Policy/ramo-title": "Aviation Insurance",
  "api/models/Policy/reactivate-not-available":
    "This action is not available in the current stage",
  "api/models/Policy/reactivate-not-available-description":
    "Only a proposal whose quote has expired can be reactivated.",
  "api/models/Policy/reactivate-target-not-initial-stage":
    "The reactivate transition must lead to the initial stage of the pipeline",
  "api/models/Policy/renewal-already-linked": "This case already has a renewal",
  "api/models/Policy/renewal-already-linked-description":
    "The previous case is already linked to another renewal. Unlink it first.",
  "api/models/Policy/report-not-applicable":
    "This report does not apply to this policy.",
  "api/models/Policy/request-in-progress": "Request in progress",
  "api/models/Policy/request-in-progress-description":
    "This proposal is already being created. Please wait.",
  "api/models/Policy/requester-case-not-open": "The case is no longer open",
  "api/models/Policy/requester-case-not-open-description":
    "The requester can only change while the case is open, before it is closed or issued.",
  "api/models/Policy/requester-entity-required": "Choose the new requester",
  "api/models/Policy/requester-entity-required-description":
    "The new requester is required to move the case.",
  "api/models/Policy/requester-forbidden":
    "You cannot change the requester of this case",
  "api/models/Policy/requester-forbidden-description":
    "Your role or your place in the agency structure does not allow moving this case.",
  "api/models/Policy/requester-not-eligible": "Underwriter not eligible",
  "api/models/Policy/requester-not-eligible-description":
    "The selected underwriter cannot be assigned to this business.",
  "api/models/Policy/requester-reason-invalid": "The reason is not valid",
  "api/models/Policy/requester-reason-invalid-description":
    "The reason is optional text of up to 500 characters.",
  "api/models/Policy/requester-target-not-eligible":
    "That person cannot be the requester of this case",
  "api/models/Policy/requester-target-not-eligible-description":
    "Choose an active user of the same agency, within your own area, who can request cases.",
  "api/models/Policy/server-managed-field": "Field is managed by the server",
  "api/models/Policy/server-managed-field-description":
    "A new policy always starts as a proposal outside any existing case; its type and parent cannot be set on creation.",
  "api/models/Policy/slip-catalogue-entry-not-found":
    "Slip catalogue entry not found",
  "api/models/Policy/slip-catalogue-entry-not-found-description":
    "A catalogue entry referenced by the quote no longer exists",
  "api/models/Policy/step-calculation-not-found":
    "This step's config.onSubmit.calculate names an action the Policy model does not implement.",
  "api/models/Policy/target-stage-not-found": "The target stage was not found",
  "api/models/Policy/target-stage-not-found-description":
    "The stage this move leads to does not exist in the pipeline of the policy.",
  "api/models/Policy/term-rule-missing": "Term rules not configured",
  "api/models/Policy/term-rule-missing-description":
    "The line of business has no term configuration. Contact the platform administrator.",
  "api/models/Policy/title-read-only": "Title is read-only",
  "api/models/Policy/title-read-only-description":
    "The Title field is computed and cannot be updated directly",
  "api/models/Policy/transition-method-not-granted":
    "You are not authorized to perform this action",
  "api/models/Policy/transition-method-not-granted-description":
    "This move runs an action that your role does not have permission to perform.",
  "api/models/Policy/transition-not-available":
    "This action is not available in the current stage",
  "api/models/Policy/transition-not-available-description":
    "The proposal cannot take this action from its current stage.",
  "api/models/Policy/warranty-crop-dusting":
    "Minimum pilot experience: {{cropDustingHours}} hours crop-dusting and {{makeModelHours}} hours in make and model.",
  "api/models/Policy/warranty-fixed-wing-multi-piston":
    "For multi-engine piston airplanes, any pilot holding a license issued by the Dirección General de Aeronáutica Civil or its foreign equivalents is covered, with a minimum of {{totalHours}} total hours as pilot in command, including {{makeModelHours}} hours in make and model.",
  "api/models/Policy/warranty-fixed-wing-single-piston":
    "For single-engine piston airplanes, any pilot holding a license issued by the Dirección General de Aeronáutica Civil or its foreign equivalents is covered, with a minimum of {{totalHours}} total hours as pilot in command, including {{makeModelHours}} hours in make and model.",
  "api/models/Policy/warranty-fixed-wing-turbine":
    "For turbine airplanes, any pilot holding a license issued by the Dirección General de Aeronáutica Civil or its foreign equivalents is covered, with a minimum of {{totalHours}} total hours as pilot in command, including {{makeModelHours}} hours in make and model.",
  "api/models/Policy/warranty-helicopter":
    "Pilot-hours warranty for {{helicopterClass}}: minimum {{totalHours}} total hours and {{makeModelHours}} hours in make and model.",
  "api/models/Policy/warranty-instructor-fixed-wing":
    "Any pilot holding an instructor pilot certificate issued by the Dirección General de Aeronáutica Civil or its foreign equivalents with a minimum experience of {{picHours}} flight hours as pilot in command, with at least {{makeModelHours}} hours in make and model.",
  "api/models/Policy/warranty-instructor-helicopter":
    "Any pilot holding an instructor pilot certificate issued by the Dirección General de Aeronáutica Civil or its foreign equivalents with a minimum experience of {{picHours}} flight hours as pilot in command, with at least {{makeModelHours}} hours in make and model.",
  "api/models/Policy/warranty-instructor-multiengine-addendum":
    "For multiengine aircraft, additionally accredit {{multiengineHours}} hours of multiengine experience.",
  "api/models/Policy/warranty-student":
    "Minimum experience of {{dualHours}} hours of dual control before the first solo flight. Solo flights are not authorized for students in multiengine aircraft.",
  "api/models/PolicyDependantsRequest/find-or-create-member/age-limit-exceeded":
    "Age limit exceeded",
  "api/models/PolicyDependantsRequest/find-or-create-member/age-limit-exceeded-description":
    "Age limit exceeded",
  "api/models/PolicyDependantsRequest/find-or-create-member/child-age-limit-exceeded":
    "Child age limit exceeded",
  "api/models/PolicyDependantsRequest/find-or-create-member/child-age-limit-exceeded-description":
    "Child age limit exceeded",
  "api/models/PolicyDependantsRequest/find-or-create-member/spouse-already-exists":
    "Spouse already exists",
  "api/models/PolicyDependantsRequest/find-or-create-member/spouse-already-exists-description":
    "A spouse with the provided details already exists.",
  "api/models/PolicyFile/key-not-allowed":
    "The file location is not valid for this policy.",
  "api/models/PolicyFile/policy-not-readable":
    "You are not allowed to access this policy.",
  "api/models/PolicyFile/policy-not-readable-description":
    "The policy does not belong to any of your cedents.",
  "api/models/PolicyFile/scope-field-immutable":
    "Policy-derived fields cannot be changed.",
  "api/models/PolicyPaymentAllocation/program-mismatch": "Program mismatch",
  "api/models/PolicyPaymentAllocation/program-mismatch-description":
    "The payment and the receipt belong to different programs.",
  "api/models/PolicyQuote/missing-scope": "Quote scope error",
  "api/models/PolicyQuote/missing-scope-description":
    "The policy is missing company information — contact support",
  "api/models/PolicyQuote/policy-id-is-required": "Policy Id is required",
  "api/models/PolicyQuote/policy-id-is-required-description":
    "Policy Id is required",
  "api/models/PolicyQuote/policy-not-found": "Policy not found",
  "api/models/PolicyQuote/policy-not-found-description": "Policy not found",
  "api/models/PolicyQuoteCoverage/coverage-definition-mismatch":
    "Coverage definition does not match",
  "api/models/PolicyQuoteCoverage/coverage-definition-mismatch-description":
    "The given CoverageDefinitionId must match the resolved SubjectMatterCoverage's own CoverageDefinitionId.",
  "api/models/PolicyQuoteCoverage/coverage-definition-not-found":
    "Coverage definition not found",
  "api/models/PolicyQuoteCoverage/coverage-definition-not-found-description":
    "The referenced CoverageDefinition does not exist.",
  "api/models/PolicyQuoteCoverage/duplicate-coverage":
    "Duplicate coverage rating result",
  "api/models/PolicyQuoteCoverage/duplicate-coverage-description":
    "A rating result has already been created for this policy quote and subject matter coverage.",
  "api/models/PolicyQuoteCoverage/policy-quote-id-is-required":
    "Policy quote is required",
  "api/models/PolicyQuoteCoverage/policy-quote-id-is-required-description":
    "Provide the PolicyQuoteId this rating result belongs to.",
  "api/models/PolicyQuoteCoverage/policy-quote-not-found":
    "Policy quote not found",
  "api/models/PolicyQuoteCoverage/policy-quote-not-found-description":
    "The referenced PolicyQuote does not exist.",
  "api/models/PolicyQuoteCoverage/subject-matter-coverage-id-is-required":
    "Subject matter coverage is required",
  "api/models/PolicyQuoteCoverage/subject-matter-coverage-id-is-required-description":
    "Provide the SubjectMatterCoverageId this rating result was computed for.",
  "api/models/PolicyQuoteCoverage/subject-matter-coverage-not-found":
    "Subject matter coverage not found",
  "api/models/PolicyQuoteCoverage/subject-matter-coverage-not-found-description":
    "The referenced SubjectMatterCoverage does not exist.",
  "api/models/PolicySubjectMatter/cardinality-exceeded":
    "Multiple records are no longer supported for this document",
  "api/models/PolicySubjectMatter/cardinality-exceeded-description":
    'This business has {{count}} "{{slug}}" records; only businesses with one are eligible to generate a new quotation slip',
  "api/models/PolicySubjectMatter/cross-program-link": "Cross-program link",
  "api/models/PolicySubjectMatter/cross-program-link-description":
    "The subject matter belongs to a different program.",
  "api/models/PolicySubjectMatter/definition-not-found":
    "Subject matter definition not found",
  "api/models/PolicySubjectMatter/definition-not-found-description":
    'No subject matter definition is configured for "{{slug}}"',
  "api/models/PolicySubjectMatter/immutable-field": "Field cannot be changed",
  "api/models/PolicySubjectMatter/instance-definition-mismatch":
    "Subject matter type mismatch",
  "api/models/PolicySubjectMatter/instance-definition-mismatch-description":
    "The subject matter belongs to a different definition than the one this link names.",
  "api/models/PolicySubjectMatter/line-not-applicable":
    "Not applicable to this line",
  "api/models/PolicySubjectMatter/line-not-applicable-description":
    "The values of this subject matter do not meet the conditions of the policy line.",
  "api/models/PolicySubjectMatter/link-locked": "Link locked",
  "api/models/PolicySubjectMatter/link-locked-description":
    "This policy is issued, so the subject matter linked to it can no longer be added or removed",
  "api/models/PolicySubjectMatter/no-subject-matter":
    "Missing required information",
  "api/models/PolicySubjectMatter/no-subject-matter-description":
    'This business has no recorded "{{slug}}" — complete the required information before generating this document',
  "api/models/PolicySubjectMatter/subject-matter-claimed":
    "This item is in another valid proposal or in an issued policy.",
  "api/models/PolicySubjectMatter/subject-matter-claimed-description":
    "Another valid proposal or an issued policy already holds this item. Choose another one or wait for that proposal to expire.",
  "api/models/PolicyTask/assignee-not-eligible": "Assignee not eligible",
  "api/models/PolicyTask/assignee-not-eligible-description":
    "This person cannot take the task: they must be an active, available member of the task company with a permitted role.",
  "api/models/PolicyTask/assignee-write-forbidden":
    "Assignee cannot be written directly",
  "api/models/PolicyTask/assignee-write-forbidden-description":
    "Use claim or reassign to change who a task is assigned to.",
  "api/models/PolicyTask/claim-forbidden": "Claim not allowed",
  "api/models/PolicyTask/claim-forbidden-description":
    "You can only claim a task for yourself.",
  "api/models/PolicyTask/entity-id-is-required": "Person required",
  "api/models/PolicyTask/policy-id-is-required": "Policy required",
  "api/models/PolicyTask/policy-id-is-required-description":
    "A task must belong to a policy.",
  "api/models/PolicyTask/policy-not-found": "Policy not found",
  "api/models/PolicyTask/policy-not-found-description":
    "The policy of this task does not exist.",
  "api/models/PolicyTask/reason-invalid": "Invalid reason",
  "api/models/PolicyTask/reason-invalid-description":
    "The reason must be text of at most 500 characters.",
  "api/models/PolicyTask/reassign-entity-id-is-required-description":
    "Name the person the task is reassigned to.",
  "api/models/PolicyTask/rule-company-mismatch":
    "Queue belongs to another company",
  "api/models/PolicyTask/rule-company-mismatch-description":
    "The assignment rule must belong to the company of the policy.",
  "api/models/PolicyTask/task-closed": "Task closed",
  "api/models/PolicyTask/task-closed-description":
    "A completed or cancelled task cannot be reassigned.",
  "api/models/PresentationRule/company-id-is-required": "Company is required",
  "api/models/PresentationRule/company-id-is-required-description":
    "A presentation rule must belong to a company",
  "api/models/PresentationRule/company-not-found": "Company not found",
  "api/models/PresentationRule/company-not-found-description":
    "The referenced company does not exist",
  "api/models/PresentationRule/condition-blocked-pattern":
    "Condition contains a blocked pattern",
  "api/models/PresentationRule/condition-blocked-pattern-description":
    "The condition references a disallowed keyword",
  "api/models/PresentationRule/condition-too-long": "Condition is too long",
  "api/models/PresentationRule/condition-too-long-description":
    "The condition exceeds the maximum allowed length",
  "api/models/PresentationRule/icon-pair-mismatch": "Icon pair mismatch",
  "api/models/PresentationRule/icon-pair-mismatch-description":
    "Icon and IconDark must both be set or both be empty",
  "api/models/PresentationRule/invalid-condition": "Invalid condition",
  "api/models/PresentationRule/invalid-condition-description":
    "The condition could not be parsed as a valid expression",
  "api/models/PresentationRule/invalid-target": "Invalid target",
  "api/models/PresentationRule/invalid-target-description":
    "Target must be one of the registered presentation targets",
  "api/models/PresentationRule/invalid-template": "Invalid template",
  "api/models/PresentationRule/invalid-template-description":
    "The template could not be compiled",
  "api/models/PresentationRule/lob-company-mismatch":
    "Line of business belongs to another company",
  "api/models/PresentationRule/lob-company-mismatch-description":
    "The line of business must belong to the same company as the rule",
  "api/models/PresentationRule/lob-not-found": "Line of business not found",
  "api/models/PresentationRule/lob-not-found-description":
    "The referenced line of business does not exist",
  "api/models/PresentationRule/name-required": "Name is required",
  "api/models/PresentationRule/name-required-description":
    "A presentation rule must have a non-empty name",
  "api/models/ProgramCedent/direct-requires-enabled":
    "Enable the cedent in the program first",
  "api/models/ProgramCedent/direct-requires-enabled-description":
    '"No agency" can be on only while the cedent is enabled in the program.',
  "api/models/ProgramCedent/engine-managed":
    "Availability rows are managed by the system",
  "api/models/ProgramCedent/engine-managed-description":
    "Switch the cedent on or off; rows cannot be created or deleted by hand.",
  "api/models/ProgramCedent/immutable-field": "Field cannot be changed",
  "api/models/ProgramCedent/immutable-field-description":
    "Only the availability switches can be changed.",
  "api/models/ProgramCedent/invalid-arguments": "The list request is not valid",
  "api/models/ProgramCedent/invalid-arguments-description":
    "Check the identifier, search text, filter, page and page size sent.",
  "api/models/ProgramCedent/not-accessible": "You cannot see these cedents",
  "api/models/ProgramCedent/not-accessible-description":
    "The program or agency is outside your access.",
  "api/models/ProgramCedentLineOfBusiness/already-exists":
    "The cedent already has this line of business",
  "api/models/ProgramCedentLineOfBusiness/already-exists-description":
    "Edit the existing line of business of this cedent instead of adding it again.",
  "api/models/ProgramCedentLineOfBusiness/immutable-field":
    "Field cannot be changed",
  "api/models/ProgramCedentLineOfBusiness/line-in-use":
    "This line of business is in use and cannot be deleted",
  "api/models/ProgramCedentLineOfBusiness/line-in-use-description":
    "Policies or proposals of this cedent use this line of business. Disable it instead: that stops new business and keeps existing business untouched.",
  "api/models/ProgramMembership/cedent-required":
    "Only canonical cedent legal entities can be program members",
  "api/models/ProgramMembership/cedent-required-description":
    "A program membership must reference a canonical (non-alias) legal insurer entity.",
  "api/models/ProgramMembership/company-mismatch":
    "The cedent and the program must belong to the same company",
  "api/models/ProgramMembership/company-mismatch-description":
    "The cedent and the program of a membership must belong to the same company.",
  "api/models/ProgramMembership/immutable":
    "Program memberships cannot be modified",
  "api/models/ProgramMembership/immutable-description":
    "A program membership cannot be changed once created; remove it and create a new one instead.",
  "api/models/ProgramMembership/member-required":
    "This entity cannot be linked to the program as a member",
  "api/models/ProgramMembership/member-required-description":
    "A program link must reference an existing entity that is neither a program root nor a participation.",
  "api/models/ProgramMembership/program-root-required":
    "Memberships must reference a program",
  "api/models/ProgramMembership/program-root-required-description":
    "A program membership must reference an Entity that is a program root.",
  "api/models/Proposal/action-not-found": "Action not found",
  "api/models/Proposal/action-not-found-description": "Action not found",
  "api/models/QuoteBridge/lob-not-found": "Line of business not found",
  "api/models/QuoteBridge/lob-not-found-description":
    "The referenced line of business does not exist.",
  "api/models/QuoteBridge/lob-required": "Line of business required",
  "api/models/QuoteBridge/lob-required-description":
    "A quote bridge must belong to a line of business.",
  "api/models/RegulatoryData/write-forbidden":
    "Regulatory data is changed only by the regulatory sync",
  "api/models/RegulatoryData/write-forbidden-description":
    "These records cannot be created, edited or deleted through the API.",
  "api/models/RelatedPartyDefinition/definition-id-is-required":
    "Subject matter definition is required",
  "api/models/RelatedPartyDefinition/definition-id-is-required-description":
    "Provide the SubjectMatterDefinitionId this related party belongs to.",
  "api/models/RelatedPartyDefinition/definition-not-found":
    "Subject matter definition not found",
  "api/models/RelatedPartyDefinition/definition-not-found-description":
    "The referenced SubjectMatterDefinition does not exist.",
  "api/models/RelatedPartyDefinition/duplicate-slug":
    "Duplicate related party slug",
  "api/models/RelatedPartyDefinition/duplicate-slug-description":
    "A related party definition with this slug already exists for this subject matter definition and line of business.",
  "api/models/RelatedPartyDefinition/line-of-business-below-proposal-start":
    "Line of business is below a proposal-start line of business",
  "api/models/RelatedPartyDefinition/line-of-business-below-proposal-start-description":
    "This related party definition is declared at a line of business strictly below one that already anchors an active QuoteBridge. Declare it at that line of business or higher.",
  "api/models/RelatedPartyDefinition/line-of-business-id-is-required":
    "Line of business is required",
  "api/models/RelatedPartyDefinition/line-of-business-id-is-required-description":
    "Provide the LineOfBusinessId this related party is declared at.",
  "api/models/RelatedPartyDefinition/line-of-business-not-found":
    "Line of business not found",
  "api/models/RelatedPartyDefinition/line-of-business-not-found-description":
    "The referenced LineOfBusiness does not exist.",
  "api/models/Role/ambiguous-definition-inheritance":
    "Ambiguous role definition inheritance",
  "api/models/Role/ambiguous-definition-inheritance-description":
    "More than one override definition applies to this branch at the same distance above the assignment; resolve the conflict before it can be used.",
  "api/models/Role/definition-field-immutable":
    "Role definition cannot be changed",
  "api/models/Role/definition-field-immutable-description":
    "The family, owner, scope and level of a role cannot change after it is created. Create a new role instead.",
  "api/models/Role/definition-owner-invalid": "Invalid role definition owner",
  "api/models/Role/definition-owner-invalid-description":
    "A role that is not a system role must be custom, or an override definition with an owner.",
  "api/models/Role/family-mismatch": "Role family does not match its scope",
  "api/models/Role/family-mismatch-description":
    "The role family is determined by its scope and level and cannot be set to a different value.",
  "api/models/Role/family-not-derivable": "Role family cannot be determined",
  "api/models/Role/family-not-derivable-description":
    "A custom role needs a company, account, agency or cedent scope and a level (admin, manager, employee or user). Global custom roles are not supported.",
  "api/models/Role/override-definition-reserved":
    "Override definitions are managed separately",
  "api/models/Role/override-definition-reserved-description":
    "Override definitions and permission specifications can only be saved through the role definition service.",
  "api/models/Role/override-slug-conflict": "Role definition conflict",
  "api/models/Role/override-slug-conflict-description":
    "Another role already uses the identifier of this override definition.",
  "api/models/Role/permission-spec-administrator-only":
    "Administrator-only models cannot be granted",
  "api/models/Role/permission-spec-administrator-only-description":
    "The permission specification grants access to a model that only a company administrator may ever reach. Remove the listed model actions.",
  "api/models/Role/permission-spec-invalid": "Invalid permission specification",
  "api/models/Role/permission-spec-invalid-description":
    "The role definition permission specification is not valid. Review the listed errors.",
  "api/models/Role/save-override-definition-invalid-body":
    "A family, owner type and owner are required.",
  "api/models/Role/save-override-definition-invalid-body-description":
    'Provide FamilySlug, DefinitionOwnerType ("company" or "participation") and DefinitionOwnerId.',
  "api/models/Role/slug-reserved-namespace":
    "Role slug uses a reserved character",
  "api/models/Role/slug-reserved-namespace-description":
    'A slug containing "~" is reserved for override definitions (family~owner type~owner id) and can only be created through the role definition service.',
  "api/models/Role/unknown-family": "Unknown role family",
  "api/models/Role/unknown-family-description":
    "An override definition must name a scoped system role family.",
  "api/models/RoleInheritance/override-inheritance-forbidden":
    "Override definitions cannot use role inheritance.",
  "api/models/RoleInheritance/override-inheritance-forbidden-description":
    "A company or participation override definition cannot inherit from, or be inherited by, another role — inheritance is a system-role concept.",
  "api/models/SHPolicy/agency-id-is-required": "Agency Id is required",
  "api/models/SHPolicy/agency-id-is-required-description":
    "Agency Id is required",
  "api/models/SHPolicy/agency-not-found": "Agency not found",
  "api/models/SHPolicy/agency-not-found-description": "Agency not found",
  "api/models/SHPolicy/comission-table-not-assigned":
    "Comission table not assigned",
  "api/models/SHPolicy/comission-table-not-assigned-description":
    "The provided agency does not have a comission table assigned for this type of policy. Please assign a comission table and try again.",
  "api/models/SHPolicyQuote/policy-id-is-required": "Policy Id is required",
  "api/models/SHPolicyQuote/policy-id-is-required-description":
    "Policy Id is required",
  "api/models/SHPolicyQuote/policy-not-found": "Policy not found",
  "api/models/SHPolicyQuote/policy-not-found-description": "Policy not found",
  "api/models/SubjectMatterAttribute/catalogue-not-found":
    "Catalogue definition not found",
  "api/models/SubjectMatterAttribute/catalogue-not-found-description":
    "The referenced CatalogueDefinition does not exist.",
  "api/models/SubjectMatterAttribute/coverage-definition-not-found":
    "Coverage definition not found",
  "api/models/SubjectMatterAttribute/coverage-definition-not-found-description":
    "The referenced CoverageDefinition does not exist.",
  "api/models/SubjectMatterAttribute/definition-not-found":
    "Subject matter definition not found",
  "api/models/SubjectMatterAttribute/definition-not-found-description":
    "The referenced SubjectMatterDefinition does not exist.",
  "api/models/SubjectMatterAttribute/identity-attribute-locked":
    "Identity attribute cannot be changed",
  "api/models/SubjectMatterAttribute/identity-attribute-locked-description":
    "This attribute identifies a record across cases, so it cannot be renamed, deleted, made multi-value or non-unique, or moved to the attachment scope.",
  "api/models/SubjectMatterAttribute/invalid-derived":
    "Invalid derived setting",
  "api/models/SubjectMatterAttribute/invalid-derived-description":
    "The Derived setting of this attribute must give a source (from) that is another catalogue attribute of the same owner and a path made of parent hops followed by name or attributes.<name>.",
  "api/models/SubjectMatterAttribute/invalid-entry-filter":
    "Invalid entry filter setting",
  "api/models/SubjectMatterAttribute/invalid-entry-filter-description":
    "The EntryFilter setting of this attribute must be a list of rules shaped as when (attribute, in) and require (entryAttribute, equals).",
  "api/models/SubjectMatterAttribute/invalid-unique-scope":
    "Invalid unique scope setting",
  "api/models/SubjectMatterAttribute/invalid-unique-scope-description":
    "The UniqueScope setting of this attribute must be shaped as kind (active-cases), excludeStages (a list of distinct stage slugs) and exemptRelation (PreviousPolicy or null).",
  "api/models/SubjectMatterAttribute/invalid-validator":
    "Invalid validator setting",
  "api/models/SubjectMatterAttribute/invalid-validator-description":
    "The Validator setting of this attribute must name a registered validator and give its configuration as an object.",
  "api/models/SubjectMatterAttribute/multiple-owners-set":
    "Only one owner is allowed",
  "api/models/SubjectMatterAttribute/multiple-owners-set-description":
    "SubjectMatterDefinitionId, CoverageDefinitionId, RelatedPartyDefinitionId and ParentAttributeId are mutually exclusive; only one may be set.",
  "api/models/SubjectMatterAttribute/owner-is-required": "An owner is required",
  "api/models/SubjectMatterAttribute/owner-is-required-description":
    "Set exactly one of SubjectMatterDefinitionId, CoverageDefinitionId, RelatedPartyDefinitionId or ParentAttributeId.",
  "api/models/SubjectMatterAttribute/parent-attribute-must-be-list":
    "Parent attribute must be a list",
  "api/models/SubjectMatterAttribute/parent-attribute-must-be-list-description":
    "ParentAttributeId must reference an attribute whose Type is 'list'.",
  "api/models/SubjectMatterAttribute/parent-attribute-not-found":
    "Parent attribute not found",
  "api/models/SubjectMatterAttribute/parent-attribute-not-found-description":
    "The referenced parent SubjectMatterAttribute does not exist.",
  "api/models/SubjectMatterAttribute/related-party-definition-not-found":
    "Related party definition not found",
  "api/models/SubjectMatterAttribute/related-party-definition-not-found-description":
    "The referenced RelatedPartyDefinition does not exist.",
  "api/models/SubjectMatterAttribute/storage-reference-server-managed":
    "Storage reference setting cannot be changed",
  "api/models/SubjectMatterAttribute/storage-reference-server-managed-description":
    "Whether an attribute holds stored file references is set by the platform, not through the API",
  "api/models/SubjectMatterAttribute/unique-multiple-conflict":
    "Unique and multiple are incompatible",
  "api/models/SubjectMatterAttribute/unique-multiple-conflict-description":
    "A multi-value attribute cannot be unique: uniqueness is only enforced on single values",
  "api/models/SubjectMatterCoverage/coverage-definition-id-is-required":
    "Coverage definition is required",
  "api/models/SubjectMatterCoverage/coverage-definition-id-is-required-description":
    "Provide the CoverageDefinitionId this row resolves.",
  "api/models/SubjectMatterCoverage/coverage-definition-not-applicable":
    "Coverage definition does not apply to this instance",
  "api/models/SubjectMatterCoverage/coverage-definition-not-applicable-description":
    "The CoverageDefinition must belong to the host instance's own subject matter definition.",
  "api/models/SubjectMatterCoverage/coverage-definition-not-found":
    "Coverage definition not found",
  "api/models/SubjectMatterCoverage/coverage-definition-not-found-description":
    "The referenced CoverageDefinition does not exist.",
  "api/models/SubjectMatterCoverage/coverage-definition-not-resolved-for-leaf-lob":
    "Coverage definition not resolved for this proposal",
  "api/models/SubjectMatterCoverage/coverage-definition-not-resolved-for-leaf-lob-description":
    "The given CoverageDefinitionId is not the row resolveCoverageInheritance resolves for this coverage's slug at the host instance's proposal leaf line of business — a more specific level overrides or excludes it.",
  "api/models/SubjectMatterCoverage/duplicate-coverage": "Duplicate coverage",
  "api/models/SubjectMatterCoverage/duplicate-coverage-description":
    "This coverage has already been created for this subject matter instance.",
  "api/models/SubjectMatterCoverage/host-instance-not-found":
    "Host subject matter instance not found",
  "api/models/SubjectMatterCoverage/host-instance-not-found-description":
    "The referenced SubjectMatterInstance does not exist.",
  "api/models/SubjectMatterCoverage/illegal-state-transition":
    "Invalid coverage state transition",
  "api/models/SubjectMatterCoverage/illegal-state-transition-description":
    "This coverage cannot move from its current state to the requested one.",
  "api/models/SubjectMatterCoverage/subject-matter-instance-id-is-required":
    "Subject matter instance is required",
  "api/models/SubjectMatterCoverage/subject-matter-instance-id-is-required-description":
    "Provide the SubjectMatterInstanceId this coverage is elected on.",
  "api/models/SubjectMatterDefinition/endorsable-in-use":
    "Endorsable cannot be turned off",
  "api/models/SubjectMatterDefinition/endorsable-in-use-description":
    "This definition already has endorsements, so turning Endorsable off would unlock them; the setting stays on",
  "api/models/SubjectMatterDefinition/identity-reuse-in-use":
    "Identity reuse setting is in use",
  "api/models/SubjectMatterDefinition/identity-reuse-in-use-description":
    "The IdentityReuse setting cannot be changed or cleared while the definition has instances.",
  "api/models/SubjectMatterDefinition/invalid-form": "Invalid standalone form",
  "api/models/SubjectMatterDefinition/invalid-form-description":
    "Choose an enabled subject-matter form belonging to this company.",
  "api/models/SubjectMatterDefinition/invalid-identity-reuse":
    "Invalid identity reuse setting",
  "api/models/SubjectMatterDefinition/invalid-identity-reuse-description":
    "The IdentityReuse setting of this definition must be empty or name one instance-scoped, unique, single-value attribute of the definition, and the definition must be endorsable and require a policy context.",
  "api/models/SubjectMatterDefinition/invalid-owner-source":
    "Invalid owner source setting",
  "api/models/SubjectMatterDefinition/invalid-owner-source-description":
    "The OwnerSource setting of this definition must be empty or policyHolder.",
  "api/models/SubjectMatterDefinitionLOB/invalid-claim":
    "The claim configuration is invalid",
  "api/models/SubjectMatterDefinitionLOB/invalid-claim-description":
    "The claim configuration of the subject matter is invalid: {{problem}}.",
  "api/models/SubjectMatterDefinitionLOB/invalid-conditions":
    "Invalid conditions setting",
  "api/models/SubjectMatterDefinitionLOB/invalid-conditions-description":
    "The Conditions setting of this line binding must be a list of conditions shaped as attribute and in.",
  "api/models/SubjectMatterInstance/active-endorsement-missing":
    "No active endorsement",
  "api/models/SubjectMatterInstance/active-endorsement-missing-description":
    "This subject matter has no active endorsement to build on",
  "api/models/SubjectMatterInstance/attribute-not-writable":
    "Attribute not editable",
  "api/models/SubjectMatterInstance/attribute-not-writable-description":
    "Your role cannot change this attribute",
  "api/models/SubjectMatterInstance/attribute-validation-failed":
    "Validation failed",
  "api/models/SubjectMatterInstance/claim-locked":
    "Subject matter held by an issued policy",
  "api/models/SubjectMatterInstance/claim-locked-description":
    "An issued policy holds this subject matter, so it can no longer be changed or deleted",
  "api/models/SubjectMatterInstance/definition-not-endorsable":
    "Definition not endorsable",
  "api/models/SubjectMatterInstance/definition-not-endorsable-description":
    "This subject matter definition does not support endorsements",
  "api/models/SubjectMatterInstance/derived-conflict": "Value is derived",
  "api/models/SubjectMatterInstance/derived-conflict-description":
    "This attribute is filled from the selected catalogue entry and cannot be set to another value",
  "api/models/SubjectMatterInstance/endorse-invalid-attributes":
    "Invalid attributes",
  "api/models/SubjectMatterInstance/endorse-invalid-attributes-description":
    "The attributes to change must be an object of attribute values",
  "api/models/SubjectMatterInstance/endorse-requires-root":
    "Root record required",
  "api/models/SubjectMatterInstance/endorse-requires-root-description":
    "A new endorsement is created from the root record of the subject matter, not from one of its endorsements",
  "api/models/SubjectMatterInstance/endorsement-destroy-not-allowed":
    "Endorsement cannot be deleted on its own",
  "api/models/SubjectMatterInstance/endorsement-destroy-not-allowed-description":
    "The history of an endorsable record is never removed piecemeal; delete the record itself to remove all of its endorsements",
  "api/models/SubjectMatterInstance/endorsement-locked": "Endorsement locked",
  "api/models/SubjectMatterInstance/endorsement-locked-description":
    "An issued policy is linked to this endorsement, so it can no longer be changed; create a new endorsement instead",
  "api/models/SubjectMatterInstance/endorsement-not-locked":
    "Endorsement not issued",
  "api/models/SubjectMatterInstance/endorsement-not-locked-description":
    "The active endorsement is still a draft; edit it instead of creating a new one",
  "api/models/SubjectMatterInstance/entry-not-applicable":
    "Option not available",
  "api/models/SubjectMatterInstance/entry-not-applicable-description":
    "The selected catalogue entry does not apply to the other values of this record",
  "api/models/SubjectMatterInstance/identity-attribute-fixed":
    "Identity attribute cannot be changed",
  "api/models/SubjectMatterInstance/identity-attribute-fixed-description":
    "This registration belongs to an aircraft that is already registered; to quote another aircraft, create a new proposal.",
  "api/models/SubjectMatterInstance/immutable-field": "Field cannot be changed",
  "api/models/SubjectMatterInstance/linked-record":
    "Record cannot be changed here",
  "api/models/SubjectMatterInstance/linked-record-description":
    "Standalone operations require an unlinked record and may change only its attributes.",
  "api/models/SubjectMatterInstance/owner-must-be-policy-holder":
    "Owner must be the policy holder",
  "api/models/SubjectMatterInstance/owner-must-be-policy-holder-description":
    "The owner of this subject matter must be the policy holder",
  "api/models/SubjectMatterInstance/parent-id-not-allowed":
    "Parent not allowed",
  "api/models/SubjectMatterInstance/parent-id-not-allowed-description":
    "A parent record cannot be set when creating; create the subject matter, then use the endorse action to add an endorsement",
  "api/models/SubjectMatterInstance/pattern-mismatch": "Invalid format",
  "api/models/SubjectMatterInstance/pattern-mismatch-description":
    "The value does not match the required format",
  "api/models/SubjectMatterInstance/policy-context-required":
    "Policy context required",
  "api/models/SubjectMatterInstance/policy-context-required-description":
    "This subject matter must be created within a policy or quote context",
  "api/models/SubjectMatterInstance/policy-holder-required":
    "Policy holder required",
  "api/models/SubjectMatterInstance/policy-holder-required-description":
    "The policy holder must be defined before creating this subject matter",
  "api/models/SubjectMatterInstance/policy-modify-required": "Not allowed",
  "api/models/SubjectMatterInstance/policy-modify-required-description":
    "You cannot change the subject matter of this business.",
  "api/models/SubjectMatterInstance/unknown-attribute": "Unknown attribute",
  "api/models/SubjectMatterInstance/unknown-attribute-description":
    "The submitted attribute is not defined for this subject matter",
  "api/models/SubjectMatterLink/cross-program-link": "Cross-program link",
  "api/models/SubjectMatterLink/cross-program-link-description":
    "The subject matter belongs to a different program.",
  "api/models/SubjectMatterLink/immutable-field": "Field cannot be changed",
  "api/models/SubjectMatterLink/instance-id-required": "Missing instance",
  "api/models/SubjectMatterLink/instance-id-required-description":
    "Source and target instances are required.",
  "api/models/SubjectMatterLink/relationship-required": "Missing relationship",
  "api/models/SubjectMatterLink/relationship-required-description":
    "A relationship is required to link subject matters.",
  "api/models/SubjectMatterLink/source-not-found": "Source not found",
  "api/models/SubjectMatterLink/source-not-found-description":
    "The source subject matter instance was not found.",
  "api/models/SubjectMatterLink/target-not-found": "Target not found",
  "api/models/SubjectMatterLink/target-not-found-description":
    "The target subject matter instance was not found.",
  "api/models/SubjectMatterRelatedParty/host-instance-not-found":
    "Host subject matter instance not found",
  "api/models/SubjectMatterRelatedParty/host-instance-not-found-description":
    "The referenced SubjectMatterInstance does not exist.",
  "api/models/SubjectMatterRelatedParty/related-party-definition-id-is-required":
    "Related party definition is required",
  "api/models/SubjectMatterRelatedParty/related-party-definition-id-is-required-description":
    "Provide the RelatedPartyDefinitionId this row attaches.",
  "api/models/SubjectMatterRelatedParty/related-party-definition-not-applicable":
    "Related party definition does not apply to this instance",
  "api/models/SubjectMatterRelatedParty/related-party-definition-not-applicable-description":
    "The RelatedPartyDefinition must belong to the host instance's own subject matter definition.",
  "api/models/SubjectMatterRelatedParty/related-party-definition-not-found":
    "Related party definition not found",
  "api/models/SubjectMatterRelatedParty/related-party-definition-not-found-description":
    "The referenced RelatedPartyDefinition does not exist.",
  "api/models/SubjectMatterRelatedParty/subject-matter-instance-id-is-required":
    "Subject matter instance is required",
  "api/models/SubjectMatterRelatedParty/subject-matter-instance-id-is-required-description":
    "Provide the SubjectMatterInstanceId this related party is attached to.",
  "api/models/Theme/invalid-hex-color": "Invalid hex color code",
  "api/models/Theme/light-color-invalid-hex":
    "Light color must be a valid hex color code",
  "api/models/Theme/primary-color-invalid-hex":
    "Primary color must be a valid hex color code",
  "api/models/Theme/scope-change-not-allowed":
    "This record cannot be moved to another company.",
  "api/models/Theme/secondary-color-invalid-hex":
    "Secondary color must be a valid hex color code",
  "api/models/Theme/tertiary-color-invalid-hex":
    "Tertiary color must be a valid hex color code",
  "api/models/Theme/text-color-invalid-hex":
    "Text color must be a valid hex color code",
  "api/models/URL/agency-not-found": "Agency not found",
  "api/models/URL/agency-not-found-description":
    "A valid and existing agency with the provided AgencyId could not be found.",
  "api/models/URL/company-id-is-required": "CompanyId is required",
  "api/models/URL/company-id-is-required-description":
    "A valid CompanyId is required to create a new URL for the company.",
  "api/models/URL/company-id-required": "Company Id is required",
  "api/models/URL/company-id-required-description":
    "Company Id is required for URL creation. Provide either CompanyId or EntityId.",
  "api/models/URL/entity-not-found": "Entity not found",
  "api/models/URL/entity-not-found-description":
    "A valid and existing entity with the provided EntityId could not be found.",
  "api/models/URL/program-root-required":
    "A program portal must be bound to a program",
  "api/models/URL/program-root-required-description":
    "In program mode, a URL’s AgencyId must reference a program root.",
  "api/models/UserAvailability/company-id-is-required": "Company required",
  "api/models/UserAvailability/company-id-is-required-description":
    "The company of the absence window could not be determined.",
  "api/models/UserAvailability/company-mismatch": "Company mismatch",
  "api/models/UserAvailability/company-mismatch-description":
    "The absence window must belong to the company of the request.",
  "api/models/UserAvailability/entity-id-is-required": "Person required",
  "api/models/UserAvailability/entity-id-is-required-description":
    "Name the person the absence window is for.",
  "api/models/UserAvailability/entity-mismatch": "Not your absence",
  "api/models/UserAvailability/entity-mismatch-description":
    "You can only register absences for yourself.",
  "api/models/UserAvailability/entity-not-found": "Person not found",
  "api/models/UserAvailability/entity-not-found-description":
    "The person does not belong to this company.",
  "api/models/UserAvailability/ids-are-immutable":
    "Person and company cannot change",
  "api/models/UserAvailability/ids-are-immutable-description":
    "Delete the window and create a new one instead.",
  "api/models/UserAvailability/not-own-row": "Not your absence",
  "api/models/UserAvailability/not-own-row-description":
    "You can only change your own absences.",
  "api/models/UserAvailability/window-invalid": "Invalid absence dates",
  "api/models/UserAvailability/window-invalid-description":
    "Both dates must be valid and the end must not precede the start.",
  "api/models/Vehicle/entity-id-is-required": "Entity Id is required",
  "api/models/Vehicle/entity-id-is-required-description":
    "Entity Id is required when creating a new Vehicle. Check the provided Id and try again.",
  "api/models/Vehicle/entity-not-found": "Entity not found",
  "api/models/Vehicle/entity-not-found-description":
    "Could not find the entity with the provided Id",
  "api/models/Vehicle/vin-already-exists": "VIN already exists",
  "api/models/Vehicle/vin-already-exists-description":
    "There is already a vehicle registered with the provided VIN. Please check the VIN and try again.",
  "api/models/VehiclePolicy/agency-id-is-required": "Agency Id is required",
  "api/models/VehiclePolicy/agency-id-is-required-description":
    "Agency Id is required",
  "api/models/VehiclePolicy/agency-not-found": "Agency not found",
  "api/models/VehiclePolicy/agency-not-found-description": "Agency not found",
  "api/models/VehiclePolicy/comission-table-not-assigned":
    "Comission table not assigned",
  "api/models/VehiclePolicy/comission-table-not-assigned-description":
    "The provided agency does not have a comission table assigned for this type of policy. Please assign a comission table and try again.",
  "api/models/agency-id-is-required": "Agency Id is required",
  "api/models/agency-id-is-required-description": "Agency Id is required",
  "api/models/agency-not-found": "Agency not found",
  "api/models/agency-not-found-description":
    "The specified agency was not found",
  "api/models/business-id-is-required": "Business Id is required",
  "api/models/business-id-is-required-description":
    "Business Id is required to create a Business Period",
  "api/models/business-not-found": "Business not found",
  "api/models/business-not-found-description":
    "The specified business was not found",
  "api/models/comission-table-not-assigned": "Comission table not assigned",
  "api/models/could-not-create-or-find-business":
    "Could not create or find business",
  "api/models/duplicate-value": "Duplicate value",
  "api/models/duplicate-value-description":
    "A record with this value already exists",
  "api/models/entity-id-is-required": "Entity Id is required",
  "api/models/entity-id-is-required-description":
    "Entity Id is required when creating a new Entity Email",
  "api/models/entity-not-found": "Entity not found",
  "api/models/entity-not-found-description": "Entity not found",
  "api/models/id-is-required": "Id is required",
  "api/models/identifier-already-registered": "Identifier already registered",
  "api/models/identifier-already-registered-description":
    "This identifier is already registered",
  "api/models/immutable-field-description":
    "This field cannot change after creation.",
  "api/models/internal-error": "Internal error",
  "api/models/invalid-attribute-value": "Invalid attribute value",
  "api/models/invalid-attribute-value-description":
    "A unique identifier cannot contain control or non-printable characters",
  "api/models/invalid-inforce-date": "Invalid in-force date",
  "api/models/invalid-inforce-date-description":
    "The in-force date provided is not valid",
  "api/models/invalid-pattern-config": "Invalid validation pattern",
  "api/models/invalid-pattern-config-description":
    "The attribute is configured with an invalid pattern",
  "api/models/invalid-unique-scope": "Invalid unique scope",
  "api/models/invalid-unique-scope-description":
    "The unique scope stored for this attribute is malformed",
  "api/models/line-of-business-is-required": "Line of Business is required",
  "api/models/line-of-business-is-required-description":
    "Line of Business is required",
  "api/models/lob-not-found": "Line of Business not found",
  "api/models/models-not-passed-in-options": "Models not passed in options",
  "api/models/module-disabled": "This module is not enabled for your company.",
  "api/models/module-disabled-description":
    "Ask a company administrator to configure and activate the module.",
  "api/models/quoting/deductible-reconciliation-no-prior-quote":
    "No prior quotation to reconcile",
  "api/models/quoting/deductible-reconciliation-no-prior-quote-description":
    "This business has no prior engine quotation on record, so its deductibles cannot be reconciled.",
  "api/models/quoting/deductible-reconciliation-no-steps-configured":
    "No deductible resolution steps configured",
  "api/models/quoting/deductible-reconciliation-no-steps-configured-description":
    "The active pipeline for this line of business has no deductible_resolution steps to reconcile.",
  "api/models/quoting/execution-error": "Pipeline execution error",
  "api/models/quoting/execution-error-description":
    "An error occurred while executing the quoting pipeline",
  "api/models/quoting/expression-error": "Expression evaluation error",
  "api/models/quoting/expression-error-description":
    "An error occurred while evaluating the formula expression",
  "api/models/quoting/fetch-related-invalid-model": "Invalid model reference",
  "api/models/quoting/fetch-related-invalid-model-description":
    "The referenced model does not exist in the system",
  "api/models/quoting/invalid-step-config":
    "Invalid pipeline step configuration",
  "api/models/quoting/invalid-step-config-description":
    "The step configuration is invalid. Please check the configuration fields.",
  "api/models/quoting/lob-required": "Line of business required",
  "api/models/quoting/lob-required-description":
    "LineOfBusinessId is required on the proposal.",
  "api/models/quoting/mandatory-check-lob-required":
    "A line of business is required for the mandatory-coverage check",
  "api/models/quoting/mandatory-check-lob-required-description":
    "The mandatory-coverage check step requires LineOfBusinessId in context; it ran before the line of business was resolved.",
  "api/models/quoting/mandatory-coverage-missing":
    "A mandatory coverage has not been elected",
  "api/models/quoting/mandatory-coverage-missing-description":
    "These mandatory coverages have not been elected for this proposal: {{missingNames}}.",
  "api/models/quoting/pipeline-not-found": "No active pipeline found",
  "api/models/quoting/pipeline-not-found-description":
    "No active quoting pipeline found for this line of business",
  "api/models/quoting/rate-not-found": "Rate not found",
  "api/models/quoting/rate-not-found-description":
    "No matching rate found in the rate table for the given value",
  "api/models/quoting/record-id-required": "A quote record id is required",
  "api/models/quoting/record-id-required-description":
    "This pipeline step requires the quote record to already exist; it ran before the record was created.",
  "api/models/quoting/snapshot-cannot-be-deleted":
    "Quote snapshot records are immutable and cannot be deleted",
  "api/models/quoting/snapshot-cannot-be-modified":
    "Quote snapshot records are immutable and cannot be updated",
  "api/models/quoting/snapshot-immutable": "Quote snapshots cannot be modified",
  "api/models/quoting/spare-parts-limit-exceeded": "Spare parts limit exceeded",
  "api/models/quoting/spare-parts-limit-exceeded-description":
    "The spare parts limit exceeds the maximum allowed",
  "api/models/quoting/spare-parts-ratio-exceeded": "Spare parts ratio exceeded",
  "api/models/quoting/spare-parts-ratio-exceeded-description":
    "The spare parts limit to hull value ratio exceeds the maximum allowed",
  "api/models/quoting/validation-failed": "Validation failed",
  "api/models/quoting/validation-failed-description":
    "A validation condition was not met",
  "api/models/quoting/warranty-premium-reconciliation-no-prior-quote":
    "No prior quotation to reconcile",
  "api/models/quoting/warranty-premium-reconciliation-no-prior-quote-description":
    "This business has no prior engine quotation on record, so its warranty/premium presentation cannot be reconciled.",
  "api/models/quoting/warranty-premium-reconciliation-no-steps-configured":
    "No warranty/premium resolution steps configured",
  "api/models/quoting/warranty-premium-reconciliation-no-steps-configured-description":
    "The active pipeline for this line of business has no warranty_resolution/premium_lines steps to reconcile.",
  "api/models/revision-conflict": "This record has changed",
  "api/models/revision-conflict-description":
    "Reload the latest version before saving your changes.",
  "api/models/revision-required": "A record revision is required",
  "api/models/revision-required-description":
    "Reload the record and submit the revision you edited.",
  "api/models/role/definition-management-reserved":
    "Only platform administrators can manage role definitions.",
  "api/models/role/definition-management-reserved-description":
    "Editing a role definition owned by a company or a participation requires a company administrator of that company, or superAdmin.",
  "api/models/transaction-required-for-uniqueness":
    "The uniqueness check needs a transaction to run safely",
  "api/models/user-not-allowed-to-execute-method":
    "User not allowed to execute method",
  "api/models/user-not-allowed-to-execute-method-description":
    "User not allowed to execute method",
  "api/not-implemented": "Not available yet",
  "api/not-implemented-description": "This operation is not available yet.",
  "api/platform/owner-not-configured": "Platform owner not configured",
  "api/platform/owner-not-configured-description":
    "The database must have exactly one active root company to own the shared platform data.",
  "api/request/company-context-conflict": "Company context conflict",
  "api/request/company-context-conflict-description":
    "The requested company does not match the one for this portal host.",
  "api/request/context-lookup-failed": "Service temporarily unavailable",
  "api/request/context-lookup-failed-description":
    "The request context could not be resolved. Try again in a moment.",
  "api/request/host-context-required": "Portal address required",
  "api/request/host-context-required-description":
    "This request did not come from a registered portal address, so it cannot be served. Open the portal from its own address and try again.",
  "api/request/idempotency-unavailable": "Service temporarily unavailable",
  "api/request/idempotency-unavailable-description":
    "The request could not be protected against duplicate submission. Try again in a moment.",
  "api/request/include-not-allowed": "Invalid related data request",
  "api/request/include-not-allowed-description":
    "One of the requested associations is not allowed.",
  "api/request/internal-error": "Something went wrong",
  "api/request/internal-error-description":
    "An unexpected error occurred. Please try again.",
  "api/request/invalid-instance": "Invalid instance",
  "api/request/invalid-instance-description":
    "The requested instance is not recognized.",
  "api/request/mass-mutation-not-allowed": "Bulk update not allowed",
  "api/request/mass-mutation-not-allowed-description":
    "This model does not allow updating or deleting multiple records at once through the data API.",
  "api/request/method-not-callable": "Method not available",
  "api/request/method-not-callable-description":
    "The requested method is not available through the data API.",
  "api/request/model-not-scoped": "Model not available",
  "api/request/model-not-scoped-description":
    "This model is not reachable through the data API.",
  "api/request/payload-key-not-allowed": "Payload key not allowed",
  "api/request/payload-key-not-allowed-description":
    "A payload key cannot name a path inside a value. Send each attribute as a whole value.",
  "api/request/payload-not-allowed": "Payload not allowed",
  "api/request/payload-not-allowed-description":
    "This method does not accept a request payload. Send query options as params.",
  "api/request/program-access-denied": "Program access denied",
  "api/request/program-access-denied-description":
    "You do not have access to this program.",
  "api/request/program-context-required": "Program context required",
  "api/request/program-context-required-description":
    "This action requires a program context, and none could be resolved for this request.",
  "api/request/program-context-unavailable": "Program context unavailable",
  "api/request/program-context-unavailable-description":
    "This portal host has no resolvable program for the requested action.",
  "api/request/query-attribute-not-readable": "Filter or sort not available",
  "api/request/query-attribute-not-readable-description":
    "This request filters or sorts by information your role cannot read. Remove that filter or sort and try again.",
  "api/request/query-key-not-allowed": "Query not allowed",
  "api/request/query-key-not-allowed-description":
    "One or more query keys in this request are not allowed.",
  "api/request/rate-limited": "Too many requests",
  "api/request/rate-limited-description": "Please wait before trying again.",
  "api/request/reference-out-of-scope": "Referenced record not found",
  "api/request/reference-out-of-scope-description":
    "The referenced record does not exist, or is outside the scope of this request.",
  "api/request/reference-owner-model-not-allowed": "Owner not allowed",
  "api/request/reference-owner-model-not-allowed-description":
    "The owner of this record is missing or is not an allowed type.",
  "api/request/reference-owner-update-denied":
    "You cannot change the owner of this record",
  "api/request/reference-owner-update-denied-description":
    "Changing this record requires permission to update its owner, which you do not have.",
  "api/request/stage-filter-forbidden": "List filter not permitted",
  "api/request/stage-filter-forbidden-description":
    "Your role may not use this list filter.",
  "api/request/stage-filter-unavailable": "List filter not available yet",
  "api/request/stage-filter-unavailable-description":
    "This list filter is not available yet.",
  "api/request/stage-filter-unknown": "List filter not declared",
  "api/request/stage-filter-unknown-description":
    "No stage declares a list filter with that key.",
  "api/request/stage-filter-value-invalid": "List filter value not valid",
  "api/request/stage-filter-value-invalid-description":
    "The value is not one the filter declares.",
  "api/request/stage-filters-invalid": "List filters not valid",
  "api/request/stage-filters-invalid-description":
    "The list filters in this request are malformed.",
  "api/request/write-params-not-allowed": "Query options not allowed",
  "api/request/write-params-not-allowed-description":
    "This method writes data and does not accept read query options such as include, attributes, order or limit.",
  "api/services/CognitoUserService/email-is-required": "Email is required",
  "api/services/CognitoUserService/email-is-required-description":
    "Email is required",
  "api/services/CognitoUserService/user-creation-failed":
    "User creation failed",
  "api/services/CognitoUserService/user-creation-failed-description":
    "User creation failed",
  "api/services/notification-template-missing":
    "Notification template not found.",
  "api/services/notification-template-missing-description":
    "The requested notification template key has no translation.",
  "api/services/notification-unavailable":
    "Notifications are not available; try again later.",
  "api/services/notification-unavailable-description":
    "No sender is configured for transactional notifications.",
  "api/utils/SubjectMatterEngine/leaf-line-of-business-not-found":
    "Line of business not found",
  "api/utils/SubjectMatterEngine/leaf-line-of-business-not-found-description":
    "The referenced leaf LineOfBusiness does not exist.",
  "api/utils/generate-model-id-error": "Error generating model Id",
  "catalogue-record-types/car": "Car",
  "catalogue-record-types/motorcycle": "Motorcycle",
  "catalogue-record-types/pickup": "Pickup",
  "catalogue-sources/gnp-mx": "GNP",
  "catalogue-sources/qualitas-mx": "Quálitas",
  "cdn/invalid-expiry": "Invalid link expiry.",
  "common/cancel": "Cancel",
  "common/delete": "Delete",
  "forms/assignExternalCatalogueCode/title": "Assign catalogue code",
  "forms/config/day": "Days",
  "forms/config/expiration-editable": "Editable expiration",
  "forms/config/inception-offset-days": "Default inception offset (days)",
  "forms/config/inherit": "Inherit",
  "forms/config/max-term-amount": "Maximum term",
  "forms/config/min-term-amount": "Minimum term",
  "forms/config/month": "Months",
  "forms/config/retroactive-allowed": "Allow retroactive inception",
  "forms/config/term-amount": "Term",
  "forms/config/term-mode": "Term mode",
  "forms/config/term-mode-bounded": "Bounded",
  "forms/config/term-mode-fixed": "Fixed",
  "forms/config/term-mode-free": "Free",
  "forms/config/term-unit": "Unit",
  "forms/config/year": "Years",
  "forms/configParticipationLinesOfBusiness/title": "Lines of business",
  "forms/createParticipation/alias": "Alias",
  "forms/createParticipation/commercial-name": "Commercial name",
  "forms/createParticipation/country": "Country",
  "forms/createParticipation/existing-organization": "Existing organization",
  "forms/createParticipation/identity-mode": "Identity",
  "forms/createParticipation/incorporation-date": "Incorporation date",
  "forms/createParticipation/legal-name": "Legal name",
  "forms/createParticipation/lookup-outcome": "Lookup outcome",
  "forms/createParticipation/lookup-token": "Lookup token",
  "forms/createParticipation/mode-existing": "Select an existing organization",
  "forms/createParticipation/mode-lookup": "I have the official identifier",
  "forms/createParticipation/mode-new": "Create without identifier",
  "forms/createParticipation/parents": "Parents",
  "forms/createParticipation/participation-level": "Participation level",
  "forms/createParticipation/tax-id": "Tax ID",
  "forms/createParticipation/validation/required": "This field is required",
  "forms/createProposal/agency": "Agency",
  "forms/createProposal/currency": "Currency",
  "forms/createProposal/empty/no-common-currency":
    "There is no common currency for this agency and cedent.",
  "forms/createProposal/empty/no-eligible-agency":
    "You have no agency available to create proposals in this program.",
  "forms/createProposal/empty/no-eligible-cedent":
    "No cedents available. Register them from Cedents.",
  "forms/createProposal/empty/no-eligible-line-of-business":
    "This cedent has no eligible line of business in this program.",
  "forms/createProposal/empty/not-authorized":
    "You are not authorized to create proposals in this program.",
  "forms/createProposal/empty/term-rule-missing":
    "Term rules are not configured for this line of business. Contact the platform administrator.",
  "forms/createProposal/expiration-date": "Expiration Date",
  "forms/createProposal/in-force-date": "In Force Date",
  "forms/createProposal/line-of-business": "Line of Business",
  "forms/createProposal/policy-holder": "Policy Holder",
  "forms/createProposal/policy-type": "Policy Type",
  "forms/createProposal/policy-type-new": "New",
  "forms/createProposal/policy-type-renewal": "Renewal",
  "forms/createProposal/previous-policy": "Previous Policy",
  "forms/createProposal/requester": "Requester",
  "forms/createProposal/title": "New proposal",
  "forms/createProposal/validation/invalid-date": "Must be a valid date",
  "forms/createProposal/validation/required": "This field is required",
  "forms/editExternalCatalogue/title": "Edit external catalogue",
  "forms/editExternalCatalogueCode/title": "Edit code",
  "forms/editLineOfBusinessCurrency/title": "Allowed currency",
  "forms/editLineOfBusinessTermRule/title": "Term rule",
  "forms/editParticipationLineOfBusiness/title": "Agency line of business",
  "forms/editProgramCedentLineOfBusiness/title": "Cedent line of business",
  "forms/registration/group-general-label": "General information",
  "forms/registration/group-identity-hint":
    "12 characters for a legal entity. The format and check digit are validated; nothing is looked up with the tax authority.",
  "forms/registration/group-identity-label": "Identity",
  "forms/registration/identifier": "Official identifier",
  "forms/registration/identifier-optional-hint": "Optional · not validated",
  "forms/registration/identifier-required": "Enter the identifier",
  "forms/registration/lookup-required":
    "Wait for the identifier lookup to finish",
  "forms/registration/reused-existing-record":
    "A record with that identifier already existed; it was reused.",
  "forms/registration/subtitle":
    "We search by tax ID first; if a match already exists, it is reused.",
  "forms/registration/subtitle-direct":
    "Register the insurer with its legal name. If you enter a tax identifier that already exists, that record is reused.",
  "forms/registration/title-cedent": "Register cedent",
  "forms/registration/title-insurer": "Register insurer",
  "forms/registration/unavailable":
    "Registration is not available right now. Contact your administrator.",
  "forms/reparentParticipation/participation-id": "Participation",
  "hello-world": "Hello World",
  "hyperseguros-web/about/acerca-de-nosotros/meta-description":
    "Design, placement and operations in equal parts, CNSF-authorised and built on our own software. Who we are and how we work with agents and companies.",
  "hyperseguros-web/about/acerca-de-nosotros/meta-title":
    "Hyper - About Us: Wholesale Insurance Agency",
  "hyperseguros-web/about/ahora-somos-hyper/heading-emphasis": "Hyper",
  "hyperseguros-web/about/ahora-somos-hyper/heading-muted": "Now we are",
  "hyperseguros-web/about/ahora-somos-hyper/meta-description":
    "HyperSeguros is now Hyper: the same team and the same mission, working today in wholesale insurance and surety, our own technology and aggregator services.",
  "hyperseguros-web/about/ahora-somos-hyper/meta-title":
    "Hyper - New name, same mission",
  "hyperseguros-web/about/ahora-somos-hyper/pill": "Now we are Hyper",
  "hyperseguros-web/about/ahora-somos-hyper/tagline":
    'We took "Seguros" out of the name, not out of the work. Same team, same mission… fewer letters.',
  "hyperseguros-web/about/ahora-somos-hyper/video-captions": "Captions",
  "hyperseguros-web/about/ahora-somos-hyper/video-close": "Close video",
  "hyperseguros-web/about/ahora-somos-hyper/video-cta": "Watch the video",
  "hyperseguros-web/about/ahora-somos-hyper/video-exit-fullscreen":
    "Exit full screen",
  "hyperseguros-web/about/ahora-somos-hyper/video-fullscreen": "Full screen",
  "hyperseguros-web/about/ahora-somos-hyper/video-mute": "Mute",
  "hyperseguros-web/about/ahora-somos-hyper/video-pause": "Pause video",
  "hyperseguros-web/about/ahora-somos-hyper/video-play": "Play video",
  "hyperseguros-web/about/ahora-somos-hyper/video-seek": "Video position",
  "hyperseguros-web/about/ahora-somos-hyper/video-unmute": "Unmute",
  "hyperseguros-web/about/ahora-somos-hyper/video-volume": "Volume",
  "hyperseguros-web/about/heading-emphasis": "And with speed like never before",
  "hyperseguros-web/about/heading-muted":
    "We manage risk with the same rigor as always.",
  "hyperseguros-web/about/pill": "About Hyper",
  "hyperseguros-web/about/tagline":
    "We design, place and run the business of agents and producers. You keep the relationship; we keep the paperwork.",
  "hyperseguros-web/about/wholesale-agentes-y-productores/meta-description":
    "Place any line of business without building the operation: technical backup on the sale, access to the right market and the full policy administration.",
  "hyperseguros-web/about/wholesale-agentes-y-productores/meta-title":
    "Hyper - Wholesale for Agents and Producers",
  "hyperseguros-web/about/wholesale-seguros/meta-description":
    "The wholesaler between the agent and the carrier: what it does, how it differs from a managing agent, and why the book of business stays the agent's.",
  "hyperseguros-web/about/wholesale-seguros/meta-title":
    "Hyper - What Is a Wholesale Insurance Agency?",
  "hyperseguros-web/agents/heading-emphasis": "Say yes",
  "hyperseguros-web/agents/heading-muted":
    "Your client asked you for aviation insurance.",
  "hyperseguros-web/agents/tagline":
    "An agent who runs their own policies is an agent who is not selling. We say it with affection, and with an operations team.",
  "hyperseguros-web/common/rail/next": "Next",
  "hyperseguros-web/common/rail/previous": "Previous",
  "hyperseguros-web/footer/legal/copyright":
    "© {{year}} Hyper. All rights reserved.",
  "hyperseguros-web/footer/links/folleto-intermediacion":
    "Intermediation Disclosure Brochure",
  "hyperseguros-web/footer/links/privacidad": "Privacy Notice",
  "hyperseguros-web/footer/links/terminos": "Terms and Conditions",
  "hyperseguros-web/home/actions/primary": "Let's work together",
  "hyperseguros-web/home/actions/secondary": "See insurance",
  "hyperseguros-web/home/figures/fianzas": "surety bonds",
  "hyperseguros-web/home/figures/industrias": "industries",
  "hyperseguros-web/home/figures/programas": "programs",
  "hyperseguros-web/home/figures/seguros": "insurance products",
  "hyperseguros-web/home/heading-emphasis": "together",
  "hyperseguros-web/home/heading-muted": "We manage risk",
  "hyperseguros-web/home/meta-description":
    "Wholesale insurance and surety agency in Mexico. We design, place and run cover for companies, agents and brokers across every line of business.",
  "hyperseguros-web/home/meta-title":
    "Hyper - Business Insurance and Surety in Mexico",
  "hyperseguros-web/home/read-more": "Read more",
  "hyperseguros-web/home/tagline":
    "We are the insurance wholesaler that helps you design and run insurance programs — and the one that explains the fine print without putting you to sleep.",
  "hyperseguros-web/hubs/fianzas/heading-emphasis": "One file",
  "hyperseguros-web/hubs/fianzas/heading-muted": "Eleven bonds.",
  "hyperseguros-web/hubs/fianzas/meta-description":
    "Eleven surety bonds in a single file: performance, advance payment, bid, latent defects, fidelity, judicial and credit bonds, issued in Mexico.",
  "hyperseguros-web/hubs/fianzas/meta-title":
    "Hyper - Surety Bonds for Companies in Mexico",
  "hyperseguros-web/hubs/fianzas/tagline":
    "Administrative, fidelity, judicial and credit bonds, with the right surety and the exact wording the beneficiary asks for. The file is built once; the bonds go out in hours.",
  "hyperseguros-web/hubs/industrias/heading-emphasis":
    "We know all twenty-four",
  "hyperseguros-web/hubs/industrias/heading-muted":
    "Every industry has a favorite risk.",
  "hyperseguros-web/hubs/industrias/meta-description":
    "Twenty-four sectors, each with its own risk profile, from agriculture to transport. Cover and surety written for how each industry works in Mexico.",
  "hyperseguros-web/hubs/industrias/meta-title":
    "Hyper - Insurance by Industry in Mexico",
  "hyperseguros-web/hubs/industrias/tagline":
    "Twenty-four sectors with their risks, their contracts and their mix of insurance and bonds. Written for Mexico, with named products instead of a form.",
  "hyperseguros-web/hubs/programas/heading-emphasis":
    "explained in a single meeting",
  "hyperseguros-web/hubs/programas/heading-muted":
    "A program is several policies",
  "hyperseguros-web/hubs/programas/meta-description":
    "Several covers that solve one problem and are run as one. Programmes for companies, schools, banks, retail chains and the public sector in Mexico.",
  "hyperseguros-web/hubs/programas/meta-title":
    "Hyper - Tailored Insurance Programmes",
  "hyperseguros-web/hubs/programas/tagline":
    "Eight programs for the private and public sectors: benefits, schools, banks, inventory, tenders, institutional life, public assets and catastrophe. Designed as one, run as one.",
  "hyperseguros-web/hubs/seguros/heading-emphasis": "Zero boredom",
  "hyperseguros-web/hubs/seguros/heading-muted": "Serious risk.",
  "hyperseguros-web/hubs/seguros/meta-description":
    "Eight families and forty covers for companies: life, health, accident, property, liability, marine and cargo, specialty lines and parametric insurance.",
  "hyperseguros-web/hubs/seguros/meta-title":
    "Hyper - Commercial Insurance in Mexico",
  "hyperseguros-web/hubs/seguros/tagline":
    "People, property, liability, parametric, transport and specialty: forty insurance products designed, placed and run by the same team. Pick yours or tell us which one is missing.",
  "hyperseguros-web/industries/agro-alimentos-y-bebidas/heading-emphasis":
    "We insure the journey",
  "hyperseguros-web/industries/agro-alimentos-y-bebidas/heading-muted":
    "Everyone talks about farm to table.",
  "hyperseguros-web/industries/agro-alimentos-y-bebidas/meta-description":
    "From field to shelf, every link with its own policy: growers, processing plants, bottlers, distributors and exporters, with property cover and surety.",
  "hyperseguros-web/industries/agro-alimentos-y-bebidas/meta-title":
    "Hyper - Insurance for Agrifood and Beverage",
  "hyperseguros-web/industries/agro-alimentos-y-bebidas/name":
    "Agriculture, Food & Beverage",
  "hyperseguros-web/industries/agro-alimentos-y-bebidas/tagline":
    "Crops, livestock, plants, fleets, batches and product recalls, with a team that knows the difference between a frost and a pest. And between an endorsement and a recall.",
  "hyperseguros-web/industries/arte-joyas-y-valores/heading-emphasis":
    "What is priceless also has an agreed value",
  "hyperseguros-web/industries/arte-joyas-y-valores/heading-muted":
    "Museums, galleries, jewellers and vaults.",
  "hyperseguros-web/industries/arte-joyas-y-valores/meta-description":
    "Museums, galleries, auction houses, jewellers and cash-in-transit firms: what cannot be replaced, insured at agreed value, on show and in transit.",
  "hyperseguros-web/industries/arte-joyas-y-valores/meta-title":
    "Hyper - Insurance for Art, Jewellery and Specie",
  "hyperseguros-web/industries/arte-joyas-y-valores/name":
    "Fine Art, Jewellery & Specie",
  "hyperseguros-web/industries/arte-joyas-y-valores/tagline":
    "Works, collections, jewellery, watches, metals and specie, at agreed value and nail to nail. Placed with London art markets, with appraisals and discretion.",
  "hyperseguros-web/industries/aseguradoras-y-reaseguro/heading-emphasis":
    "We are that someone",
  "hyperseguros-web/industries/aseguradoras-y-reaseguro/heading-muted":
    "Insurers also need someone who brings them well-built business.",
  "hyperseguros-web/industries/aseguradoras-y-reaseguro/meta-description":
    "For insurers, surety companies, reinsurers and insurtechs: capacity where there is none, well-structured business and the sector's own covers.",
  "hyperseguros-web/industries/aseguradoras-y-reaseguro/meta-title":
    "Hyper - Insurance for Carriers and Reinsurance",
  "hyperseguros-web/industries/aseguradoras-y-reaseguro/name":
    "Insurers & Reinsurance",
  "hyperseguros-web/industries/aseguradoras-y-reaseguro/tagline":
    "Facultative reinsurance, affinity programs, delegated underwriting and business that arrives with a complete file. We work for the agent; the insurer notices.",
  "hyperseguros-web/industries/automotriz/heading-emphasis":
    "The chain that does get insured end to end",
  "hyperseguros-web/industries/automotriz/heading-muted":
    "Automakers, dealers and finance companies.",
  "hyperseguros-web/industries/automotriz/meta-description":
    "From assembly to handing over the keys: carmakers, parts suppliers, dealers, finance and leasing companies and fleets, with property and cargo cover.",
  "hyperseguros-web/industries/automotriz/meta-title":
    "Hyper - Insurance for the Automotive Industry",
  "hyperseguros-web/industries/automotriz/name": "Automotive",
  "hyperseguros-web/industries/automotriz/tagline":
    "Fleets, floor plan, dealership programs, product recall and supplier liability. From assembly to key handover, without the insurance staying on the lot.",
  "hyperseguros-web/industries/aviacion-y-espacio/heading-emphasis":
    "We say with which market",
  "hyperseguros-web/industries/aviacion-y-espacio/heading-muted":
    "A line where almost nobody says yes.",
  "hyperseguros-web/industries/aviacion-y-espacio/meta-description":
    "From the crop duster to the satellite: business operators, airlines, agricultural aviation, airports, FBOs, maintenance shops and flight schools.",
  "hyperseguros-web/industries/aviacion-y-espacio/meta-title":
    "Hyper - Insurance for Aviation and Space",
  "hyperseguros-web/industries/aviacion-y-espacio/name": "Aviation & Space",
  "hyperseguros-web/industries/aviacion-y-espacio/tagline":
    "Hull, liability, war, hangars, airports and drones, placed with specialist markets and run from Mexico like any other policy.",
  "hyperseguros-web/industries/bienes-raices/heading-emphasis":
    "It's one policy per building, or one for all",
  "hyperseguros-web/industries/bienes-raices/heading-muted":
    "A real estate portfolio isn't a building.",
  "hyperseguros-web/industries/bienes-raices/meta-description":
    "The asset, the rent and the liability of admitting people: owners, developers, funds and REITs, property managers and industrial parks in Mexico.",
  "hyperseguros-web/industries/bienes-raices/meta-title":
    "Hyper - Insurance for Real Estate in Mexico",
  "hyperseguros-web/industries/bienes-raices/name": "Real Estate",
  "hyperseguros-web/industries/bienes-raices/tagline":
    "Property, loss of rent, liability and the catastrophe cover that in Mexico decides an asset's value. A program for the portfolio, not per property.",
  "hyperseguros-web/industries/ciencias-de-la-vida/heading-emphasis":
    "The line where even the fine print is regulated",
  "hyperseguros-web/industries/ciencias-de-la-vida/heading-muted":
    "COFEPRIS, clinical trials and product recalls.",
  "hyperseguros-web/industries/ciencias-de-la-vida/meta-description":
    "Product, trial, plant and batch, in a sector COFEPRIS regulates: pharmaceutical firms, biotech, medical devices, clinical labs and distributors.",
  "hyperseguros-web/industries/ciencias-de-la-vida/meta-title":
    "Hyper - Insurance for Life Sciences and Pharma",
  "hyperseguros-web/industries/ciencias-de-la-vida/name":
    "Life Sciences, Pharma & Chemicals",
  "hyperseguros-web/industries/ciencias-de-la-vida/tagline":
    "Pharmaceutical, biotech, medical devices and laboratories, with product liability, clinical trials, recall, cyber and refrigerated cargo. Regulated, and still understandable.",
  "hyperseguros-web/industries/construccion/heading-emphasis":
    "We provide the first two",
  "hyperseguros-web/industries/construccion/heading-muted":
    "Every project demands bonds, policies and patience.",
  "hyperseguros-web/industries/construccion/meta-description":
    "From the tender to the handover with one team: builders, EPC contractors, subcontractors, developers and infrastructure concession holders in Mexico.",
  "hyperseguros-web/industries/construccion/meta-title":
    "Hyper - Insurance and Surety for Construction",
  "hyperseguros-web/industries/construccion/name":
    "Construction, Engineering & Infrastructure",
  "hyperseguros-web/industries/construccion/tagline":
    "Bid, performance, advance payment, latent defects, contractors' all risks, equipment and liability: the full cycle of a project with one team. Monday's progress meeting is still yours.",
  "hyperseguros-web/industries/deportes/heading-emphasis":
    "We insure everything but the score",
  "hyperseguros-web/industries/deportes/heading-muted":
    "Clubs, leagues, stadiums and athletes.",
  "hyperseguros-web/industries/deportes/meta-description":
    "Athletes, venues, events and federations: professional clubs and teams, leagues, stadiums and arenas, promoters, gyms and sports academies in Mexico.",
  "hyperseguros-web/industries/deportes/meta-title":
    "Hyper - Insurance for Sports and Clubs in Mexico",
  "hyperseguros-web/industries/deportes/name": "Sports",
  "hyperseguros-web/industries/deportes/tagline":
    "Accident cover for athletes, event cancellation, venue liability and D&O for federations. We accept disciplines and calendars that scare other policies.",
  "hyperseguros-web/industries/ecuestre/heading-emphasis":
    "A line with more pedigree than policies",
  "hyperseguros-web/industries/ecuestre/heading-muted":
    "Horses, breeders, racetracks and schools.",
  "hyperseguros-web/industries/ecuestre/meta-description":
    "The horse, the rider, the stable and the track: studs, riding clubs, schools, racecourses, competition owners, hauliers and equine veterinarians.",
  "hyperseguros-web/industries/ecuestre/meta-title":
    "Hyper - Equine Insurance in Mexico",
  "hyperseguros-web/industries/ecuestre/name": "Equestrian / Equine",
  "hyperseguros-web/industries/ecuestre/tagline":
    "Horse mortality and accident cover, liability for facilities, rider accidents and animal transport. A niche almost nobody underwrites and we do place.",
  "hyperseguros-web/industries/educacion/heading-emphasis":
    "Let insurance not be the topic of any",
  "hyperseguros-web/industries/educacion/heading-muted":
    "Schools and universities hold a lot of board meetings.",
  "hyperseguros-web/industries/educacion/meta-description":
    "Students, teachers, campuses and boards: private schools, universities, nurseries, education networks and public education institutions in Mexico.",
  "hyperseguros-web/industries/educacion/meta-title":
    "Hyper - Insurance for Schools and Universities",
  "hyperseguros-web/industries/educacion/name": "Education",
  "hyperseguros-web/industries/educacion/tagline":
    "School accidents, orphan benefit, campus liability, property damage and board D&O, built as one comprehensive school program. From recess to the board room.",
  "hyperseguros-web/industries/energia/heading-emphasis":
    "Policies, in layers of reinsurance",
  "hyperseguros-web/industries/energia/heading-muted":
    "In energy, risks are measured in megawatts.",
  "hyperseguros-web/industries/energia/meta-description":
    "Plants, parks, pipelines and contracts: renewable generators, oil, gas and petrochemicals, distribution, service stations and their contractors.",
  "hyperseguros-web/industries/energia/meta-title":
    "Hyper - Insurance for the Energy Sector in Mexico",
  "hyperseguros-web/industries/energia/name": "Energy & Natural Resources",
  "hyperseguros-web/industries/energia/tagline":
    "Property, engineering, interruption, environmental liability, political risk and SRCC, placed with international reinsurance. For plants, farms, pipelines and contracts with the regulator.",
  "hyperseguros-web/industries/hoteleria-y-turismo/heading-emphasis":
    "The program knows",
  "hyperseguros-web/industries/hoteleria-y-turismo/heading-muted":
    "High season starts when hurricane season ends.",
  "hyperseguros-web/industries/hoteleria-y-turismo/meta-description":
    "The hotel, the guest, the activity and the date: hotels and resorts, tour and adventure operators, parks, venues, restaurants and marinas in Mexico.",
  "hyperseguros-web/industries/hoteleria-y-turismo/meta-title":
    "Hyper - Insurance for Hospitality and Tourism",
  "hyperseguros-web/industries/hoteleria-y-turismo/name":
    "Hospitality, Tourism & Entertainment",
  "hyperseguros-web/industries/hoteleria-y-turismo/tagline":
    "Property with windstorm, parametric hurricane, guest liability, event cancellation and accident cover for activities. For hotels, resorts, operators and venues that live by the calendar.",
  "hyperseguros-web/industries/instituciones-financieras/heading-emphasis":
    "We build it so it also works",
  "hyperseguros-web/industries/instituciones-financieras/heading-muted":
    "The regulator already asked for the insurance.",
  "hyperseguros-web/industries/instituciones-financieras/meta-description":
    "The money, the data, the board and the loan book: banks and financial groups, non-bank lenders, credit unions, fintechs, brokerages and fund managers.",
  "hyperseguros-web/industries/instituciones-financieras/meta-title":
    "Hyper - Insurance for Financial Institutions",
  "hyperseguros-web/industries/instituciones-financieras/name":
    "Financial Institutions",
  "hyperseguros-web/industries/instituciones-financieras/tagline":
    "Bankers Blanket Bond, D&O, E&O, cyber, fidelity and loan-book protection with credit life. For banks, SOFOMs, fintechs, credit unions and insurers.",
  "hyperseguros-web/industries/manufactura/heading-emphasis":
    "The insurance program should too",
  "hyperseguros-web/industries/manufactura/heading-muted":
    "The plant has a maintenance plan.",
  "hyperseguros-web/industries/manufactura/meta-description":
    "The plant, the line, the batch and the truck: maquiladoras, automotive and aerospace suppliers, food, chemicals, metalworking and plastics firms.",
  "hyperseguros-web/industries/manufactura/meta-title":
    "Hyper - Insurance for Manufacturing in Mexico",
  "hyperseguros-web/industries/manufactura/name": "Manufacturing & Industry",
  "hyperseguros-web/industries/manufactura/tagline":
    "Property with machinery breakdown, business interruption, product liability and recall, environmental, cargo and fleets. For plants, maquiladoras and suppliers, with risk engineering that actually visits the plant.",
  "hyperseguros-web/industries/maritimo/heading-emphasis":
    "We explain them in Spanish",
  "hyperseguros-web/industries/maritimo/heading-muted":
    "At sea, policies are written in English.",
  "hyperseguros-web/industries/maritimo/meta-description":
    "The vessel, the owner, the port and the cargo: shipping lines, ports and terminals, shipping agents, fishing fleets, shipyards and marinas in Mexico.",
  "hyperseguros-web/industries/maritimo/meta-title":
    "Hyper - Marine Industry Insurance in Mexico",
  "hyperseguros-web/industries/maritimo/name": "Marine",
  "hyperseguros-web/industries/maritimo/tagline":
    "Hull and machinery, P&I, port liability, cargo and pollution, placed with London markets and run from Mexico. For shipowners, ports, fishing fleets, shipyards and yachts.",
  "hyperseguros-web/industries/mineria/heading-emphasis":
    "Each stage with its policy and its bond",
  "hyperseguros-web/industries/mineria/heading-muted":
    "Exploration, extraction, closure.",
  "hyperseguros-web/industries/mineria/meta-description":
    "Pit, plant, tailings dams, equipment and concession, from exploration to closure: operators, mining contractors, suppliers and processing plants.",
  "hyperseguros-web/industries/mineria/meta-title":
    "Hyper - Insurance and Surety for Mining in Mexico",
  "hyperseguros-web/industries/mineria/name": "Mining",
  "hyperseguros-web/industries/mineria/tagline":
    "Property in pit and plant, heavy equipment, environmental liability, interruption, political risk and the guarantees the concession requires. For mines, contractors and suppliers in places where the adjuster takes a while to arrive.",
  "hyperseguros-web/industries/private-equity/heading-emphasis":
    "We insure the deal, the companies and the board",
  "hyperseguros-web/industries/private-equity/heading-muted":
    "A fund buys companies.",
  "hyperseguros-web/industries/private-equity/meta-description":
    "The deal, the portfolio companies and the board: private equity, venture capital, family offices, debt funds and M&A advisers operating in Mexico.",
  "hyperseguros-web/industries/private-equity/meta-title":
    "Hyper - Insurance for Private Equity and Funds",
  "hyperseguros-web/industries/private-equity/name":
    "Private Equity / Financial Sponsors",
  "hyperseguros-web/industries/private-equity/tagline":
    "D&O, warranty and indemnity, cyber and programs for the whole portfolio, with insurance due diligence before closing. For funds, family offices and sponsors.",
  "hyperseguros-web/industries/retail-y-consumo/heading-emphasis":
    "The program follows it",
  "hyperseguros-web/industries/retail-y-consumo/heading-muted":
    "Inventory moves all day.",
  "hyperseguros-web/industries/retail-y-consumo/meta-description":
    "The store, the shelf, the truck and the till: chains and department stores, supermarkets, franchises, e-commerce, last mile and consumer brands.",
  "hyperseguros-web/industries/retail-y-consumo/meta-title":
    "Hyper - Insurance for Retail and Consumer Goods",
  "hyperseguros-web/industries/retail-y-consumo/name": "Retail & Consumer",
  "hyperseguros-web/industries/retail-y-consumo/tagline":
    "Multi-site property, stock throughput, product liability and recall, SRCC, crime and delivery fleets. For chains, franchises, e-commerce and distributors with many points of sale.",
  "hyperseguros-web/industries/salud/heading-emphasis":
    "This is the one for insurance",
  "hyperseguros-web/industries/salud/heading-muted":
    "A hospital has protocols for everything.",
  "hyperseguros-web/industries/salud/meta-description":
    "The medical act, the hospital, the record and the staff: private hospitals, clinics, medical groups, laboratories, imaging and ambulance services.",
  "hyperseguros-web/industries/salud/meta-title":
    "Hyper - Insurance for Hospitals and Healthcare",
  "hyperseguros-web/industries/salud/name": "Healthcare",
  "hyperseguros-web/industries/salud/tagline":
    "Medical malpractice, hospital liability, cyber for clinical records, property and medical equipment, D&O and benefits for staff. For hospitals, clinics, laboratories and medical groups.",
  "hyperseguros-web/industries/sector-publico/heading-emphasis":
    "The law asks for someone who understands it",
  "hyperseguros-web/industries/sector-publico/heading-muted":
    "The tender asks for insurance.",
  "hyperseguros-web/industries/sector-publico/meta-description":
    "Assets, people and public officials, through public tender: federal agencies, state governments, municipalities and decentralised public bodies.",
  "hyperseguros-web/industries/sector-publico/meta-title":
    "Hyper - Insurance for the Public Sector in Mexico",
  "hyperseguros-web/industries/sector-publico/name":
    "Public Sector (Government)",
  "hyperseguros-web/industries/sector-publico/tagline":
    "Property programs, institutional life, public officials liability, parametrics and external insurance advisory. For agencies, states, municipalities and public bodies that buy by tender.",
  "hyperseguros-web/industries/servicios-profesionales/heading-emphasis":
    "And on a policy they hardly ever mention",
  "hyperseguros-web/industries/servicios-profesionales/heading-muted":
    "Firms and consultancies live on their reputation.",
  "hyperseguros-web/industries/servicios-profesionales/meta-description":
    "The judgement, the team and the firm: law firms and notaries, accountants and auditors, architects and engineers, consultancies and valuers.",
  "hyperseguros-web/industries/servicios-profesionales/meta-title":
    "Hyper - Insurance for Professional Services",
  "hyperseguros-web/industries/servicios-profesionales/name":
    "Professional Services",
  "hyperseguros-web/industries/servicios-profesionales/tagline":
    "Professional liability, E&O, cyber, D&O and benefits for the team. For lawyers, accountants, architects, engineers, consultants and agents who sign what they say.",
  "hyperseguros-web/industries/tecnologia-medios-y-telecomunicaciones/heading-emphasis":
    "They have contracts, data and a board",
  "hyperseguros-web/industries/tecnologia-medios-y-telecomunicaciones/heading-muted":
    "Technology companies don't have a factory.",
  "hyperseguros-web/industries/tecnologia-medios-y-telecomunicaciones/meta-description":
    "Contracts, data, content and the board: software and SaaS, fintech and platforms, agencies and producers, media and publishing, telecoms and data centres.",
  "hyperseguros-web/industries/tecnologia-medios-y-telecomunicaciones/meta-title":
    "Hyper - Insurance for Technology, Media and Telecom",
  "hyperseguros-web/industries/tecnologia-medios-y-telecomunicaciones/name":
    "Technology, Media & Telecommunications",
  "hyperseguros-web/industries/tecnologia-medios-y-telecomunicaciones/tagline":
    "E&O, cyber, D&O, intellectual property and media, with international wordings for clients who demand named coverages. For software, fintech, media, agencies and telecom.",
  "hyperseguros-web/industries/transporte-y-logistica/heading-emphasis":
    "And answer for them until someone signs for delivery",
  "hyperseguros-web/industries/transporte-y-logistica/heading-muted":
    "You move other people's goods.",
  "hyperseguros-web/industries/transporte-y-logistica/meta-description":
    "The vehicle, the cargo, the driver and the customer who claims: road haulage, 3PL operators, freight forwarders, warehouses and last-mile delivery.",
  "hyperseguros-web/industries/transporte-y-logistica/meta-title":
    "Hyper - Insurance for Transport and Logistics",
  "hyperseguros-web/industries/transporte-y-logistica/name":
    "Transportation & Logistics",
  "hyperseguros-web/industries/transporte-y-logistica/tagline":
    "Fleets, cargo, carrier liability, equipment, traffic bonds and stock throughput. For carriers, logistics operators, freight forwarders and warehouses, with additions and removals issued the same day.",
  "hyperseguros-web/legal/folleto-informativo-intermediacion/meta-description":
    "The disclosure the CNSF requires of every intermediary: how Hyper is authorised, how it is paid, and the insurers and surety companies it works with.",
  "hyperseguros-web/legal/folleto-informativo-intermediacion/meta-title":
    "Hyper - Intermediation Disclosure Notice",
  "hyperseguros-web/legal/folleto-intermediacion/asesoria":
    "Hyper has an obligation to provide its clients with proper advice for entering into, maintaining, or amending insurance contracts, according to what best suits the policyholder. To that end, we will provide accurate information regarding the products, as well as their coverages, premiums, conditions, exclusions, risks, benefits, obligations, and rights, so that you have the elements needed to properly evaluate the different products offered to you, while always respecting your freedom of choice.",
  "hyperseguros-web/legal/folleto-intermediacion/companias-heading":
    "Insurance and/or Bonding Institutions we intermediate with:",
  "hyperseguros-web/legal/folleto-intermediacion/entrega-intro":
    "Once your coverage application has been accepted (or if it already has been), we will deliver the following documentation to you digitally:",
  "hyperseguros-web/legal/folleto-intermediacion/entrega-items":
    "The corresponding policy declarations page (carátula) for the policy purchased.\nThe general conditions and any other documentation related to the insurance or bond contracted.\nThe receipt(s) issued by the corresponding Insurance or Bonding Institution for premium payment, clearly explaining the elements it must contain to be fully valid.",
  "hyperseguros-web/legal/folleto-intermediacion/exhorto-intro":
    "Finally, we urge you, as the policyholder, to:",
  "hyperseguros-web/legal/folleto-intermediacion/exhorto-items":
    "Verify that the documentation matches your application and, where applicable, that it contains the product's registration with the CNSF.\nCheck on the CNSF website the license and authorization details, as well as any sanctions the CNSF may impose on us.",
  "hyperseguros-web/legal/folleto-intermediacion/informacion-adicional-intro":
    "Additionally, Hyper discloses the following information regarding our activity:",
  "hyperseguros-web/legal/folleto-intermediacion/informacion-adicional-items":
    "Under no circumstance should you offer or agree to give Hyper, its executives, and/or employees money or any other consideration (without prejudice to the commission they receive from the Institutions for the services they render, or for services other than intermediation).\nUnder no circumstance accept provisional, informal, or personal receipts from Hyper, its executives, and/or employees.\nUnder no circumstance make advance payments for the contracting of the insurance policy or of an additional coverage.\nVerify at the time of contracting that the documentation matches your application and, where applicable, that it contains the product's registration with the CNSF.\nHyper, its executives, and/or employees, lack the authority to accept risks or to issue or amend policies, as they are neither an Insurance Institution, a Bonding Institution, nor Agents with binding authority (Agentes Mandatarios).",
  "hyperseguros-web/legal/folleto-intermediacion/intro":
    "In compliance with section 32.12.5 of the Single Insurance and Bonding Circular (Circular Única de Seguros y de Fianzas, CUSF) issued by Mexico's National Insurance and Bonding Commission (Comisión Nacional de Seguros y Fianzas, CNSF), Hyper Seguros México Agente de Seguros y de Fianzas S.A. de C.V. (Hyper) discloses the following information about our activity as an Insurance and Bonding Agent.",
  "hyperseguros-web/legal/folleto-intermediacion/posventa-intro":
    "In the process following the sale of insurance and/or bonding products, Hyper will:",
  "hyperseguros-web/legal/folleto-intermediacion/posventa-items":
    "Stay attentive to changes in your risk profile, in order to provide, where applicable, advice or recommendations to adjust your coverages to those changes.\nProvide you with any relevant information regarding the status of the policy you have purchased.\nSupport you in the claims process or with any complaints before the Insurance and/or Bonding Institutions.",
  "hyperseguros-web/legal/folleto-intermediacion/quienes-somos":
    "Hyper is an Insurance Agent (natural person) legally authorized by the CNSF to intermediate insurance, an activity we carry out within the legal framework, with commitment and a sense of responsibility — safeguarding our clients' information at all times and holding Errors & Omissions liability insurance for our activities, which helps guarantee the proper performance of our services as a corporate insurance and bonding agent.",
  "hyperseguros-web/legal/folleto-intermediacion/transparencia-intro":
    "Because one of our responsibilities is to advise on entering into, maintaining, or amending insurance or bonding contracts according to what best suits the policyholder, and in order to strengthen transparency in our intermediation activities by providing information to prevent possible conflicts of interest, Hyper informs you of the following:",
  "hyperseguros-web/legal/folleto-intermediacion/transparencia-items":
    "We hold the proper authorizations issued by the CNSF to intermediate insurance and/or bonds through our Agents (Apoderados), who will identify themselves to you with their full name and the type, number, and validity of their license.\nIn the proposals we deliver to you, we will disclose the Insurance and Bonding Institutions we are considering for that quotation.\nThe proposal we present to you will include an assessment of your insurance and/or bonding needs, based on an analysis of your profile and risk tolerance, including the features of the products being offered, so that you have the elements needed to evaluate the different insurance and/or bonding options — including a link to the relevant Institutions' General Conditions, where you can review terms, exclusions, and the actual scope of the coverages required. The proposal delivered to you will disclose the Insurance and/or Bonding Institutions we considered in preparing that quotation, as well as the most relevant conditions, exclusions, risks, benefits, obligations, and rights, so that you have what you need to properly evaluate the different products offered.\nWe hold Errors & Omissions liability insurance to guarantee the fulfillment of the responsibilities we may incur in connection with our activities as Agent.",
  "hyperseguros-web/legal/nav/title": "Legal",
  "hyperseguros-web/legal/privacidad/arco-body":
    "You have the right to know what personal data we hold, what we use it for and the conditions under which we use it (Access). You likewise have the right to request the correction of your personal information if it is outdated, inaccurate or incomplete (Rectification); to have it removed from our records or databases when you believe it is not being used properly (Cancellation); and to object to the use of your personal data for specific purposes (Objection). These rights are known as ARCO rights.\n\nTo exercise your ARCO rights, send your request to the Personal Data Protection Department of Hyper at privacidad@hyper.mx. The request must include: (i) your name and an address or email to receive the response; (ii) a copy of your official identification or, if you act through a representative, that of the representative and the document evidencing the representation; (iii) a clear description of the data over which you wish to exercise the right, unless it is a request for access; (iv) the right you wish to exercise or what you request, and (v) any document that helps locate your data. If you request a rectification, indicate the correction and attach the documentation supporting it.\n\nWe will communicate our response within a maximum of 20 business days from receipt of your request and, if it is granted, we will give effect to it within the following 15 business days. These periods may be extended once for an equal period when the circumstances justify it. We will deliver the information to you by email in digital format, including copies of the recordings and conversations that correspond to you. Exercising these rights is free of charge; only the costs of reproduction or shipping may be charged.",
  "hyperseguros-web/legal/privacidad/arco-heading":
    "Access, Rectification, Cancellation or Objection to the Processing of Your Personal Data (ARCO Rights)",
  "hyperseguros-web/legal/privacidad/cambios-body":
    "This Privacy Notice may be modified, changed or updated as a result of new legal requirements; our own needs regarding the products or services we offer; our privacy practices; changes to our business model, or other causes.\n\nHyper will inform you of any change to this notice through www.hyper.mx/legal/privacidad and by email to its clients.",
  "hyperseguros-web/legal/privacidad/cambios-heading":
    "Changes to this Privacy Notice",
  "hyperseguros-web/legal/privacidad/companias-heading":
    "The insurance and/or bonding companies with which your data may be shared, on a non-exhaustive, illustrative basis, are:",
  "hyperseguros-web/legal/privacidad/conservacion-col-informacion":
    "Information",
  "hyperseguros-web/legal/privacidad/conservacion-col-plazo": "Period",
  "hyperseguros-web/legal/privacidad/conservacion-heading": "Retention periods",
  "hyperseguros-web/legal/privacidad/conservacion-intro":
    "Hyper keeps your data for the time necessary for the purposes of this notice and to comply with its legal obligations. Once that period ends, the data is blocked and then securely deleted.",
  "hyperseguros-web/legal/privacidad/conservacion-row-1-informacion":
    "Call recordings and WhatsApp conversations",
  "hyperseguros-web/legal/privacidad/conservacion-row-1-plazo":
    "10 years from the date of the communication",
  "hyperseguros-web/legal/privacidad/conservacion-row-2-informacion":
    "Files you send us",
  "hyperseguros-web/legal/privacidad/conservacion-row-2-plazo":
    "They are added to your file and kept for 10 years after your relationship with Hyper ends",
  "hyperseguros-web/legal/privacidad/conservacion-row-3-informacion":
    "Record of the communications",
  "hyperseguros-web/legal/privacidad/conservacion-row-3-plazo":
    "The same period as the recording or conversation it belongs to",
  "hyperseguros-web/legal/privacidad/conservacion-suspension":
    "These periods are suspended while there is a proceeding, complaint or request from an authority related to the information.",
  "hyperseguros-web/legal/privacidad/cookies-body":
    "We inform you that our website uses cookies, web beacons and other technologies that make it possible to monitor your behaviour as an internet user, provide you with a better service and experience while browsing our site, and offer you new products and services based on your preferences.\n\nThe personal data we collect through these tracking technologies is the following: browsing schedule, time spent browsing our website, sections consulted, and websites accessed before ours.",
  "hyperseguros-web/legal/privacidad/cookies-heading":
    "Tracking technologies on our website",
  "hyperseguros-web/legal/privacidad/datos-financieros":
    "**Financial and asset data.** Hyper processes data such as the CLABE account for the payment of indemnities or reimbursements, account statements and proof of payment solely for the primary purposes of this notice. Its processing does not require additional consent, as it is necessary to fulfil the insurance contract and your relationship with Hyper (article 9, section IV of the LFPDPPP).",
  "hyperseguros-web/legal/privacidad/datos-recabados-heading":
    "Personal Data We Collect",
  "hyperseguros-web/legal/privacidad/datos-recabados-intro":
    "To carry out the purposes described in this Privacy Notice, we will use the following personal data:",
  "hyperseguros-web/legal/privacidad/datos-recabados-items":
    "Identification data.\nContact data.\nEmployment data.\nAsset and/or financial data.\nThe telephone number from which you call or write to us and, where applicable, your WhatsApp profile name.\nVoice, contained in the recording of calls and in the voice notes you send us. Hyper does not use your voice to identify you through biometric recognition.\nContent of the communications: what you tell us in calls and write to us on WhatsApp.\nFiles you send us or that we send you on WhatsApp, such as photographs, PDF documents, identification documents, receipts and voice notes.\nRecord of the communications: telephone number, date and time, duration, channel, area or menu option chosen and the executive who assisted you.",
  "hyperseguros-web/legal/privacidad/datos-sensibles-1":
    "**Sensitive personal data.** For some primary purposes, in particular the contracting of personal insurance (life, medical expenses and accidents) and the handling of claims, Hyper processes sensitive personal data, such as information about your present or past health status, diagnoses, treatments, medical reports, invoices for medical services and death certificates. This data may be contained in what you tell us in a recorded call, in the messages you write to us on WhatsApp or in the files you send us through that channel.",
  "hyperseguros-web/legal/privacidad/datos-sensibles-2":
    "Hyper will process this data solely for the primary purposes of this notice. Its processing does not require consent, as it is necessary to exercise the rights and fulfil the obligations arising from the insurance contract and from your intermediation relationship with Hyper (article 9, section IV of the LFPDPPP). In the case of persons who have no direct relationship with Hyper, such as insured persons under group policies or beneficiaries, the processing relies on the consent they give in writing in the insurance application or in the insurer's claim form. Hyper will add it to your file with reinforced security measures and will keep it in a single repository for the period indicated in the retention section. We ask you not to send health information on WhatsApp other than what the executive requests from you for your procedure.",
  "hyperseguros-web/legal/privacidad/datos-terceros":
    "**Third-party data.** If you provide us with data of other persons (insured persons, beneficiaries, dependants or deceased persons), you declare that you have the authority or authorisation to do so and undertake to make this notice known to them.",
  "hyperseguros-web/legal/privacidad/finalidades-primarias-heading":
    "Primary purposes",
  "hyperseguros-web/legal/privacidad/finalidades-primarias-intro":
    "They are necessary for the legal relationship between you and Hyper:",
  "hyperseguros-web/legal/privacidad/finalidades-primarias-items":
    "Provide the services and/or products Hyper offers, as well as carry out periodic evaluations of them in order to improve their quality.\nFulfill the obligations undertaken with clients.\nPrepare and carry out the collection of the insurance and/or bond policy(ies).\nPrepare and deliver the corresponding fiscal receipt(s).\nCarry out the renewal of the respective policies.\nSupport and follow up in the event of a claim.\nInform you of any change regarding the policy.\nAnswer the telephone calls and WhatsApp conversations that you start or that Hyper starts with you, route them to the corresponding area and follow them up, and send you administrative notices about your policies, bonds and procedures by email, telephone call or WhatsApp, such as renewals, collection, claims and changes.\nIdentify you and verify your identity before providing you with information about policies, bonds, claims or procedures.\nReceive, review and add to your file the documents, photographs, voice notes and other files you send us, and send you the documents related to your policies, bonds and procedures.\nRecord calls and keep WhatsApp conversations as a record of your requests, instructions, acceptances and agreements, and use them as evidence before the insurer or bonding company, CONDUSEF, CNSF or another authority, or for the defence of your rights or those of Hyper.\nSupervise and evaluate the quality of the service you receive from our executives.\nComply with the legal and regulatory obligations of Hyper as an insurance and bonding agent, including those on client identification and the prevention of transactions with funds of illicit origin.\nPrevent fraud and identity theft and protect the security of our communication channels.\nHandle and resolve your clarifications and complaints.\nIdentify the persons who enter the premises of Hyper, for security and surveillance reasons.",
  "hyperseguros-web/legal/privacidad/finalidades-secundarias-aceptacion":
    "By requesting or contracting a product or service with Hyper, you are understood to accept these purposes if you do not express your objection. For commercial purposes Hyper only uses your contact data, never health or financial data.",
  "hyperseguros-web/legal/privacidad/finalidades-secundarias-baja":
    "You may object or unsubscribe at any time and free of charge: by writing to privacidad@hyper.mx, by telling the executive during a call, by writing BAJA on our WhatsApp or through the link included in our emails. Your unsubscription will apply on every channel within a maximum of 5 business days and we will send you a confirmation. Your objection will not be grounds for denying you the services and products you request or contract with us.",
  "hyperseguros-web/legal/privacidad/finalidades-secundarias-celular":
    "By providing us with your mobile number, you accept that Hyper may contact you at that number, including by WhatsApp, for the purposes of this notice. If you do not end up contracting any product, we will stop sending you commercial information 24 months after your last contact with Hyper.",
  "hyperseguros-web/legal/privacidad/finalidades-secundarias-heading":
    "Secondary purposes",
  "hyperseguros-web/legal/privacidad/finalidades-secundarias-items":
    "Inform you about products and services related to those you requested or have contracted, by email, telephone call or WhatsApp.\nInvite you to answer satisfaction surveys.\nRecruit and hire personnel, directly or indirectly, on behalf of Hyper.\nCarry out internal communications, printed or digital, to encourage the performance of Hyper personnel.",
  "hyperseguros-web/legal/privacidad/intro":
    'In compliance with the Federal Law on the Protection of Personal Data Held by Private Parties published in the Official Gazette of the Federation on March 20, 2025 (hereinafter "LFPDPPP"), its Regulations and other applicable provisions, Hyper Seguros México Agente de Seguros y de Fianzas, S.A. de C.V. ("Hyper"), with domicile at Panzacola 62, Barrio Santa Catarina, Coyoacán, C.P. 04010, Ciudad de México, Mexico, is responsible for the use and protection of your personal data, and in that regard we inform you of the following:',
  "hyperseguros-web/legal/privacidad/limitacion-baja":
    "To limit the use of your data, including transfers that are not necessary for your service, write to privacidad@hyper.mx. To stop receiving promotional messages and surveys on WhatsApp, write BAJA at any time.",
  "hyperseguros-web/legal/privacidad/limitacion-heading":
    "Limiting the Use or Disclosure of Your Personal Data",
  "hyperseguros-web/legal/privacidad/limitacion-intro":
    "So that you may limit the use and disclosure of your personal information, we offer the following means:",
  "hyperseguros-web/legal/privacidad/limitacion-items":
    'Registering with the Public Registry of Users Who Do Not Wish to Receive Advertising Information on Financial Products and Services (REUS), maintained by the National Commission for the Protection and Defense of Users of Financial Services (hereinafter "Condusef"). For more information about this registry, you may consult Condusef\'s website or contact them directly.\nFor more information, send an email to the following address: privacidad@hyper.mx',
  "hyperseguros-web/legal/privacidad/meta-description":
    "Hyper's privacy notice: the personal data we collect, what we use it for, who we transfer it to, and how to exercise your ARCO rights in Mexico.",
  "hyperseguros-web/legal/privacidad/meta-title": "Hyper - Privacy Notice",
  "hyperseguros-web/legal/privacidad/proveedores-heading":
    "Providers that process your data on behalf of Hyper",
  "hyperseguros-web/legal/privacidad/proveedores-intro":
    "To operate our service channels, Hyper relies on providers that process personal data solely on behalf of Hyper and in accordance with its instructions, acting as data processors under the LFPDPPP:",
  "hyperseguros-web/legal/privacidad/proveedores-items":
    "**Amazon Web Services:** hosts, in encrypted form, call recordings, WhatsApp conversations, attachments and the record of communications, on servers located in the United States of America.\n**Meta (WhatsApp Business Platform):** transmits WhatsApp messages between you and Hyper and keeps them temporarily for that purpose only, in data centres that may be located outside Mexico.",
  "hyperseguros-web/legal/privacidad/proveedores-outro":
    "These providers are contractually bound to maintain confidentiality, to apply security measures and not to use your data for their own purposes. Hyper does not authorise them to use your data for advertising or measurement purposes. The communication of data to data processors does not constitute a transfer, so it does not require your consent. Hyper may rely on other technology providers acting as data processors under the same conditions.",
  "hyperseguros-web/legal/privacidad/reaseguro-intro":
    "Additionally, the reinsurance intermediaries with which your data may be shared, on a non-exhaustive, illustrative basis, are:",
  "hyperseguros-web/legal/privacidad/revocacion-body":
    "You may revoke at any time, without retroactive effect, the consent you have given us, by sending your request to privacidad@hyper.mx with the requirements indicated for ARCO rights. If you gave your consent via WhatsApp, you may also revoke it through that channel. We will respond within the same periods. Revocation does not apply when the processing is necessary to comply with a legal obligation, and it may mean that we are unable to continue with the service or procedure you requested from us.",
  "hyperseguros-web/legal/privacidad/revocacion-heading":
    "Revocation of consent",
  "hyperseguros-web/legal/privacidad/seguridad-body":
    "Recordings, conversations, files and records are stored encrypted, with access restricted to the personnel who need them for their duties and a log of every access. If a security breach occurs that significantly affects your economic or moral rights, we will inform you immediately.",
  "hyperseguros-web/legal/privacidad/seguridad-heading": "Security measures",
  "hyperseguros-web/legal/privacidad/telefono-body":
    "Hyper records all the calls you make to our numbers and those our executives make to you, and keeps the full content of WhatsApp conversations, including the files exchanged. On calls you make to our numbers, we will remind you of this before connecting you with an executive.\n\nRecording and retention are necessary to handle and follow up your procedure and to keep a record of what was requested and agreed.\n\nOur executives will never ask you by telephone or WhatsApp for passwords, access codes or full bank card numbers.\n\nYour use of the WhatsApp application is also governed by the terms and privacy policy of WhatsApp, which Hyper does not control.",
  "hyperseguros-web/legal/privacidad/telefono-heading":
    "Service by telephone and WhatsApp",
  "hyperseguros-web/legal/privacidad/transferencia-base-legal":
    "The transfers described in this section do not require your consent, as they are necessary to fulfil the legal relationship between you and Hyper or the contracts entered into in your interest, are made to companies of the same group operating under the same internal processes and policies, or are provided for by law (article 36, sections I, III, IV and VII of the LFPDPPP). Hyper will communicate this privacy notice and the purposes to which you subjected the processing to the recipients.",
  "hyperseguros-web/legal/privacidad/transferencia-heading":
    "Transfer of Personal Data",
  "hyperseguros-web/legal/privacidad/transferencia-intro":
    "We inform you that your personal data may be transferred and processed inside and outside the country by parties other than Hyper. In that regard, your information may be shared with our business partners: Insurers, Bonding Companies and other companies in the insurance sector, in order to manage the services we provide.",
  "hyperseguros-web/legal/privacidad/transferencia-sector":
    "Likewise, Hyper may share your data with other companies in the insurance sector that take part in handling your policy, bond or claim, such as claims adjusters, reinsurance underwriting agencies and risk assessors or inspectors, solely for that purpose.",
  "hyperseguros-web/legal/privacidad/transferencia-tramite":
    "When necessary to handle your policy, bond, claim or complaint, Hyper may share with the corresponding insurer or bonding company and, where applicable, with the reinsurance intermediary, the recordings, conversations and documents related to your procedure.",
  "hyperseguros-web/legal/privacidad/ultima-actualizacion":
    "Last updated: November 5, 2026",
  "hyperseguros-web/legal/privacidad/uso-heading": "Use of your personal data",
  "hyperseguros-web/legal/privacidad/uso-intro":
    "The personal data we collect from you will be used for the following purposes:",
  "hyperseguros-web/legal/terminos/aceptacion-body":
    "By accessing, browsing or using the Site, you state that you have read, understand and agree to be bound by these Terms and by Hyper's Privacy Notice. If you do not agree with them, please refrain from using the Site.\n\nUse of the Site implies your express consent to these Terms applying to you, without prejudice to any particular terms established for specific services.",
  "hyperseguros-web/legal/terminos/aceptacion-heading":
    "1. Acceptance of the Terms",
  "hyperseguros-web/legal/terminos/cambios-body":
    "Hyper may modify these Terms at any time. Changes take effect upon publication on the Site, so we recommend that you review them periodically. Continued use of the Site after publication implies acceptance of the modified Terms.",
  "hyperseguros-web/legal/terminos/cambios-heading": "19. Changes to the Terms",
  "hyperseguros-web/legal/terminos/cookies-body":
    "The Site uses cookies, web beacons and other similar technologies, as described in Hyper's Privacy Notice, available at www.hyper.mx/legal/privacidad. By browsing the Site, you acknowledge their use in accordance with that notice.\n\nYou may configure your browser to limit or disable these technologies, which could affect some features of the Site.",
  "hyperseguros-web/legal/terminos/cookies-heading":
    "12. Cookies and similar technologies",
  "hyperseguros-web/legal/terminos/cotizaciones-body":
    "Quotes, proposals or premium estimates that Hyper provides to you are indicative and are prepared with the information you supply. They are subject to review and acceptance by the relevant Insurer or Bonding Company, so they may vary or may not materialize.\n\nThe insurance or bonding contract is concluded only when the Insurer or Bonding Company issues the corresponding policy or bond. The general, particular and special conditions of the issued policy or bond govern the relationship between you and the Insurer or Bonding Company, and prevail over any information published on the Site.\n\nYou are responsible for the accuracy and sufficiency of the information you provide to obtain a quote or to contract. Omitted or inaccurate data may affect risk acceptance, the premium amount or the payment of a claim under applicable law.",
  "hyperseguros-web/legal/terminos/cotizaciones-heading":
    "6. Quotes and contracting",
  "hyperseguros-web/legal/terminos/cuentas-body":
    "Access to Hypernet and HyperSign is through personal, non-transferable credentials. You alone are responsible for keeping them confidential, for all transactions carried out with them, and for immediately notifying Hyper of any unauthorized use or suspicion of it.\n\nYou acknowledge and agree that the access data, verification codes, and authentication and electronic signature mechanisms that Hyper makes available to you replace your handwritten signature and produce the same effects, in accordance with the Commercial Code (Código de Comercio) and other applicable legislation on data messages and electronic signatures. Documents and consents given by these means are fully enforceable against you and may be kept in electronic format.\n\nHyper may suspend or cancel access to these tools when it detects misuse, a breach of these Terms or a risk to information security.",
  "hyperseguros-web/legal/terminos/cuentas-heading":
    "7. Hypernet, HyperSign and access credentials",
  "hyperseguros-web/legal/terminos/datos-body":
    "The processing of personal data you provide through the Site, Hypernet or HyperSign is governed by Hyper's Privacy Notice, available at www.hyper.mx/legal/privacidad. For any matter related to your personal data or the exercise of your ARCO rights, you may write to privacidad@hyper.mx.",
  "hyperseguros-web/legal/terminos/datos-heading":
    "17. Personal data protection",
  "hyperseguros-web/legal/terminos/definiciones-heading": "2. Definitions",
  "hyperseguros-web/legal/terminos/definiciones-intro":
    "For the purposes of these Terms, the following meanings apply:",
  "hyperseguros-web/legal/terminos/definiciones-items":
    "Hyper: Hyper Seguros México Agente de Seguros y de Fianzas S.A. de C.V.\nSite: the website www.hyper.mx and its pages, content and features.\nUser or you: any person who accesses or uses the Site.\nHypernet: Hyper's platform for clients and agents, available at https://portal.hyper.mx.\nHyperSign: Hyper's electronic signature tool.\nInsurers and Bonding Companies: the authorized insurance and bonding institutions that issue the policies and bonds intermediated by Hyper.\nContent: text, images, graphics, logos, trademarks, designs, software and any other material published on the Site.",
  "hyperseguros-web/legal/terminos/disponibilidad-body":
    "Hyper may modify, suspend or discontinue, temporarily or permanently, the Site, Hypernet, HyperSign or any of their features, and may carry out maintenance windows, without prior notice and without liability for Hyper.\n\nHyper is not obliged to keep any particular feature or content available, or to ensure that the Site or the platforms operate without interruption.",
  "hyperseguros-web/legal/terminos/disponibilidad-heading":
    "8. Availability of and changes to the Site and the platforms",
  "hyperseguros-web/legal/terminos/enlaces-body":
    "The Site may contain links to third-party sites or services, including those of Insurers and Bonding Companies. Hyper does not control or endorse those sites, is not responsible for their content, availability or policies, and you access them at your own risk and subject to each third party's terms.",
  "hyperseguros-web/legal/terminos/enlaces-heading":
    "11. Links to third-party sites",
  "hyperseguros-web/legal/terminos/garantias-body":
    'To the extent permitted by law, the Site and its Content are provided "as is" and "as available", without warranties of any kind, express or implied, including those of accuracy, fitness for a particular purpose or continuous availability, without prejudice to section 5.\n\nNothing in this section excludes the rights that applicable law recognizes for you as a user of financial services.',
  "hyperseguros-web/legal/terminos/garantias-heading":
    "13. Disclaimer of warranties",
  "hyperseguros-web/legal/terminos/generales-body":
    "If any provision of these Terms is declared invalid or unenforceable, the remaining provisions will retain their full validity (severability). Hyper's failure to exercise a right does not imply a waiver of it.\n\nThese Terms, together with the Privacy Notice and any specific terms established for Hypernet or HyperSign, constitute the entire agreement between you and Hyper regarding use of the Site.",
  "hyperseguros-web/legal/terminos/generales-heading": "20. General provisions",
  "hyperseguros-web/legal/terminos/indemnizacion-body":
    "You agree to hold harmless Hyper, its officers, employees and representatives from any claim, damage, loss or expense, including reasonable attorneys' fees, arising from your breach of these Terms or your unlawful use of the Site, Hypernet or HyperSign.",
  "hyperseguros-web/legal/terminos/indemnizacion-heading":
    "15. Indemnification",
  "hyperseguros-web/legal/terminos/informativo-body":
    "The information published on the Site about insurance, bonds, coverages, industries and services is purely informational and of a general nature. It does not constitute a binding offer, a personalized recommendation, legal, tax or financial advice, or a promise of risk acceptance or of the issuance of any policy or bond.\n\nHyper strives to keep the information on the Site current and accurate, but does not guarantee that it is free of errors or omissions and may update or modify it at any time without prior notice.",
  "hyperseguros-web/legal/terminos/informativo-heading":
    "5. Informational nature of the Site",
  "hyperseguros-web/legal/terminos/intro":
    'These Terms and Conditions of Use (the "Terms") govern access to and use of the website www.hyper.mx (the "Site"), owned by Hyper Seguros México Agente de Seguros y de Fianzas S.A. de C.V. (Hyper), with domicile at Panzacola 62, Barrio Santa Catarina, Coyoacán, C.P. 04010, Ciudad de México, Mexico. Please read them carefully before using the Site.',
  "hyperseguros-web/legal/terminos/ley-body":
    "These Terms are governed by the federal laws of the United Mexican States. For their interpretation and performance, you and Hyper submit to the jurisdiction of the competent courts of Mexico City, waiving any other venue that may correspond to them by reason of their present or future domicile.",
  "hyperseguros-web/legal/terminos/ley-heading":
    "21. Governing law and jurisdiction",
  "hyperseguros-web/legal/terminos/meta-description":
    "Hyper website terms and conditions: permitted use, quotes and contracting through insurers, Hypernet and HyperSign accounts, liability and governing law.",
  "hyperseguros-web/legal/terminos/meta-title": "Hyper - Terms and Conditions",
  "hyperseguros-web/legal/terminos/propiedad-body":
    '"Hyper", the logos, trademarks, trade names, designs, texts, images, software and other Content of the Site are owned by Hyper or used with authorization from their owners, and are protected by the Federal Copyright Law, the Federal Law for the Protection of Industrial Property and other applicable provisions.\n\nThese Terms grant you no license or right over such elements, other than personal, non-commercial use of the Site. Their reproduction, modification, distribution, public communication or any other use without Hyper\'s prior written authorization is prohibited.',
  "hyperseguros-web/legal/terminos/propiedad-heading":
    "9. Intellectual property",
  "hyperseguros-web/legal/terminos/quejas-body":
    "If you have a question, complaint or clarification about Hyper's intermediation services or about a policy or bond, Hyper will support you in handling it with the relevant Insurer or Bonding Company.\n\nAdditionally, you may go to the Specialized Unit for Inquiries and Claims (Unidad Especializada de Atención de Consultas y Reclamaciones, UNE) of the Insurer or Bonding Company concerned and, where applicable, to the National Commission for the Protection and Defense of Financial Services Users (Comisión Nacional para la Protección y Defensa de los Usuarios de Servicios Financieros, CONDUSEF), in accordance with applicable law.",
  "hyperseguros-web/legal/terminos/quejas-heading":
    "18. Complaints and clarifications",
  "hyperseguros-web/legal/terminos/quienes-somos-body":
    "Hyper is an insurance and bonding agent authorized by Mexico's National Insurance and Bonding Commission (Comisión Nacional de Seguros y Fianzas, CNSF). Hyper acts as an intermediary between you and the Insurers and Bonding Companies: it does not assume risks or issue policies or bonds on its own account.\n\nCoverage, conditions, exclusions and every other obligation arising from an insurance policy or bond rest exclusively with the Insurer or Bonding Company that issues it. You will find more information about our activity as intermediaries in the Intermediation Information Brochure, available at www.hyper.mx/legal/folleto-informativo-intermediacion.",
  "hyperseguros-web/legal/terminos/quienes-somos-heading":
    "3. Who we are and our regulatory status",
  "hyperseguros-web/legal/terminos/responsabilidad-cierre":
    "The foregoing does not limit any liability that Hyper has under applicable law as an insurance and bonding agent.",
  "hyperseguros-web/legal/terminos/responsabilidad-heading":
    "14. Limitation of liability",
  "hyperseguros-web/legal/terminos/responsabilidad-intro":
    "To the maximum extent permitted by law, Hyper will not be liable for:",
  "hyperseguros-web/legal/terminos/responsabilidad-items":
    "Interruptions, failures or unavailability of the Site, Hypernet or HyperSign, when arising from causes beyond its control or from maintenance.\nDamage caused by viruses or other harmful elements that, despite its security measures, may affect your equipment when using the Site.\nA decision to contract or not to contract insurance or a bond based solely on the general information on the Site.\nRisk acceptance, conditions, payment of claims and other obligations that correspond to the issuing Insurer or Bonding Company.\nMisuse of access credentials for reasons attributable to you.",
  "hyperseguros-web/legal/terminos/sugerencias-body":
    "Any ideas, suggestions or comments you send to Hyper about the Site or its services may be used by Hyper freely and without any obligation of consideration, compensation or acknowledgment in your favor.\n\nThese channels must not be used to send personal data; the processing of any personal data is governed exclusively by Hyper's Privacy Notice.",
  "hyperseguros-web/legal/terminos/sugerencias-heading":
    "10. Suggestions and feedback",
  "hyperseguros-web/legal/terminos/ultima-actualizacion":
    "Last updated: September 29, 2026",
  "hyperseguros-web/legal/terminos/uso-heading": "4. Use of the Site",
  "hyperseguros-web/legal/terminos/uso-intro":
    "You agree to use the Site lawfully, in good faith and in accordance with these Terms. The following is prohibited, among other things:",
  "hyperseguros-web/legal/terminos/uso-items":
    "Use the Site for unlawful or fraudulent purposes, or purposes contrary to morality and public order.\nProvide false or inaccurate information, or information belonging to third parties without their authorization.\nAttempt to gain unauthorized access to systems, accounts, networks or databases of Hyper or of third parties.\nIntroduce viruses, malicious code or any element that damages, overloads or interferes with the operation of the Site.\nExtract, copy or collect Site content or data by automated means, except with Hyper's prior written authorization.\nImpersonate another person or pose as a representative of Hyper, an Insurer or a Bonding Company.\nReproduce, distribute or commercially exploit the Site or its Content without authorization.",
  "hyperseguros-web/legal/terminos/vigencia-body":
    "These Terms remain in force while you use the Site. Hyper may restrict, suspend or cancel your access to the Site or the platforms in the event of a breach of these Terms, without prejudice to any other legal remedies available to it.\n\nProvisions that by their nature should survive termination, including those on intellectual property, limitation of liability, indemnification and jurisdiction, will remain in force.",
  "hyperseguros-web/legal/terminos/vigencia-heading":
    "16. Term and termination",
  "hyperseguros-web/nav/a11y/back": "Back",
  "hyperseguros-web/nav/a11y/close-menu": "Close menu",
  "hyperseguros-web/nav/a11y/main-menu": "Main menu",
  "hyperseguros-web/nav/a11y/open-menu": "Open menu",
  "hyperseguros-web/nav/cta/hypernet": "HyperNet",
  "hyperseguros-web/nav/fianzas": "Bonds",
  "hyperseguros-web/nav/groups/accidentes": "Accidents",
  "hyperseguros-web/nav/groups/administrativas": "Administrative",
  "hyperseguros-web/nav/groups/credito": "Credit",
  "hyperseguros-web/nav/groups/danos": "Property",
  "hyperseguros-web/nav/groups/especializados": "Specialty",
  "hyperseguros-web/nav/groups/fidelidad": "Fidelity",
  "hyperseguros-web/nav/groups/judiciales": "Judicial",
  "hyperseguros-web/nav/groups/nosotros": "About",
  "hyperseguros-web/nav/groups/parametricos": "Parametric",
  "hyperseguros-web/nav/groups/personas": "People",
  "hyperseguros-web/nav/groups/por-industria": "By industry",
  "hyperseguros-web/nav/groups/responsabilidad-civil": "Liability",
  "hyperseguros-web/nav/groups/salud": "Health",
  "hyperseguros-web/nav/groups/sector-privado": "Private Sector",
  "hyperseguros-web/nav/groups/sector-publico": "Public Sector",
  "hyperseguros-web/nav/groups/tecnologia": "Technology",
  "hyperseguros-web/nav/groups/transportes": "Transport",
  "hyperseguros-web/nav/groups/vida": "Life",
  "hyperseguros-web/nav/groups/wholesale": "Wholesale",
  "hyperseguros-web/nav/industrias": "Industries",
  "hyperseguros-web/nav/items/accidentes": "Accidents",
  "hyperseguros-web/nav/items/accidentes-escolares": "School Accidents",
  "hyperseguros-web/nav/items/accidentes-laborales": "Workplace Accidents",
  "hyperseguros-web/nav/items/acerca-de-nosotros": "About Us",
  "hyperseguros-web/nav/items/agentes-y-productores": "Agents & Producers",
  "hyperseguros-web/nav/items/anticipo": "Advance Payment Bond",
  "hyperseguros-web/nav/items/arte": "Fine Art",
  "hyperseguros-web/nav/items/asesoria-externa-en-materias-de-seguros":
    "External Insurance Advisory",
  "hyperseguros-web/nav/items/autos": "Auto",
  "hyperseguros-web/nav/items/aviacion": "Aviation",
  "hyperseguros-web/nav/items/bankers-blanket-bond":
    "Bankers Blanket Bond (BBB)",
  "hyperseguros-web/nav/items/beneficios-para-empleados": "Employee Benefits",
  "hyperseguros-web/nav/items/cancelacion-de-eventos": "Event Cancellation",
  "hyperseguros-web/nav/items/carga": "Cargo",
  "hyperseguros-web/nav/items/colectiva": "Blanket Fidelity",
  "hyperseguros-web/nav/items/compra-venta": "Purchase & Sale",
  "hyperseguros-web/nav/items/construccion-todo-riesgo":
    "Contractors' All Risks",
  "hyperseguros-web/nav/items/contacto": "Contact",
  "hyperseguros-web/nav/items/crime": "Crime",
  "hyperseguros-web/nav/items/cumplimiento": "Performance Bond",
  "hyperseguros-web/nav/items/cyber": "Cyber",
  "hyperseguros-web/nav/items/d-o": "Directors & Officers (D&O)",
  "hyperseguros-web/nav/items/deportivo": "Sports",
  "hyperseguros-web/nav/items/deudores": "Credit Life",
  "hyperseguros-web/nav/items/e-o": "Errors & Omissions (E&O)",
  "hyperseguros-web/nav/items/ecoturismo": "Ecotourism",
  "hyperseguros-web/nav/items/equipo-pesado": "Heavy Equipment",
  "hyperseguros-web/nav/items/eventos": "Events",
  "hyperseguros-web/nav/items/flotillas": "Fleets",
  "hyperseguros-web/nav/items/gastos-medicos": "Medical Expenses",
  "hyperseguros-web/nav/items/gastos-medicos-mayores": "Major Medical",
  "hyperseguros-web/nav/items/huracan": "Hurricane",
  "hyperseguros-web/nav/items/hypernet": "HyperNet",
  "hyperseguros-web/nav/items/hypersign": "HyperSign",
  "hyperseguros-web/nav/items/indemnizatorios": "Indemnity Plans",
  "hyperseguros-web/nav/items/individual": "Individual Fidelity",
  "hyperseguros-web/nav/items/interrupcion-de-negocio": "Business Interruption",
  "hyperseguros-web/nav/items/inundacion": "Flood",
  "hyperseguros-web/nav/items/maritimo": "Marine",
  "hyperseguros-web/nav/items/no-penales": "Non-Criminal",
  "hyperseguros-web/nav/items/orfandad": "Orphan Benefit",
  "hyperseguros-web/nav/items/paquete-empresarial": "Business Package (SMEs)",
  "hyperseguros-web/nav/items/penales": "Criminal",
  "hyperseguros-web/nav/items/polizas-patrimoniales": "Property Policies",
  "hyperseguros-web/nav/items/programas-de-afinidad": "Affinity Programs",
  "hyperseguros-web/nav/items/propiedad-todo-riesgo": "Property All Risks",
  "hyperseguros-web/nav/items/rc-ambiental":
    "Environmental & Pollution Liability",
  "hyperseguros-web/nav/items/rc-funcionarios-publicos":
    "Public Officials Liability",
  "hyperseguros-web/nav/items/rc-general": "General Liability",
  "hyperseguros-web/nav/items/rc-medica-malpraxis": "Medical Malpractice",
  "hyperseguros-web/nav/items/rc-producto-y-retiro":
    "Product Liability & Product Recall",
  "hyperseguros-web/nav/items/rc-profesional": "Professional Liability",
  "hyperseguros-web/nav/items/riesgo-politico": "Political Risk",
  "hyperseguros-web/nav/items/seguro-de-salud": "Health Insurance",
  "hyperseguros-web/nav/items/seguro-de-vida-institucional":
    "Institutional Life Insurance",
  "hyperseguros-web/nav/items/seguro-escolar-integral":
    "Comprehensive School Insurance",
  "hyperseguros-web/nav/items/seguros-parametricos": "Parametric Insurance",
  "hyperseguros-web/nav/items/sostenimiento-de-oferta": "Bid Bond",
  "hyperseguros-web/nav/items/srcc": "Strikes, Riots & Civil Commotion (SRCC)",
  "hyperseguros-web/nav/items/stock-throughput": "Stock Throughput",
  "hyperseguros-web/nav/items/suministro": "Supply",
  "hyperseguros-web/nav/items/terremoto": "Earthquake",
  "hyperseguros-web/nav/items/viales": "Traffic",
  "hyperseguros-web/nav/items/vicios-ocultos": "Latent Defects Bond",
  "hyperseguros-web/nav/items/vida-grupo": "Group Life",
  "hyperseguros-web/nav/items/wholesale-de-seguros": "Insurance Wholesale",
  "hyperseguros-web/nav/nosotros": "About",
  "hyperseguros-web/nav/programas": "Programs",
  "hyperseguros-web/nav/seguros": "Insurance",
  "hyperseguros-web/products/accidentes-afinidad/heading-emphasis":
    "It shines at nearly 500 hospitals",
  "hyperseguros-web/products/accidentes-afinidad/heading-muted":
    "The benefit that doesn't shine in your membership brochure.",
  "hyperseguros-web/products/accidentes-afinidad/meta-description":
    "The accident benefit already built into your membership or service: accidental death, medical and funeral expenses for your entire customer base.",
  "hyperseguros-web/products/accidentes-afinidad/meta-title":
    "Hyper - Affinity Accident Insurance in Mexico",
  "hyperseguros-web/products/accidentes-afinidad/tagline":
    "No individual application, no medical questionnaire. Enrollment by spreadsheet, a certificate per member, and benefits nobody forgets once they've used them.",
  "hyperseguros-web/products/accidentes-deportivo/heading-emphasis":
    "Nobody leaves because they have it",
  "hyperseguros-web/products/accidentes-deportivo/heading-muted":
    "Nobody joins the club for the insurance.",
  "hyperseguros-web/products/accidentes-deportivo/meta-description":
    "Athletes and staff covered on the pitch, in the gym and in the pool: accident medical expenses, a daily hospital benefit and dismemberment cover.",
  "hyperseguros-web/products/accidentes-deportivo/meta-title":
    "Hyper - Sports Accident Insurance in Mexico",
  "hyperseguros-web/products/accidentes-deportivo/tagline":
    "We cover training, competitions and travel. The only thing we don't cover is the excuse that the insurance was too complicated.",
  "hyperseguros-web/products/accidentes-ecoturismo/heading-emphasis":
    "The coverage climbs without complaining",
  "hyperseguros-web/products/accidentes-ecoturismo/heading-muted":
    "From the meeting point to the summit and back.",
  "hyperseguros-web/products/accidentes-ecoturismo/meta-description":
    "Tourists, guests and guides covered there and back: hiking, climbing, cycling, horse riding and temazcal, with accident medical expenses included.",
  "hyperseguros-web/products/accidentes-ecoturismo/meta-title":
    "Hyper - Adventure Tourism Accident Insurance",
  "hyperseguros-web/products/accidentes-ecoturismo/tagline":
    "Zip lines, diving, ATVs, temazcal: we accept activities other policies would rather see in photos.",
  "hyperseguros-web/products/accidentes-escolares/heading-emphasis":
    "so nobody has to explain anything afterwards",
  "hyperseguros-web/products/accidentes-escolares/heading-muted":
    "The policy your school takes out",
  "hyperseguros-web/products/accidentes-escolares/meta-description":
    "Accident cover for students, teachers and staff, on and off campus: accidental death, medical expenses, dismemberment benefits and funeral expenses.",
  "hyperseguros-web/products/accidentes-escolares/meta-title":
    "Hyper - School Accident Insurance in Mexico",
  "hyperseguros-web/products/accidentes-escolares/tagline":
    "From recess to the school bus and even the online class: settled before anyone has to explain it to the board.",
  "hyperseguros-web/products/accidentes-eventos/heading-emphasis":
    "but arrives before everyone else",
  "hyperseguros-web/products/accidentes-eventos/heading-muted":
    "The one guest who isn't on the list,",
  "hyperseguros-web/products/accidentes-eventos/meta-description":
    "Audience, participants and staff covered before, during and after the event: accidental death, medical expenses and a daily hospitalisation benefit.",
  "hyperseguros-web/products/accidentes-eventos/meta-title":
    "Hyper - Event Accident Insurance in Mexico",
  "hyperseguros-web/products/accidentes-eventos/tagline":
    "Concerts, conferences, expos, festivals: we insure the audience and the staff, even if nobody's going to applaud for it.",
  "hyperseguros-web/products/accidentes-laborales/heading-emphasis":
    "The hospital bill can't",
  "hyperseguros-web/products/accidentes-laborales/heading-muted":
    "The accident paperwork can wait.",
  "hyperseguros-web/products/accidentes-laborales/meta-description":
    "Accident cover for the whole payroll, in any industry: accidental death, medical expenses, dismemberment benefits and advance payment of the sum insured.",
  "hyperseguros-web/products/accidentes-laborales/meta-title":
    "Hyper - Workplace Accident Insurance in Mexico",
  "hyperseguros-web/products/accidentes-laborales/tagline":
    "Other insurers ask for explanations before treating anyone. Here, treatment comes first, at nearly 500 hospitals, 24 hours a day.",
  "hyperseguros-web/products/afinidad/heading-emphasis":
    "your customers actually want to read",
  "hyperseguros-web/products/afinidad/heading-muted": "The fine print",
  "hyperseguros-web/products/afinidad/meta-description":
    "The life cover already built into your product or membership: death benefit, funeral expenses, total and permanent disability and critical illness.",
  "hyperseguros-web/products/afinidad/meta-title":
    "Hyper - Affinity Life Insurance in Mexico",
  "hyperseguros-web/products/afinidad/tagline":
    "It's the benefit your program doesn't advertise in the brochure. And the one your customers are glad to find.",
  "hyperseguros-web/products/arte/heading-emphasis":
    "But it can be insured at agreed value",
  "hyperseguros-web/products/arte/heading-muted":
    "A work of art can't be replaced.",
  "hyperseguros-web/products/arte/meta-description":
    "Works, collections, jewellery and specie insured at agreed value: all risks nail to nail, exhibitions and loans, transit, packing and restoration cover.",
  "hyperseguros-web/products/arte/meta-title":
    "Hyper - Fine Art, Jewellery and Specie Insurance",
  "hyperseguros-web/products/arte/tagline":
    "Works of art, collections, jewellery and specie on exhibition, in transit and in storage, at agreed value and nail to nail. For museums, galleries, collectors and auction houses.",
  "hyperseguros-web/products/autos/heading-emphasis": "We did read it",
  "hyperseguros-web/products/autos/heading-muted":
    "The policy everyone has and nobody has read.",
  "hyperseguros-web/products/autos/meta-description":
    "Own damage, theft and third parties, in comprehensive, limited or liability-only form: occupant medical expenses, legal and roadside help, US cover.",
  "hyperseguros-web/products/autos/meta-title":
    "Hyper - Commercial Motor Insurance in Mexico",
  "hyperseguros-web/products/autos/tagline":
    "For agents who place auto and programs that include it: quoting, issuance and claims through Hypernet. The most common policy, run as if it weren't.",
  "hyperseguros-web/products/aviacion/heading-emphasis":
    "Or without hull and liability cover",
  "hyperseguros-web/products/aviacion/heading-muted":
    "Nobody takes off without a flight plan.",
  "hyperseguros-web/products/aviacion/meta-description":
    "Hull, passenger and third-party liability and war risks, in the air and on the ground: crew, spares and engines, hangars, airports and aerodromes.",
  "hyperseguros-web/products/aviacion/meta-title":
    "Hyper - Aviation Insurance in Mexico",
  "hyperseguros-web/products/aviacion/tagline":
    "Executive, commercial and agricultural aircraft and drones, with hull, liability and war risks placed with specialist reinsurance. A rare line, run without any strangeness.",
  "hyperseguros-web/products/cancelacion-de-eventos/heading-emphasis":
    "This is the plan for when B falls through too",
  "hyperseguros-web/products/cancelacion-de-eventos/heading-muted":
    "Every event has a plan B.",
  "hyperseguros-web/products/cancelacion-de-eventos/meta-description":
    "Months of production and a single date: cancellation, postponement, abandonment, committed costs, non-appearance of the artist and adverse weather.",
  "hyperseguros-web/products/cancelacion-de-eventos/meta-title":
    "Hyper - Event Cancellation Insurance in Mexico",
  "hyperseguros-web/products/cancelacion-de-eventos/tagline":
    "Cancellation, postponement, abandonment and non-appearance, for causes beyond your control. It covers committed costs and the profit the event was going to make.",
  "hyperseguros-web/products/carga/heading-emphasis":
    "The policy, for the whole cargo",
  "hyperseguros-web/products/carga/heading-muted":
    "The carrier is liable for very little.",
  "hyperseguros-web/products/carga/meta-description":
    "Goods from the moment they leave to the moment someone signs: ordinary transit risks, theft, handling, warehouse to warehouse and refrigeration cover.",
  "hyperseguros-web/products/carga/meta-title":
    "Hyper - Cargo and Transit Insurance in Mexico",
  "hyperseguros-web/products/carga/tagline":
    "Ordinary transit risks, theft, loading and unloading and stopovers, warehouse to warehouse and border to border. Per shipment or on an annual declaration policy.",
  "hyperseguros-web/products/common/coming-soon":
    "We're putting the finishing touches on this page. Check back soon for full details.",
  "hyperseguros-web/products/construccion-todo-riesgo/heading-emphasis":
    "The bank does",
  "hyperseguros-web/products/construccion-todo-riesgo/heading-muted":
    "Nobody lays the first stone thinking about insurance.",
  "hyperseguros-web/products/construccion-todo-riesgo/meta-description":
    "From excavation to handover and the maintenance period: civil works, erection, earthquake on site, cross liability and contractors' plant and machinery.",
  "hyperseguros-web/products/construccion-todo-riesgo/meta-title":
    "Hyper - Construction All Risks (CAR) Insurance",
  "hyperseguros-web/products/construccion-todo-riesgo/tagline":
    "Civil works, erection, equipment and cross liability in one policy. From excavation to the maintenance period, without anyone deciphering three contracts.",
  "hyperseguros-web/products/crime/heading-emphasis":
    "The policy trusts the audit",
  "hyperseguros-web/products/crime/heading-muted": "You trust your team.",
  "hyperseguros-web/products/crime/meta-description":
    "For the money that leaves without anyone seeing it go: employee dishonesty, forgery, computer fraud, social engineering and money in transit cover.",
  "hyperseguros-web/products/crime/meta-title":
    "Hyper - Commercial Crime and Fidelity Insurance",
  "hyperseguros-web/products/crime/tagline":
    "Employee dishonesty, forgery, computer fraud, social engineering and money in transit. For losses that don't show up in the inventory but in the bank statement.",
  "hyperseguros-web/products/cyber/heading-emphasis":
    "This is the policy for when it isn't enough",
  "hyperseguros-web/products/cyber/heading-muted":
    "Your company already has a firewall.",
  "hyperseguros-web/products/cyber/meta-description":
    "The whole incident from the first call: response, data restoration, business interruption, ransomware and privacy liability, with a 72-hour playbook.",
  "hyperseguros-web/products/cyber/meta-title":
    "Hyper - Cyber Insurance for Companies in Mexico",
  "hyperseguros-web/products/cyber/tagline":
    "Incident response, data restoration, business interruption, extortion and third-party liability. With a forensic team on the line before the lawyer.",
  "hyperseguros-web/products/deudores/heading-emphasis":
    "No need to become a life-policy expert",
  "hyperseguros-web/products/deudores/heading-muted":
    "We shield your loan book.",
  "hyperseguros-web/products/deudores/meta-description":
    "Protect your loan book without becoming a life underwriter: death, total and permanent disability and unemployment, covered against the balance owed.",
  "hyperseguros-web/products/deudores/meta-title":
    "Hyper - Credit Life Insurance in Mexico",
  "hyperseguros-web/products/deudores/tagline":
    "The credit committee already has enough dull topics. Don't let an unpaid loan be one more.",
  "hyperseguros-web/products/dno/heading-emphasis":
    "The good ones ask whether there is any",
  "hyperseguros-web/products/dno/heading-muted":
    "Nobody joins a board for the insurance.",
  "hyperseguros-web/products/dno/meta-description":
    "The personal wealth of the people who decide: Side A, B and C, legal defence and investigations, employment practices and outside directorships.",
  "hyperseguros-web/products/dno/meta-title":
    "Hyper - D&O Liability Insurance in Mexico",
  "hyperseguros-web/products/dno/tagline":
    "It protects the personal assets of the people who decide: defense, investigations and claims from shareholders, regulators and employees. The policy the board should approve before the budget.",
  "hyperseguros-web/products/eno/heading-emphasis": "It's a cover",
  "hyperseguros-web/products/eno/heading-muted":
    '"Errors and omissions" sounds like an apology.',
  "hyperseguros-web/products/eno/meta-description":
    "For the service you sell and the contract you signed: service failure, breach of contract, legal defence, intellectual property and subcontractors.",
  "hyperseguros-web/products/eno/meta-title":
    "Hyper - Errors and Omissions (E&O) Insurance",
  "hyperseguros-web/products/eno/tagline":
    "It covers claims over failures in the service you sell: software, consulting, intermediation, advertising. With legal defense from the first email from the client's lawyer.",
  "hyperseguros-web/products/equipo-pesado/heading-emphasis":
    "We insure what has no license plates",
  "hyperseguros-web/products/equipo-pesado/heading-muted":
    "Cranes, excavators, tractors.",
  "hyperseguros-web/products/equipo-pesado/meta-description":
    "Cranes, excavators and tractors on site, in transit and in the yard: physical damage in operation, theft, catastrophe perils and hired-in plant.",
  "hyperseguros-web/products/equipo-pesado/meta-title":
    "Hyper - Heavy Equipment Insurance in Mexico",
  "hyperseguros-web/products/equipo-pesado/tagline":
    "Contractors' equipment, owned or leased, in operation, on site and in transit. The cover follows the machine, not the address.",
  "hyperseguros-web/products/fianzas-anticipo/heading-emphasis":
    "The bond is why they trust you",
  "hyperseguros-web/products/fianzas-anticipo/heading-muted":
    "They hand you the money before you start.",
  "hyperseguros-web/products/fianzas-anticipo/meta-description":
    "The guarantee that the advance becomes work: application of the advance, amortisation under the contract and return of the unamortised balance.",
  "hyperseguros-web/products/fianzas-anticipo/meta-title":
    "Hyper - Advance Payment Bond in Mexico",
  "hyperseguros-web/products/fianzas-anticipo/tagline":
    "It guarantees the client that the advance will go into the work or the order and, if not, that it will be returned. It amortizes as you progress: the guaranteed balance drops with every estimate.",
  "hyperseguros-web/products/fianzas-credito-compra-venta/heading-emphasis":
    "Or a bond, which is faster",
  "hyperseguros-web/products/fianzas-credito-compra-venta/heading-muted":
    "Buying in installments takes trust.",
  "hyperseguros-web/products/fianzas-credito-compra-venta/meta-description":
    "The guarantee that the buyer will pay the instalments: payment of the price, outstanding balance, interest and charges on goods sold on credit.",
  "hyperseguros-web/products/fianzas-credito-compra-venta/meta-title":
    "Hyper - Credit Bond for Instalment Sales",
  "hyperseguros-web/products/fianzas-credito-compra-venta/tagline":
    "It guarantees the seller payment of the agreed price in an installment sale: machinery, equipment, vehicles, real estate. If the buyer doesn't pay, the surety does, and then collects.",
  "hyperseguros-web/products/fianzas-credito-suministro/heading-emphasis":
    "The bond covers the ninety",
  "hyperseguros-web/products/fianzas-credito-suministro/heading-muted":
    "You deliver today and collect in ninety days.",
  "hyperseguros-web/products/fianzas-credito-suministro/meta-description":
    "The guarantee that the supplier will get paid: settlement of invoices, the credit line balance, interest and charges on deferred payment terms.",
  "hyperseguros-web/products/fianzas-credito-suministro/meta-title":
    "Hyper - Supply Credit Bond in Mexico",
  "hyperseguros-web/products/fianzas-credito-suministro/tagline":
    "It guarantees the supplier payment for goods or services supplied on credit when the buyer doesn't pay. The buyer takes it out; the supplier requires it.",
  "hyperseguros-web/products/fianzas-cumplimiento/heading-emphasis":
    "And none of them explains",
  "hyperseguros-web/products/fianzas-cumplimiento/heading-muted":
    "The bond every contract asks for.",
  "hyperseguros-web/products/fianzas-cumplimiento/meta-description":
    "The guarantee that you will do what you signed: contract performance, liquidated damages and the labour and tax obligations that come with it.",
  "hyperseguros-web/products/fianzas-cumplimiento/meta-title":
    "Hyper - Performance Bond in Mexico",
  "hyperseguros-web/products/fianzas-cumplimiento/tagline":
    "It guarantees the beneficiary that you will perform the contract on time and as agreed. If you don't, the surety pays and then has a word with you.",
  "hyperseguros-web/products/fianzas-fidelidad-colectiva/heading-emphasis":
    "And no names to update every month",
  "hyperseguros-web/products/fianzas-fidelidad-colectiva/heading-muted":
    "All your employees, one bond.",
  "hyperseguros-web/products/fianzas-fidelidad-colectiva/meta-description":
    "Every position of trust in one bond, with no list of names to update each month: theft, fraud, breach of trust and complicity by any employee.",
  "hyperseguros-web/products/fianzas-fidelidad-colectiva/meta-title":
    "Hyper - Blanket Fidelity Bond in Mexico",
  "hyperseguros-web/products/fianzas-fidelidad-colectiva/tagline":
    "It guarantees the company payment of losses from theft, fraud or breach of trust by any of its employees, without naming them one by one. It covers positions, not people.",
  "hyperseguros-web/products/fianzas-fidelidad-individual/heading-emphasis":
    "One bond carries their name",
  "hyperseguros-web/products/fianzas-fidelidad-individual/heading-muted":
    "One person handles the money.",
  "hyperseguros-web/products/fianzas-fidelidad-individual/meta-description":
    "One position of trust, with a name on it: theft, fraud, breach of trust and complicity, for the person who actually handles the company's money.",
  "hyperseguros-web/products/fianzas-fidelidad-individual/meta-title":
    "Hyper - Individual Fidelity Bond in Mexico",
  "hyperseguros-web/products/fianzas-fidelidad-individual/tagline":
    "It guarantees the company against theft, fraud or breach of trust by a specific employee: the treasurer, the collector, the branch manager. With their name, their position and their sum.",
  "hyperseguros-web/products/fianzas-judiciales-no-penales/heading-emphasis":
    "And won't take your word for it",
  "hyperseguros-web/products/fianzas-judiciales-no-penales/heading-muted":
    "A judge asks for a guarantee.",
  "hyperseguros-web/products/fianzas-judiciales-no-penales/meta-description":
    "The security a civil, family or constitutional judge asks for: maintenance payments, executors, guardians and receivers, and stay of proceedings.",
  "hyperseguros-web/products/fianzas-judiciales-no-penales/meta-title":
    "Hyper - Civil and Family Court Bonds in Mexico",
  "hyperseguros-web/products/fianzas-judiciales-no-penales/tagline":
    "It guarantees the obligations a civil, family, commercial or amparo judge imposes on you during a lawsuit: alimony, estate administration, stay of the contested act, damages from precautionary measures. Issued in hours, because court deadlines don't wait.",
  "hyperseguros-web/products/fianzas-judiciales-penales/heading-emphasis":
    "Without selling the house to guarantee it",
  "hyperseguros-web/products/fianzas-judiciales-penales/heading-muted":
    "To face the proceedings in freedom.",
  "hyperseguros-web/products/fianzas-judiciales-penales/meta-description":
    "The guarantee to face proceedings at liberty: bail security, reparation of damage and financial penalties ordered by a criminal judge in Mexico.",
  "hyperseguros-web/products/fianzas-judiciales-penales/meta-title":
    "Hyper - Criminal Court Bail Bond in Mexico",
  "hyperseguros-web/products/fianzas-judiciales-penales/tagline":
    "It guarantees conditional release, reparation of damages and the financial penalties a criminal judge sets as a precautionary measure. Processed immediately, because in criminal proceedings hours count.",
  "hyperseguros-web/products/fianzas-judiciales-viales/heading-emphasis":
    "And doesn't become a case file",
  "hyperseguros-web/products/fianzas-judiciales-viales/heading-muted":
    "So a crash stays a crash.",
  "hyperseguros-web/products/fianzas-judiciales-viales/meta-description":
    "The driver's guarantee, arranged before the accident: release of the driver, reparation of damage and financial penalties after a collision.",
  "hyperseguros-web/products/fianzas-judiciales-viales/meta-title":
    "Hyper - Road Accident Court Bond in Mexico",
  "hyperseguros-web/products/fianzas-judiciales-viales/tagline":
    "It guarantees the driver's release and reparation of damages when a traffic accident turns into criminal proceedings. Taken out in advance, on an annual term, and activated the day it's needed.",
  "hyperseguros-web/products/fianzas-sostenimiento-de-oferta/heading-emphasis":
    "The bond shouldn't be the hard part",
  "hyperseguros-web/products/fianzas-sostenimiento-de-oferta/heading-muted":
    "Bidding already costs enough.",
  "hyperseguros-web/products/fianzas-sostenimiento-de-oferta/meta-description":
    "The guarantee that your bid is serious: holding prices and conditions, signing the contract and delivering the performance bond that follows.",
  "hyperseguros-web/products/fianzas-sostenimiento-de-oferta/meta-title":
    "Hyper - Bid Bond for Public Tenders in Mexico",
  "hyperseguros-web/products/fianzas-sostenimiento-de-oferta/tagline":
    "It guarantees that, if you win, you will sign the contract and deliver the performance bond. We issue it in hours, because tender deadlines don't wait.",
  "hyperseguros-web/products/fianzas-vicios-ocultos/heading-emphasis":
    "The latent defects bond does",
  "hyperseguros-web/products/fianzas-vicios-ocultos/heading-muted":
    "The handover certificate doesn't close the contract.",
  "hyperseguros-web/products/fianzas-vicios-ocultos/meta-description":
    "The quality guarantee that outlives the handover: latent defects, quality faults and the repair or replacement of what has already been delivered.",
  "hyperseguros-web/products/fianzas-vicios-ocultos/meta-title":
    "Hyper - Latent Defects (Maintenance) Bond",
  "hyperseguros-web/products/fianzas-vicios-ocultos/tagline":
    "It guarantees the quality of the work or goods delivered for the period the contract sets. The client signs the handover at ease; you collect the final payment.",
  "hyperseguros-web/products/flotillas/heading-emphasis":
    "Your policy shouldn't",
  "hyperseguros-web/products/flotillas/heading-muted":
    "Your fleet moves every day.",
  "hyperseguros-web/products/flotillas/meta-description":
    "Every unit on one policy with a single renewal date: damage and theft, liability, cargo and cross liability, and cover for the United States run.",
  "hyperseguros-web/products/flotillas/meta-title":
    "Hyper - Fleet Insurance for Companies in Mexico",
  "hyperseguros-web/products/flotillas/tagline":
    "One policy for the whole fleet, with additions and removals through Hypernet, loss history per unit and the federal-highway liability cover from day one.",
  "hyperseguros-web/products/gmm/heading-emphasis":
    "And the one nobody leaves over",
  "hyperseguros-web/products/gmm/heading-muted":
    "The benefit they do ask about in the interview.",
  "hyperseguros-web/products/gmm/meta-description":
    "Private hospital care without the cashier's desk: hospitalisation and surgery, fees, diagnostics, medicines, maternity and emergency cover abroad.",
  "hyperseguros-web/products/gmm/meta-title":
    "Hyper - Major Medical Expenses Insurance (GMM)",
  "hyperseguros-web/products/gmm/tagline":
    "Hospital network, direct billing and a deductible you understand the first time. The rest is fine print, and we read that too.",
  "hyperseguros-web/products/huracan/heading-emphasis":
    "Just one figure: the category",
  "hyperseguros-web/products/huracan/heading-muted":
    "No adjuster, no damage inventory, no argument.",
  "hyperseguros-web/products/huracan/meta-description":
    "No loss adjuster and no damage inventory: a category, a zone and a sum written into the policy, paid within days of the official measurement.",
  "hyperseguros-web/products/huracan/meta-title":
    "Hyper - Parametric Hurricane Insurance in Mexico",
  "hyperseguros-web/products/huracan/tagline":
    "If the wind reaches the agreed category in your zone, the payout goes out in days, not months. For when the season isn't over yet.",
  "hyperseguros-web/products/interrupcion-de-negocio/heading-emphasis":
    "And by then it's off the market",
  "hyperseguros-web/products/interrupcion-de-negocio/heading-muted":
    "The cover nobody buys until they need it.",
  "hyperseguros-web/products/interrupcion-de-negocio/meta-description":
    "The income that stops when the operation stops: gross profit, fixed costs and payroll, increased cost of working and contingent business interruption.",
  "hyperseguros-web/products/interrupcion-de-negocio/meta-title":
    "Hyper - Business Interruption Insurance in Mexico",
  "hyperseguros-web/products/interrupcion-de-negocio/tagline":
    "It covers what property insurance can't see: the months without revenue. We set the period with you, with a calculator and no optimism.",
  "hyperseguros-web/products/inundacion/heading-emphasis":
    "that doesn't ask for photos of the damage",
  "hyperseguros-web/products/inundacion/heading-muted": "The only flood cover",
  "hyperseguros-web/products/inundacion/meta-description":
    "A water level, a zone and a sum: the trigger is measured from official rainfall or river-level data and the payment lands in days, with no photographs.",
  "hyperseguros-web/products/inundacion/meta-title":
    "Hyper - Parametric Flood Insurance in Mexico",
  "hyperseguros-web/products/inundacion/tagline":
    "When rainfall or the river level crosses the agreed threshold, the payout goes out. For areas and businesses where traditional flood insurance costs too much or doesn't exist.",
  "hyperseguros-web/products/maritimo/heading-emphasis":
    "For what floats, what carries and what docks",
  "hyperseguros-web/products/maritimo/heading-muted":
    "Hull, machinery and P&I.",
  "hyperseguros-web/products/maritimo/meta-description":
    "The vessel, the owner and the port: hull and machinery, protection and indemnity, port and terminal operators' liability, and war and strikes risks.",
  "hyperseguros-web/products/maritimo/meta-title":
    "Hyper - Marine Hull and P&I Insurance in Mexico",
  "hyperseguros-web/products/maritimo/tagline":
    "Hull and machinery, protection and indemnity and liability for ports and operators. Placed with the markets that actually understand ships.",
  "hyperseguros-web/products/medmal/heading-emphasis": "and still get sued",
  "hyperseguros-web/products/medmal/heading-muted":
    "For hospitals and doctors who do everything right",
  "hyperseguros-web/products/medmal/meta-description":
    "For hospitals, clinics and doctors: professional liability, legal defence, CONAMED conciliation, moral damages, trainees and telemedicine cover.",
  "hyperseguros-web/products/medmal/meta-title":
    "Hyper - Medical Malpractice Insurance in Mexico",
  "hyperseguros-web/products/medmal/tagline":
    "Professional liability for doctors, clinics and hospitals, with legal defense and support before CONAMED. You look after patients; we look after the claim.",
  "hyperseguros-web/products/orfandad/heading-emphasis":
    "between being a school and being a debt collector",
  "hyperseguros-web/products/orfandad/heading-muted":
    "So a school doesn't have to choose",
  "hyperseguros-web/products/orfandad/meta-description":
    "Education continuity for the school and the family: death, total and permanent disability and unemployment, in individual, joint or solidary form.",
  "hyperseguros-web/products/orfandad/meta-title":
    "Hyper - Education Continuity Insurance in Mexico",
  "hyperseguros-web/products/orfandad/tagline":
    "Nobody builds a school budget with this in mind. That's why it's worth settling before anyone has to ask.",
  "hyperseguros-web/products/paquete-empresarial/heading-emphasis":
    "It has this policy",
  "hyperseguros-web/products/paquete-empresarial/heading-muted":
    "For the business without a risk department.",
  "hyperseguros-web/products/paquete-empresarial/meta-description":
    "One business, one policy: fire on building and contents, robbery, general liability, glass, money and electronic equipment, for small and mid-sized firms.",
  "hyperseguros-web/products/paquete-empresarial/meta-title":
    "Hyper - Business Package Insurance for SMEs",
  "hyperseguros-web/products/paquete-empresarial/tagline":
    "A package isn't a discount: it's a policy built for a business with better things to do than read nine policies.",
  "hyperseguros-web/products/propiedad-todo-riesgo/heading-emphasis":
    "We read the exceptions",
  "hyperseguros-web/products/propiedad-todo-riesgo/heading-muted":
    "All risks is called that for a reason.",
  "hyperseguros-web/products/propiedad-todo-riesgo/meta-description":
    "Building, contents and everything inside: fire and lightning, earthquake, windstorm and flood, robbery and machinery breakdown, with the exclusions read.",
  "hyperseguros-web/products/propiedad-todo-riesgo/meta-title":
    "Hyper - Property All Risks Insurance in Mexico",
  "hyperseguros-web/products/propiedad-todo-riesgo/tagline":
    "In Mexico, insuring a building without earthquake and windstorm cover is insuring half of it. We insure the whole building.",
  "hyperseguros-web/products/rc-ambiental/heading-emphasis":
    "The guarantee, since you take it out",
  "hyperseguros-web/products/rc-ambiental/heading-muted":
    "The Federal Environmental Liability Act has existed since 2013.",
  "hyperseguros-web/products/rc-ambiental/meta-description":
    "For the pollution, the clean-up and Mexico's environmental liability law: biodiversity damage, remediation, transport of substances and legal defence.",
  "hyperseguros-web/products/rc-ambiental/meta-title":
    "Hyper - Environmental Liability Insurance",
  "hyperseguros-web/products/rc-ambiental/tagline":
    "Sudden and gradual pollution, clean-up costs, damage to third parties and biodiversity, with legal defense. The financial guarantee the law requires, without guessing how much.",
  "hyperseguros-web/products/rc-funcionarios-publicos/heading-emphasis":
    "Neither should signing a memo",
  "hyperseguros-web/products/rc-funcionarios-publicos/heading-muted":
    "Public service shouldn't cost you your assets.",
  "hyperseguros-web/products/rc-funcionarios-publicos/meta-description":
    "For those who decide with public money: patrimonial liability, legal defence, administrative proceedings, and criminal and tax matters in Mexico.",
  "hyperseguros-web/products/rc-funcionarios-publicos/meta-title":
    "Hyper - Public Officials Liability Insurance",
  "hyperseguros-web/products/rc-funcionarios-publicos/tagline":
    "Legal defense and personal liability for people who make decisions in government. Because the Accountability Law doesn't come with instructions.",
  "hyperseguros-web/products/rc-general/heading-emphasis":
    "Until one of them sues you",
  "hyperseguros-web/products/rc-general/heading-muted":
    '"Third parties" is the dullest phrase in insurance.',
  "hyperseguros-web/products/rc-general/meta-description":
    "For what your operation causes others: premises and operations, products, employer's, contractual and tenant liability, plus sudden pollution cover.",
  "hyperseguros-web/products/rc-general/meta-title":
    "Hyper - General Liability Insurance in Mexico",
  "hyperseguros-web/products/rc-general/tagline":
    "It covers what your operation may cause to other people and their property, and pays the defense when someone decides it was your fault.",
  "hyperseguros-web/products/rc-producto-y-retiro/heading-emphasis":
    "It costs like a crisis",
  "hyperseguros-web/products/rc-producto-y-retiro/heading-muted":
    '"Voluntary product recall" sounds like paperwork.',
  "hyperseguros-web/products/rc-producto-y-retiro/meta-description":
    "For what your product causes and what it costs to pull it: third-party damage, exported products, recall expenses and the loss of profit that follows.",
  "hyperseguros-web/products/rc-producto-y-retiro/meta-title":
    "Hyper - Product Liability and Recall Insurance",
  "hyperseguros-web/products/rc-producto-y-retiro/tagline":
    "It covers what your product may cause to someone and what it costs to pull it off the shelves. Food, auto parts, cosmetics, pharma: anything with a batch number.",
  "hyperseguros-web/products/rc-profesional/heading-emphasis":
    "But nobody signs a big contract without one",
  "hyperseguros-web/products/rc-profesional/heading-muted":
    "Nobody hires a firm for its liability policy.",
  "hyperseguros-web/products/rc-profesional/meta-description":
    "For what you advise, calculate and sign: errors, omissions and negligence, legal defence and loss of documents, for firms and licensed professionals.",
  "hyperseguros-web/products/rc-profesional/meta-title":
    "Hyper - Professional Indemnity Insurance in Mexico",
  "hyperseguros-web/products/rc-profesional/tagline":
    "For those who make a living giving advice, opinions and drawings. When the client says the advice turned out expensive, this policy pays for the conversation.",
  "hyperseguros-web/products/riesgo-politico/heading-emphasis":
    "Don't let the government over there change it",
  "hyperseguros-web/products/riesgo-politico/heading-muted":
    "Investing abroad is a business decision.",
  "hyperseguros-web/products/riesgo-politico/meta-description":
    "For when it is the government that changes the rules: expropriation, currency inconvertibility, political violence and sovereign contract default.",
  "hyperseguros-web/products/riesgo-politico/meta-title":
    "Hyper - Political Risk Insurance in Mexico",
  "hyperseguros-web/products/riesgo-politico/tagline":
    "It protects investments, contracts and financing against expropriation, currency restrictions, political violence and government non-payment. For when politics stops being news and becomes a claim.",
  "hyperseguros-web/products/salud-indemnizatorios/heading-emphasis":
    "and doesn't ask what you spend it on",
  "hyperseguros-web/products/salud-indemnizatorios/heading-muted":
    "Health insurance that hands you the money",
  "hyperseguros-web/products/salud-indemnizatorios/meta-description":
    "On diagnosis, a fixed sum you decide how to spend: a closed list of serious conditions, common surgeries, emergencies and traumatic injuries.",
  "hyperseguros-web/products/salud-indemnizatorios/meta-title":
    "Hyper - Indemnity Health Insurance in Mexico",
  "hyperseguros-web/products/salud-indemnizatorios/tagline":
    "On diagnosis, a fixed sum in your account. Public or private hospital, your call. We don't weigh in.",
  "hyperseguros-web/products/seguro-de-salud/heading-emphasis":
    "So it stays that way",
  "hyperseguros-web/products/seguro-de-salud/heading-muted":
    "The insurance you use when nothing is wrong.",
  "hyperseguros-web/products/seguro-de-salud/meta-description":
    "Consultations, lab work and check-ups without waiting for an emergency: preventive medicine, first-contact urgent care, medicines, dental and vision.",
  "hyperseguros-web/products/seguro-de-salud/meta-title":
    "Hyper - Primary Health Insurance in Mexico",
  "hyperseguros-web/products/seguro-de-salud/tagline":
    "Consultations, lab work and preventive care on a dedicated network. It's the plan your team uses every month, not every crisis.",
  "hyperseguros-web/products/srcc/heading-emphasis":
    "The exclusion your property policy ships with",
  "hyperseguros-web/products/srcc/heading-muted": "Roadblocks, looting, riots.",
  "hyperseguros-web/products/srcc/meta-description":
    "The exclusion your property policy ships with: strikes and stoppages, riots, vandalism, blockades, terrorism and the consequential losses they cause.",
  "hyperseguros-web/products/srcc/meta-title":
    "Hyper - Strikes, Riots and Civil Commotion Cover",
  "hyperseguros-web/products/srcc/tagline":
    "Strikes, riots, looting and malicious damage, covered as an extension or a standalone policy. One less exclusion in your property program.",
  "hyperseguros-web/products/terremoto/heading-emphasis":
    "Because there is no adjuster",
  "hyperseguros-web/products/terremoto/heading-muted":
    "The only earthquake cover that doesn't argue with the adjuster.",
  "hyperseguros-web/products/terremoto/meta-description":
    "A magnitude, a distance and a sum: the payout is triggered by the official reading of the quake and arrives in days, with no adjuster and no argument.",
  "hyperseguros-web/products/terremoto/meta-title":
    "Hyper - Parametric Earthquake Insurance in Mexico",
  "hyperseguros-web/products/terremoto/tagline":
    "Magnitude, depth and distance to the epicenter set the payout; the National Seismological Service confirms it. Cash in days to rebuild while traditional insurance is only starting to adjust.",
  "hyperseguros-web/products/vida-grupo/heading-emphasis":
    "but always appreciates having",
  "hyperseguros-web/products/vida-grupo/heading-muted":
    "The benefit your team didn't ask for,",
  "hyperseguros-web/products/vida-grupo/meta-description":
    "The benefit that holds a workforce together: death, funeral expenses, dismemberment, total and permanent disability and critical illness cover.",
  "hyperseguros-web/products/vida-grupo/meta-title":
    "Hyper - Group Life Insurance in Mexico",
  "hyperseguros-web/products/vida-grupo/tagline":
    "We know it's not the most exciting topic in the boardroom. But it's the one your team remembers when it matters.",
  "hyperseguros-web/programs/asesoria-externa-en-materias-de-seguros/heading-emphasis":
    "Let it be someone who understands insurance",
  "hyperseguros-web/programs/asesoria-externa-en-materias-de-seguros/heading-muted":
    "Someone writes the tender documents.",
  "hyperseguros-web/programs/asesoria-externa-en-materias-de-seguros/meta-description":
    "Diagnosis, tender documents, bid evaluation and programme administration for federal agencies, states, municipalities and public sector bodies.",
  "hyperseguros-web/programs/asesoria-externa-en-materias-de-seguros/meta-title":
    "Hyper - External Insurance Advisory for Public Bodies",
  "hyperseguros-web/programs/asesoria-externa-en-materias-de-seguros/tagline":
    "Diagnosis of the insurance program, tender documents, bid evaluation, policy and claims administration for agencies, states and municipalities. Registered with the CNSF as external advisors, hired by public tender.",
  "hyperseguros-web/programs/bankers-blanket-bond/heading-emphasis":
    "and almost no board has read",
  "hyperseguros-web/programs/bankers-blanket-bond/heading-muted":
    "The insurance every bank has",
  "hyperseguros-web/programs/bankers-blanket-bond/meta-description":
    "The global banking fidelity policy, module by module: for banks, non-bank lenders, brokerages, fintechs and cash-in-transit companies in Mexico.",
  "hyperseguros-web/programs/bankers-blanket-bond/meta-title":
    "Hyper - Bankers Blanket Bond (BBB) in Mexico",
  "hyperseguros-web/programs/bankers-blanket-bond/tagline":
    "Employee dishonesty, cash on premises and in transit, forgery, computer fraud and professional liability in one program for banks, SOFOMs, credit unions and fintechs. With the modules the regulator expects and the ones the operation needs.",
  "hyperseguros-web/programs/beneficios-para-empleados/heading-emphasis":
    "A program HR can actually explain",
  "hyperseguros-web/programs/beneficios-para-empleados/heading-muted":
    "Life, medical and accident.",
  "hyperseguros-web/programs/beneficios-para-empleados/meta-description":
    "Life, medical and accident cover in one programme, with one meeting and one layout: for mid-sized and large companies, SMEs and multinationals.",
  "hyperseguros-web/programs/beneficios-para-empleados/meta-title":
    "Hyper - Employee Benefits Programme in Mexico",
  "hyperseguros-web/programs/beneficios-para-empleados/tagline":
    "Group life, major medical, accident and indemnity plans designed as one program, with one renewal, one enrollment file and one point of contact. What the team remembers when it matters, without HR having to remind them.",
  "hyperseguros-web/programs/polizas-patrimoniales/heading-emphasis":
    "Just by public tender",
  "hyperseguros-web/programs/polizas-patrimoniales/heading-muted":
    "The nation's assets are insured too.",
  "hyperseguros-web/programs/polizas-patrimoniales/meta-description":
    "Public assets in one integrated programme with a real inventory: federal agencies, state governments, municipalities and water and transport bodies.",
  "hyperseguros-web/programs/polizas-patrimoniales/meta-title":
    "Hyper - Public Asset Insurance Programmes",
  "hyperseguros-web/programs/polizas-patrimoniales/tagline":
    "Buildings, contents, fleets, equipment, infrastructure and liability for agencies, states and municipalities in one comprehensive program with reinsurance. Designed with the real inventory and tendered with documents insurers can actually quote.",
  "hyperseguros-web/programs/seguro-de-vida-institucional/heading-emphasis":
    "And that gets tendered every year as if it were new",
  "hyperseguros-web/programs/seguro-de-vida-institucional/heading-muted":
    "The benefit the collective agreement requires.",
  "hyperseguros-web/programs/seguro-de-vida-institucional/meta-description":
    "The life benefit for public servants, tendered and administered each year: federal agencies, states, municipalities and state-owned companies.",
  "hyperseguros-web/programs/seguro-de-vida-institucional/meta-title":
    "Hyper - Institutional Group Life Insurance",
  "hyperseguros-web/programs/seguro-de-vida-institucional/tagline":
    "Group life for public servants with the sums, coverages and beneficiaries the law and the collective agreement set. Tender documents that can be evaluated, enrollment files that can be loaded and claims that do get paid.",
  "hyperseguros-web/programs/seguro-escolar-integral/heading-emphasis":
    "One program for the whole school",
  "hyperseguros-web/programs/seguro-escolar-integral/heading-muted":
    "From recess to the board room.",
  "hyperseguros-web/programs/seguro-escolar-integral/meta-description":
    "Students, families, campus and staff in a single programme: private schools, universities, nurseries, education networks and sports academies.",
  "hyperseguros-web/programs/seguro-escolar-integral/meta-title":
    "Hyper - Comprehensive School Insurance Programme",
  "hyperseguros-web/programs/seguro-escolar-integral/tagline":
    "School accidents, orphan benefit, campus liability, property damage and benefits for teachers, built so the school can explain them at a parents' meeting and run them with one enrollment file.",
  "hyperseguros-web/programs/seguros-parametricos/heading-emphasis":
    "The parametric payout doesn't",
  "hyperseguros-web/programs/seguros-parametricos/heading-muted":
    "After the hurricane, the emergency declaration takes time.",
  "hyperseguros-web/programs/seguros-parametricos/meta-description":
    "Hurricane, earthquake and flood with payment in days for states and municipalities: the liquidity that arrives before the emergency declaration.",
  "hyperseguros-web/programs/seguros-parametricos/meta-title":
    "Hyper - Parametric Insurance Programmes in Mexico",
  "hyperseguros-web/programs/seguros-parametricos/tagline":
    "Hurricane, earthquake and flood with public triggers and payouts in days, for states and municipalities that need cash before the declaration. The same mechanism the federal catastrophe insurance uses, at the scale of a local budget.",
  "hyperseguros-web/programs/stock-throughput/heading-emphasis":
    "This policy doesn't need to know either",
  "hyperseguros-web/programs/stock-throughput/heading-muted":
    "Your inventory doesn't know whether it's in transit or in storage.",
  "hyperseguros-web/programs/stock-throughput/meta-description":
    "One policy for inventory, from raw material to point of sale: manufacturers, distributors, retailers, importers and logistics operators in Mexico.",
  "hyperseguros-web/programs/stock-throughput/meta-title":
    "Hyper - Stock Throughput Insurance in Mexico",
  "hyperseguros-web/programs/stock-throughput/tagline":
    "One policy for goods from raw material to point of sale: in the plant, in transit, in your warehouse or a third party's. No gaps between the cargo policy and the property policy, and at selling price.",
  "hyperseguros-web/wholesale/heading-emphasis": "We are that work",
  "hyperseguros-web/wholesale/heading-muted":
    "Between you and the carrier there is a lot of work.",
  "hyperseguros-web/wholesale/tagline":
    "A wholesale is what happens when someone decides that running insurance deserved to be done well too.",
  "legal-limit-exceeded": "Legal limit exceeded",
  "legal-limit-exceeded-description": "Legal limit exceeded",
  "mock-error": "mock-error",
  "mock/error-message-string": "mock/error-message-string",
  "mock/error-name": "mock/error-name",
  "not-authorized": "Not Authorized",
  "not-authorized-to-create-object":
    "You do not have permission to save this information. If you need access, contact your administrator. (Ref.: {{modelName}})",
  "not-authorized-to-delete-object":
    "You do not have permission to delete this information. If you need access, contact your administrator. (Ref.: {{modelName}})",
  "not-authorized-to-list-object":
    "You do not have permission to view this information. If you need access, contact your administrator. (Ref.: {{modelName}})",
  "not-authorized-to-read-object":
    "You do not have permission to view this information. If you need access, contact your administrator. (Ref.: {{modelName}})",
  "not-authorized-to-update-object":
    "You do not have permission to update this information. If you need access, contact your administrator. (Ref.: {{modelName}})",
  "notifications/agency-admin-missing/body":
    "A user was deactivated and {{openCases}} open case(s) could not be handed over because their agency has no active director.\n\nAssign each case to a requester of the agency from the case screen.",
  "notifications/agency-admin-missing/subject":
    "Cases without an agency director after a deactivation",
  "notifications/agency-admin-missing/summary":
    "{{openCases}} open case(s) of a deactivated user were left as they were.",
  "notifications/agency-admin-missing/title":
    "Cases without an agency director",
  "notifications/catalogue-update-failed/body":
    "The update for model years {{fromYear}} to {{toYear}} failed: {{failedPortions}} of {{totalPortions}} parts did not complete. Existing versions and their availability were not changed.\n\nOpen Updates in the portal for details and try again.",
  "notifications/catalogue-update-failed/subject":
    "Vehicle catalogue update failed ({{fromYear}}-{{toYear}})",
  "notifications/catalogue-update-failed/summary":
    "No part of the update completed ({{failedPortions}} of {{totalPortions}} failed).",
  "notifications/catalogue-update-failed/title":
    "Vehicle catalogue update failed",
  "notifications/catalogue-update-partial/body":
    "The update for model years {{fromYear}} to {{toYear}} has a partial result: {{failedPortions}} of {{totalPortions}} parts did not complete and the rest was saved ({{new}} new and {{updated}} updated versions).\n\nOpen Updates in the portal to see which parts failed and run those years again.",
  "notifications/catalogue-update-partial/subject":
    "Vehicle catalogue update: partial result ({{fromYear}}-{{toYear}})",
  "notifications/catalogue-update-partial/summary":
    "{{failedPortions}} of {{totalPortions}} parts failed; {{new}} new and {{updated}} updated versions saved.",
  "notifications/catalogue-update-partial/title":
    "Vehicle catalogue update: partial result",
  "notifications/catalogue-update-succeeded/body":
    "The update for model years {{fromYear}} to {{toYear}} finished successfully. New versions: {{new}}. Updated versions: {{updated}}. Of these, {{pending}} await name normalization. Excluded on purpose: {{excluded}}. No rule matched: {{unclassified}}.\n\nSign in to the portal and open Notifications.",
  "notifications/catalogue-update-succeeded/subject":
    "Vehicle catalogue update completed ({{fromYear}}-{{toYear}})",
  "notifications/catalogue-update-succeeded/summary":
    "{{new}} new and {{updated}} updated versions, {{pending}} pending normalization.",
  "notifications/catalogue-update-succeeded/title":
    "Vehicle catalogue update completed",
  "notifications/login-email-changed/body":
    "The login email of your account was changed by an administrator. If you did not expect this, contact your administrator.",
  "notifications/login-email-changed/subject": "Your login email was changed",
  "policy/requester": "Requester",
  "portal/account": "Account",
  "portal/account-is-required": "Account is required",
  "portal/account-users": "Account Users",
  "portal/accounts": "Accounts",
  "portal/add": "Add",
  "portal/add-aircraft": "Add Aircraft",
  "portal/add-commission-table": "Add Table",
  "portal/add-condition": "Add Condition",
  "portal/add-entry": "Add Entry",
  "portal/add-file": "Add File",
  "portal/add-line-of-business": "Add Line of Business",
  "portal/add-lob": "Add Line of Business",
  "portal/add-pipeline": "Add Pipeline",
  "portal/add-pipeline-step": "Add Pipeline Step",
  "portal/add-proposal": "Add Proposal",
  "portal/add-rate-table": "Add Rate Table",
  "portal/add-rate-table-entry": "Add Rate Table Entry",
  "portal/add-step": "Add Step",
  "portal/add-step-condition": "Add Step Condition",
  "portal/add-variable": "Add Variable",
  "portal/address": "Address",
  "portal/address/address-is-required": "Address is required",
  "portal/address/apt-suite": "Apt/Suite",
  "portal/address/existing-address": "Existing Address",
  "portal/address/neighboorhood": "Neighborhood",
  "portal/address/neighborhood-is-required": "Neighborhood is required",
  "portal/address/new-address": "New Address",
  "portal/address/new-or-existing": "New or Existing Address",
  "portal/address/new-or-existing-is-required":
    "New or Existing Address is required",
  "portal/address/street-name": "Street Name",
  "portal/address/street-name-is-required": "Street name is required",
  "portal/address/street-number": "Street Number",
  "portal/address/street-number-is-required": "Street number is required",
  "portal/address/zipcode": "Zipcode",
  "portal/address/zipcode-is-required": "Zipcode is required",
  "portal/addresses": "Addresses",
  "portal/agencies": "Agencies",
  "portal/agencies/add-commission-table": "Add Table",
  "portal/agencies/all": "All Agencies",
  "portal/agencies/edit-commission-table": "Edit Table",
  "portal/agencies/level-1-agency": "Level 1 Agency",
  "portal/agencies/level-1-agency-commission": "Level 1 Agency Commission",
  "portal/agencies/level-2-agency": "Level 2 Agency",
  "portal/agencies/level-2-agency-commission": "Level 2 Agency Commission",
  "portal/agencies/level-3-agency": "Level 3 Agency",
  "portal/agencies/level-3-agency-commission": "Level 3 Agency Commission",
  "portal/agencies/promoter": "Promoter",
  "portal/agencies/promoter-commission": "Promoter Commission",
  "portal/agencies/regional": "Regional",
  "portal/agencies/regional-commission": "Regional Commission",
  "portal/agency": "Agency",
  "portal/agency-is-required": "Agency is required",
  "portal/agency-level": "Agency Level",
  "portal/agency-level-agency1": "Agency Level 1",
  "portal/agency-level-agency2": "Agency Level 2",
  "portal/agency-level-agency3": "Agency Level 3",
  "portal/agency-level-promoter": "Promoter",
  "portal/agency-level-regional": "Regional",
  "portal/agency-users": "Agency Users",
  "portal/agency/add-agent-key": "Add agent key",
  "portal/agency/add-commission-table": "Add commission table",
  "portal/agency/add-participation": "Add participation",
  "portal/agency/add-sub-agency": "Add Sub-agency",
  "portal/agency/create-sub-agency": "Create Sub-agency",
  "portal/agency/edit-alias": "Edit alias",
  "portal/agency/general/agent-keys": "Agent keys",
  "portal/agency/general/all-insurers": "All insurers",
  "portal/agency/general/by-office": "By office",
  "portal/agency/general/chain": "Chain",
  "portal/agency/general/commercial-name": "Commercial name",
  "portal/agency/general/contact": "Contact and incorporation",
  "portal/agency/general/country": "Country",
  "portal/agency/general/email": "Email",
  "portal/agency/general/entity-id": "Entity ID",
  "portal/agency/general/incorporation-date": "Incorporation date",
  "portal/agency/general/legal-entity": "Legal entity",
  "portal/agency/general/legal-person": "Legal person",
  "portal/agency/general/level": "Level",
  "portal/agency/general/mobile": "Mobile",
  "portal/agency/general/natural-person": "Natural person",
  "portal/agency/general/no-expiry": "No expiry",
  "portal/agency/general/no-key-captured": "No key captured",
  "portal/agency/general/no-own-keys": "No keys of its own",
  "portal/agency/general/no-own-keys-house":
    "No keys of its own · uses {{house}}'s keys",
  "portal/agency/general/offices": "Offices",
  "portal/agency/general/parent-agency": "Parent agency",
  "portal/agency/general/pending": "To be confirmed",
  "portal/agency/general/person-type": "Person type",
  "portal/agency/general/positions": "Positions",
  "portal/agency/general/shared-with": "Shared with {{names}}",
  "portal/agency/general/validity": "Validity: {{from}} – {{to}}",
  "portal/agency/keys": "Keys",
  "portal/agency/keys/actions": "Key actions",
  "portal/agency/keys/edit": "Edit key",
  "portal/agency/keys/empty-body-house":
    "Places business with {{house}}'s keys.",
  "portal/agency/keys/empty-body-house-keys":
    "Places business with {{house}}'s keys ({{keys}}).",
  "portal/agency/keys/empty-title": "No keys of its own",
  "portal/agency/keys/history": "History",
  "portal/agency/keys/own": "Own",
  "portal/agency/keys/retire": "Retire",
  "portal/agency/keys/retire-message":
    "The key stops being in force today for {{nodes}}. Issued policies keep the key they were issued with.",
  "portal/agency/keys/retire-message-no-nodes":
    "The key stops being in force today. Issued policies keep the key they were issued with.",
  "portal/agency/keys/retire-title": "Retire the key {{code}}",
  "portal/agency/keys/shared": "Shared",
  "portal/agency/keys/valid-between": "In force from {{from}} to {{to}}",
  "portal/agency/keys/valid-since": "In force since {{from}}",
  "portal/agency/legal-entity": "Legal entity",
  "portal/agency/parent-not-found": "Parent agency not found",
  "portal/agency/parents": "Parents",
  "portal/agency/positions-one": "1 position",
  "portal/agency/positions-other": "{{count}} positions",
  "portal/agency/program": "Program",
  "portal/agency/reparent-participation": "Change parents",
  "portal/agency/shared-participation": "Shared",
  "portal/agency/sheet/alias-hint": "Optional · the name shown in the list",
  "portal/agency/sheet/legal-entity-required":
    "Choose a legal entity or add a new one",
  "portal/agency/sheet/level-required": "Level is required",
  "portal/agency/sheet/new-legal-name": "New legal entity",
  "portal/agency/sheet/position": "Position",
  "portal/agency/structure": "Structure",
  "portal/agency/structure/empty":
    "This agency has no position in the structure",
  "portal/agency/structure/this-agency": "This agency",
  "portal/agency/structure/tree": "Structure tree",
  "portal/agent-key/assigned-to": "Assigned to",
  "portal/agent-key/assigned-to-hint":
    "The holder's positions. A key can be assigned to several.",
  "portal/agent-key/code": "Key",
  "portal/agent-key/conflict":
    "{{node}} already has the key {{code}} in force at {{insurer}}",
  "portal/agent-key/edit": "Edit agent key",
  "portal/agent-key/holder": "Holder",
  "portal/agent-key/insurer": "Insurer",
  "portal/agent-key/key-group": "Key",
  "portal/agent-key/new": "New agent key",
  "portal/agent-key/required": "Required",
  "portal/agent-key/valid-from": "Valid from",
  "portal/agent-key/valid-to": "Valid to",
  "portal/agents": "Agents",
  "portal/agents/laipo/actions/approve": "Approve",
  "portal/agents/laipo/actions/archive": "Archive",
  "portal/agents/laipo/actions/cancel": "Cancel",
  "portal/agents/laipo/actions/edit": "Edit",
  "portal/agents/laipo/actions/escalate": "Escalate",
  "portal/agents/laipo/actions/followup": "Follow up",
  "portal/agents/laipo/actions/refresh": "Refresh",
  "portal/agents/laipo/actions/reject": "Reject",
  "portal/agents/laipo/actions/save-and-review": "Save and review",
  "portal/agents/laipo/actions/send": "Send",
  "portal/agents/laipo/archived": "Archived",
  "portal/agents/laipo/card/already-on-thread": "Already on thread",
  "portal/agents/laipo/card/applied-knowledge": "Applied knowledge",
  "portal/agents/laipo/card/brief": "Summary",
  "portal/agents/laipo/card/draft": "Draft",
  "portal/agents/laipo/card/from": "From",
  "portal/agents/laipo/card/intent": "Proposed intent",
  "portal/agents/laipo/card/matched-rule": "Matched rule",
  "portal/agents/laipo/card/subject": "Subject",
  "portal/agents/laipo/chat/counter": "{{count}} / {{max}}",
  "portal/agents/laipo/chat/empty":
    "Teach Laipo how to handle this case and it'll remember for next time.",
  "portal/agents/laipo/chat/failed":
    "Laipo couldn't reply. Tap Retry to try again.",
  "portal/agents/laipo/chat/laipo": "Laipo",
  "portal/agents/laipo/chat/placeholder": "Tell Laipo how to handle this case…",
  "portal/agents/laipo/chat/retry": "Retry",
  "portal/agents/laipo/chat/send": "Send",
  "portal/agents/laipo/chat/title": "Chat with Laipo",
  "portal/agents/laipo/chat/you": "You",
  "portal/agents/laipo/delegated": "Delegated",
  "portal/agents/laipo/escalated": "Escalated",
  "portal/agents/laipo/followup": "Followup",
  "portal/agents/laipo/followup/1-week": "In 1 week",
  "portal/agents/laipo/followup/3-days": "In 3 days",
  "portal/agents/laipo/followup/custom": "Custom date",
  "portal/agents/laipo/followup/submit": "OK",
  "portal/agents/laipo/followup/tomorrow": "Tomorrow",
  "portal/agents/laipo/new": "New",
  "portal/agents/laipo/rejected": "Rejected",
  "portal/agents/laipo/resolver": "Resolver",
  "portal/agents/laipo/teach": "Teach Laipo",
  "portal/agents/laipo/teach/just-absorbed": "Learned",
  "portal/agents/laipo/teach/recent-title": "Recently learned",
  "portal/agents/laipo/teach/submit": "Teach",
  "portal/agents/laipo/teach/textarea-placeholder":
    "Tell Laipo something it should know…",
  "portal/agents/laipo/teach/title": "Teach Laipo",
  "portal/agents/not-found": "Agent not found",
  "portal/aggregation-strategy": "Aggregation Strategy",
  "portal/aircraft-brands": "Aircraft Brands",
  "portal/aircraft-usages": "Aircraft Usages",
  "portal/aircraft-usages-is-required":
    "At least one aircraft usage must be selected",
  "portal/all-policies": "All Policies",
  "portal/all-rights-reserved": "All rights reserved",
  "portal/appearance/auto": "Auto",
  "portal/appearance/close": "Close",
  "portal/appearance/dark": "Dark",
  "portal/appearance/light": "Light",
  "portal/appearance/save-error":
    "Could not save your appearance preference. Try again.",
  "portal/appearance/title": "Appearance",
  "portal/assign-role": "Assign Role",
  "portal/audit-trail/action/catalogue-entry-availability-changed":
    "Availability changed",
  "portal/audit-trail/action/catalogue-mapping-normalized":
    "Dictionary row normalized",
  "portal/audit-trail/action/catalogue-update-started": "Update started",
  "portal/audit-trail/after": "After",
  "portal/audit-trail/before": "Before",
  "portal/audit-trail/empty": "No changes recorded.",
  "portal/audit-trail/load-error": "Could not load the history.",
  "portal/audit-trail/title": "History",
  "portal/authentication/change-password-instructions":
    "You must set a new password to continue.",
  "portal/authentication/change-user": "Change User",
  "portal/authentication/click-continue-to-sign-in":
    "Click continue to sign in",
  "portal/authentication/code-delivery-failed":
    "We could not send the access code to your email. Please contact support.",
  "portal/authentication/confirm-new-password": "Confirm New Password",
  "portal/authentication/confirm-new-password-is-required":
    "Password confirmation is required",
  "portal/authentication/expired-code":
    "The verification code has expired. Please request a new one.",
  "portal/authentication/forgot-password": "Forgot Password",
  "portal/authentication/forgot-password-reset-instructions":
    "Enter the verification code and your new password.",
  "portal/authentication/generic-error":
    "Something went wrong. Please try again.",
  "portal/authentication/invalid-code": "The verification code is invalid.",
  "portal/authentication/invalid-new-password":
    "The new password does not meet the requirements.",
  "portal/authentication/network-error":
    "Unable to connect. Please check your connection and try again.",
  "portal/authentication/new-password": "New Password",
  "portal/authentication/new-password-is-required": "New password is required",
  "portal/authentication/otp": "OTP",
  "portal/authentication/otp-expired":
    "The verification code has expired. Please request a new one.",
  "portal/authentication/otp-instructions": "OTP",
  "portal/authentication/otp-invalid":
    "The verification code is invalid. Please try again.",
  "portal/authentication/otp-is-required": "OTP is required",
  "portal/authentication/otp-session-expired":
    "Your code expired. We sent a new code to your email.",
  "portal/authentication/otp-title": "Verification code",
  "portal/authentication/otp-verification-failed":
    "Verification failed. Please try again.",
  "portal/authentication/password": "Password",
  "portal/authentication/password-at-least-1-lowercase":
    "At least 1 lowercase letter",
  "portal/authentication/password-at-least-1-number": "At least 1 number",
  "portal/authentication/password-at-least-1-special-character":
    "At least 1 special character",
  "portal/authentication/password-at-least-1-uppercase":
    "At least 1 uppercase letter",
  "portal/authentication/password-at-least-8-characters":
    "At least 8 characters",
  "portal/authentication/password-change-failed":
    "Failed to change password. Please try again.",
  "portal/authentication/password-is-invalid":
    "The provided password is not valid",
  "portal/authentication/password-is-required": "Password is required",
  "portal/authentication/password-must-be-changed":
    "You must change your password",
  "portal/authentication/password-reset-failed":
    "Password reset failed. Please try again.",
  "portal/authentication/passwords-do-not-match": "Passwords do not match",
  "portal/authentication/resend-code": "Resend Code",
  "portal/authentication/resend-code-countdown": "Resend Code ({{countdown}})",
  "portal/authentication/resend-code-failed":
    "Failed to resend code. Please try again.",
  "portal/authentication/resend-code-sent":
    "A new code has been sent to your email.",
  "portal/authentication/reset-password-title": "Reset password",
  "portal/authentication/session-error":
    "Unable to load your session. Please try again.",
  "portal/authentication/session-expired":
    "Your sign-in session expired. Please sign in again.",
  "portal/authentication/sso-redirect-message":
    "Click Continue to sign in with your organization's identity provider.",
  "portal/authentication/sso-title": "Single sign-on",
  "portal/authentication/too-many-attempts":
    "Too many attempts. Please wait a moment and try again.",
  "portal/authentication/use-your-account": "Use your {{DisplayName}} account",
  "portal/authentication/user-not-confirmed":
    "Your account is not confirmed. Please check your email.",
  "portal/authentication/user-not-registred":
    "There is no user registered with the provided email",
  "portal/authentication/verification-code": "Verification Code",
  "portal/authentication/verification-code-is-required":
    "Verification code is required",
  "portal/authentication/welcome-back": "Welcome back",
  "portal/authentication/welcome-back-female": "Welcome back",
  "portal/authentication/welcome-back-male": "Welcome back",
  "portal/autos/brands": "Brands",
  "portal/autos/dictionary": "Dictionary",
  "portal/autos/group": "Autos",
  "portal/autos/models": "Models",
  "portal/autos/updates": "Updates",
  "portal/autos/versions": "Versions",
  "portal/back": "Back",
  "portal/businesses": "Businesses",
  "portal/cancelled-policies": "Cancelled",
  "portal/catalogue-admin/filters": "Filters",
  "portal/catalogue-admin/in-catalogue": "In the catalogue",
  "portal/catalogue-admin/no-results": "No results found.",
  "portal/catalogue-admin/normalized": "Normalized",
  "portal/catalogue-admin/retry": "Retry",
  "portal/catalogue-admin/section-origin": "Origin",
  "portal/catalogue-admin/status": "Status",
  "portal/catalogue-admin/system-actor": "Automatic update",
  "portal/catalogue-admin/tab-summary": "Summary",
  "portal/catalogue-definitions/add-attribute": "Add Attribute",
  "portal/catalogue-definitions/add-entry": "Add Entry",
  "portal/catalogue-definitions/attribute": "Attribute",
  "portal/catalogue-definitions/attribute-values-helper":
    "JSON object whose keys match the attribute Names defined in this catalogue.",
  "portal/catalogue-definitions/attribute-values-json":
    "Attribute values (JSON)",
  "portal/catalogue-definitions/attributes": "Attributes",
  "portal/catalogue-definitions/children": "Child Catalogues",
  "portal/catalogue-definitions/delete": "Delete",
  "portal/catalogue-definitions/edit": "Edit",
  "portal/catalogue-definitions/empty-list": "No catalogue definitions yet.",
  "portal/catalogue-definitions/empty-results":
    "No matching catalogue definitions.",
  "portal/catalogue-definitions/entries": "Entries",
  "portal/catalogue-definitions/entry": "Entry",
  "portal/catalogue-definitions/general": "General",
  "portal/catalogue-definitions/load-error":
    "Could not load catalogue definitions",
  "portal/catalogue-definitions/no-attributes": "No attributes defined yet.",
  "portal/catalogue-definitions/no-children": "No child catalogues.",
  "portal/catalogue-definitions/no-entries":
    "No entries in this catalogue yet.",
  "portal/catalogue-definitions/no-parent": "No parent",
  "portal/catalogue-definitions/parent-catalogue": "Parent Catalogue",
  "portal/catalogue-definitions/save": "Save",
  "portal/catalogue-definitions/saving": "Saving…",
  "portal/catalogue-definitions/search-placeholder":
    "Search catalogue definitions",
  "portal/catalogue-definitions/select":
    "Select a catalogue to see its details.",
  "portal/catalogue-definitions/sidebar": "Catalogues",
  "portal/catalogue-definitions/title": "Catalogue Definitions",
  "portal/catalogue-dictionary/brand": "Normalized brand",
  "portal/catalogue-dictionary/conflict":
    "Changed by someone else. Reload to see it.",
  "portal/catalogue-dictionary/conflict-body":
    "Reload to see it. No change was saved.",
  "portal/catalogue-dictionary/conflict-title": "Someone else changed it",
  "portal/catalogue-dictionary/edit-title": "Edit mapping",
  "portal/catalogue-dictionary/empty":
    "There are no mappings in the dictionary.",
  "portal/catalogue-dictionary/failed-body":
    "No version was changed. What you entered is still here; save again.",
  "portal/catalogue-dictionary/failed-title": "Not saved",
  "portal/catalogue-dictionary/filter-all": "All",
  "portal/catalogue-dictionary/filter-pending": "Pending",
  "portal/catalogue-dictionary/governed": "Versions governed: {{count}}",
  "portal/catalogue-dictionary/grouping": "Grouping",
  "portal/catalogue-dictionary/include-model": "Group by model",
  "portal/catalogue-dictionary/include-model-hint":
    "The versions are grouped under the name of the model.",
  "portal/catalogue-dictionary/load-error": "Could not load the dictionary.",
  "portal/catalogue-dictionary/model": "Normalized model",
  "portal/catalogue-dictionary/name-brand": "Brand",
  "portal/catalogue-dictionary/name-model": "Model",
  "portal/catalogue-dictionary/names": "Normalized names",
  "portal/catalogue-dictionary/names-hint":
    "This is how the brand and the model of the versions of this mapping are shown.",
  "portal/catalogue-dictionary/names-missing": "Enter the brand and the model.",
  "portal/catalogue-dictionary/no-changes": "There are no changes to save.",
  "portal/catalogue-dictionary/no-name": "No normalized name",
  "portal/catalogue-dictionary/no-names": "No normalized names",
  "portal/catalogue-dictionary/only-pending": "Pending only",
  "portal/catalogue-dictionary/only-pending-count":
    "Pending only · {{pending}} of {{total}}",
  "portal/catalogue-dictionary/pending": "Pending",
  "portal/catalogue-dictionary/pending-body":
    "Until it has normalized names, the versions of this mapping are not published.",
  "portal/catalogue-dictionary/record-load-error":
    "Could not load the mapping.",
  "portal/catalogue-dictionary/record-type": "Class",
  "portal/catalogue-dictionary/reload": "Reload",
  "portal/catalogue-dictionary/required":
    "Enter the normalized brand and model.",
  "portal/catalogue-dictionary/save-failed":
    "Not saved. No version was changed.",
  "portal/catalogue-dictionary/saved": "Saved. Versions updated: {{count}}.",
  "portal/catalogue-dictionary/saved-body": "Versions updated: {{count}}.",
  "portal/catalogue-dictionary/saved-title": "Saved",
  "portal/catalogue-dictionary/search": "Search mappings",
  "portal/catalogue-dictionary/select": "Select a mapping to see its details.",
  "portal/catalogue-dictionary/source-brand": "Source brand",
  "portal/catalogue-dictionary/source-model": "Source model",
  "portal/catalogue-dictionary/subtitle": "{{pending}} pending of {{total}}",
  "portal/catalogue-dictionary/versions": "Versions",
  "portal/catalogue-dictionary/versions-many": "{{count}} versions",
  "portal/catalogue-dictionary/versions-one": "{{count}} version",
  "portal/catalogue-updates/active-body":
    "It started {{when}} ({{trigger}}). You can start another when it ends; no new one was started.",
  "portal/catalogue-updates/active-notice":
    "Update started {{when}} still running. Wait for it.",
  "portal/catalogue-updates/active-title": "An update is already in progress",
  "portal/catalogue-updates/affected": "Affected records",
  "portal/catalogue-updates/affected-conflict": "Conflict",
  "portal/catalogue-updates/affected-invalid": "Invalid",
  "portal/catalogue-updates/affected-title": "{{brand}} · code {{code}}",
  "portal/catalogue-updates/card-new": "Versions that entered the catalogue",
  "portal/catalogue-updates/card-unchanged": "Already up to date",
  "portal/catalogue-updates/card-updated": "With changes",
  "portal/catalogue-updates/count/conflicts": "Conflicts",
  "portal/catalogue-updates/count/excluded": "Excluded on purpose",
  "portal/catalogue-updates/count/invalid": "Invalid",
  "portal/catalogue-updates/count/new": "New",
  "portal/catalogue-updates/count/pending": "Of which pending normalization",
  "portal/catalogue-updates/count/unchanged": "Unchanged",
  "portal/catalogue-updates/count/unclassified": "Unclassified",
  "portal/catalogue-updates/count/updated": "Updated",
  "portal/catalogue-updates/effective": "Effective range",
  "portal/catalogue-updates/effective-by-source": "Effective range per source",
  "portal/catalogue-updates/effective-hint":
    "What each source will deliver for the requested range.",
  "portal/catalogue-updates/effective-of": "Effective range · {{source}}",
  "portal/catalogue-updates/errors": "Errors",
  "portal/catalogue-updates/errors-shown":
    "Showing {{shown}} of {{total}} errors",
  "portal/catalogue-updates/failed-note":
    "Nothing was imported. The catalogue is as it was.",
  "portal/catalogue-updates/failed-title": "The update failed",
  "portal/catalogue-updates/finished": "Finished",
  "portal/catalogue-updates/footer-active": "An update is in progress",
  "portal/catalogue-updates/footer-invalid": "Correct the range",
  "portal/catalogue-updates/from-year": "From year",
  "portal/catalogue-updates/history-empty": "No updates yet.",
  "portal/catalogue-updates/interrupted-note":
    "The update stopped responding and was closed.",
  "portal/catalogue-updates/load-error": "Could not load the updates.",
  "portal/catalogue-updates/no-range": "No range",
  "portal/catalogue-updates/not-run": "It did not run",
  "portal/catalogue-updates/partial-note":
    "Records obtained remain available. Request the range again to retry.",
  "portal/catalogue-updates/partial-title": "Partial result",
  "portal/catalogue-updates/portion-counts":
    "{{new}} new · {{updated}} updated · {{unchanged}} unchanged",
  "portal/catalogue-updates/portion-label": "{{source}} · {{year}}",
  "portal/catalogue-updates/portions": "Portions",
  "portal/catalogue-updates/range-invalid": "Enter a valid year range.",
  "portal/catalogue-updates/requested": "Requested range",
  "portal/catalogue-updates/requested-by": "Requested by",
  "portal/catalogue-updates/requested-by-name": "Requested by {{name}}",
  "portal/catalogue-updates/result": "Result",
  "portal/catalogue-updates/row-counts": "{{new}} new · {{updated}} updated",
  "portal/catalogue-updates/run-load-error": "Could not load the update.",
  "portal/catalogue-updates/run-title": "Update {{range}}",
  "portal/catalogue-updates/search": "Search updates",
  "portal/catalogue-updates/section-range": "Range",
  "portal/catalogue-updates/section-run": "Run",
  "portal/catalogue-updates/see-run": "See update",
  "portal/catalogue-updates/select": "Select an update to see its details.",
  "portal/catalogue-updates/skipped-note":
    "It was skipped because another update was already in progress. It is not an error.",
  "portal/catalogue-updates/start": "Start update",
  "portal/catalogue-updates/start-failed": "The update could not be started.",
  "portal/catalogue-updates/start-submit": "Start",
  "portal/catalogue-updates/start-subtitle":
    "Brings the new versions and the changes of the range from the source.",
  "portal/catalogue-updates/started": "Started",
  "portal/catalogue-updates/status/empty": "No records",
  "portal/catalogue-updates/status/excluded-only": "Excluded only",
  "portal/catalogue-updates/status/failed": "Failed",
  "portal/catalogue-updates/status/interrupted": "Interrupted",
  "portal/catalogue-updates/status/partial": "Partial",
  "portal/catalogue-updates/status/pending": "Pending",
  "portal/catalogue-updates/status/running": "Running",
  "portal/catalogue-updates/status/skipped-overlap":
    "Skipped (another update was running)",
  "portal/catalogue-updates/status/succeeded": "Succeeded",
  "portal/catalogue-updates/to-year": "To year",
  "portal/catalogue-updates/trigger": "Trigger",
  "portal/catalogue-updates/trigger/manual": "Manual",
  "portal/catalogue-updates/trigger/scheduled": "Scheduled",
  "portal/catalogue-updates/years": "Year range",
  "portal/catalogue-updates/years-hint":
    "The catalogue spans {{min}} to {{max}}.",
  "portal/catalogue/company-wide-entry": "Company-wide",
  "portal/catalogue/constraint/at-least-one-line":
    "This usage must apply to cars, motorcycles, or both before it can be saved.",
  "portal/catalogue/constraint/at-least-one-type":
    "This brand must apply to airplanes, helicopters, or both before it can be saved.",
  "portal/catalogue/definition": "Catalogue",
  "portal/catalogue/enabled": "Enabled",
  "portal/catalogue/entry": "Entry",
  "portal/catalogue/parent-catalogue": "Parent Catalogue",
  "portal/catalogue/parent-entry": "Parent Entry",
  "portal/catalogue/required-field": "This field is required",
  "portal/category": "Category",
  "portal/cedent": "Cedent",
  "portal/cedent-is-required": "Cedent is required",
  "portal/cedent/edit": "Edit Cedent",
  "portal/cedents": "Cedents",
  "portal/cedents/all": "All Cedents",
  "portal/cedents/availability": "Cedents",
  "portal/cedents/availability-agency": "Available to the agency",
  "portal/cedents/availability-direct": "No agency",
  "portal/cedents/availability-program": "Program",
  "portal/cedents/filter-all": "All",
  "portal/cedents/filter-disabled": "Disabled",
  "portal/cedents/filter-enabled": "Enabled",
  "portal/change-file": "Change File",
  "portal/commission-tables": "Commission Tables",
  "portal/commission-tables/agency-component": "Agency commission",
  "portal/commission-tables/cedent-component": "Cedent commission",
  "portal/commission-tables/component": "Component",
  "portal/commission-tables/rate": "Rate",
  "portal/companies": "Companies",
  "portal/companies/select-a-company-from-the-list":
    "Select a company from the list",
  "portal/company": "Company",
  "portal/company-is-required": "Company is required",
  "portal/company/favicon-dark": "Favicon Light",
  "portal/company/favicon-light": "Favicon Light",
  "portal/company/logo-dark": "Logo Light",
  "portal/company/logo-light": "Logo Light",
  "portal/condition": "Condition",
  "portal/condition-result": "Condition Result",
  "portal/conditions": "Conditions",
  "portal/conditions/and": "AND",
  "portal/conditions/or": "OR",
  "portal/configuration/currencies": "Currencies",
  "portal/configuration/currencies-inherited": "Inherited currencies",
  "portal/configuration/currency-boundary": "Allowed currencies",
  "portal/configuration/lines-of-business": "Lines of business",
  "portal/configuration/lob-delete-message":
    "The line of business leaves this cedent. You can add it again later. A line of business that business uses cannot be deleted; disable it instead.",
  "portal/configuration/lob-delete-title": "Delete line of business",
  "portal/configuration/lob-disabled": "Disabled",
  "portal/configuration/lob-enabled": "Enabled",
  "portal/configuration/lob-inherited": "Inherited",
  "portal/configuration/lob-status": "Status",
  "portal/configuration/program-configuration": "Program configuration",
  "portal/configuration/term-rule": "Term rule",
  "portal/continue": "Continue",
  "portal/count-variable": "Count Variable",
  "portal/create-policy": "New Policy",
  "portal/create-proposal": "Create Proposal",
  "portal/create-proposal/cedent-is-required": "Cedent is required",
  "portal/create-proposal/missing-params":
    "Missing required parameters to create a proposal",
  "portal/create-proposal/no-cedents-available":
    "There are no cedents enabled for this agency.",
  "portal/currency": "Currency",
  "portal/data-type": "Data Type",
  "portal/date-variable": "Date Variable",
  "portal/default-expression": "Default Expression",
  "portal/default-value": "Default Value",
  "portal/dependants": "Dependants",
  "portal/dependants/all": "All",
  "portal/dependants/capture": "Capture",
  "portal/dependants/overview": "Overview",
  "portal/dependants/quote": "Quoted",
  "portal/dependants/requested": "Requested",
  "portal/dependants/select-a-certificate": "Select a certificate",
  "portal/dependants/welcome": "Welcome",
  "portal/description": "Description",
  "portal/document-asset/file": "File",
  "portal/document-asset/font-upload": "Upload font",
  "portal/document-asset/image-upload": "Upload image",
  "portal/documents": "Documents",
  "portal/download-file": "Download File",
  "portal/dynamic-form/add-instance": "Add",
  "portal/dynamic-form/add-item": "Add",
  "portal/dynamic-form/async-error":
    "Could not load this information. Try again.",
  "portal/dynamic-form/collection-active": "Active",
  "portal/dynamic-form/collection-filter": "Filter",
  "portal/dynamic-form/collection-inactive": "Inactive",
  "portal/dynamic-form/collection-search": "Search",
  "portal/dynamic-form/collection-update-failed":
    "The change could not be saved.",
  "portal/dynamic-form/delete-success": "Deleted",
  "portal/dynamic-form/error": "Form Error",
  "portal/dynamic-form/invalid-submit":
    "Some fields need attention. Review the form and try again.",
  "portal/dynamic-form/load-error": "Failed to load form definition.",
  "portal/dynamic-form/load-more": "Load more",
  "portal/dynamic-form/loading": "Loading Form",
  "portal/dynamic-form/pending-submit": "Wait until the form finishes loading",
  "portal/dynamic-form/pending-submit-field":
    "Wait for {{field}} to finish loading",
  "portal/dynamic-form/remove-instance": "Remove",
  "portal/dynamic-form/render-error": "Form Rendering Error",
  "portal/dynamic-form/retry": "Retry",
  "portal/dynamic-form/save-success": "Saved",
  "portal/dynamic-form/submit-blocked-generic": "Complete the required fields",
  "portal/dynamic-form/timeout": "The request took too long. Try again.",
  "portal/dynamic-form/unavailable": "This form is not available right now.",
  "portal/dynamic-form/unknown-error":
    "An unexpected error occurred while rendering the form.",
  "portal/dynamic-form/validation/date-eq": "The date must be {{date}}",
  "portal/dynamic-form/validation/date-max":
    "Choose a date on or before {{max}}",
  "portal/dynamic-form/validation/date-min":
    "Choose a date on or after {{min}}",
  "portal/easyre/add-rate": "Add Rate",
  "portal/easyre/add-territory": "Add Territory",
  "portal/easyre/add-usage": "Add Usage",
  "portal/easyre/age-surcharges": "Age Surcharges",
  "portal/easyre/aircraft": "Aircraft",
  "portal/easyre/aircraft-brand": "Aircraft Brand",
  "portal/easyre/aircraft-brand-is-required": "Aircraft brand is required",
  "portal/easyre/aircraft-identification": "Identification",
  "portal/easyre/aircraft-operation": "Operation",
  "portal/easyre/aircraft-type": "Aircraft Type",
  "portal/easyre/aircraft-type-is-required": "Aircraft Type is required",
  "portal/easyre/aircrafts": "Aircrafts",
  "portal/easyre/airplanes": "Airplanes",
  "portal/easyre/all-risk": "All Risk",
  "portal/easyre/base-airport": "Base Airport",
  "portal/easyre/basic": "Basic",
  "portal/easyre/brand": "Brand",
  "portal/easyre/breach-of-warranty": "Breach of Warranty",
  "portal/easyre/breach-of-warranty-hint": "90% of hull value",
  "portal/easyre/breach-of-warranty-sum": "Breach of Warranty Sum",
  "portal/easyre/cargo-liability": "Cargo Liability",
  "portal/easyre/cargo-liability-sum": "Cargo Liability Sum",
  "portal/easyre/coverage-section-hull": "Hull",
  "portal/easyre/coverage-type": "Coverage Type",
  "portal/easyre/coverage-type/all-risk-body":
    "Hull in flight and on the ground, plus liability.",
  "portal/easyre/coverage-type/all-risk-title": "All Risk",
  "portal/easyre/coverage-type/basic-body": "Liability only, no hull.",
  "portal/easyre/coverage-type/basic-title": "Basic",
  "portal/easyre/coverage-type/hull-only-body":
    "Physical damage only, no liability.",
  "portal/easyre/coverage-type/hull-only-title": "Hull Only",
  "portal/easyre/coverage-type/limited-body":
    "Hull on the ground only, plus liability.",
  "portal/easyre/coverage-type/limited-title": "Limited",
  "portal/easyre/crew-is-required": "Crew number is required",
  "portal/easyre/crew-medical-payments": "Medical Payments",
  "portal/easyre/crew-medical-payments-sum": "Crew Medical Payments Sum",
  "portal/easyre/crew-must-be-greater-than-zero":
    "Crew number must be greater than 0",
  "portal/easyre/crew-number": "Crew Number",
  "portal/easyre/crew-voluntary-settlements": "Voluntary Settlements",
  "portal/easyre/crew-voluntary-settlements-sum":
    "Crew Voluntary Settlements Sum",
  "portal/easyre/csl": "CSL",
  "portal/easyre/edit-rate": "Edit Rate",
  "portal/easyre/edit-territory": "Edit Territory",
  "portal/easyre/edit-usage": "Edit Usage",
  "portal/easyre/entity-is-required": "Entity is required",
  "portal/easyre/extended-liability": "Extended Liability",
  "portal/easyre/geographic-limit": "Geographic Limit",
  "portal/easyre/geographic-limit-is-required": "Geographic limit is required",
  "portal/easyre/geographic-limits": "Geographic Limits",
  "portal/easyre/hangar-liability": "Hangar Liability",
  "portal/easyre/hangar-liability-sum": "Hangar Liability Sum",
  "portal/easyre/helicopter": "Helicopter",
  "portal/easyre/helicopters": "Helicopters",
  "portal/easyre/hull-coverage": "Hull Coverage",
  "portal/easyre/hull-deductible": "Hull Deductible",
  "portal/easyre/hull-only": "Hull Only",
  "portal/easyre/hull-value": "Hull Value",
  "portal/easyre/hull-value-is-required": "Hull value is required",
  "portal/easyre/hull-value-must-be-greater-than-zero":
    "Hull value must be greater than 0",
  "portal/easyre/hull-value-must-not-exceed-limit":
    "Hull value must not exceed 5,000,000",
  "portal/easyre/liability": "Liability",
  "portal/easyre/liability-coverage": "Liability Coverage",
  "portal/easyre/liability-limit": "Liability Limit",
  "portal/easyre/liability-limit-is-required":
    "Liability limit must be greater than 0",
  "portal/easyre/licence": "Licence Number",
  "portal/easyre/licence-is-required": "Licence is required",
  "portal/easyre/limited": "Limited",
  "portal/easyre/luggage-liability": "Luggage Liability",
  "portal/easyre/luggage-liability-sum": "Luggage Liability Sum",
  "portal/easyre/max-is-required": "Max is required",
  "portal/easyre/medical-payments": "Medical Payments",
  "portal/easyre/medical-payments-sum": "Medical Payments Sum",
  "portal/easyre/min-is-required": "Min is required",
  "portal/easyre/model": "Model",
  "portal/easyre/model-is-required": "Model is required",
  "portal/easyre/other-coverages": "Other Coverages",
  "portal/easyre/passenger-voluntary-settlements":
    "Passenger Voluntary Settlements",
  "portal/easyre/passenger-voluntary-settlements-hint": "Per seat",
  "portal/easyre/passenger-voluntary-settlements-sum":
    "Passenger Voluntary Settlements Sum",
  "portal/easyre/passengers": "Passengers",
  "portal/easyre/pilot": "Pilot",
  "portal/easyre/pilot/add-pilot": "Add pilot",
  "portal/easyre/pilot/age": "Age",
  "portal/easyre/pilot/aircraft-type-hours": "Hours in aircraft type",
  "portal/easyre/pilot/change-certificate": "Change certificate",
  "portal/easyre/pilot/detail-certificate": "Certificate",
  "portal/easyre/pilot/detail-last-simulator": "Last simulator",
  "portal/easyre/pilot/detail-next-simulator": "Next simulator",
  "portal/easyre/pilot/detail-total-hours": "Total hours",
  "portal/easyre/pilot/detail-type-hours": "Hours in type",
  "portal/easyre/pilot/hours-total-suffix": "total hours",
  "portal/easyre/pilot/hours-type-suffix": "type hours",
  "portal/easyre/pilot/hours-warranty-notice":
    "Each named pilot must meet the applicable flight-hours warranty for this aircraft.",
  "portal/easyre/pilot/last-simulator-training":
    "Last simulator training (within 12 months)",
  "portal/easyre/pilot/license": "License",
  "portal/easyre/pilot/make-model-hours": "Hours in make and model",
  "portal/easyre/pilot/modal-title": "Pilot",
  "portal/easyre/pilot/name": "Name",
  "portal/easyre/pilot/next-scheduled-simulator": "Next scheduled simulator",
  "portal/easyre/pilot/no-pilots": "No pilots added",
  "portal/easyre/pilot/select-certificate": "Select certificate",
  "portal/easyre/pilot/total-flight-hours": "Total flight hours",
  "portal/easyre/pilot/training-certificate": "Training certificate",
  "portal/easyre/pilot/training-date": "Training date",
  "portal/easyre/pilot/training-details": "Most recent training details",
  "portal/easyre/pilot/training-location": "Training location",
  "portal/easyre/pilot/validation/positive": "Must be greater than zero",
  "portal/easyre/pilot/validation/required": "This field is required",
  "portal/easyre/pilots": "Pilots",
  "portal/easyre/quote": "Quote",
  "portal/easyre/quote/error": "The quote could not be calculated",
  "portal/easyre/quote/loading": "Calculating quote…",
  "portal/easyre/quote/retry": "Retry",
  "portal/easyre/rate-is-required": "Rate is required",
  "portal/easyre/rates": "Rates",
  "portal/easyre/serial": "Serial",
  "portal/easyre/serial-is-required": "Serial is required",
  "portal/easyre/spare-parts": "Spare Parts",
  "portal/easyre/spare-parts-sum": "Spare Parts Sum",
  "portal/easyre/usage": "Usage",
  "portal/easyre/usage-is-required": "Usage is required",
  "portal/easyre/usage-surcharges": "Usage Surcharges",
  "portal/easyre/voluntary-settlements": "Voluntary Settlements",
  "portal/easyre/war-risk-coverage": "War Risk Coverage",
  "portal/easyre/war-risk-coverage-hint": "LSW555D",
  "portal/easyre/war-risk-coverage-sum": "Sum Insured",
  "portal/easyre/year": "Year",
  "portal/easyre/year-is-required": "Year is required",
  "portal/easyre/year-must-be-between":
    "Year must be between {{min}} and {{max}}",
  "portal/edit": "Edit",
  "portal/edit-aircraft": "Edit Aircraft",
  "portal/edit-cedent": "Edit Cedent",
  "portal/edit-commission-table": "Add Table",
  "portal/edit-condition": "Edit Condition",
  "portal/edit-entity": "Edit Entity",
  "portal/edit-entry": "Edit Entry",
  "portal/edit-insurer": "Edit Insurer",
  "portal/edit-line-of-business": "Edit Line of Business",
  "portal/edit-lob": "Edit Line of Business",
  "portal/edit-pipeline": "Edit Pipeline",
  "portal/edit-pipeline-step": "Edit Pipeline Step",
  "portal/edit-policy-file": "Edit Policy File",
  "portal/edit-policy-payment": "Register Payment",
  "portal/edit-policy-receipt": "Receipt Details",
  "portal/edit-proposal": "Edit Proposal",
  "portal/edit-rate-table": "Edit Rate Table",
  "portal/edit-rate-table-entry": "Edit Rate Table Entry",
  "portal/edit-step": "Edit Step",
  "portal/edit-step-condition": "Edit Step Condition",
  "portal/edit-variable": "Edit Variable",
  "portal/editDependent/authorization-form-is-required":
    "Authorization form is required",
  "portal/editDependent/birthday": "Birthday",
  "portal/editDependent/birthday-is-required": "Birthday is required",
  "portal/editDependent/child": "Child",
  "portal/editDependent/dependent": "Dependent",
  "portal/editDependent/female": "Female",
  "portal/editDependent/gender": "Gender",
  "portal/editDependent/gender-is-required": "Gender is required",
  "portal/editDependent/invalid-birthday": "Invalid birthday",
  "portal/editDependent/invalid-national-id": "Invalid National Id",
  "portal/editDependent/lastname": "Last Name",
  "portal/editDependent/lastname-is-required": "Last name is required",
  "portal/editDependent/male": "Male",
  "portal/editDependent/medical-form-is-required": "Medical form is required",
  "portal/editDependent/name": "Name",
  "portal/editDependent/name-is-required": "Name is required",
  "portal/editDependent/national-id": "National Id (CURP)",
  "portal/editDependent/national-id-is-required": "National Id is required",
  "portal/editDependent/relationship": "Relationship",
  "portal/editDependent/relationship-is-required": "Relationship is required",
  "portal/editDependent/request-id-is-required": "Request Id is required",
  "portal/editDependent/spouse": "Spouse",
  "portal/editDependent/surname": "Surname",
  "portal/editDependent/surname-is-required": "Surname is required",
  "portal/email": "Email",
  "portal/email-is-invalid": "The provided email is not valid",
  "portal/email-is-required": "Email is required",
  "portal/employees": "Employees",
  "portal/end-date": "End Date",
  "portal/entities/load-error": "Could not load the list",
  "portal/entities/search-placeholder": "Search",
  "portal/entity": "Entity",
  "portal/entity-not-found": "Entity not found",
  "portal/entity/alias": "Alias",
  "portal/entity/appointed-carrier": "Appointed Carrier",
  "portal/entity/birthday": "Birthday",
  "portal/entity/birthday-is-required": "Birthday is required",
  "portal/entity/client": "Client",
  "portal/entity/client-is-required": "Client is required",
  "portal/entity/commercial-name": "Commercial Name",
  "portal/entity/country": "Country",
  "portal/entity/country-is-required": "Country is required",
  "portal/entity/email": "Email",
  "portal/entity/entity": "Persona",
  "portal/entity/entity-type": "Type",
  "portal/entity/entity-type-is-required": "Client is required",
  "portal/entity/existing-client": "Existing Person",
  "portal/entity/existing-entity-is-required": "Existing Entity is required",
  "portal/entity/external-id": "External ID",
  "portal/entity/gender": "Gender",
  "portal/entity/gender/female": "female",
  "portal/entity/gender/male": "male",
  "portal/entity/incorporation-date": "Incorporation Date",
  "portal/entity/incorporation-date-is-required":
    "Incorporation Date is required",
  "portal/entity/is-insurer": "Is Insurer",
  "portal/entity/lastname": "Last Name",
  "portal/entity/lastname-is-required": "Lastname is required",
  "portal/entity/legal-person": "Legal Person",
  "portal/entity/legalname": "Legal Name",
  "portal/entity/legalname-is-required": "Legal Name is required",
  "portal/entity/middlename": "Middle Name",
  "portal/entity/mobile": "Mobile",
  "portal/entity/name": "First Name",
  "portal/entity/name-is-required": "Name is required",
  "portal/entity/national-id": "National ID",
  "portal/entity/natural-person": "Natural Person",
  "portal/entity/new-client": "New Person",
  "portal/entity/new-or-existing": "New or Existing Entity",
  "portal/entity/new-or-existing-is-required":
    "New or Existing Client is required",
  "portal/entity/not-a-legal-entity": "The record is not a legal entity",
  "portal/entity/not-a-natural-entity": "The record is not a natural person",
  "portal/entity/summary/commercial-name": "Trade name",
  "portal/entity/summary/country": "Country",
  "portal/entity/summary/entity-id": "Entity identifier",
  "portal/entity/summary/general": "General information",
  "portal/entity/summary/incorporation-date": "Incorporation date",
  "portal/entity/summary/incorporation-section": "Incorporation",
  "portal/entity/summary/legal-name": "Legal name",
  "portal/entity/summary/tax-id": "Tax identifier",
  "portal/entity/surname": "Last Name",
  "portal/entity/surname-is-required": "Lastname is required",
  "portal/entity/tax-id-is-invalid": "Tax Id is invalid",
  "portal/entity/tax-id-is-required": "Tax Id is required",
  "portal/entity/tax-regime": "Tax Regime",
  "portal/entity/taxid": "Tax Id",
  "portal/entity/use-existing-client": "Use Existing Client",
  "portal/error-behavior": "Error Behavior",
  "portal/error-description-key": "Error Description Key",
  "portal/error-message-key": "Error Message Key",
  "portal/errors/acknowledge": "Got it",
  "portal/errors/close": "Close",
  "portal/errors/dismiss": "Continue",
  "portal/errors/recovering": "Recovering application state...",
  "portal/executed-by": "Executed By",
  "portal/execution-time": "Execution Time",
  "portal/existing": "Existing",
  "portal/exixting": "Existing",
  "portal/expiration-date": "Expiration Date",
  "portal/expiration-date-is-required": "Expiration date is required",
  "portal/expression": "Expression",
  "portal/external-catalogues/active-codes": "Active codes",
  "portal/external-catalogues/assign-code": "Assign code",
  "portal/external-catalogues/catalogue": "Catalogue",
  "portal/external-catalogues/cedent": "Cedent",
  "portal/external-catalogues/code": "Code",
  "portal/external-catalogues/codes": "Codes",
  "portal/external-catalogues/country": "Country",
  "portal/external-catalogues/deactivate-code": "Deactivate code",
  "portal/external-catalogues/deactivate-code-message":
    "The code will no longer be offered. Existing records keep it.",
  "portal/external-catalogues/deactivate-code-title": "Deactivate this code?",
  "portal/external-catalogues/disabled": "Disabled",
  "portal/external-catalogues/edit": "Edit catalogue",
  "portal/external-catalogues/edit-code": "Edit code",
  "portal/external-catalogues/empty-list": "No external catalogues yet.",
  "portal/external-catalogues/empty-results":
    "No catalogues match your search.",
  "portal/external-catalogues/enabled": "Enabled",
  "portal/external-catalogues/general": "General",
  "portal/external-catalogues/key": "Key",
  "portal/external-catalogues/load-error":
    "Could not load the external catalogues.",
  "portal/external-catalogues/name": "Name",
  "portal/external-catalogues/search-placeholder": "Search catalogues",
  "portal/external-catalogues/select": "Select a catalogue to see its details.",
  "portal/external-catalogues/sidebar": "External catalogues",
  "portal/external-catalogues/status": "Status",
  "portal/external-catalogues/title": "External catalogues",
  "portal/extract-fields": "Extract Fields (key:variable, ...)",
  "portal/file": "File",
  "portal/files": "Files",
  "portal/filter-agencies": "Agencies",
  "portal/filter-by": "Filter by",
  "portal/filter-insurers": "Insurers",
  "portal/filter-lobs": "Lines of Business",
  "portal/final-premiums": "Final Premiums",
  "portal/form/accepted-formats": "Accepted Formats",
  "portal/form/action-target": "Target Field",
  "portal/form/action-type": "Action Type",
  "portal/form/action-value": "Value",
  "portal/form/action/calculate": "Calculate",
  "portal/form/action/callMethod": "Call method",
  "portal/form/action/clearValue": "Clear Value",
  "portal/form/action/copyValue": "Copy value",
  "portal/form/action/fetchData": "Fetch Data",
  "portal/form/action/fetchMatch": "Fetch matching record",
  "portal/form/action/fetchRecord": "Fetch record",
  "portal/form/action/setCardOptions": "Set card options",
  "portal/form/action/setDisabled": "Set Disabled",
  "portal/form/action/setFieldProps": "Set field properties",
  "portal/form/action/setOptions": "Set Options",
  "portal/form/action/setOrder": "Set order",
  "portal/form/action/setRequired": "Set Required",
  "portal/form/action/setValidationBounds": "Set validation bounds",
  "portal/form/action/setValidationBoundsFromFields":
    "Set validation bounds from fields",
  "portal/form/action/setValue": "Set Value",
  "portal/form/action/setVisibility": "Set Visibility",
  "portal/form/actions": "Actions",
  "portal/form/add": "New Form",
  "portal/form/add-action": "Add Action",
  "portal/form/add-condition": "Add Condition",
  "portal/form/add-field": "Add Field",
  "portal/form/add-filter": "Add Filter",
  "portal/form/add-format": "Add",
  "portal/form/add-group": "Add Group",
  "portal/form/add-rule": "Add Rule",
  "portal/form/add-step": "Add Step",
  "portal/form/add-validation": "Add Validation Rule",
  "portal/form/all": "All",
  "portal/form/allow-create": "Allow Create",
  "portal/form/back-to-list": "Back to List",
  "portal/form/both": "Both",
  "portal/form/close": "Close",
  "portal/form/collapse-group": "Collapse group",
  "portal/form/condition-group": "Group",
  "portal/form/conditions": "Conditions",
  "portal/form/configure": "Configure",
  "portal/form/create-form": "Create Form",
  "portal/form/custom-field": "Custom Field",
  "portal/form/data-source": "Data Source",
  "portal/form/default-value": "Default Value",
  "portal/form/delete": "Delete",
  "portal/form/delete-confirm":
    "Are you sure you want to delete this form definition?",
  "portal/form/disabled": "Disabled",
  "portal/form/disabled-condition": "Disabled Condition",
  "portal/form/edit": "Edit",
  "portal/form/edit-roles": "Edit Roles",
  "portal/form/editor": "Form Editor",
  "portal/form/embedded": "Embedded",
  "portal/form/enabled": "Enabled",
  "portal/form/error-message": "Error Message",
  "portal/form/expand-group": "Expand group",
  "portal/form/expression": "Expression",
  "portal/form/field-config": "Field Configuration",
  "portal/form/field-label": "Label",
  "portal/form/field-name": "Field Name",
  "portal/form/field-reference": "Field Reference",
  "portal/form/field-type": "Field Type",
  "portal/form/field-types": "Field Types",
  "portal/form/fields": "Fields",
  "portal/form/file-config": "File Configuration",
  "portal/form/filter-attribute": "Attribute",
  "portal/form/filter-lob": "Filter by LOB",
  "portal/form/filter-model": "Filter by Model",
  "portal/form/filter-operator": "Operator",
  "portal/form/filter-source-field": "Source Field",
  "portal/form/filter-status": "Filter by Status",
  "portal/form/filters": "Filters",
  "portal/form/general": "General",
  "portal/form/group-assignment": "Group",
  "portal/form/label-attribute": "Label Attribute",
  "portal/form/literal-value": "Literal Value",
  "portal/form/lob": "Line of Business",
  "portal/form/max-file-size": "Max File Size (MB)",
  "portal/form/modal": "Modal",
  "portal/form/model-attribute": "Model Attribute",
  "portal/form/move-down": "Move down",
  "portal/form/move-up": "Move up",
  "portal/form/multiple-files": "Multiple Files",
  "portal/form/name": "Name",
  "portal/form/name-required": "Name is required",
  "portal/form/no-conditions": "No conditions",
  "portal/form/no-definitions": "No form definitions found",
  "portal/form/no-fields": "No fields yet. Add a field from the sidebar.",
  "portal/form/no-results": "No forms match your search",
  "portal/form/no-rules": "No rules defined",
  "portal/form/no-steps":
    "No steps configured. Use Add Step to create the first step.",
  "portal/form/no-validations": "No validation rules",
  "portal/form/operand": "Operand",
  "portal/form/operands": "Operands",
  "portal/form/operation": "Operation",
  "portal/form/order": "Order",
  "portal/form/permissions": "Permissions",
  "portal/form/phase": "Phase",
  "portal/form/placeholder": "Placeholder",
  "portal/form/preview": "Preview",
  "portal/form/remove": "Remove",
  "portal/form/remove-format": "Remove format",
  "portal/form/remove-step": "Remove step",
  "portal/form/render-mode": "Render Mode",
  "portal/form/repeatable": "Repeatable",
  "portal/form/required": "Required",
  "portal/form/required-condition": "Required Condition",
  "portal/form/rule-name": "Rule Name",
  "portal/form/rules": "Rules",
  "portal/form/save": "Save",
  "portal/form/save-error": "Error saving form",
  "portal/form/save-success": "Form saved successfully",
  "portal/form/saving": "Saving...",
  "portal/form/search-attribute": "Search Attribute",
  "portal/form/select-a-form": "Select a form from the list",
  "portal/form/select-field": "Select a field to configure",
  "portal/form/slug": "Slug",
  "portal/form/slug-required": "Slug is required",
  "portal/form/source-model": "Source Model",
  "portal/form/step-assignment": "Step",
  "portal/form/step-label": "Step label",
  "portal/form/steps": "Steps",
  "portal/form/target-model": "Target Model",
  "portal/form/title": "Form Definitions",
  "portal/form/trigger-field-change": "On Field Change",
  "portal/form/trigger-fields": "Trigger Fields",
  "portal/form/trigger-init": "On Initialize",
  "portal/form/trigger-type": "Trigger Type",
  "portal/form/type/age": "Age",
  "portal/form/type/creditCard": "Credit Card",
  "portal/form/type/currency": "Currency",
  "portal/form/type/date": "Date",
  "portal/form/type/email": "Email",
  "portal/form/type/file": "File",
  "portal/form/type/multipleSelect": "Multiple Select",
  "portal/form/type/number": "Number",
  "portal/form/type/otp": "OTP",
  "portal/form/type/percentage": "Percentage",
  "portal/form/type/phone": "Phone",
  "portal/form/type/radio": "Radio",
  "portal/form/type/richText": "Rich Text",
  "portal/form/type/select": "Select",
  "portal/form/type/selectFetch": "Select (Remote)",
  "portal/form/type/switch": "Switch",
  "portal/form/type/text": "Text",
  "portal/form/type/url": "URL",
  "portal/form/validation": "Validation",
  "portal/form/validator-type": "Validator",
  "portal/form/value-attribute": "Value Attribute",
  "portal/form/view-roles": "View Roles",
  "portal/form/virtual-path": "Virtual Path",
  "portal/form/visibility-condition": "Visibility Condition",
  "portal/forms": "Forms",
  "portal/forms/move-down": "Move down",
  "portal/forms/move-up": "Move up",
  "portal/forms/name-and-slug-required": "Name and slug are required",
  "portal/global": "Global",
  "portal/go-back": "Back",
  "portal/home": "Home",
  "portal/home/active-in-force": "Active in-force",
  "portal/home/balance": "Outstanding Balance",
  "portal/home/days-ago": "{{count}}d ago",
  "portal/home/hours-ago": "{{count}}h ago",
  "portal/home/in-pipeline": "In pipeline",
  "portal/home/just-now": "Just now",
  "portal/home/load-error": "Could not load data",
  "portal/home/minutes-ago": "{{count}}m ago",
  "portal/home/my-assignments": "My Assignments",
  "portal/home/no-assignments": "No pending assignments",
  "portal/home/no-recent-activity": "No recent activity",
  "portal/home/placements": "Placements",
  "portal/home/policies": "Policies",
  "portal/home/premium": "Premium",
  "portal/home/recent-activity": "Recent Activity",
  "portal/home/retry": "Retry",
  "portal/home/total-outstanding": "Total outstanding",
  "portal/home/total-written": "Total written",
  "portal/home/view-all": "View all",
  "portal/home/welcome": "Welcome back,",
  "portal/icon": "Icon",
  "portal/in-force-date": "Inforce Date",
  "portal/in-force-policies": "In Force",
  "portal/inforce-date-is-required": "Inforce date is required",
  "portal/input-context": "Input Context",
  "portal/insurer/edit": "Edit Insurer",
  "portal/insurer/financials/accumulated": "Year to date {{range}}",
  "portal/insurer/financials/caption": "Figures in millions of pesos.",
  "portal/insurer/financials/collapse": "Collapse",
  "portal/insurer/financials/column-account": "Account",
  "portal/insurer/financials/column-annual-change": "YoY change (%)",
  "portal/insurer/financials/empty-title":
    "No financial statements published for key {{key}}",
  "portal/insurer/financials/expand": "Expand",
  "portal/insurer/financials/operation": "Operation",
  "portal/insurer/financials/period": "Period",
  "portal/insurer/financials/statement": "Financial statement",
  "portal/insurer/financials/statement-balance": "Balance sheet",
  "portal/insurer/financials/statement-results": "Results",
  "portal/insurer/financials/summary": "Summary",
  "portal/insurer/financials/summary-assets": "Total assets",
  "portal/insurer/financials/summary-claims": "Net cost of claims",
  "portal/insurer/financials/summary-equity": "Total equity",
  "portal/insurer/financials/summary-liabilities": "Total liabilities",
  "portal/insurer/financials/summary-premiums": "Written premiums",
  "portal/insurer/financials/summary-result": "Profit (loss) for the year",
  "portal/insurer/financials/tab": "Financials",
  "portal/insurer/financials/title-balance": "Balance sheet",
  "portal/insurer/financials/title-results": "Income statement",
  "portal/insurer/financials/unit": "MXN mm",
  "portal/insurer/indexes/cnsf-key": "CNSF key",
  "portal/insurer/indexes/column-quarter": "Quarter",
  "portal/insurer/indexes/coverage-index": "Coverage index",
  "portal/insurer/indexes/empty-body":
    "Assign the CNSF key in General data to see its indexes.",
  "portal/insurer/indexes/empty-title": "This insurer has no CNSF key",
  "portal/insurer/indexes/history": "History",
  "portal/insurer/indexes/history-range": "History period",
  "portal/insurer/indexes/last-quarter-title":
    "Last reported quarter · {{period}} · CNSF key {{key}}",
  "portal/insurer/indexes/no-data-title":
    "No indicators published for key {{key}}",
  "portal/insurer/indexes/range-all": "All",
  "portal/insurer/indexes/range-last-8": "Last 8 quarters",
  "portal/insurer/indexes/source":
    "Source: CNSF · Financial Information, indicators reviewed by the CNSF. Published quarterly.",
  "portal/insurer/indexes/stale":
    "The CNSF has not published indicators for key {{key}} since {{month}} {{year}}.",
  "portal/insurer/indexes/state-green": "Sufficient",
  "portal/insurer/indexes/state-red": "Insufficient",
  "portal/insurer/indexes/state-yellow": "Tight",
  "portal/insurer/indexes/tab": "Indexes",
  "portal/insurer/lobs": "Lines of Business",
  "portal/insurer/no-lobs": "No lines of business assigned",
  "portal/insurer/period/month-01": "January",
  "portal/insurer/period/month-02": "February",
  "portal/insurer/period/month-03": "March",
  "portal/insurer/period/month-04": "April",
  "portal/insurer/period/month-05": "May",
  "portal/insurer/period/month-06": "June",
  "portal/insurer/period/month-07": "July",
  "portal/insurer/period/month-08": "August",
  "portal/insurer/period/month-09": "September",
  "portal/insurer/period/month-10": "October",
  "portal/insurer/period/month-11": "November",
  "portal/insurer/period/month-12": "December",
  "portal/insurer/period/month-in-text-01": "January",
  "portal/insurer/period/month-in-text-02": "February",
  "portal/insurer/period/month-in-text-03": "March",
  "portal/insurer/period/month-in-text-04": "April",
  "portal/insurer/period/month-in-text-05": "May",
  "portal/insurer/period/month-in-text-06": "June",
  "portal/insurer/period/month-in-text-07": "July",
  "portal/insurer/period/month-in-text-08": "August",
  "portal/insurer/period/month-in-text-09": "September",
  "portal/insurer/period/month-in-text-10": "October",
  "portal/insurer/period/month-in-text-11": "November",
  "portal/insurer/period/month-in-text-12": "December",
  "portal/insurer/period/month-short-01": "Jan",
  "portal/insurer/period/month-short-02": "Feb",
  "portal/insurer/period/month-short-03": "Mar",
  "portal/insurer/period/month-short-04": "Apr",
  "portal/insurer/period/month-short-05": "May",
  "portal/insurer/period/month-short-06": "Jun",
  "portal/insurer/period/month-short-07": "Jul",
  "portal/insurer/period/month-short-08": "Aug",
  "portal/insurer/period/month-short-09": "Sep",
  "portal/insurer/period/month-short-10": "Oct",
  "portal/insurer/period/month-short-11": "Nov",
  "portal/insurer/period/month-short-12": "Dec",
  "portal/insurer/period/month-short-in-text-01": "Jan",
  "portal/insurer/period/month-short-in-text-02": "Feb",
  "portal/insurer/period/month-short-in-text-03": "Mar",
  "portal/insurer/period/month-short-in-text-04": "Apr",
  "portal/insurer/period/month-short-in-text-05": "May",
  "portal/insurer/period/month-short-in-text-06": "Jun",
  "portal/insurer/period/month-short-in-text-07": "Jul",
  "portal/insurer/period/month-short-in-text-08": "Aug",
  "portal/insurer/period/month-short-in-text-09": "Sep",
  "portal/insurer/period/month-short-in-text-10": "Oct",
  "portal/insurer/period/month-short-in-text-11": "Nov",
  "portal/insurer/period/month-short-in-text-12": "Dec",
  "portal/insurer/period/month-year": "{{month}} {{year}}",
  "portal/insurer/period/range": "{{from}}–{{to}} {{year}}",
  "portal/insurer/regulatory/load-error":
    "The regulatory data could not be loaded.",
  "portal/insurers": "Insurers",
  "portal/insurers/active": "Active",
  "portal/insurers/all": "All",
  "portal/insurers/appointed": "Appointed",
  "portal/insurers/inactive": "Inactive",
  "portal/internal-users": "Internal Users",
  "portal/invalid-json": "Invalid JSON",
  "portal/is-active": "Active",
  "portal/label": "Label",
  "portal/lapsed-policies": "Lapsed",
  "portal/limit-variable": "Limit Variable",
  "portal/line-of-business": "Line of Business",
  "portal/lines-of-business": "Lines of Business",
  "portal/list/and": "{{list}} and {{last}}",
  "portal/loading": "Loading",
  "portal/lob/add-stage": "Add Stage",
  "portal/lob/create-pipeline": "Create Pipeline",
  "portal/lob/forms": "Forms",
  "portal/lob/generates-receipts": "Generates receipts",
  "portal/lob/icon": "Icon",
  "portal/lob/issuable": "Issuable",
  "portal/lob/lob1": "Operation",
  "portal/lob/lob2": "Line of Business",
  "portal/lob/lob3": "Line of Business 2",
  "portal/lob/lob4": "Line of Business 4",
  "portal/lob/pipeline-builder": "Pipeline Builder",
  "portal/lob/prefix": "Line Prefix",
  "portal/lob/publish-pipeline": "Publish",
  "portal/lob/stages": "Stages",
  "portal/lobs/builders-risk": "Builders Risk",
  "portal/lobs/dno": "Directors and Officers",
  "portal/lobs/er-aviation": "Aviación",
  "portal/lobs/group-accident": "Group Accidents",
  "portal/lobs/group-health": "Group Health",
  "portal/lobs/group-life": "Group Life",
  "portal/lobs/home": "Home",
  "portal/lobs/individual-health": "Gastos Médicos Mayores Individual",
  "portal/lobs/individual-vehicle": "Individual Vehicle",
  "portal/lobs/load-error": "Could not load lines of business",
  "portal/lobs/motor": "Motor — High-Value Vehicles",
  "portal/lobs/search-placeholder": "Search lines of business",
  "portal/lobs/select-a-lob-from-the-list":
    "Select a Line of Business from the list",
  "portal/lobs/tra": "Travel",
  "portal/logical-operator": "Logical Operator",
  "portal/lookup-field": "Lookup Field",
  "portal/lookup-type": "Lookup Type",
  "portal/lookup-value-variable": "Lookup Value Variable",
  "portal/managed-catalogue/availability": "Availability",
  "portal/managed-catalogue/availability-hint":
    "A record that is not available is not offered when quoting.",
  "portal/managed-catalogue/available": "Available",
  "portal/managed-catalogue/available-to-quote": "Available for quoting",
  "portal/managed-catalogue/children": "{{label}}: {{count}}",
  "portal/managed-catalogue/empty": "No records yet.",
  "portal/managed-catalogue/filter-all": "All",
  "portal/managed-catalogue/filter-no": "No",
  "portal/managed-catalogue/filter-status": "Status",
  "portal/managed-catalogue/filter-yes": "Yes",
  "portal/managed-catalogue/load-error": "Could not load the records.",
  "portal/managed-catalogue/load-error-of": "Could not load {{title}}.",
  "portal/managed-catalogue/normalization": "Normalization",
  "portal/managed-catalogue/pending": "Pending normalization",
  "portal/managed-catalogue/record-load-error": "Could not load the record.",
  "portal/managed-catalogue/save-failed": "Not saved. Availability unchanged.",
  "portal/managed-catalogue/save-failed-body":
    "The availability is as it was. Try again.",
  "portal/managed-catalogue/save-failed-short": "Could not save.",
  "portal/managed-catalogue/save-failed-title":
    "Could not save the availability",
  "portal/managed-catalogue/saving": "Saving…",
  "portal/managed-catalogue/search": "Search {{title}}",
  "portal/managed-catalogue/section-catalogue": "Catalogue",
  "portal/managed-catalogue/section-general": "General",
  "portal/managed-catalogue/see-in-dictionary": "See in Dictionary",
  "portal/managed-catalogue/source": "Source",
  "portal/managed-catalogue/source-value": "{{source}} · {{code}}",
  "portal/managed-catalogue/unavailable": "Unavailable",
  "portal/managed-catalogue/update-running":
    "Update running. Records stay available.",
  "portal/managed-catalogue/update-running-body":
    "A catalogue update is in progress. The rows remain available; availability changes are not lost.",
  "portal/managed-catalogue/update-running-title": "Update in progress",
  "portal/marketing": "Marketing",
  "portal/marketing-preferences/required-badge": "Required",
  "portal/marketing-preferences/required-explanation":
    "This category cannot be disabled.",
  "portal/marketing-preferences/save": "Save preferences",
  "portal/marketing-preferences/saved": "Your preferences were saved.",
  "portal/marketing-preferences/stale":
    "This page was out of date; it now shows your current preferences.",
  "portal/marketing-preferences/subtitle":
    "Choose which emails you want to receive.",
  "portal/marketing-preferences/test-preview-body":
    "No preferences are affected by this preview link.",
  "portal/marketing-preferences/test-preview-title": "This is a test preview",
  "portal/marketing-preferences/title": "Email preferences",
  "portal/marketing/access-denied": "You do not have access to Marketing.",
  "portal/marketing/approval/approved": "Approved",
  "portal/marketing/approval/pending": "Pending approval",
  "portal/marketing/approval/rejected": "Rejected",
  "portal/marketing/audiences": "Audiences",
  "portal/marketing/campaigns": "Campaigns",
  "portal/marketing/campaigns/audience/audiences": "Audiences",
  "portal/marketing/campaigns/audience/audiences-empty":
    "There are no audiences you can read.",
  "portal/marketing/campaigns/audience/audiences-selected":
    "{{count}} audiences selected",
  "portal/marketing/campaigns/audience/blocked-body":
    "Part of the saved audience (sources or contacts) is hidden from your role, so saving a new revision would silently drop it. Ask someone with wider access to change this campaign, or duplicate it and build a new audience.",
  "portal/marketing/campaigns/audience/blocked-title":
    "This audience cannot be edited from here",
  "portal/marketing/campaigns/audience/excluded-unnamed": "Contact {{number}}",
  "portal/marketing/campaigns/audience/exclusion-add": "Exclude",
  "portal/marketing/campaigns/audience/exclusion-remove":
    "Remove exclusion for {{name}}",
  "portal/marketing/campaigns/audience/exclusions": "Excluded contacts",
  "portal/marketing/campaigns/audience/exclusions-search":
    "Search contacts to exclude",
  "portal/marketing/campaigns/audience/exclusions-selected":
    "{{count}} contacts excluded",
  "portal/marketing/campaigns/audience/groups": "Groups",
  "portal/marketing/campaigns/audience/groups-empty":
    "There are no groups you can read.",
  "portal/marketing/campaigns/audience/groups-selected":
    "{{count}} groups selected",
  "portal/marketing/campaigns/audience/lists": "Lists",
  "portal/marketing/campaigns/audience/lists-empty":
    "There are no lists you can read.",
  "portal/marketing/campaigns/audience/lists-selected":
    "{{count}} lists selected",
  "portal/marketing/campaigns/audience/no-size-estimate":
    "The final recipient count is calculated when the campaign is scheduled.",
  "portal/marketing/campaigns/audience/none-selected":
    "Select at least one list, group or audience.",
  "portal/marketing/campaigns/back": "Back",
  "portal/marketing/campaigns/conflict-body":
    "Reload to see the latest version before making more changes. Nothing was overwritten.",
  "portal/marketing/campaigns/conflict-reload": "Reload",
  "portal/marketing/campaigns/conflict-title":
    "Someone else changed this campaign",
  "portal/marketing/campaigns/content/category": "Category",
  "portal/marketing/campaigns/content/name": "Campaign name",
  "portal/marketing/campaigns/content/name-readonly":
    "The name cannot be changed after the campaign is created.",
  "portal/marketing/campaigns/content/no-templates":
    "There are no templates yet. Create one in Templates first.",
  "portal/marketing/campaigns/content/sender": "Sender",
  "portal/marketing/campaigns/content/subject": "Subject",
  "portal/marketing/campaigns/content/subject-hint":
    "The subject comes from the selected template version and is the same for every recipient.",
  "portal/marketing/campaigns/content/template": "Template",
  "portal/marketing/campaigns/content/version": "Template version",
  "portal/marketing/campaigns/content/version-label": "Version {{version}}",
  "portal/marketing/campaigns/control/already":
    "The send was already in that state.",
  "portal/marketing/campaigns/control/cancel": "Cancel send",
  "portal/marketing/campaigns/control/cancel-done": "Cancellation requested.",
  "portal/marketing/campaigns/control/cancel-message":
    "Messages not yet sent will not be sent. This cannot be undone.",
  "portal/marketing/campaigns/control/cancel-title": "Cancel this send?",
  "portal/marketing/campaigns/control/conflict-body":
    "Progress was refreshed. Review the new state and try again.",
  "portal/marketing/campaigns/control/conflict-title": "The send changed",
  "portal/marketing/campaigns/control/held-body":
    "The send cannot resume while the hold is active. Cancel this campaign and duplicate it to send again.",
  "portal/marketing/campaigns/control/held-title": "The hold is still active",
  "portal/marketing/campaigns/control/pause": "Pause",
  "portal/marketing/campaigns/control/pause-done": "Pause requested.",
  "portal/marketing/campaigns/control/resume": "Resume",
  "portal/marketing/campaigns/control/resume-done": "Send resumed.",
  "portal/marketing/campaigns/control/still-draining-body":
    "The send is still finishing messages in flight. Try again in a moment.",
  "portal/marketing/campaigns/control/still-draining-title": "Still pausing",
  "portal/marketing/campaigns/detail/duplicate": "Duplicate",
  "portal/marketing/campaigns/detail/duplicate-failed":
    "The campaign could not be duplicated.",
  "portal/marketing/campaigns/detail/edit": "Open in wizard",
  "portal/marketing/campaigns/detail/load-error":
    "The campaign could not be loaded.",
  "portal/marketing/campaigns/detail/no-dispatch":
    "This campaign has not been scheduled yet.",
  "portal/marketing/campaigns/detail/refresh": "Refresh",
  "portal/marketing/campaigns/detail/select":
    "Select a campaign to see its details.",
  "portal/marketing/campaigns/field-required": "This field is required.",
  "portal/marketing/campaigns/list/empty": "There are no campaigns yet.",
  "portal/marketing/campaigns/list/no-revision": "No revision yet",
  "portal/marketing/campaigns/list/not-scheduled": "Not scheduled",
  "portal/marketing/campaigns/list/readiness": "Revision: {{state}}",
  "portal/marketing/campaigns/list/readiness/invalid": "has errors",
  "portal/marketing/campaigns/list/readiness/pending": "being checked",
  "portal/marketing/campaigns/list/readiness/ready": "ready",
  "portal/marketing/campaigns/list/readiness/unknown": "unknown",
  "portal/marketing/campaigns/list/scheduled-at": "Scheduled {{when}}",
  "portal/marketing/campaigns/list/subtitle":
    "Create, review and monitor email campaigns.",
  "portal/marketing/campaigns/list/title": "Campaigns",
  "portal/marketing/campaigns/list/updated-at": "Updated {{when}}",
  "portal/marketing/campaigns/load-error":
    "The campaign data could not be loaded.",
  "portal/marketing/campaigns/loading": "Loading…",
  "portal/marketing/campaigns/new": "New campaign",
  "portal/marketing/campaigns/next": "Next",
  "portal/marketing/campaigns/permission-denied":
    "You do not have permission to do this.",
  "portal/marketing/campaigns/placeholder-title": "Campaigns",
  "portal/marketing/campaigns/progress/counts": "Recipients by state",
  "portal/marketing/campaigns/progress/hold-body":
    "Sending stopped automatically. If the cause does not clear, cancel this campaign and duplicate it to send again.",
  "portal/marketing/campaigns/progress/hold-reasons": "Reasons",
  "portal/marketing/campaigns/progress/hold-reasons-hidden":
    "Your role cannot see the hold reasons. Ask an administrator.",
  "portal/marketing/campaigns/progress/hold-title": "This send is on hold",
  "portal/marketing/campaigns/progress/issues":
    "{{count}} recipients need attention",
  "portal/marketing/campaigns/progress/load-error":
    "Progress could not be loaded. The last known values are shown.",
  "portal/marketing/campaigns/progress/pausing":
    "Pausing: messages already in flight are being finished. You can resume once the send is paused.",
  "portal/marketing/campaigns/progress/scheduled-for": "Scheduled for {{when}}",
  "portal/marketing/campaigns/progress/state": "Status",
  "portal/marketing/campaigns/progress/title": "Send progress",
  "portal/marketing/campaigns/progress/total": "{{total}} recipients",
  "portal/marketing/campaigns/read-only":
    "You can review this campaign but not edit it.",
  "portal/marketing/campaigns/request-failed": "The request failed. Try again.",
  "portal/marketing/campaigns/review/approval": "Approval",
  "portal/marketing/campaigns/review/approve": "Approve",
  "portal/marketing/campaigns/review/approved-done": "Revision approved.",
  "portal/marketing/campaigns/review/audiences": "Audiences",
  "portal/marketing/campaigns/review/category": "Category",
  "portal/marketing/campaigns/review/contacts": "Individual contacts",
  "portal/marketing/campaigns/review/deleted": "Deleted",
  "portal/marketing/campaigns/review/excluded": "Excluded contacts",
  "portal/marketing/campaigns/review/groups": "Groups",
  "portal/marketing/campaigns/review/lists": "Lists",
  "portal/marketing/campaigns/review/no-approval": "Not requested yet",
  "portal/marketing/campaigns/review/no-revision":
    "This campaign has no saved revision yet.",
  "portal/marketing/campaigns/review/none": "None",
  "portal/marketing/campaigns/review/not-ready": "Not ready to send",
  "portal/marketing/campaigns/review/readiness": "Readiness",
  "portal/marketing/campaigns/review/readiness-hidden":
    "Readiness is shown to people who can schedule or approve.",
  "portal/marketing/campaigns/review/ready": "Ready to send",
  "portal/marketing/campaigns/review/reject": "Reject",
  "portal/marketing/campaigns/review/rejected-done": "Revision rejected.",
  "portal/marketing/campaigns/review/restricted": "Restricted",
  "portal/marketing/campaigns/review/revision": "Revision {{number}}",
  "portal/marketing/campaigns/review/sender": "Sender",
  "portal/marketing/campaigns/review/subject": "Subject",
  "portal/marketing/campaigns/review/template": "Template",
  "portal/marketing/campaigns/saving": "Saving…",
  "portal/marketing/campaigns/schedule/date": "Date",
  "portal/marketing/campaigns/schedule/done": "Campaign scheduled.",
  "portal/marketing/campaigns/schedule/invalid-time":
    "Enter the time as HH:mm.",
  "portal/marketing/campaigns/schedule/missing-date": "Choose a date.",
  "portal/marketing/campaigns/schedule/no-access":
    "Scheduling and test sends are available to people who can send campaigns.",
  "portal/marketing/campaigns/schedule/offset": "UTC offset",
  "portal/marketing/campaigns/schedule/offset-hint":
    "This time happens twice when clocks go back. Choose which one you mean.",
  "portal/marketing/campaigns/schedule/replayed":
    "This request was already processed; no second send was created.",
  "portal/marketing/campaigns/schedule/submit": "Schedule send",
  "portal/marketing/campaigns/schedule/time": "Time (HH:mm)",
  "portal/marketing/campaigns/schedule/time-zone": "Time zone",
  "portal/marketing/campaigns/step-go-to": "Go back to {{step}}",
  "portal/marketing/campaigns/step/audience": "Audience",
  "portal/marketing/campaigns/step/content": "Content",
  "portal/marketing/campaigns/step/review": "Review",
  "portal/marketing/campaigns/step/schedule": "Schedule and test",
  "portal/marketing/campaigns/test/done": "Test sent.",
  "portal/marketing/campaigns/test/limit":
    "You can choose at most {{max}} recipients.",
  "portal/marketing/campaigns/test/none-allowed":
    "No test recipients are configured. Add them in Marketing settings.",
  "portal/marketing/campaigns/test/recipients": "Test recipients",
  "portal/marketing/campaigns/test/select-one":
    "Choose at least one recipient.",
  "portal/marketing/campaigns/test/send": "Send test",
  "portal/marketing/campaigns/test/title": "Send a test",
  "portal/marketing/campaigns/wizard-nav": "Campaign steps",
  "portal/marketing/campaigns/wizard-title": "New campaign",
  "portal/marketing/campaigns/wizard-title-edit": "Edit campaign",
  "portal/marketing/category/announcements": "Announcements",
  "portal/marketing/category/marketing-sales": "Marketing & Sales",
  "portal/marketing/category/transactional": "Transactional",
  "portal/marketing/contacts": "Contacts",
  "portal/marketing/contacts/audit-action/contact.created": "Contact created",
  "portal/marketing/contacts/audit-action/subscription.changed":
    "Preferences changed",
  "portal/marketing/contacts/create": "Create contact",
  "portal/marketing/contacts/display-name": "Display name",
  "portal/marketing/contacts/display-name-entity-owned":
    "Synced from the linked Entity. Edit it there to change the name.",
  "portal/marketing/contacts/edit-title": "Edit contact",
  "portal/marketing/contacts/email": "Email",
  "portal/marketing/contacts/empty":
    "No contacts yet. Import a CSV or wait for Entity sync.",
  "portal/marketing/contacts/entity-linked": "Entity-linked",
  "portal/marketing/contacts/existing-found": "An existing contact was found.",
  "portal/marketing/contacts/filter/all": "All",
  "portal/marketing/contacts/filter/entity-linked": "Entity-linked",
  "portal/marketing/contacts/filter/mailing-only": "Mailing-only",
  "portal/marketing/contacts/filter/suppressed": "Suppressed",
  "portal/marketing/contacts/filter/unsubscribed": "Unsubscribed",
  "portal/marketing/contacts/history/audit-events": "Activity",
  "portal/marketing/contacts/history/campaigns": "Campaigns",
  "portal/marketing/contacts/history/coming-soon":
    "Available when campaigns ship.",
  "portal/marketing/contacts/history/memberships": "Lists",
  "portal/marketing/contacts/history/no-audit-events": "No activity recorded.",
  "portal/marketing/contacts/history/no-memberships":
    "Not a member of any list.",
  "portal/marketing/contacts/history/suppressions": "Suppressions",
  "portal/marketing/contacts/identity": "Identity",
  "portal/marketing/contacts/locale": "Locale",
  "portal/marketing/contacts/mailing-only": "Mailing-only",
  "portal/marketing/contacts/no-notes": "No notes",
  "portal/marketing/contacts/notes": "Notes",
  "portal/marketing/contacts/open-entity": "Open Entity",
  "portal/marketing/contacts/open-existing": "Open existing",
  "portal/marketing/contacts/personalization": "Personalization",
  "portal/marketing/contacts/provenance": "Source",
  "portal/marketing/contacts/provenance/entity-sync": "Entity synchronization",
  "portal/marketing/contacts/provenance/import": "CSV import",
  "portal/marketing/contacts/provenance/manual": "Manual entry",
  "portal/marketing/contacts/select-from-list":
    "Select a contact from the list",
  "portal/marketing/contacts/tab/history": "History",
  "portal/marketing/contacts/tab/main": "Main",
  "portal/marketing/contacts/tab/preferences": "Preferences",
  "portal/marketing/contacts/unsubscribe-all": "Unsubscribe from all",
  "portal/marketing/contacts/unsubscribe-all-confirm":
    "This contact will stop receiving all optional communications. Required communications continue.",
  "portal/marketing/contacts/updated": "Updated",
  "portal/marketing/deliverability/check-advisory": "Warning",
  "portal/marketing/deliverability/check-failed": "Failed",
  "portal/marketing/deliverability/check-passed": "Passed",
  "portal/marketing/deliverability/hold-placed": "Placed",
  "portal/marketing/deliverability/hold-reason": "Reason",
  "portal/marketing/deliverability/hold-scope": "Scope",
  "portal/marketing/deliverability/holds-title": "Active dispatch holds",
  "portal/marketing/deliverability/kill-switch-banner":
    "Dispatch is currently blocked: {{count}} active hold(s) or a failed launch-readiness check.",
  "portal/marketing/deliverability/no-holds": "No active holds.",
  "portal/marketing/deliverability/no-suppressions": "No suppressed addresses.",
  "portal/marketing/deliverability/not-ready": "Not ready to send",
  "portal/marketing/deliverability/readiness-title": "Launch readiness",
  "portal/marketing/deliverability/ready": "Ready to send",
  "portal/marketing/deliverability/refresh": "Refresh",
  "portal/marketing/deliverability/suppression-effective": "Since",
  "portal/marketing/deliverability/suppression-email": "Email",
  "portal/marketing/deliverability/suppression-reason": "Reason",
  "portal/marketing/deliverability/suppressions-title": "Suppressions",
  "portal/marketing/deliverability/suppressions-total":
    "{{count}} active suppression(s) — most recent 50 shown",
  "portal/marketing/disabled": "Marketing is not enabled for this company.",
  "portal/marketing/hold-reason/audience-cap-exceeded":
    "The audience is too large",
  "portal/marketing/hold-reason/authority-revoked":
    "The scheduler no longer has permission",
  "portal/marketing/hold-reason/aws-reputation-bounce":
    "Sending account reputation warning",
  "portal/marketing/hold-reason/complaint-campaign":
    "Spam complaints on this campaign",
  "portal/marketing/hold-reason/complaint-provider-scope":
    "Spam complaints on the sending account",
  "portal/marketing/hold-reason/feedback-health-degraded":
    "Delivery feedback is degraded",
  "portal/marketing/hold-reason/feedback-inbox-hard-failure-unprocessed":
    "Delivery feedback could not be processed",
  "portal/marketing/hold-reason/local-permanent-bounce-ratio":
    "Too many permanent bounces",
  "portal/marketing/hold-reason/missed-window": "The scheduled time was missed",
  "portal/marketing/hold-reason/module-disabled": "Marketing is disabled",
  "portal/marketing/hold-reason/operational-eligibility-missing":
    "Eligibility for this category is not configured",
  "portal/marketing/hold-reason/other": "On hold",
  "portal/marketing/hold-reason/provider-sending-paused":
    "Provider sending is paused",
  "portal/marketing/hold-reason/provider-sending-state":
    "Provider sending is restricted",
  "portal/marketing/hold-reason/provider-suppression-sync-untrusted":
    "Suppression list is not in sync",
  "portal/marketing/hold-reason/revision-drifted":
    "The approved revision changed",
  "portal/marketing/hold-reason/sender-not-ready": "The sender is not ready",
  "portal/marketing/import/already-imported": "Already imported on {{date}}",
  "portal/marketing/import/change-file": "Choose another file",
  "portal/marketing/import/columns": "CSV columns",
  "portal/marketing/import/commit": "Commit",
  "portal/marketing/import/commit-action": "Commit import",
  "portal/marketing/import/continue": "Continue",
  "portal/marketing/import/created": "Contacts created",
  "portal/marketing/import/display-name": "Display name",
  "portal/marketing/import/done": "Import complete",
  "portal/marketing/import/download-file-name": "contact-import-problems.csv",
  "portal/marketing/import/download-problems": "Download problem rows",
  "portal/marketing/import/duplicates-in-file": "Duplicates in file",
  "portal/marketing/import/email": "Email",
  "portal/marketing/import/existing-contacts": "Existing contacts",
  "portal/marketing/import/file-size-limit":
    "Maximum file size: {{bytes}} bytes",
  "portal/marketing/import/file-too-large":
    "The file exceeds the import size limit.",
  "portal/marketing/import/ignore": "Do not import this column",
  "portal/marketing/import/invalid": "Invalid rows",
  "portal/marketing/import/invalid-page": "Unable to read the import results.",
  "portal/marketing/import/locale": "Locale",
  "portal/marketing/import/map": "Map columns",
  "portal/marketing/import/next-page": "Next rows",
  "portal/marketing/import/notes": "Notes",
  "portal/marketing/import/nothing-written":
    "No contacts have been created or changed.",
  "portal/marketing/import/personalization": "Personalization field",
  "portal/marketing/import/personalization-key": "Personalization field name",
  "portal/marketing/import/personalization-key-required":
    "Enter a name for this personalization field",
  "portal/marketing/import/previous-page": "Previous rows",
  "portal/marketing/import/problem/duplicate-in-file":
    "Duplicate within this file",
  "portal/marketing/import/problem/existing-contact": "Contact already exists",
  "portal/marketing/import/problem/invalid-display-name":
    "Display name is too long (255 characters max)",
  "portal/marketing/import/problem/invalid-email": "Invalid email address",
  "portal/marketing/import/problem/invalid-locale": "Unsupported locale",
  "portal/marketing/import/problem/invalid-notes":
    "Notes are too long (2,000 characters max)",
  "portal/marketing/import/problem/invalid-personalization-value":
    "Personalization value is too long (500 characters max)",
  "portal/marketing/import/problems": "Problems",
  "portal/marketing/import/row": "Row",
  "portal/marketing/import/skipped": "Duplicates skipped",
  "portal/marketing/import/title": "Import contacts",
  "portal/marketing/import/unmapped": "Choose a field…",
  "portal/marketing/import/upload": "Upload",
  "portal/marketing/import/upload-helper": "Choose a CSV file.",
  "portal/marketing/import/valid": "Valid rows",
  "portal/marketing/import/validate": "Validate",
  "portal/marketing/import/view-contacts": "View contacts",
  "portal/marketing/import/will-create": "Contacts to create",
  "portal/marketing/lists": "Lists",
  "portal/marketing/lists/add-members": "Add members",
  "portal/marketing/lists/create": "Create list",
  "portal/marketing/lists/current-members": "Current members",
  "portal/marketing/lists/current-members-count": "{{count}} current members",
  "portal/marketing/lists/current-members-count-one": "1 current member",
  "portal/marketing/lists/description": "Description",
  "portal/marketing/lists/edit": "Edit list",
  "portal/marketing/lists/empty": "No lists yet",
  "portal/marketing/lists/members": "Members",
  "portal/marketing/lists/name": "Name",
  "portal/marketing/lists/no-members": "This list has no visible members",
  "portal/marketing/lists/remove": "Remove member",
  "portal/marketing/lists/remove-confirm": "Remove this contact from the list?",
  "portal/marketing/lists/select": "Select a list",
  "portal/marketing/lists/select-contacts": "Search contacts",
  "portal/marketing/lists/subtitle": "Manage static contact lists",
  "portal/marketing/lists/tab/members": "Members",
  "portal/marketing/lists/tab/settings": "Settings",
  "portal/marketing/not-enabled": "Marketing is not enabled for this company.",
  "portal/marketing/overview": "Overview",
  "portal/marketing/overview/add-sender": "Add sender",
  "portal/marketing/overview/attention": "Blocked and attention",
  "portal/marketing/overview/campaigns-sent": "Campaigns sent",
  "portal/marketing/overview/contacts-eligible": "Eligible contacts",
  "portal/marketing/overview/import-contacts": "Import contacts",
  "portal/marketing/overview/last-30-days": "Last 30 days",
  "portal/marketing/overview/load-error": "Unable to load overview",
  "portal/marketing/overview/new-campaign": "New campaign",
  "portal/marketing/overview/no-campaigns": "No campaigns yet",
  "portal/marketing/overview/recent-campaigns": "Recent campaigns",
  "portal/marketing/overview/recipients-accepted": "Recipients accepted",
  "portal/marketing/overview/see-all": "See all",
  "portal/marketing/overview/sender-readiness": "Sender readiness",
  "portal/marketing/overview/start": "Start",
  "portal/marketing/preferences/all-optional-opt-out":
    "Unsubscribe from all optional emails",
  "portal/marketing/preferences/conflict":
    "Preferences were updated elsewhere; showing the latest.",
  "portal/marketing/preferences/load-error": "Preferences could not be loaded.",
  "portal/marketing/preferences/loading": "Loading preferences",
  "portal/marketing/preferences/required": "Required",
  "portal/marketing/preferences/required-readout":
    "Required, cannot be changed",
  "portal/marketing/preferences/retry": "Retry",
  "portal/marketing/preferences/subscribed": "Subscribed",
  "portal/marketing/preferences/unset": "Unset",
  "portal/marketing/recipient-state/accepted": "Accepted for delivery",
  "portal/marketing/recipient-state/cancelled": "Cancelled",
  "portal/marketing/recipient-state/claimed": "In progress",
  "portal/marketing/recipient-state/failed": "Failed",
  "portal/marketing/recipient-state/pending": "Pending",
  "portal/marketing/recipient-state/pending-error": "Could not be prepared",
  "portal/marketing/recipient-state/suppressed": "Suppressed",
  "portal/marketing/recipient-state/unknown": "Outcome unknown",
  "portal/marketing/resources": "Resources",
  "portal/marketing/retry": "Retry",
  "portal/marketing/settings": "Settings",
  "portal/marketing/settings/ImportMaxCellBytes": "Maximum bytes per cell",
  "portal/marketing/settings/ImportMaxColumns": "Maximum import columns",
  "portal/marketing/settings/ImportMaxFileBytes": "Maximum CSV file bytes",
  "portal/marketing/settings/ImportMaxRows": "Maximum import rows",
  "portal/marketing/settings/MaxAttachmentAggregateBytes":
    "Maximum total attachment bytes",
  "portal/marketing/settings/MaxAttachments": "Maximum attachments",
  "portal/marketing/settings/MaxCampaignRecipients":
    "Maximum campaign recipients",
  "portal/marketing/settings/MaxEncodedMessageBytes":
    "Maximum encoded message bytes",
  "portal/marketing/settings/TestRecipientMaxCount": "Maximum test recipients",
  "portal/marketing/settings/add-sender": "Add sender",
  "portal/marketing/settings/audit": "Audit",
  "portal/marketing/settings/audit-actor": "Actor identifier",
  "portal/marketing/settings/audit-object": "Object type",
  "portal/marketing/settings/brand": "Brand",
  "portal/marketing/settings/brand-accent-color": "Accent color",
  "portal/marketing/settings/brand-footer-address": "Footer address",
  "portal/marketing/settings/brand-footer-legal-name": "Footer legal name",
  "portal/marketing/settings/brand-logo": "Logo",
  "portal/marketing/settings/brand-name": "Brand name",
  "portal/marketing/settings/brand-no-logo": "No logo registered yet",
  "portal/marketing/settings/categories": "Categories",
  "portal/marketing/settings/category-subscription-note":
    "Changing a category never alters existing subscriptions.",
  "portal/marketing/settings/check-now": "Check now",
  "portal/marketing/settings/check-now-caption":
    "With the manual checker, no sender reaches verified automatically.",
  "portal/marketing/settings/click-tracking-enabled": "Measure clicks",
  "portal/marketing/settings/create-brand-profile": "Create brand profile",
  "portal/marketing/settings/default": "Default",
  "portal/marketing/settings/deliverability": "Deliverability",
  "portal/marketing/settings/disable": "Disable",
  "portal/marketing/settings/disable-sender-confirm":
    "A disabled sender cannot be selected for new drafts. Existing scheduled campaigns are unaffected.",
  "portal/marketing/settings/disabled": "Disabled",
  "portal/marketing/settings/edit": "Edit",
  "portal/marketing/settings/edit-category": "Edit category",
  "portal/marketing/settings/edit-limits": "Edit limits",
  "portal/marketing/settings/enable": "Enable",
  "portal/marketing/settings/enabled": "Enabled",
  "portal/marketing/settings/first-batch-observation-hold-minutes":
    "First batch observation hold (minutes)",
  "portal/marketing/settings/first-batch-size": "First batch size",
  "portal/marketing/settings/label-en": "English label",
  "portal/marketing/settings/label-es": "Spanish label",
  "portal/marketing/settings/limits": "Limits",
  "portal/marketing/settings/max-recipients": "Maximum recipients",
  "portal/marketing/settings/no-audit": "No audit events",
  "portal/marketing/settings/no-brand-profile":
    "No brand profile configured yet",
  "portal/marketing/settings/no-policy": "No policy configured",
  "portal/marketing/settings/no-senders": "No senders configured yet",
  "portal/marketing/settings/open-tracking-enabled": "Measure opens",
  "portal/marketing/settings/order": "Order",
  "portal/marketing/settings/register-hosted-logo": "Register hosted logo",
  "portal/marketing/settings/register-hosted-logo-caption":
    "Registers an already-hosted image (e.g. an existing company logo) as this brand’s published logo. This is an M1 bootstrap action, not the resource library upload pipeline.",
  "portal/marketing/settings/register-hosted-logo-name": "Logo name",
  "portal/marketing/settings/register-hosted-logo-url": "Hosted image URL",
  "portal/marketing/settings/required": "Required",
  "portal/marketing/settings/sender-binding": "Provider binding",
  "portal/marketing/settings/sender-display-name": "Display name",
  "portal/marketing/settings/sender-from-email": "From address",
  "portal/marketing/settings/sender-reply-to": "Reply-to address",
  "portal/marketing/settings/senders": "Senders",
  "portal/marketing/settings/set-default": "Set as default",
  "portal/marketing/settings/test-recipient-limit": "Test recipient limit",
  "portal/marketing/settings/test-recipients": "Approved test recipients",
  "portal/marketing/state/accepted": "Accepted",
  "portal/marketing/state/approved": "Approved",
  "portal/marketing/state/blocked": "Blocked",
  "portal/marketing/state/bounced": "Bounced",
  "portal/marketing/state/cancelled": "Cancelled",
  "portal/marketing/state/cancelling": "Cancelling",
  "portal/marketing/state/claimed": "Claimed",
  "portal/marketing/state/clean": "Clean",
  "portal/marketing/state/complained": "Complaint",
  "portal/marketing/state/complaint": "Complaint",
  "portal/marketing/state/completed": "Completed",
  "portal/marketing/state/completed-with-issues": "Completed with issues",
  "portal/marketing/state/delivered": "Delivered",
  "portal/marketing/state/draft": "Draft",
  "portal/marketing/state/hard-bounce": "Hard bounce",
  "portal/marketing/state/held": "On hold",
  "portal/marketing/state/manual": "Manual",
  "portal/marketing/state/manual-attested": "Manually attested",
  "portal/marketing/state/manual-attested-description":
    "Attested manually, not scanned",
  "portal/marketing/state/not_verified": "Not verified",
  "portal/marketing/state/paused": "Paused",
  "portal/marketing/state/pausing": "Pausing",
  "portal/marketing/state/pending": "Pending",
  "portal/marketing/state/pending-error": "Pending correction",
  "portal/marketing/state/preparing": "Preparing",
  "portal/marketing/state/provider-suppressed": "Provider suppression",
  "portal/marketing/state/ready": "Ready",
  "portal/marketing/state/revalidation_required": "Revalidation required",
  "portal/marketing/state/scheduled": "Scheduled",
  "portal/marketing/state/sending": "Sending",
  "portal/marketing/state/suppressed": "Suppressed",
  "portal/marketing/state/temporary": "Temporary",
  "portal/marketing/state/unknown": "Unknown",
  "portal/marketing/state/verification_failed": "Verification failed",
  "portal/marketing/state/verification_pending": "Verification pending",
  "portal/marketing/state/verified": "Verified",
  "portal/marketing/templates": "Templates",
  "portal/marketing/templates/category": "Category",
  "portal/marketing/templates/create": "New template",
  "portal/marketing/templates/diagnostics-title":
    "Removed or unsupported content",
  "portal/marketing/templates/empty": "No templates yet",
  "portal/marketing/templates/insert-variable": "Insert variable",
  "portal/marketing/templates/name": "Name",
  "portal/marketing/templates/no-variables":
    "No personalization variables declared",
  "portal/marketing/templates/preheader": "Preheader",
  "portal/marketing/templates/preview-desktop": "Desktop",
  "portal/marketing/templates/preview-mobile": "Mobile",
  "portal/marketing/templates/preview-title": "Email preview",
  "portal/marketing/templates/reload-latest": "Reload latest",
  "portal/marketing/templates/revision-conflict":
    "This template changed elsewhere. Reload the latest version before saving.",
  "portal/marketing/templates/select-from-list":
    "Select a template from the list",
  "portal/marketing/templates/select-variable": "Select a variable",
  "portal/marketing/templates/subject": "Subject",
  "portal/marketing/templates/updated": "Updated",
  "portal/missing-company-context": "No company is selected",
  "portal/modals/editEntityRole/no-assignable-scopes":
    "You have no assignable scopes",
  "portal/modals/editEntityRole/options-load-failed":
    "The roles you can assign could not be loaded. Close this window and try again.",
  "portal/model": "Model",
  "portal/name": "Name",
  "portal/new": "New",
  "portal/new-business": "New Póliza",
  "portal/next": "Next",
  "portal/no": "No",
  "portal/no-agencies-to-display": "No agencies to display",
  "portal/no-cedents-to-display": "No cedents to display",
  "portal/no-commission-tables": "No commission tables to display",
  "portal/no-customers-to-display": "No customers to display",
  "portal/no-employees-to-display": "No employees to display",
  "portal/no-files": "No files",
  "portal/no-insurers-to-display": "No insurers to display",
  "portal/no-placement-to-display": "No placement to display",
  "portal/no-policies-to-display": "No policies to display",
  "portal/no-records": "No records",
  "portal/no-results-found": "No results found",
  "portal/no-roles-assigned": "No roles assigned",
  "portal/no-users-to-display": "No users to display",
  "portal/no-vendors-to-display": "No vendors to display",
  "portal/none": "None",
  "portal/not-a-valid-date": "Not a valid date",
  "portal/notifications/empty": "You have no notifications.",
  "portal/notifications/load-error": "Could not load them.",
  "portal/notifications/mark-all-read": "Mark all as read",
  "portal/notifications/severity-error": "Error",
  "portal/notifications/severity-info": "Information",
  "portal/notifications/severity-warning": "Warning",
  "portal/notifications/title": "Notifications",
  "portal/notifications/unread": "Unread: {{count}}",
  "portal/notifications/unread-status": "Unread",
  "portal/order": "Order",
  "portal/output-context": "Output Context",
  "portal/output-fields": "Output Fields (key:variable, ...)",
  "portal/output-variable": "Output Variable",
  "portal/overview": "Overview",
  "portal/payment-annually": "Annually",
  "portal/payment-monthly": "Monthly",
  "portal/payment-quarterly": "Quarterly",
  "portal/payment-semiannually": "Semiannually",
  "portal/pipeline-active": "Active",
  "portal/pipeline-version": "Version",
  "portal/pipeline/actions": "Actions",
  "portal/pipeline/activity-tab":
    "Activity tab: shows the case timeline, it has no fields.",
  "portal/pipeline/add-action": "Add Action",
  "portal/pipeline/add-condition": "Add Condition",
  "portal/pipeline/add-document": "Add Document",
  "portal/pipeline/add-field": "Add Field",
  "portal/pipeline/add-group": "Add Group",
  "portal/pipeline/add-rule": "Add Rule",
  "portal/pipeline/add-stage": "Add Stage",
  "portal/pipeline/add-step": "Add Step",
  "portal/pipeline/add-tab": "Add Tab",
  "portal/pipeline/add-transition": "Add Transition",
  "portal/pipeline/add-user-skill": "Add Skill",
  "portal/pipeline/assignment-rule-name": "Rule Name",
  "portal/pipeline/assignment-rules": "Assignment Rules",
  "portal/pipeline/back": "Back",
  "portal/pipeline/capabilities": "Capabilities",
  "portal/pipeline/column-format": "Format",
  "portal/pipeline/column-header": "Column Header",
  "portal/pipeline/column-width": "Width",
  "portal/pipeline/columns": "Columns",
  "portal/pipeline/component": "Component",
  "portal/pipeline/condition-group": "Group",
  "portal/pipeline/conditions": "Conditions",
  "portal/pipeline/delete-transition": "Delete Transition",
  "portal/pipeline/delete-transition-confirm":
    "Are you sure you want to delete this transition? This action cannot be undone.",
  "portal/pipeline/detail-layout": "Detail Layout",
  "portal/pipeline/detail-view": "Detail",
  "portal/pipeline/disabled": "Disabled",
  "portal/pipeline/document-format": "Format",
  "portal/pipeline/documents": "Documents",
  "portal/pipeline/edit-action": "Edit Action",
  "portal/pipeline/edit-condition": "Edit Condition",
  "portal/pipeline/edit-document": "Edit Document",
  "portal/pipeline/edit-pdf-template": "Edit PDF Template",
  "portal/pipeline/edit-rule": "Edit Rule",
  "portal/pipeline/edit-stage": "Edit Stage",
  "portal/pipeline/edit-transition": "Edit Transition",
  "portal/pipeline/edit-user-skill": "Edit Skill",
  "portal/pipeline/edit-xlsx-template": "Edit XLSX Template",
  "portal/pipeline/enabled": "Enabled",
  "portal/pipeline/expression": "Expression",
  "portal/pipeline/field": "Field",
  "portal/pipeline/fields/agency-name": "Agency name",
  "portal/pipeline/fields/group-entity": "Entity",
  "portal/pipeline/fields/group-lob": "Line of business",
  "portal/pipeline/fields/group-policy": "Policy",
  "portal/pipeline/fields/insurer-name": "Insurer name",
  "portal/pipeline/fields/lob-generates-receipts":
    "Line of business generates receipts",
  "portal/pipeline/fields/lob-issuable": "Line of business issuable",
  "portal/pipeline/fields/lob-name": "Line of business name",
  "portal/pipeline/fields/lob-prefix": "Line of business prefix",
  "portal/pipeline/fields/modality": "Modality",
  "portal/pipeline/fields/net-premium": "Net premium",
  "portal/pipeline/fields/policy-holder-country": "Policy holder country",
  "portal/pipeline/fields/policy-holder-name": "Policy holder name",
  "portal/pipeline/fields/policy-number": "Policy number",
  "portal/pipeline/fields/policy-type": "Policy type",
  "portal/pipeline/fields/stage": "Stage",
  "portal/pipeline/fields/total-premium": "Total premium",
  "portal/pipeline/fields/type": "Type",
  "portal/pipeline/form-definition": "Dynamic Form",
  "portal/pipeline/form-definition-none": "None",
  "portal/pipeline/form-steps": "Form Steps",
  "portal/pipeline/form-view": "Form",
  "portal/pipeline/icon": "Icon",
  "portal/pipeline/indent": "Indent",
  "portal/pipeline/insert-field": "Insert Field",
  "portal/pipeline/label": "Label",
  "portal/pipeline/lob-categories": "LOB Categories",
  "portal/pipeline/lock-all-fields":
    "Lock every field of the case at this stage",
  "portal/pipeline/lock-all-fields-hint":
    "The server refuses any change to the case, its subject matter and its attributes while it sits in this stage. Stage moves and system updates still work.",
  "portal/pipeline/method": "Method",
  "portal/pipeline/move-down": "Move down",
  "portal/pipeline/move-up": "Move up",
  "portal/pipeline/no-actions-configured": "No actions configured.",
  "portal/pipeline/no-attributes": "No attributes defined.",
  "portal/pipeline/no-columns": "No columns defined. Click + to add one.",
  "portal/pipeline/no-conditions": "No conditions configured",
  "portal/pipeline/no-definitions":
    "No subject matter definitions found for this LOB.",
  "portal/pipeline/no-documents-configured":
    "No document templates configured.",
  "portal/pipeline/no-fields-configured": "No fields configured.",
  "portal/pipeline/no-form-steps-configured": "No form steps configured.",
  "portal/pipeline/no-lob-selected":
    "No line of business linked to this stage.",
  "portal/pipeline/no-rules": "No assignment rules configured.",
  "portal/pipeline/notes-content": "Notes Content",
  "portal/pipeline/operator": "Operator",
  "portal/pipeline/order": "Order",
  "portal/pipeline/outdent": "Outdent",
  "portal/pipeline/priority": "Priority",
  "portal/pipeline/read-only-at-stage": "Read-only at this stage",
  "portal/pipeline/rename-sheet": "Rename Sheet",
  "portal/pipeline/required-at-stage": "Required at this stage",
  "portal/pipeline/roles/assignee": "Assignee",
  "portal/pipeline/roles/external": "External",
  "portal/pipeline/roles/internal": "Internal",
  "portal/pipeline/roles/requester": "Requester",
  "portal/pipeline/section-header": "Header",
  "portal/pipeline/section-notes": "Notes",
  "portal/pipeline/section-separator": "Separator",
  "portal/pipeline/section-table": "Table",
  "portal/pipeline/section-title": "Title",
  "portal/pipeline/sections": "Sections",
  "portal/pipeline/select-section": "Select a section to edit",
  "portal/pipeline/separator-description":
    "Renders a horizontal line in the document",
  "portal/pipeline/sheet-name": "Sheet Name",
  "portal/pipeline/skill-filter": "Skill Filter",
  "portal/pipeline/stage-not-found": "Stage not found",
  "portal/pipeline/stage-properties": "Stage Properties",
  "portal/pipeline/strategy": "Strategy",
  "portal/pipeline/strategy/least-loaded": "Least loaded",
  "portal/pipeline/strategy/manual-claim": "Manual claim",
  "portal/pipeline/strategy/round-robin": "Round robin",
  "portal/pipeline/subject-matter-requirements": "Subject Matter Requirements",
  "portal/pipeline/tab": "Tab",
  "portal/pipeline/task-type": "Task Type",
  "portal/pipeline/transition-not-found": "Transition not found",
  "portal/pipeline/transition-properties": "Transition Properties",
  "portal/pipeline/transition-type": "Type",
  "portal/pipeline/type-action": "Action",
  "portal/pipeline/type-automatic": "Automatic",
  "portal/pipeline/user-skill-capability": "Capability",
  "portal/pipeline/user-skill-lob-category": "LOB Category",
  "portal/pipeline/value": "Value",
  "portal/pipeline/value-type": "Value Type",
  "portal/pipeline/view-detail": "Detail",
  "portal/pipeline/view-form": "Form",
  "portal/pipeline/view-none": "None",
  "portal/pipeline/views": "Views",
  "portal/pipelines": "Pipelines",
  "portal/placement": "Placement",
  "portal/placement/accepted": "Accepted",
  "portal/placement/add-proposal": "Add Proposal",
  "portal/placement/all": "All Cases",
  "portal/placement/cancelled": "Cancelled",
  "portal/placement/closed": "Closed Cases",
  "portal/placement/completed": "Completed",
  "portal/placement/declined": "Declined",
  "portal/placement/draft": "Draft",
  "portal/placement/drafts": "Drafts",
  "portal/placement/edit-quote": "Edit Quote",
  "portal/placement/expedition": "Expedition",
  "portal/placement/inforce": "In Force",
  "portal/placement/issuance": "Issuance",
  "portal/placement/issuance-accepted": "Issuance Accepted",
  "portal/placement/issuance-rejected": "Issuance rejected",
  "portal/placement/issuance-requested": "Issuance Requested",
  "portal/placement/issuing": "Issuing",
  "portal/placement/lapsed": "Lapsed",
  "portal/placement/lost": "Lost",
  "portal/placement/open": "Open Cases",
  "portal/placement/pending-issuance": "Pending Issuance",
  "portal/placement/pending-quote": "Pending Quote",
  "portal/placement/pre-issuance": "Pre-Issuance",
  "portal/placement/quote-expired": "Expired",
  "portal/placement/quoted": "Quoted",
  "portal/placement/rejected": "Rejected",
  "portal/placement/requested": "Requested",
  "portal/policies": "Policies",
  "portal/policies/address": "Address",
  "portal/policies/cancel-order": "Cancel Order",
  "portal/policies/contacts": "Contacts",
  "portal/policies/coverages": "Coverages",
  "portal/policies/endorsement": "Endorsement",
  "portal/policies/entity-information": "Client Information",
  "portal/policies/er-aircrafts": "Aircrafts",
  "portal/policies/expiration-date": "Expiration Date",
  "portal/policies/files": "Files",
  "portal/policies/filters/expired": "Expired",
  "portal/policies/filters/issued": "Issued",
  "portal/policies/group-accidents": "Group Accidents",
  "portal/policies/group-health": "Group Health",
  "portal/policies/group-life": "Group Life",
  "portal/policies/home": "Home",
  "portal/policies/in-force-date": "In Force Date",
  "portal/policies/individual-health": "Individual Health",
  "portal/policies/individual-vehicle": "Individual Vehicle",
  "portal/policies/list-filters": "Filters",
  "portal/policies/list-filters-all": "All",
  "portal/policies/load-error": "The policy list could not be loaded",
  "portal/policies/main-contact": "Main Contact",
  "portal/policies/no-policies-to-display": "No policies to display",
  "portal/policies/no-results": "No results",
  "portal/policies/overview": "Overview",
  "portal/policies/policy": "Policy",
  "portal/policies/policy-files": "Policy Files",
  "portal/policies/policy-holder": "Policy Holder",
  "portal/policies/policy-information": "Policy Information",
  "portal/policies/policyholder": "Policy Holder",
  "portal/policies/premiums": "Premiums",
  "portal/policies/primary-insured": "Primary Insured",
  "portal/policies/proposal": "Proposal",
  "portal/policies/quote": "Quote",
  "portal/policies/quotes": "Quotes",
  "portal/policies/recall-quote": "Cancel Request",
  "portal/policies/search-placeholder-placement": "Search placement",
  "portal/policies/search-placeholder-policies": "Search policies",
  "portal/policies/select-policy-from-the-list":
    "Select a policy from the list",
  "portal/policies/select-quote-from-the-list": "Select a quote from the list",
  "portal/policies/sh/caribean": "Caribean",
  "portal/policies/sh/hull-region": "Hull Region",
  "portal/policies/sh/hull-value": "Hull Value",
  "portal/policies/sh/hull-year": "Hull Year",
  "portal/policies/sh/pacific": "Pacific",
  "portal/policies/sh/ship-information": "Ship Information",
  "portal/policies/ship-happens": "Ship Happens",
  "portal/policies/term-and-modality": "Term & Modality",
  "portal/policies/total-premium": "Total Premium",
  "portal/policies/underwriter": "Underwriter",
  "portal/policies/usual-driver": "Usual Driver",
  "portal/policies/vehicle": "Vehicle",
  "portal/policy-field": "Policy Field",
  "portal/policy-file/change-file": "Change",
  "portal/policy-file/endorsement-id": "Endorsement ID",
  "portal/policy-file/file": "File",
  "portal/policy-file/file-is-required": "File is required",
  "portal/policy-file/name": "File Name",
  "portal/policy-file/name-is-required": "File name is required",
  "portal/policy-file/policy-id": "Policy ID",
  "portal/policy-file/policy-id-is-required": "Policy ID is required",
  "portal/policy-file/select-file": "Select",
  "portal/policy-holder": "Policy Holder",
  "portal/policy-receipt/due-date": "Due Date",
  "portal/policy-receipt/fees": "Fees",
  "portal/policy-receipt/inforce-date": "In-Force Date",
  "portal/policy-receipt/net-premium": "Net Premium",
  "portal/policy-receipt/number": "Number",
  "portal/policy-receipt/stage": "Status",
  "portal/policy-receipt/stage-is-required": "Status is required",
  "portal/policy-receipt/taxes": "Taxes",
  "portal/policy-receipt/total-premium": "Total Premium",
  "portal/policy-type": "Policy Type",
  "portal/policy-type-is-required": "Policy type is required",
  "portal/policy/accounting": "Accounting",
  "portal/policy/accounting/amount": "Amount",
  "portal/policy/accounting/balance": "Balance",
  "portal/policy/accounting/date": "Date",
  "portal/policy/accounting/description": "Description",
  "portal/policy/accounting/empty": "No receipts or payments yet",
  "portal/policy/accounting/movements": "Movements",
  "portal/policy/accounting/stage": "Status",
  "portal/policy/action-failed": "Action failed",
  "portal/policy/action-not-found": "Action not found",
  "portal/policy/action-not-found-description":
    'The action "{{action}}" does not exist on the Policy model',
  "portal/policy/activity/created": "Recorded data",
  "portal/policy/activity/error-title": "The activity could not be loaded",
  "portal/policy/activity/moved-to": "Moved to {{stage}}",
  "portal/policy/activity/no": "No",
  "portal/policy/activity/someone": "A user",
  "portal/policy/activity/system": "System",
  "portal/policy/activity/tab": "Activity",
  "portal/policy/activity/today": "Today",
  "portal/policy/activity/truncated": "Showing the 200 most recent events.",
  "portal/policy/activity/updated": "Updated data",
  "portal/policy/activity/yes": "Yes",
  "portal/policy/activity/yesterday": "Yesterday",
  "portal/policy/add-file": "Add File",
  "portal/policy/add-payment": "Add Payment",
  "portal/policy/add-receipt": "Add Receipt",
  "portal/policy/agency": "Agency",
  "portal/policy/agency-1": "Level 1 Agency",
  "portal/policy/agency-1-commission": "Agency 1 Commission",
  "portal/policy/agency-2": "Level 2 Agency",
  "portal/policy/agency-2-commission": "Agency 2 Commission",
  "portal/policy/agency-3": "Level Agency 3",
  "portal/policy/agency-3-commission": "Agency 3 Commission",
  "portal/policy/aircraft": "Aircraft",
  "portal/policy/aircraft/aircraftType": "Aircraft Type",
  "portal/policy/aircraft/aircraftType/airplane": "Airplane",
  "portal/policy/aircraft/aircraftType/helicopter": "Helicopter",
  "portal/policy/aircraft/airplaneClass": "Airplane Class",
  "portal/policy/aircraft/airplaneClass/jet": "Jet",
  "portal/policy/aircraft/airplaneClass/piston": "Piston",
  "portal/policy/aircraft/airplaneClass/turboprop": "Turboprop",
  "portal/policy/aircraft/baseAirport": "Base Airport",
  "portal/policy/aircraft/brand": "Brand",
  "portal/policy/aircraft/crew": "Crew",
  "portal/policy/aircraft/engineCount": "Engine Count",
  "portal/policy/aircraft/engineCount/multi": "Multi-engine",
  "portal/policy/aircraft/engineCount/single": "Single-engine",
  "portal/policy/aircraft/geographicLimit": "Geographic Limit",
  "portal/policy/aircraft/geographicLimit/required":
    "Geographic limit is required",
  "portal/policy/aircraft/helicopterPropulsion": "Helicopter Propulsion",
  "portal/policy/aircraft/helicopterPropulsion/piston": "Piston",
  "portal/policy/aircraft/helicopterPropulsion/turbine": "Turbine",
  "portal/policy/aircraft/hullValue": "Hull Value (USD)",
  "portal/policy/aircraft/licence": "Licence",
  "portal/policy/aircraft/licence-format":
    "Invalid registration. Accepted formats: (1) 1 to 3 letters, a hyphen, then 1 to 5 letters or digits — HK-5039, HC-CPQ, TG-ABC, YS-904P, HI-1015A, FAC-1234; (2) the same, plus an optional second hyphen with 1 to 3 letters or digits — HK-5071-X, YS-111-N, TI-UL-042, UAV-TG-001; (3) a US registration: N followed by 1 to 5 digits and up to 2 letters, excluding I and O — N2801, N421A, N700AF, N99999. The hyphen after the country mark is always required (FAC-1234, not FAC1234).",
  "portal/policy/aircraft/model": "Model",
  "portal/policy/aircraft/passengers": "Passengers",
  "portal/policy/aircraft/serial": "Serial",
  "portal/policy/aircraft/usage": "Usage",
  "portal/policy/aircraft/usage/required": "Usage is required",
  "portal/policy/aircraft/validation/required": "This field is required",
  "portal/policy/aircraft/year": "Year",
  "portal/policy/allocated": "Allocated",
  "portal/policy/authority-correct": "Correct Data",
  "portal/policy/av/line-breach-of-warranty": "Breach of warranty",
  "portal/policy/av/line-cargo": "Cargo",
  "portal/policy/av/line-cmp": "Crew medical payments",
  "portal/policy/av/line-cvs": "Crew voluntary settlements",
  "portal/policy/av/line-hangar-liability": "Hangar liability",
  "portal/policy/av/line-hull": "Hull",
  "portal/policy/av/line-liability": "Third-party liability",
  "portal/policy/av/line-luggage": "Baggage",
  "portal/policy/av/line-pmp": "Passenger medical payments",
  "portal/policy/av/line-pvs": "Passenger voluntary settlements",
  "portal/policy/av/line-spare-parts": "Parts and spares",
  "portal/policy/av/line-war": "War risks",
  "portal/policy/balance": "Balance",
  "portal/policy/cancel": "Cancel",
  "portal/policy/cedent": "Cedent",
  "portal/policy/close": "Close",
  "portal/policy/close-unissued": "Close Without Issuing",
  "portal/policy/coberturas-adicionales": "Additional Coverages",
  "portal/policy/coberturas-adicionales/avn23p":
    "AVN23A — Type E and F Airports",
  "portal/policy/coberturas-adicionales/avn26a":
    "AVN26A — Return of Premium for Grounding",
  "portal/policy/coberturas-adicionales/avn61": "AVN61 — Agreed Value",
  "portal/policy/coberturas-adicionales/avn63":
    "AVN63 — Cross Liability Clause",
  "portal/policy/coberturas-adicionales/avn6a": "AVN6A — Premium Payment",
  "portal/policy/coberturas-adicionales/avn71":
    "AVN71 — Nuclear Risks Exclusion",
  "portal/policy/coberturas-adicionales/avn72":
    "AVN72 — Contracts (Third Party Rights), 1999 Act Exclusion",
  "portal/policy/coberturas-adicionales/avn73":
    "AVN73 — Pilots and Crew Liability Clause",
  "portal/policy/coberturas-adicionales/avn74": "AVN74 — Indemnity to Pilots",
  "portal/policy/coberturas-adicionales/avn75":
    "AVN75 — Flying Clothing and Equipment",
  "portal/policy/coberturas-adicionales/avn76":
    "AVN76 — Additional Payments, Clauses (a) to (d)",
  "portal/policy/coberturas-adicionales/avn77": "AVN77 — Unauthorized Use",
  "portal/policy/coberturas-adicionales/avn78": "AVN78 — Forced Landing Clause",
  "portal/policy/coberturas-adicionales/avn81":
    "AVN81 — Notification Outside Business Hours",
  "portal/policy/coberturas-adicionales/avn91": "AVN91 — Cost of Intruders",
  "portal/policy/coberturas-adicionales/avn94":
    "AVN94 — Airworthiness Regulations",
  "portal/policy/commissions": "Commissions",
  "portal/policy/coverages": "Coverages",
  "portal/policy/coverages/breachOfWarranty": "Breach of Warranty",
  "portal/policy/coverages/breachOfWarrantyLimit": "Breach of Warranty Limit",
  "portal/policy/coverages/cargo": "Cargo",
  "portal/policy/coverages/cargoLimit": "Cargo Limit",
  "portal/policy/coverages/cmp": "Crew Medical Payments",
  "portal/policy/coverages/cmpLimit": "CMP Limit",
  "portal/policy/coverages/coverage-row-not-found":
    "This coverage was not found on the case. Reopen it from the host subject matter step.",
  "portal/policy/coverages/coverageType": "Coverage Type",
  "portal/policy/coverages/coverageType/all-risk": "All Risk",
  "portal/policy/coverages/coverageType/basic": "Basic",
  "portal/policy/coverages/coverageType/hull-only": "Hull Only",
  "portal/policy/coverages/coverageType/limited": "Limited",
  "portal/policy/coverages/cvs": "Crew Voluntary Settlements",
  "portal/policy/coverages/cvsLimit": "CVS Limit",
  "portal/policy/coverages/extendedLiability": "Extended Liability",
  "portal/policy/coverages/hangarLiability": "Hangar Liability",
  "portal/policy/coverages/hangarLiabilityLimit": "Hangar Liability Limit",
  "portal/policy/coverages/host-definition-not-found":
    "This coverage step has no configured host subject matter.",
  "portal/policy/coverages/hull-type-cap":
    "The hull value cannot exceed {{max}} for this aircraft type",
  "portal/policy/coverages/hullValue": "Hull Value (USD)",
  "portal/policy/coverages/liability-type-cap":
    "The liability limit (LUC) cannot exceed {{max}} for this aircraft type",
  "portal/policy/coverages/liabilityLimit": "Liability Limit",
  "portal/policy/coverages/limit-out-of-range":
    "The limit must be between {{min}} and {{max}}",
  "portal/policy/coverages/luggage": "Luggage",
  "portal/policy/coverages/luggageLimit": "Luggage Limit",
  "portal/policy/coverages/no-target-to-link":
    "The host subject matter must be captured before coverages.",
  "portal/policy/coverages/pmp": "Passenger Medical Payments",
  "portal/policy/coverages/pmpLimit": "PMP Limit",
  "portal/policy/coverages/pvs": "Passenger Voluntary Settlements",
  "portal/policy/coverages/pvsLimit": "PVS Limit",
  "portal/policy/coverages/section/hull": "Hull coverage",
  "portal/policy/coverages/section/liability": "Liability coverage",
  "portal/policy/coverages/section/other": "Other coverages",
  "portal/policy/coverages/spareParts": "Spare Parts",
  "portal/policy/coverages/sparePartsLimit": "Spare Parts Limit",
  "portal/policy/coverages/unknown-attribute-owner":
    "A field on this step is not configured correctly and cannot be saved. Contact support.",
  "portal/policy/coverages/usage-hull-value-cap":
    'The hull value cannot exceed {{max}} for use "{{label}}"',
  "portal/policy/coverages/validation/liability-limit-positive":
    "Enter an amount greater than zero",
  "portal/policy/coverages/validation/positive":
    "Enter an amount greater than zero",
  "portal/policy/coverages/validation/required": "This field is required",
  "portal/policy/coverages/warRiskCoverage": "War Risk",
  "portal/policy/covered-period-text":
    "From {{inForceTime}} of {{inForceDate}} to {{expirationTime}} of {{expirationDate}}",
  "portal/policy/credit": "Credit",
  "portal/policy/crew-medical-payments-coverage":
    "Passenger Voluntary Settlements Coverage",
  "portal/policy/crew-medical-payments-coverage-description":
    "Passenger Voluntary Settlements Coverage",
  "portal/policy/crew-voluntary-settlements-coverage":
    "Passenger Voluntary Settlements Coverage",
  "portal/policy/crew-voluntary-settlements-coverage-description":
    "Passenger Voluntary Settlements Coverage",
  "portal/policy/currency": "Currency",
  "portal/policy/currency-description": "Currency of the policy",
  "portal/policy/data-client-not-available": "Data client is not available",
  "portal/policy/debit": "Debit",
  "portal/policy/document-download-failed":
    "The document could not be downloaded",
  "portal/policy/document-download-failed-description":
    "Try again in a few moments.",
  "portal/policy/document-download-subtitle": "Select the file type",
  "portal/policy/document-download-title": "Download {{name}}",
  "portal/policy/document-format-docx": "Word",
  "portal/policy/document-format-pdf": "PDF",
  "portal/policy/download": "Download",
  "portal/policy/due-date": "Due Date",
  "portal/policy/duplicate": "Duplicate",
  "portal/policy/endorse": "Endorse",
  "portal/policy/endorsement": "Endorsement",
  "portal/policy/endorsement-is-required": "Endorsement is required",
  "portal/policy/endorsement-number": "Endorsement Number",
  "portal/policy/endorsement-number-is-required":
    "Endorsement Number is required",
  "portal/policy/entity/fetch-failed": "Could not fetch the entity",
  "portal/policy/entity/save-failed": "Could not create or update the entity",
  "portal/policy/er-aircrafts": "Aircrafts",
  "portal/policy/er-aircrafts/add-aircraft": "Add Aircraft",
  "portal/policy/er-aircrafts/age-surcharge": "Age Surcharge",
  "portal/policy/er-aircrafts/aircraft-details": "Aircraft Details",
  "portal/policy/er-aircrafts/applicable-clauses": "Applicable Clauses",
  "portal/policy/er-aircrafts/base-airport": "Base Airport",
  "portal/policy/er-aircrafts/base-rate": "Base Rate",
  "portal/policy/er-aircrafts/brand-and-model": "Brand and Model",
  "portal/policy/er-aircrafts/breach-of-warranty": "Breach of Warranty",
  "portal/policy/er-aircrafts/capacity": "Capacity",
  "portal/policy/er-aircrafts/cargo": "Cargo",
  "portal/policy/er-aircrafts/coverages": "Coverages",
  "portal/policy/er-aircrafts/crew": "Crew",
  "portal/policy/er-aircrafts/geographic-surcharge":
    "Geographic Limit Surcharge",
  "portal/policy/er-aircrafts/gmp": "PMP",
  "portal/policy/er-aircrafts/gmt": "CME",
  "portal/policy/er-aircrafts/hangar-liability": "Hangar Liability",
  "portal/policy/er-aircrafts/hull-all-risk-coverage":
    "Hull All Risk / Hull All Risk",
  "portal/policy/er-aircrafts/hull-all-risk-coverage-description":
    "<<This text needs to be translated>>",
  "portal/policy/er-aircrafts/hull-all-risk-coverage-war":
    "Hull All Risk / Hull All Risk",
  "portal/policy/er-aircrafts/hull-all-risk-coverage-war-description":
    "<<This text needs to be translated>>",
  "portal/policy/er-aircrafts/hull-insured-sum": "Hull Insured Sum",
  "portal/policy/er-aircrafts/hull-insured-sum-description":
    "The insured sum for the hull of the aircraft",
  "portal/policy/er-aircrafts/hull-limited-coverage": "Hull Limited",
  "portal/policy/er-aircrafts/hull-limited-coverage-description":
    "<<This text needs to be translated>>",
  "portal/policy/er-aircrafts/liability-coverage": "Liability Coverage",
  "portal/policy/er-aircrafts/liability-coverage-description":
    "Liability Coverage",
  "portal/policy/er-aircrafts/liability-insured-sum": "Liability Insured Sum",
  "portal/policy/er-aircrafts/liability-insured-sum-description":
    "Liability Insured Sum",
  "portal/policy/er-aircrafts/licence": "Licence",
  "portal/policy/er-aircrafts/luc": "CSL",
  "portal/policy/er-aircrafts/luggage": "Luggage",
  "portal/policy/er-aircrafts/modify": "Modify",
  "portal/policy/er-aircrafts/net-premium": "Net Premium",
  "portal/policy/er-aircrafts/no-aircrafts":
    "This proposal has no registered aircrafts",
  "portal/policy/er-aircrafts/passengers": "Passengers",
  "portal/policy/er-aircrafts/pvp": "PVP",
  "portal/policy/er-aircrafts/pvt": "PVT",
  "portal/policy/er-aircrafts/sections-description":
    "Section {{section}} of {{sections}}",
  "portal/policy/er-aircrafts/serial": "Serial",
  "portal/policy/er-aircrafts/spare-parts": "Spare Parts",
  "portal/policy/er-aircrafts/sub-limits": "Sub Limits",
  "portal/policy/er-aircrafts/sum-insured": "Sum Insured",
  "portal/policy/er-aircrafts/total-hull": "Total Hull",
  "portal/policy/er-aircrafts/total-liability": "Total Liability",
  "portal/policy/er-aircrafts/total-others": "Total Other Coverages",
  "portal/policy/er-aircrafts/usage": "Usage",
  "portal/policy/er-aircrafts/usage-surcharge": "Usage Surcharge",
  "portal/policy/er-aircrafts/war-risk": "War Risk",
  "portal/policy/er-aircrafts/year": "Year",
  "portal/policy/expedition-date": "Expedition Date",
  "portal/policy/expiration-date": "Expiration Date",
  "portal/policy/expiration-date-is-required": "Expiration Date is required",
  "portal/policy/fees": "Fees",
  "portal/policy/fees-is-required": "Fees is required",
  "portal/policy/file-upload": "Upload",
  "portal/policy/files": "Files",
  "portal/policy/files-empty": "No files yet",
  "portal/policy/files/download": "Download",
  "portal/policy/files/edit": "Edit",
  "portal/policy/files/remove": "Remove",
  "portal/policy/first-payment": "First Payment",
  "portal/policy/first-payment-is-required": "First Payment is required",
  "portal/policy/form/calculate-quote": "Calculate quote",
  "portal/policy/form/error": "Error loading form",
  "portal/policy/form/insured-pending": "Insured not yet set",
  "portal/policy/form/loading": "Loading form...",
  "portal/policy/form/no-form-layout":
    "No form layout is configured for this step",
  "portal/policy/form/no-renderer-declared":
    "No renderer declared for this step",
  "portal/policy/form/no-step-defined": "No form step defined",
  "portal/policy/form/not-found": "Form definition not found",
  "portal/policy/form/present": "Submit",
  "portal/policy/form/salamander-test": "Salamander Test Form",
  "portal/policy/form/test-notes": "Test Notes",
  "portal/policy/in-force-date": "In Force Date",
  "portal/policy/inforce-date": "In Force Date",
  "portal/policy/inforce-date-is-required": "Inforce Date is required",
  "portal/policy/insurer": "Insurer",
  "portal/policy/insurer-is-required": "Insurer is required",
  "portal/policy/interest": "Interest",
  "portal/policy/interest-is-required": "Interest is required",
  "portal/policy/issue": "Issue Policy",
  "portal/policy/issue-date": "Issue Date",
  "portal/policy/issue-date-is-required": "Issue Date is required",
  "portal/policy/ledger": "Ledger",
  "portal/policy/lifecycle/actions/issue": "Issue",
  "portal/policy/lifecycle/actions/reactivate": "Reactivate",
  "portal/policy/lifecycle/actions/reply-and-resend": "Reply and Resend",
  "portal/policy/lifecycle/actions/reply-to-insurer": "Reply",
  "portal/policy/lifecycle/back/changed-hint": "Requote to save the changes",
  "portal/policy/lifecycle/cancel/confirm-cancel": "Go back",
  "portal/policy/lifecycle/cancel/confirm-message":
    "The proposal will be deleted and the aircraft will be freed. This action cannot be undone.",
  "portal/policy/lifecycle/cancel/confirm-ok": "Delete",
  "portal/policy/lifecycle/cancel/confirm-title": "Delete proposal?",
  "portal/policy/lifecycle/cancel/label": "Cancel",
  "portal/policy/lifecycle/claim/field":
    "This aircraft is in another valid proposal or in an issued policy.",
  "portal/policy/lifecycle/claim/refusal-description":
    "Aircraft {{label}} is in another valid proposal or in an issued policy.",
  "portal/policy/lifecycle/claim/refusal-ok": "Got it",
  "portal/policy/lifecycle/claim/refusal-title": "Cannot reactivate",
  "portal/policy/lifecycle/general-information/step": "General Information",
  "portal/policy/lifecycle/general-information/title": "General Information",
  "portal/policy/lifecycle/issuance/eyebrow": "Issuance",
  "portal/policy/lifecycle/validity/expired":
    "Quote expired on {{date}}. Reactivate the proposal to quote again.",
  "portal/policy/lifecycle/validity/expired-status": "Expired",
  "portal/policy/lifecycle/validity/issued-label": "Quoted",
  "portal/policy/lifecycle/validity/remaining": "{{days}} days left",
  "portal/policy/lifecycle/validity/running":
    "Valid until {{date}} · {{days}} days",
  "portal/policy/lifecycle/validity/section-title": "Quote",
  "portal/policy/lifecycle/validity/valid-until-label": "Valid until",
  "portal/policy/main": "Main",
  "portal/policy/modal-payments": "Modal Payments",
  "portal/policy/modal-payments-is-required": "Payments is required",
  "portal/policy/modality": "Modality",
  "portal/policy/modality-is-required": "Modality is required",
  "portal/policy/modify": "Edit",
  "portal/policy/motor-retention-ceiling-inline": "Must be below 100%",
  "portal/policy/motor-retention-too-low-inline":
    "Must be at least the band minimum",
  "portal/policy/motor/annual-premium": "Annual premium",
  "portal/policy/motor/armoring-cost": "Armoring cost (USD)",
  "portal/policy/motor/armoring-level": "Armoring level",
  "portal/policy/motor/band": "Value band",
  "portal/policy/motor/block-1": "Block 1",
  "portal/policy/motor/block-2": "Block 2",
  "portal/policy/motor/block-3": "Block 3",
  "portal/policy/motor/block-card-title": "Block {number}",
  "portal/policy/motor/blocks-title": "Own damage + theft block",
  "portal/policy/motor/brand": "Brand",
  "portal/policy/motor/brand-model-year": "Brand / Model / Year",
  "portal/policy/motor/ceded-xl": "Amount ceded to XL",
  "portal/policy/motor/cedent-declared": "Cedent-declared",
  "portal/policy/motor/ceding-commission": "Ceding commission",
  "portal/policy/motor/coverages": "Coverages",
  "portal/policy/motor/coverages/band-error":
    "No rate band matches the declared sum insured for this vehicle type.",
  "portal/policy/motor/coverages/loading": "Loading rate band…",
  "portal/policy/motor/derived-chip": "Derived",
  "portal/policy/motor/derived-note":
    "Pro-rated for the requested retention — this premium is computed, not rated.",
  "portal/policy/motor/dm-deductible": "Own damage deductible",
  "portal/policy/motor/elected-limit": "Elected limit",
  "portal/policy/motor/gm-limit": "GM limit (USD)",
  "portal/policy/motor/gm-toggle": "Medical expenses (GM)",
  "portal/policy/motor/gross-premium": "Annual gross premium",
  "portal/policy/motor/limit-bounds": "Between {min} and {max}",
  "portal/policy/motor/limit-help": "From 1 up to the table limit ({limit})",
  "portal/policy/motor/line-block": "Own damage + theft (block)",
  "portal/policy/motor/line-gm": "Medical expenses (GM)",
  "portal/policy/motor/line-rc": "Third-party liability (RC)",
  "portal/policy/motor/model": "Model",
  "portal/policy/motor/net-to-reinsurer": "Net to reinsurer",
  "portal/policy/motor/policy-period": "Policy period",
  "portal/policy/motor/policy-period-value": "{from} — {to} (12 months)",
  "portal/policy/motor/premium-lines": "Premium lines",
  "portal/policy/motor/pro-rata-factor": "Pro-rata factor",
  "portal/policy/motor/quote": "Quote",
  "portal/policy/motor/quote-expiry": "Quote valid until",
  "portal/policy/motor/quote/error": "The quote could not be calculated",
  "portal/policy/motor/quote/loading": "Calculating quote…",
  "portal/policy/motor/quote/retry": "Retry",
  "portal/policy/motor/rc-limit": "RC limit (USD)",
  "portal/policy/motor/rc-toggle": "Third-party liability (RC)",
  "portal/policy/motor/reinsurance-slip": "Slip de Reaseguro",
  "portal/policy/motor/requested-retention": "Requested retention",
  "portal/policy/motor/retention-bounds": "Between {min} and {max}",
  "portal/policy/motor/retention-help":
    "Band minimum {min}%. Must be below 100%.",
  "portal/policy/motor/retention-pct": "Retention %",
  "portal/policy/motor/retention-usd": "Retention (USD)",
  "portal/policy/motor/retention-usd-echo": "Retained amount",
  "portal/policy/motor/selected-block": "Selected block",
  "portal/policy/motor/sum-insured": "Sum insured (USD)",
  "portal/policy/motor/sum-insured-split":
    "Vehicle {vehicle} + armoring {armoring}",
  "portal/policy/motor/theft-deductible": "Theft deductible",
  "portal/policy/motor/validation/positive": "Must be greater than zero",
  "portal/policy/motor/validation/required": "This field is required",
  "portal/policy/motor/validation/vin-format":
    "17 characters, letters/digits, no I, O or Q",
  "portal/policy/motor/validation/year-range": "Year must be 1900 or later",
  "portal/policy/motor/vehicle": "Vehicle",
  "portal/policy/motor/vehicle-type": "Vehicle type (cedent-declared)",
  "portal/policy/motor/vehicle-type/blindados": "Armored vehicle",
  "portal/policy/motor/vehicle-type/deportivo": "Sports car",
  "portal/policy/motor/vehicle-type/motocicletas": "Motorcycle",
  "portal/policy/motor/vehicle-type/pasajeros-privados":
    "Passenger van / people carrier",
  "portal/policy/motor/vehicle-type/sedan": "Sedan",
  "portal/policy/motor/vehicle-type/suv": "SUV",
  "portal/policy/motor/vehicle-value": "Vehicle value (USD)",
  "portal/policy/motor/vin": "VIN",
  "portal/policy/motor/year": "Year",
  "portal/policy/net-premium": "Net Premium",
  "portal/policy/net-premium-is-required": "Net Premium is required",
  "portal/policy/no-agency": "No agency",
  "portal/policy/not-found": "Policy not found",
  "portal/policy/number": "Policy Number",
  "portal/policy/outstanding-balance": "Outstanding Balance",
  "portal/policy/overpaid": "Overpaid",
  "portal/policy/partial": "Partial",
  "portal/policy/parties": "Parties",
  "portal/policy/parties/add-additional-insured": "Add additional insured",
  "portal/policy/parties/add-additional-insured-title":
    "Add additional insured",
  "portal/policy/parties/additional-insured": "Additional insured",
  "portal/policy/parties/additional-insureds": "Additional insureds",
  "portal/policy/parties/additional-insureds-empty":
    "No additional insureds have been added",
  "portal/policy/parties/capture-main-insured":
    "Do you want to capture the main insured's information?",
  "portal/policy/parties/capture-main-insured-blocked-hint":
    "Remove the additional insureds to turn this option off.",
  "portal/policy/parties/capture-main-insured-hint": "This step is optional.",
  "portal/policy/parties/capture-preferred-beneficiary":
    "Do you want to capture the preferred beneficiary's information?",
  "portal/policy/parties/capture-preferred-beneficiary-hint": "Optional.",
  "portal/policy/parties/main-insured-title": "Main insured",
  "portal/policy/parties/preferred-beneficiary": "Preferred beneficiary",
  "portal/policy/passenger-medical-payments-coverage":
    "Passenger Voluntary Settlements Coverage",
  "portal/policy/passenger-medical-payments-coverage-description":
    "Passenger Voluntary Settlements Coverage",
  "portal/policy/passenger-voluntary-settlements-coverage":
    "Passenger Voluntary Settlements Coverage",
  "portal/policy/passenger-voluntary-settlements-coverage-description":
    "Passenger Voluntary Settlements Coverage",
  "portal/policy/payment": "Payment",
  "portal/policy/payment-amount": "Amount",
  "portal/policy/payment-date": "Payment Date",
  "portal/policy/payment-date-is-required": "Payment date is required",
  "portal/policy/payment-ref": "Payment — {{reference}}",
  "portal/policy/payment-reference": "Reference",
  "portal/policy/payments": "Payments",
  "portal/policy/period": "Period",
  "portal/policy/policy-fees": "Policy Fees",
  "portal/policy/policy-files": "Policy Files",
  "portal/policy/policy-holder": "Policy Holder",
  "portal/policy/policy-id-is-required": "Policy is required",
  "portal/policy/policy-information": "Policy Information",
  "portal/policy/policy-interest": "Policy Interest",
  "portal/policy/policy-number": "Policy Number",
  "portal/policy/policy-number-is-required": "Policy Number is required",
  "portal/policy/policy-taxes": "Policy Taxes",
  "portal/policy/policy-term": "Policy Term",
  "portal/policy/policy-term-description": "Policy Term",
  "portal/policy/policy-type": "Policy Type",
  "portal/policy/policy-type/new": "New Policy",
  "portal/policy/policy-type/renewal": "Renewal Policy",
  "portal/policy/policy-type/required": "Policy type is required",
  "portal/policy/primary-insured": "Primary Insured",
  "portal/policy/promoter": "Promoter",
  "portal/policy/promoter-commission": "Promoter Commission",
  "portal/policy/proposal": "Proposal",
  "portal/policy/quotation-date": "Quotation Date",
  "portal/policy/quote-error/back": "Go back and edit",
  "portal/policy/quote-error/continue": "Continue",
  "portal/policy/quote-error/message":
    "The quotation could not be calculated. Your information was saved — try again.",
  "portal/policy/quote-layout/caption-on-csl": "On CSL {{valor}}",
  "portal/policy/quote-layout/caption-on-value": "On {{valor}}",
  "portal/policy/quote-layout/caption-quoted-on": "Quoted on {{fecha}}",
  "portal/policy/quote-layout/note-count-times-limit": "{{count}} × {{limit}}",
  "portal/policy/quote-reference/deductibles": "Deductibles",
  "portal/policy/quote-reference/insured-value": "Insured value",
  "portal/policy/quote-reference/package": "Package",
  "portal/policy/quote-reference/term": "Term",
  "portal/policy/quote-reference/value-type": "Value type",
  "portal/policy/quote-step/derived-chip": "Derived",
  "portal/policy/quote-step/error": "The quote could not be calculated",
  "portal/policy/quote-step/hull-total": "Hull premium",
  "portal/policy/quote-step/liability-total": "Liability premium",
  "portal/policy/quote-step/loading": "Calculating quote…",
  "portal/policy/quote-step/no-quote": "No quotation yet",
  "portal/policy/quote-step/others-total": "Other coverages premium",
  "portal/policy/quote-step/retry": "Retry",
  "portal/policy/quote-step/title": "Quote",
  "portal/policy/quote-step/usage-premium": "Usage surcharge",
  "portal/policy/reasons/carrier-decline-reasons/driver-profile":
    "Driver profile",
  "portal/policy/reasons/carrier-decline-reasons/incomplete-information":
    "Incomplete information",
  "portal/policy/reasons/carrier-decline-reasons/other": "Other",
  "portal/policy/reasons/carrier-decline-reasons/risk-not-accepted":
    "Outside risk appetite",
  "portal/policy/reasons/carrier-decline-reasons/title":
    "Carrier decline reasons",
  "portal/policy/reasons/carrier-decline-reasons/vehicle-not-insurable":
    "Vehicle not insurable",
  "portal/policy/reasons/carrier-decline-reasons/zone-not-covered":
    "Zone not covered",
  "portal/policy/reasons/close-reasons/chose-outside-hyper":
    "Chose another option outside Hyper",
  "portal/policy/reasons/close-reasons/do-not-renew": "Do not renew",
  "portal/policy/reasons/close-reasons/no-response": "No response",
  "portal/policy/reasons/close-reasons/not-accepted": "Customer did not accept",
  "portal/policy/reasons/close-reasons/other": "Other",
  "portal/policy/reasons/close-reasons/price": "Price",
  "portal/policy/reasons/close-reasons/sold-vehicle": "Sold the vehicle",
  "portal/policy/reasons/close-reasons/title": "Close reasons",
  "portal/policy/reasons/no-issue-reasons/carrier-declines-risk":
    "Carrier declines the risk",
  "portal/policy/reasons/no-issue-reasons/carrier-system-unavailable":
    "Carrier system unavailable",
  "portal/policy/reasons/no-issue-reasons/data-error": "Data error",
  "portal/policy/reasons/no-issue-reasons/missing-document": "Missing document",
  "portal/policy/reasons/no-issue-reasons/other": "Other",
  "portal/policy/reasons/no-issue-reasons/price-changed": "Price changed",
  "portal/policy/reasons/no-issue-reasons/title":
    "Carrier does not issue reasons",
  "portal/policy/reasons/no-renewal-reasons/customer-declines":
    "Customer declines",
  "portal/policy/reasons/no-renewal-reasons/moving-to-another-broker":
    "Moving to another broker",
  "portal/policy/reasons/no-renewal-reasons/no-contact": "No contact",
  "portal/policy/reasons/no-renewal-reasons/other": "Other",
  "portal/policy/reasons/no-renewal-reasons/price": "Price",
  "portal/policy/reasons/no-renewal-reasons/sold-vehicle": "Sold the vehicle",
  "portal/policy/reasons/no-renewal-reasons/title": "Do not renew reasons",
  "portal/policy/reasons/no-renewal-reasons/total-loss": "Total loss",
  "portal/policy/reasons/requote-origins/add-carriers": "Add carriers",
  "portal/policy/reasons/requote-origins/carrier-update": "Carrier update",
  "portal/policy/reasons/requote-origins/customer-requested-change":
    "Customer requested a change",
  "portal/policy/reasons/requote-origins/data-correction": "Data correction",
  "portal/policy/reasons/requote-origins/offer-expired": "Offer expired",
  "portal/policy/reasons/requote-origins/other": "Other",
  "portal/policy/reasons/requote-origins/title": "Requote origins",
  "portal/policy/reasons/vehicle-change-reasons/other": "Other",
  "portal/policy/reasons/vehicle-change-reasons/replaced-by-new":
    "Replaced by a new vehicle",
  "portal/policy/reasons/vehicle-change-reasons/replaced-by-used":
    "Replaced by a used vehicle",
  "portal/policy/reasons/vehicle-change-reasons/sold-vehicle":
    "Sold the vehicle",
  "portal/policy/reasons/vehicle-change-reasons/title":
    "Vehicle change reasons",
  "portal/policy/reasons/vehicle-change-reasons/total-loss": "Total loss",
  "portal/policy/receipt": "Receipt",
  "portal/policy/receipt-of": "Receipt {{number}} of {{total}}",
  "portal/policy/receipts": "Receipts",
  "portal/policy/received": "Received",
  "portal/policy/regional": "Wholesaler",
  "portal/policy/regional-commission": "Regional Commission",
  "portal/policy/report-download-failed": "Report download failed",
  "portal/policy/requester": "Requester",
  "portal/policy/slip": "Slip",
  "portal/policy/slip/additional-insureds": "Additional Insureds",
  "portal/policy/slip/aeronave": "Aircraft",
  "portal/policy/slip/aeronave-ano": "Year",
  "portal/policy/slip/aeronave-clase": "Class",
  "portal/policy/slip/aeronave-marca": "Brand",
  "portal/policy/slip/aeronave-matricula": "Registration",
  "portal/policy/slip/aeronave-modelo": "Model",
  "portal/policy/slip/aeronave-pasajeros": "Passenger capacity",
  "portal/policy/slip/aeronave-serie": "Serial number",
  "portal/policy/slip/aeronave-tipo": "Type",
  "portal/policy/slip/aeronave-tripulacion": "Crew capacity",
  "portal/policy/slip/aeropuerto-base": "Base airport",
  "portal/policy/slip/aeropuertos-permitidos": "Permitted airports",
  "portal/policy/slip/asegurado-principal": "Main Insured",
  "portal/policy/slip/breach-of-warranty": "Breach of warranty",
  "portal/policy/slip/capacidad": "Capacity",
  "portal/policy/slip/caption-cotizada-el": "Quoted on",
  "portal/policy/slip/caption-limite-unico-combinado-ocurrencia":
    "Combined single limit per occurrence",
  "portal/policy/slip/caption-sobre": "On",
  "portal/policy/slip/caption-sobre-luc": "On CSL",
  "portal/policy/slip/caption-tripulacion-pasajeros": "Crew + passengers",
  "portal/policy/slip/cardinality-blocked":
    "This business cannot generate a new quote slip. Fallback message — the server should always supply a specific one.",
  "portal/policy/slip/cardinality-blocked-title":
    "This business cannot generate a new slip",
  "portal/policy/slip/cedente": "Ceding company",
  "portal/policy/slip/clause-description": "Description",
  "portal/policy/slip/clause-identifier": "Code",
  "portal/policy/slip/clausulas-aplicables": "Applicable clauses",
  "portal/policy/slip/clausulas-incluidas": "Included clauses",
  "portal/policy/slip/cobertura-casco": "Hull",
  "portal/policy/slip/cobertura-partes-refacciones": "Spares and parts",
  "portal/policy/slip/cobertura-responsabilidad-civil": "Liability",
  "portal/policy/slip/cobertura-responsabilidad-civil-hangar":
    "Hangar liability",
  "portal/policy/slip/coberturas-limites": "Coverages and limits",
  "portal/policy/slip/condiciones": "Conditions",
  "portal/policy/slip/condiciones-particulares": "Particular conditions",
  "portal/policy/slip/content-error-title":
    "The slip content could not be loaded",
  "portal/policy/slip/dano-fisico": "Physical damage",
  "portal/policy/slip/date-range": "From {{start}} to {{end}}",
  "portal/policy/slip/datos-aeronave": "Aircraft Data",
  "portal/policy/slip/datos-generales": "General Information",
  "portal/policy/slip/deducible": "Deductible",
  "portal/policy/slip/deducibles": "Deductibles",
  "portal/policy/slip/fecha-cotizacion": "Quotation date",
  "portal/policy/slip/garantia": "Warranty",
  "portal/policy/slip/garantia-pilotos": "Pilot warranty",
  "portal/policy/slip/guerra-riesgos-afines": "War and allied perils",
  "portal/policy/slip/impuestos-aplicables": "Applicable taxes",
  "portal/policy/slip/instruccion-horas": "Hours",
  "portal/policy/slip/insurer-at-issuance": "Insurer defined at issuance",
  "portal/policy/slip/marca-y-modelo": "Make and model",
  "portal/policy/slip/moneda": "Currency",
  "portal/policy/slip/partes": "Parties",
  "portal/policy/slip/pilot-age-exceeds-maximum":
    "Exceeds the maximum age for named pilots — verify recorded age",
  "portal/policy/slip/piloto-nombrado": "Named pilot",
  "portal/policy/slip/pilotos": "Pilots",
  "portal/policy/slip/pilotos-nombrados": "Named pilots",
  "portal/policy/slip/pilotos-nombrados-edad": "Age",
  "portal/policy/slip/pilotos-nombrados-horas-marca-modelo": "Make/model hours",
  "portal/policy/slip/pilotos-nombrados-horas-totales": "Total hours",
  "portal/policy/slip/pilotos-nombrados-licencia": "License",
  "portal/policy/slip/pilotos-nombrados-nombre": "Name",
  "portal/policy/slip/poliza": "Policy",
  "portal/policy/slip/por-confirmar": "To be confirmed",
  "portal/policy/slip/preferred-beneficiary": "Preferred Beneficiary",
  "portal/policy/slip/prima": "Premium",
  "portal/policy/slip/prima-neta": "Net premium",
  "portal/policy/slip/ramo": "Class of business",
  "portal/policy/slip/recargos": "Surcharges",
  "portal/policy/slip/solicitante": "Requester",
  "portal/policy/slip/sublimite-carga": "Cargo",
  "portal/policy/slip/sublimite-cmp": "Crew medical payments",
  "portal/policy/slip/sublimite-cvs": "Crew voluntary settlements",
  "portal/policy/slip/sublimite-equipaje": "Baggage",
  "portal/policy/slip/sublimite-extortion-secuestro": "Extortion and kidnap",
  "portal/policy/slip/sublimite-pmp": "Passenger medical payments",
  "portal/policy/slip/sublimite-pvs": "Passenger voluntary settlements",
  "portal/policy/slip/sublimites": "Sublimits",
  "portal/policy/slip/sufijo-limite-unico-combinado": "Combined single limit",
  "portal/policy/slip/sufijo-por-evento": "per event",
  "portal/policy/slip/sufijo-por-pasajero": "per passenger",
  "portal/policy/slip/sufijo-por-tripulante": "per crew member",
  "portal/policy/slip/term-days": "From {{time}} · {{days}} days",
  "portal/policy/slip/term-days-hours":
    "From {{start}} to {{end}} · {{days}} days",
  "portal/policy/slip/territorialidad": "Territoriality",
  "portal/policy/slip/uso": "Use",
  "portal/policy/slip/usos-aeronave": "Aircraft uses",
  "portal/policy/slip/usos-territorio": "Uses and territory",
  "portal/policy/slip/validez-cotizacion": "Quotation valid until",
  "portal/policy/slip/valor-casco": "Hull value",
  "portal/policy/slip/vigencia": "Effective period",
  "portal/policy/stage-canceled": "Canceled",
  "portal/policy/stage-due": "Due",
  "portal/policy/stage-not-defined": "Stage not defined",
  "portal/policy/stage-paid": "Paid",
  "portal/policy/stage-scheduled": "Scheduled",
  "portal/policy/stages/bind-accepted": "Bind Accepted",
  "portal/policy/stages/bind-authorization": "Bind Authorization",
  "portal/policy/stages/bind-authorized": "Bind Authorized",
  "portal/policy/stages/bind-correction-requested": "Correction Requested",
  "portal/policy/stages/bind-form": "Bind Form",
  "portal/policy/stages/bind-in-progress": "Bind In Progress",
  "portal/policy/stages/bind-rejected": "Bind Rejected",
  "portal/policy/stages/bind-requested": "Bind Requested",
  "portal/policy/stages/bind-validation": "In Validation",
  "portal/policy/stages/bind-validation-escalated": "Validation Escalated",
  "portal/policy/stages/binded": "Binded",
  "portal/policy/stages/binding-form": "Issuing",
  "portal/policy/stages/canceled": "Canceled",
  "portal/policy/stages/closed-lost": "Closed",
  "portal/policy/stages/closed-unissued": "Closed Without Issuing",
  "portal/policy/stages/deleted": "Deleted",
  "portal/policy/stages/draft": "Draft",
  "portal/policy/stages/endorsing": "Endorsing",
  "portal/policy/stages/expired": "Expired",
  "portal/policy/stages/inforce": "In Force",
  "portal/policy/stages/issued": "Issued",
  "portal/policy/stages/issuing": "Issuing",
  "portal/policy/stages/placement-completed": "Placement Completed",
  "portal/policy/stages/placement-declined": "Placement Declined",
  "portal/policy/stages/placement-rejected": "Placement Rejected",
  "portal/policy/stages/placement-requested": "Placement Requested",
  "portal/policy/stages/policy-expired": "Expired",
  "portal/policy/stages/quote-accepted": "Quote Accepted",
  "portal/policy/stages/quote-declined": "Quote Declined",
  "portal/policy/stages/quote-expired": "Expired",
  "portal/policy/stages/quote-rejected": "Quote Rejected",
  "portal/policy/stages/quote-requested": "Quote Requested",
  "portal/policy/stages/quoted": "Quoted",
  "portal/policy/stages/recalled": "Canceled",
  "portal/policy/stages/requoting": "Requoting",
  "portal/policy/stages/withdrawn": "Withdrawn",
  "portal/policy/subject-matter/earlier-version":
    "You are viewing an earlier version of this record, not the current one.",
  "portal/policy/subject-matter/locked":
    "A policy has been issued against this version, so it is shown read-only. Changes are recorded as a new version.",
  "portal/policy/taxes": "Taxes",
  "portal/policy/taxes-is-required": "Taxes is required",
  "portal/policy/total-billed": "Total Billed",
  "portal/policy/total-collected": "Total Collected",
  "portal/policy/total-premium": "Total Premium",
  "portal/policy/total-premium-is-required": "Total Premium is required",
  "portal/policy/unallocated": "Unallocated",
  "portal/policy/vehicle": "Vehicle",
  "portal/policy/vehicle/brand": "Brand",
  "portal/policy/vehicle/brandFilter": "Narrow by brand",
  "portal/policy/vehicle/color": "Color",
  "portal/policy/vehicle/model": "Model",
  "portal/policy/vehicle/modelFilter": "Narrow by model",
  "portal/policy/vehicle/motorNumber": "Engine number",
  "portal/policy/vehicle/passengers": "Passengers",
  "portal/policy/vehicle/plates": "Plates",
  "portal/policy/vehicle/transmission": "Transmission",
  "portal/policy/vehicle/type/car": "Car",
  "portal/policy/vehicle/type/motorcycle": "Motorcycle",
  "portal/policy/vehicle/type/pickup": "Pickup",
  "portal/policy/vehicle/usage": "Usage",
  "portal/policy/vehicle/validation/required": "This field is required",
  "portal/policy/vehicle/vehicleType": "Vehicle type",
  "portal/policy/vehicle/version": "Version",
  "portal/policy/vehicle/vin": "Serial number (VIN)",
  "portal/policy/vehicle/year": "Year",
  "portal/policy/view-not-defined": "View not defined",
  "portal/precision": "Precision",
  "portal/previous-policy": "Previous Policy",
  "portal/previous-policy-is-required": "Previous policy is required",
  "portal/privacy-policy": "Privacy Policy",
  "portal/program/access-denied": "You don't have access to this program",
  "portal/program/context-unavailable":
    "This portal address is not configured for a program",
  "portal/program/session-expired": "Your session has ended",
  "portal/program/session-expired-body": "Sign in again to continue.",
  "portal/program/sign-out": "Sign out",
  "portal/proposal-model": "Proposal Model",
  "portal/proposals/select-proposal-from-the-list":
    "Select a proposal from the list",
  "portal/quote-snapshots": "Quote Snapshots",
  "portal/quote-snapshots/created": "Created",
  "portal/quote-snapshots/error": "Error",
  "portal/quote-snapshots/executed": "Executed",
  "portal/quote-snapshots/execution-time": "Execution time (ms)",
  "portal/quote-snapshots/final-premiums": "Final premiums",
  "portal/quote-snapshots/output-value": "Output value",
  "portal/quote-snapshots/output-variable": "Output variable",
  "portal/quote-snapshots/proposal-id": "Proposal",
  "portal/quote-snapshots/status": "Status",
  "portal/quote-snapshots/step": "Step",
  "portal/quote-snapshots/step-details": "Step details",
  "portal/quotes": "Quotes",
  "portal/rate-table-slug": "Rate Table",
  "portal/rate-table/aggregation/average": "Average",
  "portal/rate-table/aggregation/first": "First",
  "portal/rate-table/aggregation/max": "Maximum",
  "portal/rate-table/aggregation/min": "Minimum",
  "portal/rate-table/aggregation/sum": "Sum",
  "portal/rate-table/key": "Key",
  "portal/rate-table/label": "Label",
  "portal/rate-table/lookup-type/exact": "Exact",
  "portal/rate-table/lookup-type/range": "Range",
  "portal/rate-table/lookup-type/selection": "Selection",
  "portal/rate-table/max": "Maximum",
  "portal/rate-table/min": "Minimum",
  "portal/rate-table/rate": "Rate",
  "portal/rate-table/rate-type": "Rate type",
  "portal/rate-table/rate-type/currency": "Currency amount",
  "portal/rate-table/rate-type/percentage": "Percentage",
  "portal/rate-tables": "Rate Tables",
  "portal/rate-type": "Rate Type",
  "portal/record-not-found": "Record not found",
  "portal/registration/identifier/ar-cuit": "CUIT (legal entity)",
  "portal/registration/identifier/ar-cuit-help":
    "11-digit CUIT issued by ARCA to the legal entity",
  "portal/registration/identifier/bo-nit": "NIT (legal entity)",
  "portal/registration/identifier/bo-nit-help":
    "NIT issued by the Servicio de Impuestos Nacionales to the legal entity",
  "portal/registration/identifier/cl-rut": "RUT (legal entity)",
  "portal/registration/identifier/cl-rut-help":
    "RUT issued by SII to the legal entity (check character 0-9 or 'K')",
  "portal/registration/identifier/co-nit": "NIT (legal entity, with DV)",
  "portal/registration/identifier/co-nit-help":
    "9-digit NIT plus its 1-digit DV, issued by DIAN to the legal entity",
  "portal/registration/identifier/cr-cedula-juridica":
    "Cédula jurídica (legal entity)",
  "portal/registration/identifier/cr-cedula-juridica-help":
    "10-digit cédula jurídica issued to the legal entity",
  "portal/registration/identifier/do-rnc": "RNC (legal entity, with DV)",
  "portal/registration/identifier/do-rnc-help":
    "8-digit RNC base plus its 1-digit DV, issued by DGII to the legal entity",
  "portal/registration/identifier/ec-ruc": "RUC (legal entity)",
  "portal/registration/identifier/ec-ruc-help":
    "13-digit RUC issued by SRI to the society",
  "portal/registration/identifier/gt-nit": "NIT (legal entity)",
  "portal/registration/identifier/gt-nit-help":
    "NIT issued by SAT to the legal entity, including its verification character",
  "portal/registration/identifier/hn-rtn": "RTN (legal entity)",
  "portal/registration/identifier/hn-rtn-help":
    "14-digit Registro Tributario Nacional issued to the legal entity",
  "portal/registration/identifier/mx-rfc": "RFC (legal entity)",
  "portal/registration/identifier/mx-rfc-help":
    "12-character RFC issued by SAT to the legal entity",
  "portal/registration/identifier/mx-rfc-pf": "RFC (natural person)",
  "portal/registration/identifier/mx-rfc-pf-help":
    "13-character RFC issued by SAT to the natural person",
  "portal/registration/identifier/ni-ruc": "RUC (legal entity)",
  "portal/registration/identifier/ni-ruc-help":
    "RUC issued by DGI to the legal entity ('J' followed by 13 digits)",
  "portal/registration/identifier/pa-ruc": "RUC (legal entity)",
  "portal/registration/identifier/pa-ruc-help":
    "segmented RUC (folio-type-year) plus its DV, issued by DGI to the legal entity",
  "portal/registration/identifier/pe-ruc": "RUC (legal entity)",
  "portal/registration/identifier/pe-ruc-help":
    "11-digit RUC issued by SUNAT to the legal entity (legal-person prefix '20')",
  "portal/registration/identifier/py-ruc": "RUC (legal entity, with DV)",
  "portal/registration/identifier/py-ruc-help":
    "3-8 digit RUC base plus its 1-digit DV, issued by DNIT to the legal entity",
  "portal/registration/identifier/sv-nit": "NIT (legal entity)",
  "portal/registration/identifier/sv-nit-help":
    "14-digit NIT issued by the Ministry of Finance to the legal entity",
  "portal/registration/identifier/uy-rut": "RUT (legal entity)",
  "portal/registration/identifier/uy-rut-help":
    "12-digit RUT issued by DGI to the legal entity",
  "portal/remove": "Remove",
  "portal/remove-file": "Remove File",
  "portal/remove-role": "Remove Role",
  "portal/renewal": "Renewal",
  "portal/renewals": "Renewals",
  "portal/requester": "Requester",
  "portal/requester-is-required": "Requester is required",
  "portal/role-level": "Role Level",
  "portal/role-level-is-required": "Role level is required",
  "portal/role-scope": "Role Scope",
  "portal/role-scope-is-required": "Role scope is required",
  "portal/roles": "Roles",
  "portal/roles-management": "Roles",
  "portal/roles-management/action-count": "action(s)",
  "portal/roles-management/active": "Active",
  "portal/roles-management/add-condition": "Add Condition",
  "portal/roles-management/add-group": "Add Group",
  "portal/roles-management/add-parent": "Add Parent Role",
  "portal/roles-management/all": "All Roles",
  "portal/roles-management/app-access": "App Access",
  "portal/roles-management/assignment-count": "assignment(s)",
  "portal/roles-management/assignments": "Assignments",
  "portal/roles-management/condition-left-operand": "Left operand",
  "portal/roles-management/condition-operator": "Operator",
  "portal/roles-management/condition-overrides": "Condition Overrides",
  "portal/roles-management/condition-overrides-description":
    "Override auto-derived conditions for specific permissions. Enable overrides to customize the condition tree.",
  "portal/roles-management/condition-plural": "conditions",
  "portal/roles-management/condition-right-operand": "Right operand",
  "portal/roles-management/condition-singular": "condition",
  "portal/roles-management/create": "Create Role",
  "portal/roles-management/create-role": "Create Role",
  "portal/roles-management/custom": "Custom Roles",
  "portal/roles-management/custom-badge": "Custom",
  "portal/roles-management/denied": "Denied",
  "portal/roles-management/description": "Description",
  "portal/roles-management/disable-override": "Disable Override",
  "portal/roles-management/enable-overrides": "Enable Overrides",
  "portal/roles-management/enable-overrides-description":
    "Toggle permissions below to enable custom condition overrides instead of auto-derived conditions.",
  "portal/roles-management/general": "General",
  "portal/roles-management/granted": "Granted",
  "portal/roles-management/inactive": "Inactive",
  "portal/roles-management/inheritance": "Inheritance",
  "portal/roles-management/level": "Level",
  "portal/roles-management/level/admin": "Admin",
  "portal/roles-management/level/employee": "Employee",
  "portal/roles-management/level/manager": "Manager",
  "portal/roles-management/level/user": "User",
  "portal/roles-management/load-error": "Could not load roles",
  "portal/roles-management/model": "Model",
  "portal/roles-management/more-actions": "More actions",
  "portal/roles-management/name": "Name",
  "portal/roles-management/no-assignments": "No users assigned to this role",
  "portal/roles-management/no-conditions":
    "No conditions defined. Add a condition or group below.",
  "portal/roles-management/no-overrides": "No condition overrides configured.",
  "portal/roles-management/no-parents": "No parent roles configured",
  "portal/roles-management/no-results": "No roles match your search",
  "portal/roles-management/no-roles": "No roles found",
  "portal/roles-management/parent-roles": "Parent Roles",
  "portal/roles-management/permissions": "Permissions",
  "portal/roles-management/revoke-assignment": "Revoke Assignment",
  "portal/roles-management/role-name": "Role Name",
  "portal/roles-management/role-name-required": "Role name is required",
  "portal/roles-management/role-slug": "Role Slug",
  "portal/roles-management/role-slug-required": "Role slug is required",
  "portal/roles-management/scope-type": "Scope Type",
  "portal/roles-management/scope/account": "Account",
  "portal/roles-management/scope/agency": "Agency",
  "portal/roles-management/scope/company": "Company",
  "portal/roles-management/scope/global": "Global",
  "portal/roles-management/search-placeholder": "Search roles",
  "portal/roles-management/select-role": "Select a role to view details",
  "portal/roles-management/slug": "Slug",
  "portal/roles-management/superadmin-only":
    "Condition overrides are only available to super administrators.",
  "portal/roles-management/system": "System Roles",
  "portal/roles-management/system-badge": "System",
  "portal/roles-management/system-role-inheritance-readonly":
    "System role inheritance is read-only.",
  "portal/roles-management/system-role-read-only":
    "System role access is read-only.",
  "portal/roles-management/view-user": "View User",
  "portal/roles/admin": "Admin",
  "portal/roles/definition-owner": "Definition owner",
  "portal/roles/employee": "Employee",
  "portal/roles/family": "Role family",
  "portal/roles/guest": "Guest",
  "portal/roles/manager": "Manager",
  "portal/roles/override-assignments-explanation":
    "Users are assigned to the role family; this definition applies through the hierarchy.",
  "portal/roles/override-definition": "Override definition",
  "portal/roles/override-inheritance-disabled":
    "Inheritance is not available for override definitions.",
  "portal/roles/super-admin": "Super Admin",
  "portal/roles/user": "User",
  "portal/route-not-authorized": "You do not have access to this section",
  "portal/route-not-found": "This route has not been implemented",
  "portal/save": "Save",
  "portal/scope/global": "Global",
  "portal/select-a-cedent-from-the-list": "Select a cedent from the list",
  "portal/select-a-customer-from-the-list": "Select a customer from the list",
  "portal/select-a-placement-from-the-list": "Select a placement from the list",
  "portal/select-a-policy-from-the-list": "Select a policy from the list",
  "portal/select-a-user-from-the-list": "Select a user from the list",
  "portal/select-a-vendor-from-the-list": "Select a vendor from the list",
  "portal/select-an-agency-from-the-list": "Select an agency from the list",
  "portal/select-an-employee-from-the-list": "Select an employee from the list",
  "portal/select-an-entity-from-the-list": "Select an entity from the list",
  "portal/select-an-insurer-from-the-list": "Select an insurer from the list",
  "portal/select-existing-entity": "Select Existing Entity",
  "portal/select-file": "Select File",
  "portal/selected-ids-variable": "Selected IDs Variable",
  "portal/settings": "Settings",
  "portal/settings/companies": "Companies",
  "portal/settings/urls": "URLs",
  "portal/shortcut/access-denied":
    "This shortcut is unavailable or you do not have access.",
  "portal/shortcut/browse-only":
    "This definition has no standalone form configured.",
  "portal/shortcut/cancel": "Cancel",
  "portal/shortcut/create": "Create record",
  "portal/shortcut/delete-confirm": "Delete this record?",
  "portal/shortcut/empty": "No records found.",
  "portal/shortcut/form-definition": "Standalone form",
  "portal/shortcut/linked-read-only":
    "This record is linked. Manage it through the policy flow.",
  "portal/shortcut/previous": "Previous",
  "portal/shortcut/search": "Search records",
  "portal/shortcut/select": "Select a record to view its details.",
  "portal/shortcuts/category-general": "General",
  "portal/shortcuts/category-navigation": "Navigation",
  "portal/shortcuts/category-settings": "Settings",
  "portal/shortcuts/open-palette": "Open command palette",
  "portal/shortcuts/open-sheet": "Show keyboard shortcuts",
  "portal/show-sidebar": "Show sidebar",
  "portal/sidebar-back": "Back",
  "portal/sidebar-hide": "Hide Sidebar",
  "portal/sidebar/account": "{{name}} — account",
  "portal/sidebar/account-menu": "{{name}} — account menu",
  "portal/sidebar/appearance": "Appearance",
  "portal/sidebar/connected": "Connected",
  "portal/sidebar/logo": "Company logo",
  "portal/sidebar/main-navigation": "Main navigation",
  "portal/sidebar/sign-out": "Sign out",
  "portal/sign-out-error": "Sign Out Error",
  "portal/sign-out-error-message":
    "An error occurred while signing out. Please try again.",
  "portal/signin": "Sign In",
  "portal/skip-to-content": "Skip to content",
  "portal/slug": "Slug",
  "portal/source": "Source",
  "portal/start-date": "Start Date",
  "portal/step-config": "Step Configuration",
  "portal/step-slugs": "Step Slugs (comma-separated)",
  "portal/step-type": "Step Type",
  "portal/steps": "Steps",
  "portal/subject-matter-definitions/attribute": "Attribute",
  "portal/subject-matter-definitions/cardinality-many": "Many per policy",
  "portal/subject-matter-definitions/cardinality-one": "One per policy",
  "portal/subject-matter-definitions/catalogue-id": "Catalogue Definition Id",
  "portal/subject-matter-definitions/coverages": "Coverages",
  "portal/subject-matter-definitions/coverages/available-when":
    "Available when",
  "portal/subject-matter-definitions/coverages/declared-at":
    "Declared at {{level}}",
  "portal/subject-matter-definitions/coverages/empty":
    "No coverages declared for this line of business.",
  "portal/subject-matter-definitions/coverages/excluded-badge":
    "Excluded here, inherited from {{level}}",
  "portal/subject-matter-definitions/coverages/fields": "Fields",
  "portal/subject-matter-definitions/coverages/mandatory": "Mandatory",
  "portal/subject-matter-definitions/coverages/mandatory-when":
    "Mandatory when",
  "portal/subject-matter-definitions/coverages/no-fields": "None",
  "portal/subject-matter-definitions/coverages/reenable": "Re-enable",
  "portal/subject-matter-definitions/coverages/reenable-confirm":
    "Re-enable this coverage here? It will resolve again from the level it is inherited from.",
  "portal/subject-matter-definitions/coverages/state-declined": "Declined",
  "portal/subject-matter-definitions/coverages/state-elected": "Elected",
  "portal/subject-matter-definitions/coverages/state-excluded": "Excluded",
  "portal/subject-matter-definitions/coverages/state-offered": "Offered",
  "portal/subject-matter-definitions/delete": "Delete",
  "portal/subject-matter-definitions/description": "Description",
  "portal/subject-matter-definitions/edit": "Edit",
  "portal/subject-matter-definitions/empty-list":
    "No subject matter definitions yet.",
  "portal/subject-matter-definitions/empty-results":
    "No matching subject matter definitions.",
  "portal/subject-matter-definitions/enabled": "Enabled",
  "portal/subject-matter-definitions/general": "General",
  "portal/subject-matter-definitions/label": "Label",
  "portal/subject-matter-definitions/link": "Link",
  "portal/subject-matter-definitions/link-lob": "Link LOB to this Definition",
  "portal/subject-matter-definitions/linked-lobs": "Linked Lines of Business",
  "portal/subject-matter-definitions/load-error":
    "Could not load subject matter definitions",
  "portal/subject-matter-definitions/lob": "Line of Business",
  "portal/subject-matter-definitions/lobs": "Lines of Business",
  "portal/subject-matter-definitions/name": "Name",
  "portal/subject-matter-definitions/no": "No",
  "portal/subject-matter-definitions/no-lobs": "No Lines of Business linked.",
  "portal/subject-matter-definitions/options-helper":
    'Required for type=select. Example: [{"value":"a","label":"A"}].',
  "portal/subject-matter-definitions/options-json": "Options (JSON)",
  "portal/subject-matter-definitions/order": "Order",
  "portal/subject-matter-definitions/required": "Required",
  "portal/subject-matter-definitions/save": "Save",
  "portal/subject-matter-definitions/saving": "Saving…",
  "portal/subject-matter-definitions/search-placeholder":
    "Search subject matter definitions",
  "portal/subject-matter-definitions/searchable": "Searchable",
  "portal/subject-matter-definitions/select":
    "Select a definition to see its details.",
  "portal/subject-matter-definitions/sidebar": "Insurable Interest",
  "portal/subject-matter-definitions/slug": "Slug",
  "portal/subject-matter-definitions/title": "Subject Matter Definitions",
  "portal/subject-matter-definitions/type": "Type",
  "portal/subject-matter-definitions/unique": "Unique",
  "portal/subject-matter-definitions/unlink": "Unlink",
  "portal/subject-matter-definitions/yes": "Yes",
  "portal/subject-matter/add-attribute": "Add Attribute",
  "portal/subject-matter/attributes": "Attributes",
  "portal/subject-matter/cardinality": "Cardinality",
  "portal/subject-matter/cardinality/many": "Many",
  "portal/subject-matter/cardinality/one": "One",
  "portal/subject-matter/definition": "Subject Matter Definition",
  "portal/subject-matter/endorsable": "Endorsable",
  "portal/subject-matter/entity-relationship": "Entity Relationship",
  "portal/subject-matter/instance": "Subject Matter",
  "portal/subject-matter/no-attributes": "No attributes defined yet.",
  "portal/subject-matter/not-validated/default":
    "Not validated. This value was saved as entered and its format was not checked.",
  "portal/subject-matter/not-validated/model-year-unknown":
    "Not validated. The model year is not available, so the identifier format could not be checked.",
  "portal/subject-matter/not-validated/pre-standard":
    "Not validated. Identifiers of this model year do not follow the standard format, so it was saved as entered and checked only for duplicates.",
  "portal/subject-matter/validator/invalid": "The value is not valid.",
  "portal/subject-matter/validator/niv-nom001/charset":
    "The identifier contains a character that is not allowed (I, O, Q and symbols are not valid).",
  "portal/subject-matter/validator/niv-nom001/check-digit":
    "The identifier check character does not match. Review the identifier.",
  "portal/subject-matter/validator/niv-nom001/length":
    "The identifier must have exactly 17 characters.",
  "portal/subject-matter/validator/niv-nom001/model-year":
    "The identifier does not match the model year of the vehicle.",
  "portal/subject-matter/validator/vin-iso3779/charset":
    "The identifier contains a character that is not allowed (I, O, Q and symbols are not valid).",
  "portal/subject-matter/validator/vin-iso3779/check-digit":
    "The identifier check character does not match. Review the identifier.",
  "portal/subject-matter/validator/vin-iso3779/length":
    "The identifier must have exactly 17 characters.",
  "portal/subject-matter/validator/vin-iso3779/wmi":
    "The manufacturer code of the identifier is not valid.",
  "portal/sum-field": "Sum Field",
  "portal/surcharge-factor": "Surcharge Factor",
  "portal/sync-to-parent": "Sync to Parent",
  "portal/tab": "Tab",
  "portal/target": "Target",
  "portal/tasks/assigned": "Assigned",
  "portal/tasks/cancelled": "Cancelled",
  "portal/tasks/claim": "Claim",
  "portal/tasks/complete": "Complete",
  "portal/tasks/completed": "Completed",
  "portal/tasks/in-progress": "In Progress",
  "portal/tasks/my-tasks": "My Tasks",
  "portal/tasks/no-tasks": "No tasks to display.",
  "portal/tasks/pending": "Pending",
  "portal/tasks/sort-by-created": "Created",
  "portal/tasks/sort-by-priority": "Priority",
  "portal/tbc": "TBC",
  "portal/terms-of-use": "Terms of Use",
  "portal/this-account-uses-sso-you-will-be-redirected":
    "This account uses SSO, you will be redirected",
  "portal/transform": "Transform",
  "portal/urls": "URLs",
  "portal/urls/agency-id": "Agency",
  "portal/urls/company-id": "Company",
  "portal/urls/display-name": "Display name",
  "portal/urls/entity-id": "Entity",
  "portal/urls/favicon-dark": "Favicon (dark)",
  "portal/urls/favicon-light": "Favicon (light)",
  "portal/urls/feature-flags": "Feature flags",
  "portal/urls/legal-name": "Legal name",
  "portal/urls/load-error": "Could not load URLs",
  "portal/urls/logo-dark": "Logo (dark)",
  "portal/urls/logo-light": "Logo (light)",
  "portal/urls/no-urls": "No URLs found",
  "portal/urls/primary-dark": "Primary (dark)",
  "portal/urls/primary-light": "Primary (light)",
  "portal/urls/promoter-id": "Promoter",
  "portal/urls/regional-id": "Regional",
  "portal/urls/search-placeholder": "Search URLs",
  "portal/urls/secondary-dark": "Secondary (dark)",
  "portal/urls/secondary-light": "Secondary (light)",
  "portal/urls/select-a-url": "Select a URL from the list",
  "portal/urls/theme": "Theme",
  "portal/urls/title": "URL Configuration",
  "portal/urls/url": "URL",
  "portal/user-roles/remove-confirm-message":
    "The user will no longer have the role {{role}} at {{target}}. Their other roles do not change.",
  "portal/user-roles/remove-confirm-title": "Remove this role?",
  "portal/user-roles/remove-last-confirm-message":
    "The role {{role}} at {{target}} is the only role this user has. After removing it the user loses all access: they can still sign in, but they will see no content until they receive a new role.",
  "portal/users": "Users",
  "portal/users-and-access-control": "Users & Access Control",
  "portal/users/all": "All Users",
  "portal/users/change-login-email": "Change login email",
  "portal/users/change-login-email-confirmation":
    "The user will be signed out of every session and the previous address will be notified.",
  "portal/value": "Value",
  "portal/variables": "Variables",
  "portal/vehicle": "Vehicle",
  "portal/vehicle-catalogues": "Vehicle Catalogues",
  "portal/vehicle-is-required": "Vehicle is required",
  "portal/vehicles": "Vehicles",
  "portal/vendors": "Vendors",
  "portal/view-file": "View File",
  "portal/was-executed": "Executed",
  "portal/year": "Year",
  "portal/yes": "Yes",
  "renaissance/activity-timeline/after": "After: {{value}}",
  "renaissance/activity-timeline/before": "Before: {{value}}",
  "renaissance/activity-timeline/empty": "No activity to show.",
  "renaissance/activity-timeline/filter-actions": "Actions",
  "renaissance/activity-timeline/filter-all": "All",
  "renaissance/activity-timeline/filter-changes": "Data changes",
  "renaissance/activity-timeline/filter-system": "System and AI",
  "renaissance/activity-timeline/no-value": "No value",
  "renaissance/activity-timeline/title": "Activity",
  "renaissance/input-currency/currency-code": "Currency code",
  "renaissance/modal/assign": "Assign",
  "renaissance/modal/back": "Go Back",
  "renaissance/modal/cancel": "Cancel",
  "renaissance/modal/close": "Close",
  "renaissance/modal/continue": "Continue",
  "renaissance/modal/create": "Create",
  "renaissance/modal/register": "Register",
  "renaissance/modal/save": "Save",
  "renaissance/more": "More",
  "renaissance/portal-shell/connection-offline": "You're offline",
  "renaissance/portal-shell/connection-reconnecting": "Reconnecting…",
  "renaissance/portal-shell/show-sidebar": "Show sidebar",
  "renaissance/search": "Search",
  "renaissance/steps/label": "Steps",
  "renaissance/steps/progress": "Step {{current}} of {{total}}",
  "renaissance/ui-command-palette/dialog-label": "Command palette",
  "renaissance/ui-command-palette/hint":
    "↑↓ to navigate, ↵ to select, Esc to close",
  "renaissance/ui-command-palette/no-results": "No matches",
  "renaissance/ui-command-palette/no-results-body":
    "Try a different search term.",
  "renaissance/ui-command-palette/placeholder": "Search pages and settings…",
  "renaissance/ui-confirm/cancel-label": "Cancel",
  "renaissance/ui-confirm/confirm-label": "Confirm",
  "renaissance/ui-input-file/upload-not-configured":
    "File upload is not configured for this field.",
  "renaissance/ui-input-percentage/required": "This field is required",
  "renaissance/ui-input-percentage/value-above-max":
    "Value must be at most {{max}}%",
  "renaissance/ui-input-percentage/value-below-min":
    "Value must be at least {{min}}%",
  "renaissance/ui-input-phone/country-code": "Country code",
  "renaissance/ui-input-select/no-options": "No matches",
  "renaissance/ui-input-url/copy": "Copy to clipboard",
  "renaissance/ui-list/error": "Something went wrong loading this list",
  "renaissance/ui-live-region/alerts-label": "Alerts",
  "renaissance/ui-live-region/updates-label": "Updates",
  "renaissance/ui-loading-view/label": "Loading",
  "renaissance/ui-popover/close": "Close",
  "renaissance/ui-search/clear": "Clear search",
  "renaissance/ui-shortcut-sheet/close": "Close",
  "renaissance/ui-shortcut-sheet/title": "Keyboard shortcuts",
  "renaissance/ui-table/empty": "Nothing here yet",
  "renaissance/ui-table/error": "Something went wrong loading this table",
  "renaissance/ui-table/loading": "Loading rows",
  "renaissance/ui-table/no-access": "You don't have access to this data",
  "renaissance/ui-table/no-results": "No results match your search",
  "renaissance/ui-table/retry": "Retry",
  "renaissance/ui-table/select-all-rows": "Select all rows",
  "renaissance/ui-table/select-row": "Select row",
  "renaissance/ui-table/sort-ascending":
    "Sorted ascending. Activate to sort descending.",
  "renaissance/ui-table/sort-descending":
    "Sorted descending. Activate to clear sorting.",
  "renaissance/ui-table/sort-none": "Not sorted. Activate to sort ascending.",
  "renaissance/ui-toast/dismiss": "Dismiss",
  "renaissance/ui-tree-list/collapse": "Collapse {{name}}",
  "renaissance/ui-tree-list/expand": "Expand {{name}}",
  "renaissance/wizard/actions": "Step actions",
  "renaissance/wizard/summary": "Summary",
  "spare-parts-limit-exceeded": "Spare parts limit exceeded",
  "spare-parts-limit-exceeded-description": "Spare parts limit exceeded",
  "spare-parts-ratio-exceeded": "Spare parts ratio exceeded",
  "spare-parts-ratio-exceeded-description": "Spare parts ratio exceeded",
  "to-be-informed": "To be informed",
  "united-states-dollars": "United States Dollars",
  "websites/hyperseguros/go-to-mian-page": "Go to main page",
  "websites/hyperseguros/go-to-second-page": "Go to second page",
  "websites/hyperseguros/hello-main-page": "Hello from the main page",
  "websites/hyperseguros/hello-second-page": "Hello from the second page",
};

export default enmx;
